const fr = {
  "artworkModals": {
    "common": {
      "cancel": "Annuler",
      "add": "Ajouter",
      "save": "Enregistrer",
      "delete": "Supprimer",
      "close": "Fermer",
      "browse": "Parcourir",
      "uploading": "Téléversement en cours…",
      "saving": "Enregistrement…",
      "notes": "Notes",
      "height": "Hauteur (H)",
      "width": "Largeur (L)",
      "depth": "Profondeur (P)",
      "unit": "Unité",
      "centimeters": "Centimètres",
      "inches": "Pouces",
      "inchesHelp": "Pour les dimensions en pouces, utilisez des décimales, par exemple 10,5 au lieu de 10 1/2.",
      "dimensionsPositive": "Les dimensions doivent être supérieures à zéro."
    },
    "document": {
      "title": "Ajouter un document",
      "types": {
        "certificate": "Certificat d’authenticité",
        "invoice": "Facture",
        "conditionReport": "Rapport de conservation",
        "exhibition": "Documents d’exposition",
        "other": "Autre"
      },
      "errors": {
        "tooLarge": "Le fichier {{name}} dépasse la taille maximale de 30 Mo.",
        "nameRequired": "Veuillez saisir un nom pour le document.",
        "typeRequired": "Veuillez sélectionner un type de document.",
        "fileRequired": "Veuillez sélectionner un fichier.",
        "upload": "Erreur lors du téléversement : {{message}}"
      },
      "fields": {
        "type": "Type de document",
        "selectType": "Sélectionner un type…",
        "name": "Nom du document",
        "namePlaceholder": "Nom du document"
      },
      "actions": {
        "remove": "Supprimer"
      },
      "dropzone": "Glissez-déposez un fichier ici",
      "maxSize": "Taille maximale : 30 Mo"
    },
    "donation": {
      "title": "Donner cette œuvre",
      "errors": {
        "save": "Erreur lors de l’enregistrement de la donation."
      },
      "fields": {
        "valuation": "Valeur estimée (€)",
        "recipient": "Bénéficiaire",
        "date": "Date de la donation"
      },
      "receiptHelp": "Pour le reçu fiscal",
      "placeholders": {
        "recipient": "Musée, fondation, association…",
        "notes": "Informations supplémentaires sur la donation"
      },
      "actions": {
        "confirm": "Confirmer la donation"
      }
    },
    "duration": {
      "title": "Ajouter une durée",
      "description": "Spécifiez la durée de cette œuvre. Applicable aux vidéos, performances, installations temporaires ou œuvres sonores.",
      "inputFormat": "Format d’entrée",
      "simple": "Texte libre",
      "detailed": "Détaillé (h/min/s)",
      "duration": "Durée",
      "placeholder": "Ex. : 12 min 30 s, 1 h 45 min, boucle infinie…",
      "examples": "Exemples : « 12 min », « 1 h 30 min », « 2 h 45 min 30 s », « boucle infinie »…",
      "presets": "Durées prédéfinies",
      "infiniteLoop": "Boucle infinie",
      "hours": "Heures",
      "minutes": "Minutes",
      "seconds": "Secondes",
      "preview": "Aperçu :",
      "none": "(Aucune durée spécifiée)",
      "errors": {
        "required": "Veuillez spécifier une durée."
      }
    },
    "frameSize": {
      "title": "Ajouter les dimensions encadrées",
      "description": "Indiquez les dimensions de l’œuvre avec son cadre. Par défaut, nous suggérons des dimensions 20 % plus grandes que l’œuvre elle-même."
    },
    "imageUpload": {
      "title": "Ajouter des images",
      "errors": {
        "unsupported": "Le fichier {{name}} n’est pas dans un format d’image pris en charge.",
        "tooLarge": "Le fichier {{name}} dépasse la taille maximale de 30 Mo.",
        "required": "Veuillez sélectionner au moins une image.",
        "uploadFile": "Erreur lors du téléversement de {{name}} : {{message}}",
        "publicUrl": "Impossible d’obtenir l’URL publique pour {{name}}.",
        "noneUploaded": "Aucune image n’a pu être téléversée.",
        "upload": "Une erreur est survenue pendant le téléversement des images."
      },
      "dropzone": "Glissez-déposez des images ici",
      "limits": "Limite de 10 images. Taille maximale : 30 Mo par image.",
      "formats": "Formats pris en charge : JPEG, PNG, WEBP",
      "selected": "Images sélectionnées ({{count}})",
      "progress": "Progression",
      "actions": {
        "upload": "Téléverser les images"
      }
    },
    "insurance": {
      "title": "Détails de l’assurance",
      "notProvided": "Non renseigné",
      "notSpecified": "Non précisé",
      "notSpecifiedFeminine": "Non spécifiée",
      "invalidDate": "Format invalide",
      "fields": {
        "insurer": "Assureur",
        "policyNumber": "N° de police",
        "period": "Période de couverture",
        "coverageAmount": "Montant assuré",
        "coverage": "Couverture",
        "premium": "Prime annuelle",
        "deductible": "Franchise"
      },
      "actions": {
        "manage": "Gérer l’assurance"
      }
    },
    "loan": {
      "title": "Enregistrer un prêt",
      "returnTitle": "Retirer du prêt",
      "errors": {
        "save": "Erreur lors de l’enregistrement."
      },
      "currentInfo": "Cette œuvre est actuellement en prêt chez {{institution}}. Confirmer le retour la marquera comme disponible.",
      "unknownInstitution": "une institution",
      "fields": {
        "institution": "Institution / bénéficiaire",
        "contact": "Contact sur place",
        "startDate": "Début du prêt",
        "endDate": "Fin du prêt",
        "contractReference": "Référence du contrat",
        "insuranceRequired": "Assurance requise"
      },
      "placeholders": {
        "institution": "Musée d’Art moderne, FRAC, galerie…",
        "contact": "Nom, e-mail ou téléphone",
        "contractReference": "N° de convention de prêt",
        "notes": "Conditions particulières, clauses, restrictions…"
      },
      "actions": {
        "confirmLoan": "Confirmer le prêt",
        "confirmReturn": "Confirmer le retour"
      }
    },
    "location": {
      "title": "Changer l’emplacement",
      "description": "Sélectionnez le nouvel emplacement pour cette œuvre.",
      "loading": "Chargement des emplacements…",
      "unspecifiedType": "Type non spécifié",
      "empty": "Aucun autre emplacement disponible",
      "actions": {
        "add": "Ajouter un nouvel emplacement"
      }
    },
    "paperSize": {
      "title": "Ajouter les dimensions du papier",
      "description": "Indiquez les dimensions du support papier de cette œuvre. Elles sont généralement plus grandes que celles de l’image elle-même.",
      "standardFormats": "Formats standard (optionnel)",
      "standardHelp": "Cliquez sur un format standard pour appliquer automatiquement ses dimensions."
    },
    "provenance": {
      "addTitle": "Ajouter un élément de provenance",
      "editTitle": "Modifier l’élément de provenance",
      "fields": {
        "type": "Type de provenance",
        "date": "Date",
        "description": "Description",
        "location": "Lieu / commentaire"
      },
      "required": "(obligatoire)",
      "placeholders": {
        "description": "Galerie La Rive, Paris, vente privée, 2018…",
        "location": "Ville, pays, n° de facture… (optionnel)"
      },
      "types": {
        "select": "— Sélectionner un type —",
        "direct_artiste": "Direct artiste",
        "echange_production": "Échange / production",
        "galerie": "Galerie",
        "vente_privee": "Vente privée",
        "encheres": "Vente aux enchères",
        "succession": "Succession / héritage",
        "don": "Don",
        "collection_privee": "Collection privée",
        "autre": "Autre"
      }
    },
    "size": {
      "dimensionsTitle": "Ajouter des dimensions",
      "durationLabel": "Durée (format : HH:MM:SS)",
      "durationPlaceholder": "00:00:00",
      "durationHelp": "Format : heures:minutes:secondes, par exemple 01:30:00 pour 1 h 30."
    },
    "deleteConfirm": {
      "title": "Supprimer l’œuvre",
      "messageBefore": "Êtes-vous sûr de vouloir supprimer l’œuvre",
      "messageAfter": "Cette action est irréversible et supprimera définitivement cette œuvre de votre collection."
    }
  },
  "invoicesPage": {
    "title": "Mes factures & paiements",
    "facturxNote": "Votre facture officielle est au format électronique (Factur-X). Elle est émise et transmise via notre plateforme de dématérialisation agréée, conformément à la facturation électronique. Les documents ci-dessous sont les justificatifs de paiement correspondants.",
    "colNumber": "Numéro",
    "colStatus": "Statut",
    "colAmount": "Montant",
    "colReceipt": "Justificatif de paiement",
    "colDetail": "Détail",
    "download": "Télécharger",
    "view": "Voir",
    "loading": "Chargement…",
    "empty": "Aucune facture pour le moment.",
    "loginPrompt": "Connectez-vous pour voir vos factures.",
    "error": "Erreur lors du chargement des factures."
  },
  "actusVentes": {
    "dateUnavailable": "Date non disponible",
    "errorMessage": "Erreur : {{message}}",
    "noUpcoming": "Aucune vente à venir pour cette maison",
    "seeAll": "Voir toutes les ventes",
    "source": "Source : {{house}}"
  },
  "advisor": {
    "accessGranted": "Accès accordé",
    "expert": "Expert",
    "findOne": "Trouver un conseiller",
    "loading": "Chargement...",
    "none": "Aucun conseiller pour le moment",
    "pricing": {
      "desc": "La mise en relation est 100% gratuite (incluse dans votre abonnement). Les services payants (estimations, expertises) sont facturés séparément au prix affiché, sans frais supplémentaires pour vous.",
      "title": "Mise en relation gratuite"
    },
    "revokeAccess": "Révoquer l'accès",
    "shareCollections": "Partager mes collections",
    "sharedSince": "Collections partagées depuis le",
    "sharing": "Partage en cours...",
    "status": {
      "accepted": "L'expert a accepté votre invitation",
      "pending": "En attente de réponse de l'expert",
      "rejected": "L'expert a refusé votre invitation"
    },
    "subtitle": "Votre expert personnel pour vous accompagner dans la gestion de votre collection",
    "title": "Mon conseiller Artkiv"
  },
  "artwork": {
    "access": {
      "granted": "Accès accordé",
      "pending": "Accès en attente",
      "revoked": "Accès retiré"
    },
    "accessPrivacy": {
      "badgePrivate": "Privé",
      "body": "Cette œuvre est privée par défaut. Seules les personnes que tu invites peuvent la consulter.",
      "hint": "Tu peux modifier ou retirer un accès à tout moment depuis 'Partage'.",
      "pill1": "Partage contrôlé",
      "pill2": "Accès tracés",
      "pill3": "Artkiv n'y accède que si tu le demandes",
      "title": "Accès & confidentialité"
    },
    "availability": {
      "available": "Disponible",
      "in_restoration": "En restauration",
      "not_found": "Non trouvée",
      "on_loan": "En prêt",
      "reserved": "Réservée",
      "sold": "Vendue",
      "lost_or_stolen": "Perdue / volée",
      "to_destroy": "À détruire",
      "unavailable": "Indisponible",
      "loaned": "En prêt"
    },
    "mediumCategories": {
      "design": "Design",
      "nft": "NFT / Art numérique",
      "other": "Autre"
    },
    "mediums": {
      "oil_on_canvas": "Huile sur toile",
      "acrylic_on_canvas": "Acrylique sur toile",
      "oil_on_wood": "Huile sur bois",
      "acrylic_on_wood": "Acrylique sur bois",
      "painting_generic": "Peinture",
      "paper_maroufle": "Papier marouflé",
      "watercolor_on_paper": "Aquarelle sur papier",
      "gouache_on_paper": "Gouache sur papier",
      "ink_on_paper": "Encre sur papier",
      "charcoal_on_paper": "Fusain sur papier",
      "pencil_on_paper": "Crayon sur papier",
      "pastel_on_paper": "Pastel sur papier",
      "collage_on_paper": "Collage sur papier",
      "mixed_media_on_paper": "Technique mixte sur papier",
      "work_on_paper": "Travail sur papier",
      "lithograph": "Lithographie",
      "screenprint": "Sérigraphie",
      "engraving": "Gravure",
      "etching": "Eau-forte",
      "aquatint": "Aquatinte",
      "print": "Estampe",
      "photographic_print": "Tirage photographique",
      "silver_gelatin_print": "Tirage argentique",
      "lambda_print": "Tirage lambda",
      "pigment_print": "Tirage pigmentaire",
      "inkjet_print": "Tirage jet d’encre",
      "digital_print": "Impression numérique",
      "bronze": "Bronze",
      "marble": "Marbre",
      "resin": "Résine",
      "wood": "Bois",
      "steel": "Acier",
      "aluminium": "Aluminium",
      "porcelain": "Porcelaine",
      "ceramic_glazed": "Céramique émaillée",
      "mixed_media": "Technique mixte",
      "textile_fiber": "Textile / fibres",
      "video_installation": "Installation vidéo",
      "digital": "Art numérique",
      "nft_art": "NFT / Art numérique",
      "other": "Autre",
      "painting": "Peinture",
      "sculpture": "Sculpture",
      "photography": "Photographie",
      "drawing": "Dessin",
      "installation": "Installation",
      "video": "Vidéo",
      "textile": "Textile",
      "ceramic": "Céramique",
      "nft": "NFT / Art numérique",
      "oil_on_panel": "Huile sur panneau",
      "oil_on_paper": "Huile sur papier",
      "acrylic_on_paper": "Acrylique sur papier",
      "acrylic_on_panel": "Acrylique sur panneau",
      "watercolor": "Aquarelle",
      "gouache": "Gouache",
      "ink_on_canvas": "Encre sur toile",
      "mixed_media_on_canvas": "Techniques mixtes sur toile",
      "collage": "Collage",
      "serigraph": "Sérigraphie",
      "photography_generic": "Photographie",
      "c_print": "Tirage C-print",
      "iron": "Fer",
      "glass": "Verre",
      "fresco": "Fresque",
      "tempera": "Tempera",
      "oil_on_linen": "Huile sur lin",
      "pencil_on_canvas": "Crayon sur toile",
      "crayon": "Crayon",
      "pen_and_ink": "Plume et encre"
    },
    "condition": {
      "excellent": "Excellent",
      "very_good": "Très bon",
      "good": "Bon",
      "fair": "Moyen",
      "very_poor": "Très moyen",
      "heavily_damaged": "Très abîmé restaurable",
      "partially_restorable": "Partiellement restaurable",
      "irreparable": "Irréparable",
      "poor": "Mauvais",
      "damaged": "Endommagé",
      "to_restore": "À restaurer",
      "unknown": "Inconnu"
    },
    "typeOfArt": {
      "contemporary_art": "Art contemporain",
      "postwar_art": "Art d'après-guerre",
      "modern_art": "Art moderne",
      "impressionism": "Impressionnisme",
      "old_masters": "Arts anciens",
      "asian_art": "Art asiatique",
      "african_art": "Art africain",
      "middle_eastern_art": "Art du Moyen-Orient",
      "latin_american_art": "Art latino-américain",
      "tribal_art": "Art tribal",
      "street_art": "Street art",
      "photography": "Photographie",
      "design": "Design",
      "decorative_arts": "Arts décoratifs",
      "antiquities": "Antiquités",
      "nineteenth_century_art": "Art du 19e siècle",
      "prints_multiples": "Estampes & multiples",
      "digital_art": "Art numérique / NFT",
      "unknown": "Non renseigné",
      "other": "Autre"
    },
    "history": {
      "noViews": "Aucune consultation pour le moment",
      "viewedBy": "Consulté par"
    }
  },
  "artworkAccess": {
    "active": {
      "canEdit": "Peut modifier",
      "empty": "Aucun accès partagé",
      "emptyDescription": "Cette œuvre n'est partagée avec personne pour le moment",
      "revoke": "Révoquer l'accès",
      "sharedAt": "Partagé",
      "title": "Accès actifs"
    },
    "confirm": {
      "revoke": "Révoquer l'accès de {{name}} ?"
    },
    "error": {
      "invite": "Erreur lors de l'invitation",
      "revoke": "Erreur lors de la révocation"
    },
    "invite": {
      "button": "Inviter",
      "description": "Invitez des experts, conservateurs ou partenaires à consulter cette fiche",
      "emailLabel": "Adresse email",
      "messageLabel": "Message (optionnel)",
      "messagePlaceholder": "Ajoutez un message personnalisé...",
      "roleLabel": "Rôle",
      "send": "Envoyer l'invitation",
      "sending": "Envoi...",
      "title": "Partager cette œuvre"
    }
  },
  "artworkDetail": {
    "access": {
      "blockchain": "Chaque consultation est enregistrée de manière infalsifiable afin de garantir la traçabilité, la confidentialité et l'intégrité des données.",
      "cta": "Gérer les accès",
      "description": "Cette œuvre est accessible uniquement aux personnes explicitement autorisées par le collectionneur.",
      "empty": "Rien à signaler pour l'instant. Dès qu'un tiers consulte cette œuvre, ça apparaîtra ici.",
      "hint": "Vous gardez le contrôle total sur qui peut voir cette œuvre, quand et dans quel cadre.",
      "loading": "On remonte les accès…",
      "log": "Les accès sont horodatés et associés à un rôle (collectionneur, expert, conseiller, partenaire).",
      "whyArtkiv": "Pour des raisons de sécurité et de conformité, l'accès à cette œuvre se fait exclusivement via Artkiv."
    },
    "acquisition": {
      "date": "Date d'acquisition",
      "inventoryNumber": "Numéro d'inventaire",
      "price": "Prix d'acquisition",
      "source": "Source",
      "title": "Détails d'acquisition",
      "type": "Type d'acquisition"
    },
    "actions": {
      "aiTracking": "Suivi IA",
      "conservation": "Conservation",
      "costs": "Coûts",
      "curatorialReading": "Lecture curatoriale",
      "curatorialReadingSubtext": "Service expert partenaire",
      "requestExpertValuation": "Demander une estimation à un expert",
      "requestExpertValuationSubtext": "Envoyer cette œuvre à un expert partenaire nommé",
      "delete": "Supprimer",
      "donation": "Donation",
      "downloadZip": "Télécharger le dossier",
      "downloadZipSubtext": "Images + documents en un fichier ZIP",
      "edit": "Modifier",
      "insurance": "Assurance",
      "maintenance": "Maintenance",
      "proposeExhibition": "Proposer l’œuvre",
      "proposeToMuseum": "Proposer musée",
      "qrCode": "QR Code",
      "registerDonation": "Enregistrer une donation",
      "registerSale": "Enregistrer une vente",
      "requestInsurance": "Demander une analyse d'assurance",
      "requestTransport": "Demander un transport",
      "sale": "Vente",
      "showQr": "Afficher le QR code",
      "transport": "Transport",
      "zipping": "Préparation du ZIP…",
      "exportDossier": "Exporter le dossier",
      "loanArtwork": "Prêter l'œuvre",
      "removeFromLoan": "Retirer du prêt",
      "declareLoss": "Déclarer perte ou vol",
      "estimateComparables": "Estimer par comparables",
      "duplicateArtwork": "Dupliquer la fiche",
      "duplicating": "Duplication…",
      "transportTitle": "Demander un transport (devis déplacement/retour)",
      "addToLot": "Mettre en lot",
      "addToLotTitle": "Regrouper cette œuvre dans un lot",
      "removeFromLotTitle": "Retirer cette œuvre du lot",
      "removeFromLotConfirm": "Retirer cette œuvre du lot ?",
      "removeFromLotError": "Erreur lors du retrait du lot."
    },
    "ai": {
      "analyzeButton": "Lancer l’analyse IA",
      "description": "Utilisez l’IA pour analyser cette œuvre, enrichir ses métadonnées et affiner sa valorisation.",
      "eligible": "Éligible au module IA Artkiv.",
      "title": "Analyse IA"
    },
    "ocr": {
      "button": "Enrichir via OCR",
      "loading": "Enrichissement…",
      "blockedPlan": "L'enrichissement OCR par IA est disponible à partir du plan Premium.",
      "blockedConsent": "Vous n'avez pas encore accepté les conditions d'utilisation de l'IA.",
      "blockedDisabled": "L'IA est désactivée sur votre compte. Activez-la dans vos préférences.",
      "viewPlans": "Voir les plans →",
      "profile": "Mon profil →"
    },
    "visualAi": {
      "title": "Analyse visuelle IA",
      "description": "Analyse des images de l'œuvre via Vision.artkiv.com",
      "launch": "Lancer l'analyse →"
    },
    "lot": {
      "fallbackName": "Lot",
      "copySingular": "{{count}} exemplaire",
      "copyPlural": "{{count}} exemplaires",
      "show": "afficher",
      "collapse": "réduire",
      "duplicateTitle": "Dupliquer cet exemplaire dans le lot",
      "duplicate": "Dupliquer",
      "edit": "Modifier le lot",
      "referenceAlt": "Visuel de référence du lot",
      "referenceLabel": "Visuel de référence du lot",
      "referenceLabelUpper": "VISUEL DE RÉFÉRENCE DU LOT",
      "useAsPrimaryTitle": "Utiliser le visuel du lot comme image principale de cette œuvre",
      "useAsPrimary": "Utiliser comme principale",
      "setAsPrimary": "Inscrire ce visuel comme image principale",
      "sharedVisualTitle": "Ce visuel sera commun à toutes les œuvres du lot",
      "uploading": "Upload en cours…",
      "changeVisual": "Changer le visuel du lot",
      "addVisual": "Ajouter un visuel de lot",
      "applyAllTitle": "Appliquer ce visuel comme image principale sur toutes les œuvres du lot",
      "applying": "Application…",
      "applyAll": "Appliquer à tout le lot",
      "applySuccess": "✓ Visuel appliqué à {{count}} œuvre(s) du lot.",
      "applyPartial": "⚠ {{count}} / {{total}} appliquées. {{errors}} erreur(s).",
      "uploadError": "Erreur lors de l'upload du visuel lot : {{message}}",
      "usePrimaryError": "Erreur : {{message}}",
      "applyConfirm": "Appliquer ce visuel comme image principale sur toutes les œuvres du lot ?\n\nLes œuvres qui ont déjà une photo propre verront ce visuel ajouté en première position. Les autres l'auront comme image principale. Aucune image existante n'est supprimée.",
      "globalPriceTitle": "Prix global du lot (installation)",
      "globalPriceDescription": "Ce prix s'applique à l'ensemble de l'installation ({{count}} tirages). Il n'est pas divisible par exemplaire."
    },
    "loanBanner": {
      "status": "En prêt",
      "manage": "Gérer dans Dépôts & Prêts →"
    },
    "loss": {
      "badges": {
        "vol": "Œuvre volée",
        "perte": "Œuvre perdue",
        "destruction": "Œuvre détruite",
        "incendie": "Sinistre incendie",
        "inondation": "Sinistre inondation",
        "autre": "Sinistre déclaré",
        "generic": "Perdue / Volée"
      },
      "viewRegister": "Voir dans Pertes & Vols →",
      "saveError": "Erreur lors de l'enregistrement.",
      "types": {
        "vol": "Vol",
        "perte": "Perte",
        "destruction": "Destruction",
        "incendie": "Incendie",
        "inondation": "Inondation",
        "autre": "Autre"
      },
      "modal": {
        "title": "Déclarer perte ou vol",
        "artwork": "Œuvre",
        "type": "Type",
        "declaredValue": "Valeur déclarée (EUR)",
        "estimatedValue": "Valeur estimée",
        "policeReport": "Dépôt de plainte effectué",
        "insuranceClaim": "Déclaration assurance effectuée",
        "notes": "Notes",
        "notesPlaceholder": "Décrivez les circonstances…",
        "notice": "L’œuvre sera marquée comme « {{status}} » et retirée de votre inventaire actif. Retrouvez le suivi dans Pertes & Vols.",
        "cancel": "Annuler",
        "saving": "Enregistrement…",
        "confirm": "Confirmer la déclaration"
      }
    },
    "duplicate": {
      "confirm": "Dupliquer cette fiche ?",
      "error": "Erreur lors de la duplication : {{message}}"
    },
    "catalogImport": {
      "title": "Fiche incomplète — importée depuis catalogue",
      "description": "Technique, dimensions et visuel manquants. Photographiez la double page correspondante.",
      "enrich": "Enrichir →"
    },
    "pricing": {
      "atPurchaseRate": "au taux d'achat"
    },
    "loginRequired": "Vous devez être connecté.",
    "viewArtistWorks": "Voir toutes les œuvres de {{artist}}",
    "backToCollection": "Retour à ma collection",
    "badges": {
      "archived": "Archivée",
      "blockchain": "Preuve d'authenticité",
      "donated": "Donnée (archive)",
      "heirAssigned": "Héritier assigné",
      "insured": "Assurée",
      "notCertified": "Non certifiée",
      "notInsured": "Non assurée",
      "sold": "Vendue (archive)"
    },
    "blockchain": {
      "badgeCertified": "Preuve d'authenticité",
      "badgeNotCertified": "Non certifiée",
      "blockchain": "Technologie :",
      "contract": "Contrat :",
      "link": "Lien :",
      "linkLabel": "Voir",
      "title": "Preuve d'authenticité — détail technique",
      "tokenId": "Identifiant :",
      "type": "Type :"
    },
    "proof": {
      "title": "Empreinte numérique",
      "loading": "Chargement de votre abonnement…",
      "lockedText": "Créez une empreinte SHA-256 datée de cette fiche œuvre. Fonctionnalité réservée aux comptes Premium.",
      "upgradeButton": "Passer à Premium",
      "statusPending": "Empreinte créée",
      "statusCertified": "Ancrée sur blockchain",
      "emptyText": "Cette œuvre n’a pas encore d’empreinte numérique ARTKIV.",
      "generateButton": "Créer l’empreinte numérique",
      "generating": "Génération en cours…",
      "generateSuccess": "Empreinte numérique créée.",
      "premiumRequired": "Cette fonctionnalité nécessite un plan Premium ou supérieur.",
      "generateError": "Erreur lors de la création de l’empreinte.",
      "certificateId": "Identifiant :",
      "fingerprint": "Empreinte numérique :",
      "createdAt": "Date de création :",
      "technology": "Technologie :",
      "ecoFriendly": "Éco-responsable",
      "pendingInfo": "L’empreinte SHA-256 est enregistrée dans ARTKIV. Elle n’est pas encore ancrée sur une blockchain publique.",
      "downloadPdf": "Télécharger le document PDF",
      "pdfSoon": "PDF (bientôt)",
      "verifySoon": "Vérification publique (bientôt)",
      "viewOnChain": "Voir sur la blockchain",
      "notAnchored": "Non ancrée",
      "loadError": "Impossible de charger l’empreinte numérique.",
      "howItWorksTitle": "À quoi sert cette empreinte ?",
      "how": {
        "unique": "Empreinte unique : votre preuve est identifiée par un code propre à cette œuvre.",
        "tamperproof": "Infalsifiable : toute tentative de modification serait immédiatement détectable.",
        "timestamped": "Horodatée : la date de création est enregistrée de façon permanente.",
        "verifiable": "Vérifiable : l'authenticité peut être confirmée à tout moment.",
        "comingSoon": "Bientôt : cette preuve sera également inscrite sur une blockchain publique pour une traçabilité permanente."
      }
    },
    "defaultTitle": "Sans titre",
    "delete": {
      "confirm": "Voulez-vous vraiment supprimer cette œuvre ?",
      "error": "Erreur lors de la suppression."
    },
    "description": {
      "title": "Description"
    },
    "details": {
      "availability": "Disponibilité",
      "condition": "État",
      "conditionNotes": "Notes",
      "dimensions": "Dimensions (LxHxP)",
      "duration": "Durée",
      "edition": "Édition",
      "editionMultiple": "Édition multiple",
      "editionUnique": "Pièce unique",
      "location": "Localisation",
      "subject": "Sujet / thème",
      "type": "Type",
      "value": "Valeur"
    },
    "health": {
      "docsMissing": "Documents à ajouter",
      "docsOk": "{{count}} document(s)",
      "locationMissing": "Localisation manquante",
      "locationOk": "Localisation renseignée",
      "ok": "Dossier à jour",
      "purchaseMissing": "Prix d'achat manquant",
      "purchaseOk": "Prix d'achat renseigné",
      "todo": "{{count}} point(s) à compléter"
    },
    "history": {
      "empty": "Pas encore d'activité. Lance une action (ajout de provenance, certificat d'artiste, déplacement de l'oeuvre, pour créer une trace.",
      "emptyDesc": "L'activité sur cette œuvre sera visible ici",
      "fullHistory": "Historique complet",
      "itemTitle": "Événement",
      "loading": "Chargement…",
      "noThirdParty": "Aucun accès tiers enregistré",
      "noThirdPartyDesc": "Les consultations par des experts ou partenaires apparaîtront ici",
      "showAll": "Voir les {{count}} autres événements",
      "showLess": "Réduire",
      "thirdPartyAccess": "Accès tiers",
      "loadingFallback": "Chargement de l'historique…",
      "actionViewed": "a consulté la fiche",
      "actionUpdated": "a mis à jour des informations",
      "actionDocumentAdded": "a ajouté un document",
      "actionImageAdded": "a ajouté une image",
      "actionShared": "a partagé l'accès",
      "actionRevoked": "a révoqué l'accès",
      "actionGenericNamed": "a effectué une action ({{action}})",
      "actionGeneric": "a effectué une action",
      "thirdPartyBadge": "Tiers",
      "actorYou": "Vous",
      "actorUnknown": "Un intervenant",
      "before": "Avant",
      "after": "Après"
    },
    "info": {
      "estimatedValue": "Valeur :",
      "locationLabel": "Lieu :"
    },
    "inventoryNumber": "Identifiant inventaire",
    "loading": "Chargement…",
    "locationMissingCta": "Ajouter un lieu (pour la retrouver instantanément)",
    "locationMissingReadonly": "Lieu non renseigné",
    "login": {
      "title": "Connexion",
      "subtitle": "Accédez à votre collection Artkiv",
      "email": "Email",
      "password": "Mot de passe",
      "forgot": "Mot de passe oublié ?",
      "submit": "Se connecter",
      "loading": "Connexion en cours...",
      "noAccount": "Pas encore de compte ?",
      "signup": "Créer un compte",
      "error": {
        "invalid": "Email ou mot de passe incorrect",
        "required": "Veuillez remplir tous les champs",
        "unknown": "Une erreur est survenue, réessayez"
      }
    },
    "media": {
      "noImages": "Aucune image associée à cette œuvre.",
      "noMainImage": "Aucune image",
      "title": "Visuels de l'œuvre"
    },
    "meta": {
      "artistLabel": "Artiste :",
      "blockchainCertified": "Preuve d'authenticité",
      "condition": "État",
      "conditionNotes": "Notes",
      "dimensions": "Dimensions",
      "duration": "Durée :",
      "edition": "Edition",
      "location": "Localisation",
      "locationUnknown": "Non renseignée",
      "mediumLabel": "Techniques:",
      "notSet": "Non renseigné",
      "ownerStatus": {
        "owner": "Vous êtes propriétaire",
        "ownerShared": "Cette fiche est partagée",
        "sharedAccess": "Accès partagé par le propriétaire"
      },
      "subjectMatter": "Sujet / thème",
      "typeOfArt": "Type d'art :",
      "yearLabel": "Année :"
    },
    "nextAction": {
      "docs": {
        "cta": "Ajouter un document",
        "desc": "Ajoutez au moins un document (facture, certificat, email, photo).",
        "title": "Sécurisez le dossier en 1 minute"
      },
      "location": {
        "cta": "Ajouter une localisation",
        "desc": "Ajoutez une localisation pour la logistique et la traçabilité.",
        "title": "Retrouvez l'œuvre instantanément"
      },
      "ok": {
        "cta": "Voir l'historique",
        "desc": "Votre fiche est complète. Vous pouvez suivre l'activité et partager l'accès.",
        "title": "Tout est prêt"
      },
      "purchase": {
        "cta": "Ajouter le prix d'achat",
        "desc": "Renseignez le prix d'achat pour suivre l'évolution de valeur.",
        "title": "Calculez la plus-value"
      },
      "viewTab": "Voir l'onglet"
    },
    "noDescription": "Aucune description n'a encore été ajoutée pour cette œuvre.",
    "noDescriptionCta": "Ajouter une description (30 sec)",
    "noImage": "Aucune image disponible pour cette œuvre",
    "noLocation": "Non renseigné",
    "notFound": {
      "back": "Retour au tableau de bord",
      "cta": "Retour à ma collection",
      "description": "Certaines œuvres sur Artkiv sont protégées par des accès privés.\n\nPour garantir la sécurité, la traçabilité et l'historique des consultations, chaque fiche œuvre est visible uniquement par les personnes invitées.",
      "hint": "Si vous pensez que vous devriez y avoir accès, demandez simplement une invitation.",
      "title": "Cette œuvre n'est pas accessible pour l'instant"
    },
    "qr": {
      "download": "Télécharger",
      "scanText": "Scannez ce QR code.",
      "title": "QR Code"
    },
    "services": {
      "aiInsights": "Recommandations IA",
      "conservation": "Conservation & restauration",
      "costManagement": "Gestion des coûts",
      "donationOption": "🎁 Faire une donation",
      "insurance": "Assurance & couverture",
      "insuranceDesc": "Préparez un dossier complet pour votre assureur ou nos partenaires assureurs.",
      "museumProposal": "Proposition à un musée",
      "saleDonation": "Vente / Donation",
      "saleDonationDesc": "Structurez une vente, une donation ou un legs avec Artkiv et vos conseillers.",
      "saleOption": "📈 Mettre en vente",
      "title": "Services autour de cette œuvre",
      "transport": "Transport & logistique",
      "valuation": "Évaluation & estimation",
      "valuationDesc": "Demandez une estimation actualisée grâce à l'IA Artkiv et à nos experts partenaires."
    },
    "shared": {
      "description": "Consultez, documentez et gérez l'ensemble des informations liées à cette œuvre.",
      "title": "Détail de l'œuvre"
    },
    "story": {
      "acquisition": "Acquisition",
      "action": "Modification",
      "empty": "Aucune entrée pour le moment. Ajoutez un document ou une provenance pour créer la story.",
      "event": "Événement",
      "provenance": "Provenance",
      "subtitle": "Une trace claire, en un coup d'œil",
      "title": "Story de l'œuvre",
      "unknownDate": "Date inconnue",
      "view": "Consultation"
    },
    "tabs": {
      "access": "Accès & traçabilité",
      "details": "Détails",
      "documents": "Documents",
      "history": "Historique",
      "images": "Images",
      "location": "Emplacement",
      "medias": "Visuels",
      "provenance": "Provenance",
      "specifications": "Spécifications",
      "valuations": "Évaluations"
    },
    "tags": {
      "title": "Mots-clés"
    },
    "valuations": {
      "acquisitionDateLabel": "Date :",
      "acquisitionPrice": "Prix d'acquisition",
      "acquisitionSourceLabel": "Source :",
      "acquisitionTypeLabel": "Type :",
      "acquisitionUnknown": "Non renseigné",
      "current": "Valeur actuelle",
      "currentHint": "Valeur indicative.",
      "currentUnknown": "Non renseignée",
      "plusValue": "Plus-value",
      "plusValueHint": "Calcul : valeur – prix d'achat.",
      "plusValueNA": "N/A",
      "title": "Évaluations"
    },
    "value": {
      "acquiredOn": "Acquise le ",
      "noValue": "Non disponible",
      "premiumBadge": "Fonctionnalités avancées réservées aux comptes Premium",
      "title": "Valeur",
      "vsPurchase": " Calcul : valeur – prix d'achat."
    }
  },
  "importJournal": {
    "title": "Journal des imports",
    "subtitle": "Vos imports récents. Vous pouvez annuler un import (les œuvres créées seront supprimées).",
    "undo": "Annuler l'import",
    "undoing": "Annulation…",
    "undone": "{{n}} œuvre(s) supprimée(s).",
    "error": "Échec de l'annulation.",
    "confirm": "Annuler cet import et supprimer les {{n}} œuvre(s) créées ? Action irréversible.",
    "skipped": "ignorées",
    "col": { "file": "Fichier", "collection": "Collection", "date": "Date", "result": "Résultat", "status": "Statut" },
    "status": { "running": "En cours", "completed": "Terminé", "completed_with_errors": "Terminé (avec erreurs)", "cancelled": "Annulé" }
  },
  "concentration": {
    "eyebrow": "Analyse",
    "title": "Concentration de la collection",
    "subtitle": "Répartition de la valeur — repère patrimonial, pas un indice financier.",
    "top5": "Poids des 5 principales",
    "stale": "Sans valo. récente",
    "insured": "Assurées",
    "byArtist": "Par artiste (top 5)",
    "byMedium": "Par médium (top 5)",
    "confidence": "Confiance des valeurs",
    "confHigh": "élevée",
    "confMedium": "moyenne",
    "confLow": "faible"
  },
  "valuationHistory": {
    "eyebrow": "Traçabilité",
    "title": "Historique des valeurs",
    "add": "Ajouter une valeur",
    "cancel": "Annuler",
    "save": "Enregistrer la valeur",
    "saving": "Enregistrement…",
    "empty": "Aucune valeur enregistrée pour l'instant.",
    "showHistory": "Voir l'historique complet ({{n}})",
    "hideHistory": "Masquer l'historique complet",
    "type": {
      "acquisition": "Prix d'acquisition",
      "market_estimate": "Estimation de marché",
      "algorithmic": "Valeur algorithmique",
      "expert": "Valeur d'expertise",
      "retained": "Valeur retenue",
      "insurance": "Valeur d'assurance"
    },
    "field": {
      "type": "Nature", "min": "Montant min", "max": "Montant max", "retained": "Retenu",
      "currency": "Devise", "date": "Date", "source": "Source",
      "sourcePh": "facture, expert, Artprice…", "confidence": "Confiance"
    },
    "confidence": { "low": "Faible", "medium": "Moyenne", "high": "Élevée" },
    "col": { "date": "Date", "type": "Nature", "amount": "Montant", "source": "Source", "confidence": "Confiance" }
  },
  "aiDisclosure": {
    "type": {
      "generated": "Généré par IA",
      "extracted": "Extrait automatiquement · à vérifier",
      "suggested": "Suggestion IA",
      "assisted": "Assisté par IA",
      "simulation": "Simulation indicative · aucune décision automatique"
    },
    "status": { "reviewed": "Revu par l'utilisateur", "expertValidated": "Validé par un expert" },
    "confidence": "Confiance : {{n}} %",
    "learnMore": "En savoir plus sur l'IA chez ARTKIV"
  },
  "artworkEdit": {
    "artist": {
      "living": "vivant·e",
      "rank": "Artprice #{{n}}",
      "hint": "Suggestions du référentiel de côtes — saisie libre possible.",
      "linked": "Artiste référencé",
      "best": "plus haut"
    },
    "edit": {
      "cancel": "Annuler",
      "confidentialLocationBody": "La localisation précise de cette œuvre est confidentielle et n’est pas accessible avec vos droits actuels.",
      "confidentialLocationTitle": "Localisation confidentielle",
      "consentNote": "Ces données sont utilisées uniquement sous forme agrégée et anonymisée.",
      "consentText": "Autoriser l’inclusion de cette œuvre dans les statistiques et analyses agrégées Artkiv.",
      "consentTitle": "Utilisation dans les statistiques Artkiv",
      "editTitle": "Modifier « {{title}} »",
      "loadError": "Erreur lors du chargement de l’œuvre.",
      "loading": "Chargement de l’œuvre…",
      "noEditRights": "Vous n’avez pas les droits d’édition pour cette œuvre.",
      "notFound": "Œuvre introuvable ou accès non autorisé.",
      "save": "Enregistrer",
      "saveError": "Erreur lors de l’enregistrement de l’œuvre.",
      "saving": "Enregistrement…",
      "sharedNotice": "Vous modifiez une œuvre partagée selon les droits accordés par son propriétaire.",
      "tabDetails": "Détails",
      "tabDocuments": "Documents",
      "tabExpertise": "Expertise CUP",
      "tabLocation": "Localisation",
      "tabNft": "NFT / Blockchain",
      "tabProvenance": "Provenance & acquisition",
      "tabSpecifications": "Spécifications",
      "untitled": "Sans titre",
      "updated": "Œuvre mise à jour.",
      "imageUploadError": "Une erreur est survenue lors du téléversement des images.",
      "imageDeleteError": "Une erreur est survenue lors de la suppression de l’image.",
      "imagePrimaryError": "Impossible de définir l’image principale.",
      "saveErrorDetailed": "Erreur lors de l’enregistrement de l’œuvre. {{message}}",
      "noRowUpdated": "Aucune ligne n’a été modifiée. Vérifiez les droits d’édition de cette œuvre."
    },
    "detail": {
      "acquisition": "Détails d'acquisition",
      "acquisitionDate": "Date d'acquisition",
      "acquisitionPrice": "Prix d'acquisition",
      "acquisitionSource": "Source (galerie, maison de vente, artiste...)",
      "acquisitionType": "Type d'acquisition",
      "artist": "Artiste",
      "availability": "Disponibilité",
      "subject": "Sujet / thème",
      "subjectPlaceholder": "Portrait, paysage, abstraction...",
      "priceGallery": "Prix / galerie",
      "priceLow": "Fourchette basse",
      "priceHigh": "Fourchette haute",
      "salePriceGallery": "Prix de vente souhaité galerie",
      "salePriceGallerySlash": "Prix de vente souhaité / galerie",
      "expertValuation": "Valorisation expert",
      "valuationRange": "Fourchette",
      "galleryCap": "Borne haute galerie",
      "indicative": "indicatif",
      "publicForSale": "Afficher cette œuvre comme disponible à la vente / galerie",
      "priceGalleryHelp": "Champs distincts : fourchette de prix, prix de vente souhaité galerie et visibilité publique.",
      "currencyGalleryHelp": "Cette devise s'applique aux prix galerie : fourchette basse, fourchette haute et prix de vente souhaité.",
      "conditionSection": "État de l'œuvre",
      "condition": "État de conservation",
      "conditionLabel": "Condition",
      "conditionPlaceholder": "— Sélectionner —",
      "conditionNotes": "Notes sur l'état",
      "conditionNotesPlaceholder": "Description de l'état, mentions de restaurations, défauts, etc.",
      "conditionDecoteWarning": "Une décote sera appliquée automatiquement à la valorisation CUP.",
      "conditionFair": "Moyen (−20%)",
      "conditionVeryPoor": "Très moyen (−30%)",
      "conditionHeavilyDamaged": "Très abîmé restaurable (−50%)",
      "conditionPartiallyRestorable": "Partiellement restaurable (−65%)",
      "conditionIrreparable": "Irréparable — dépréciation totale",
      "currency": "Devise",
      "description": "Description",
      "descriptionPlaceholder": "Description de l'œuvre, contexte, exposition, etc.",
      "edition": "Edition / multiples (lithographie, photographie, sculpture...)",
      "inventoryNumber": "N° inventaire",
      "medium": "Techniques employées",
      "mediumCategory": "Medium",
      "mediumCategoryCeramics": "Céramique",
      "mediumCategoryDesign": "Design",
      "mediumCategoryDrawing": "Dessin",
      "mediumCategoryFilmVideo": "Film / Vidéo",
      "mediumCategoryInstallation": "Installation",
      "mediumCategoryMixedMedia": "Technique mixte",
      "mediumCategoryNft": "NFT / Art numérique",
      "mediumCategoryOther": "Autre",
      "mediumCategoryPainting": "Peinture",
      "mediumCategoryPhotography": "Photographie",
      "mediumCategoryPrints": "Gravure / Estampe",
      "mediumCategorySculpture": "Sculpture",
      "mediumCategoryTextile": "Textile / Tapisserie",
      "mediumCategoryWorkOnPaper": "Travail sur papier",
      "mediumPlaceholder": "Ex : Tirage argentique Ed. 1/3, Huile sur toile…",
      "noDescription": "Aucune description disponible.",
      "notSpecified": "Non spécifié",
      "notSpecifiedF": "Non spécifiée",
      "select": "Sélectionner",
      "signature": "Authentification",
      "statsTitle": "Participation aux statistiques anonymes",
      "tagsAdd": "Ajouter",
      "tagsAI": "Suggestions IA",
      "tagsApiSettings": "Paramètres API",
      "tagsClear": "Supprimer tous les mots-clés",
      "tagsCount": "/ 10 mots-clés utilisés",
      "tagsLocal": "Suggestions locales",
      "tagsManual": "Manuel",
      "tagsMode": "Mode :",
      "tagsPlaceholder": "Ajouter un mot-clé et appuyer sur Entrée",
      "tagsRemove": "Supprimer",
      "tagsTitle": "Mots-clés / tags",
      "titleLabel": "Titre de l'œuvre",
      "typeOfArt": "Type d'art",
      "valueLabel": "Valeur / estimation actuelle",
      "year": "Année",
      "yearHint": "Date estimée au 1er janvier — à préciser si vous disposez de la date exacte."
    },
    "yearModal": {
      "body": "Seule l'année est renseignée. En art contemporain, c'est souvent suffisant. Souhaitez-vous tout de même préciser le",
      "bodyEnd": "comme date de référence ?",
      "jan1": "1er janvier {{year}}",
      "confirm": "Préciser le {{date}}",
      "hint": "Vous pourrez toujours corriger cette date si vous disposez de l'information exacte.",
      "keepYear": "Garder l'année seule",
      "label": "Année de création"
    },
    "provenanceTab": {
      "entryEyebrow": "Acquisition & provenance",
      "entryTitle": "Entrée dans la collection",
      "entryHelp": "Renseignez les informations relatives à l’acquisition actuelle de l’œuvre. L’historique de propriété antérieur reste documenté séparément dans la provenance.",
      "historyEyebrow": "Historique",
      "historyTitle": "Provenance antérieure",
      "historyHelp": "Documentez les propriétaires, collections, ventes et transmissions antérieurs à l’entrée de l’œuvre dans votre collection.",
      "journeyEyebrow": "Parcours de l’œuvre",
      "journeyTitle": "Historique de provenance",
      "journeyHelp": "Retracez les propriétaires, collections, ventes et transmissions successifs de l’œuvre.",
      "addHistory": "Ajouter un élément de provenance",
      "emptyHistory": "Aucun historique de provenance antérieur n’est renseigné."
    },
    "acquisitionForm": {
      "type": "Type d’acquisition",
      "date": "Date d’acquisition",
      "sourceGeneric": "Source / vendeur",
      "sourcePlaceholder": "Galerie, maison de vente, artiste, collection privée…",
      "purchaseCurrency": "Devise d’acquisition",
      "price": "Prix d’acquisition",
      "pricePlaceholder": "Montant payé hors frais",
      "city": "Ville d’acquisition",
      "country": "Pays d’acquisition",
      "exchangeRate": "Taux de change vers l’euro",
      "priceEur": "Prix d’acquisition converti en EUR",
      "selectType": "— Sélectionner —",
      "typeGallery": "Galerie",
      "typeAuction": "Vente aux enchères",
      "typePrivate": "Vente privée",
      "typeArtist": "Achat direct auprès de l’artiste",
      "typeDonation": "Donation",
      "typeInheritance": "Succession / héritage",
      "typeExchange": "Échange",
      "typeCommission": "Commande",
      "typePurchase": "Achat",
      "typeOther": "Autre",
      "currencyEUR": "euro",
      "currencyUSD": "dollar américain",
      "currencyGBP": "livre sterling",
      "currencyCHF": "franc suisse",
      "currencyJPY": "yen japonais",
      "currencyCNY": "yuan chinois",
      "currencyHKD": "dollar de Hong Kong",
      "currency": {
        "EUR": "euro",
        "USD": "dollar américain",
        "GBP": "livre sterling",
        "CHF": "franc suisse",
        "JPY": "yen japonais",
        "CNY": "yuan chinois",
        "HKD": "dollar de Hong Kong"
      },
      "currencies": {
        "EUR": "euro",
        "USD": "dollar américain",
        "GBP": "livre sterling",
        "CHF": "franc suisse",
        "JPY": "yen japonais",
        "CNY": "yuan chinois",
        "HKD": "dollar de Hong Kong"
      },
      "currencyLabels": {
        "EUR": "euro",
        "USD": "dollar américain",
        "GBP": "livre sterling",
        "CHF": "franc suisse",
        "JPY": "yen japonais",
        "CNY": "yuan chinois",
        "HKD": "dollar de Hong Kong"
      },
      "currencyNames": {
        "EUR": "euro",
        "USD": "dollar américain",
        "GBP": "livre sterling",
        "CHF": "franc suisse",
        "JPY": "yen japonais",
        "CNY": "yuan chinois",
        "HKD": "dollar de Hong Kong"
      },
      "currencyOptions": {
        "EUR": "euro",
        "USD": "dollar américain",
        "GBP": "livre sterling",
        "CHF": "franc suisse",
        "JPY": "yen japonais",
        "CNY": "yuan chinois",
        "HKD": "dollar de Hong Kong"
      },
      "currencyLabelEUR": "euro",
      "currencyLabelUSD": "dollar américain",
      "currencyLabelGBP": "livre sterling",
      "currencyLabelCHF": "franc suisse",
      "currencyLabelJPY": "yen japonais",
      "currencyLabelCNY": "yuan chinois",
      "currencyLabelHKD": "dollar de Hong Kong",
      "currencyNameEUR": "euro",
      "currencyNameUSD": "dollar américain",
      "currencyNameGBP": "livre sterling",
      "currencyNameCHF": "franc suisse",
      "currencyNameJPY": "yen japonais",
      "currencyNameCNY": "yuan chinois",
      "currencyNameHKD": "dollar de Hong Kong",
      "currencyOptionEUR": "euro",
      "currencyOptionUSD": "dollar américain",
      "currencyOptionGBP": "livre sterling",
      "currencyOptionCHF": "franc suisse",
      "currencyOptionJPY": "yen japonais",
      "currencyOptionCNY": "yuan chinois",
      "currencyOptionHKD": "dollar de Hong Kong",
      "currencyHelp": "Cette devise s’applique uniquement au prix d’acquisition. Elle est distincte de la devise utilisée pour les prix galerie et de vente.",
      "exchangeRateHelp": "Indiquez le taux de conversion vers l’euro à la date d’acquisition lorsque la devise n’est pas l’EUR."
    }
  },
  "artworksDashboard": {
    "action": {
      "open": "Ouvrir →"
    },
    "addArtwork": "Ajouter une œuvre",
    "addFirstArtwork": "Ajouter ma première œuvre",
    "empty": "Aucune œuvre ne correspond à vos critères",
    "importPremiumTitle": "Importer des œuvres",
    "count": "{{count}} œuvre(s) trouvée(s)",
    "fallback": {
      "noTitle": "(Sans titre)"
    },
    "draftBadge": "Brouillon",
    "filter": {
      "allCollections": "Toutes les collections",
      "artist": "Artiste",
      "artistPlaceholder": "Rechercher un artiste",
      "collection": "Collection",
      "maxValue": "Valeur max (€)",
      "minValue": "Valeur min (€)",
      "tags": "Tags",
      "tagsPlaceholder": "tag1, tag2",
      "category": "Medium",
      "medium": "Techniques utilisées",
      "location": "Localisation",
      "inventory": "Inventaire",
      "inventoryPlaceholder": "Rechercher un numéro d’inventaire",
      "condition": "État",
      "conditionAll": "Tous les états",
      "conditionExcellent": "Excellent",
      "conditionGood": "Bon",
      "conditionFair": "Moyen",
      "conditionPoor": "Mauvais"
    },
    "importNeedCollection": "Pour importer vous devez d'abord sélectionner une collection.",
    "importPremium": "Importer CSV/XLSX",
    "importWithExpert": "Importer (avec expert)",
    "loading": "Chargement des œuvres...",
    "noResults": {
      "subtitle": "Modifiez les filtres ou ajoutez de nouvelles œuvres.",
      "title": "Aucune œuvre ne correspond à vos critères"
    },
    "sort": {
      "dateAsc": "Plus ancien",
      "dateDesc": "Plus récent",
      "label": "Trier par :",
      "titleAsc": "Titre A–Z",
      "titleDesc": "Titre Z–A",
      "inventoryAsc": "Inventaire A–Z",
      "valueAsc": "Valeur croissante",
      "valueDesc": "Valeur décroissante"
    },
    "table": {
      "actions": "Actions",
      "artist": "Artiste",
      "artwork": "Œuvre",
      "date": "Date",
      "type": "Type",
      "value": "Valeur"
    },
    "title": "Œuvres",
    "of": "–",
    "artworks": "œuvre(s)",
    "pagination": {
      "previous": "← Précédent",
      "next": "Suivant →",
      "page": "Page {{page}} / {{total}}"
    },
    "view": {
      "grid": "Vue grille",
      "label": "Affichage :",
      "list": "Vue liste",
      "mosaic": "Vue mosaïque"
    }
  },
  "beneficiaries": {
    "add": {
      "emailPlaceholder": "Email",
      "namePlaceholder": "Nom",
      "relationPlaceholder": "Relation (fils, fille, neveu, ami…)",
      "submit": "Ajouter",
      "title": "Ajouter un héritier"
    },
    "empty": "Vous n'avez pas encore ajouté d'héritiers à votre profil.",
    "remove": "Supprimer",
    "title": "Gestion des héritiers"
  },
  "beneficiary": {
    "permissions": {
      "full": "Gestion complète",
      "read": "Lecture seule",
      "title": "Permissions de {{name}}",
      "valuation": "Valorisation uniquement"
    }
  },
  "billing": {
    "alert": {
      "demoDisabled": "Cette fonctionnalité est désactivée sur les comptes de démonstration.\n\nPour accéder au vrai portail de facturation, veuillez créer un compte client réel.",
      "noSubscription": "Vous devez d'abord souscrire à un abonnement.",
      "portalOpenFailed": "Impossible d'ouvrir le portail : {{error}}"
    },
    "demo": {
      "badge": "PROFIL DÉMO",
      "bannerText": "Les fonctionnalités de paiement sont simulées",
      "bannerTitle": "Compte de démonstration",
      "noSub": {
        "button": "Voir les offres (démo)",
        "note": "💡 Note : Pour tester l'affichage d'un abonnement actif, contactez l'administrateur pour activer un abonnement simulé sur ce compte.",
        "text": "Ce compte de démonstration peut fonctionner sans abonnement actif. Toutes les fonctionnalités sont accessibles en mode test.",
        "title": "Compte de démonstration"
      },
      "pageTitle": "Facturation & Abonnement",
      "status": {
        "active": "Actif",
        "canceled": "Annulé",
        "none": "Aucun",
        "past_due": "Paiement en retard",
        "trialing": "Essai gratuit"
      },
      "withSub": {
        "aboutLink": "Créer un compte client",
        "aboutText": "Ce compte est en mode démonstration. Pour accéder aux vraies fonctionnalités de facturation et de paiement, créez un compte client réel.",
        "aboutTitle": "À propos du mode démo",
        "button": {
          "invoices": "Mes factures",
          "portalDisabled": "Ouvrir le portail (désactivé)",
          "seeOffers": "Voir les offres"
        },
        "explainer": "Sur un compte réel, vous pourriez depuis ce portail mettre à jour votre carte bancaire, consulter vos factures, changer de plan ou annuler votre abonnement.",
        "nextPayment": "Prochain paiement",
        "nextPaymentValue": "N/A (démo)",
        "note": "🎭 Mode démonstration : Cet abonnement est simulé. Aucun paiement réel n'est effectué sur ce compte. Les fonctionnalités de gestion de facturation sont désactivées.",
        "plan": "Plan",
        "price": "Prix mensuel",
        "priceValue": "29€ (simulé)"
      }
    },
    "portal": {
      "checking": "Vérification en cours...",
      "loginButton": "Se connecter",
      "requireLogin": "Connectez-vous pour accéder au portail de facturation.",
      "title": "Gérer l'abonnement"
    },
    "real": {
      "button": {
        "changePlan": "Changer d'offre",
        "invoices": "Mes factures",
        "portal": "Ouvrir le portail"
      },
      "explainer": "Depuis votre portail de facturation, vous pouvez mettre à jour votre carte bancaire, consulter vos factures, changer de plan ou annuler votre abonnement à tout moment.",
      "help": {
        "link": "Contacter le support",
        "text": "Pour toute question concernant votre abonnement ou votre facturation, notre équipe est à votre disposition.",
        "title": "Besoin d'aide ?"
      },
      "noSub": {
        "button": "Découvrir les offres",
        "text": "Vous n'avez pas encore d'abonnement. Choisissez une offre pour commencer à gérer votre collection d'art.",
        "title": "Aucun abonnement actif"
      },
      "pageTitle": "Facturation & Abonnement"
    },
    "status": {
      "active": "Abonnement actif",
      "canceled": "Abonnement annulé",
      "none": "Aucun abonnement",
      "past_due": "Paiement en retard",
      "trialing": "Essai gratuit en cours"
    }
  },
  "client": {
    "proposals": {
      "operational": {
        "title": "Exposition, prêt & donation",
        "desc": "Suivez les demandes envoyées aux institutions pour vos œuvres."
      },
      "alert": {
        "cancellationError": "Impossible d'envoyer la demande.",
        "cancellationRequested": "Demande d'annulation envoyée à l'expert.",
        "deleted": "Proposition supprimée.",
        "deleteError": "Échec de la suppression."
      },
      "artwork": {
        "unknownArtist": "Artiste inconnu"
      },
      "button": {
        "cancel": "Annuler"
      },
      "chip": {
        "blockchain": "Preuve d'authenticité",
        "proposals": "Propositions institutions",
        "vision": "IA Vision"
      },
      "column": {
        "action": "Action",
        "artwork": "Œuvre",
        "date": "Date",
        "institution": "Institution",
        "type": "Type"
      },
      "confirm": {
        "delete": "Voulez-vous supprimer cette proposition ?",
        "requestCancellation": "Souhaitez-vous demander l'annulation de cette proposition ?"
      },
      "empty": {
        "desc": "Quand vous proposerez une œuvre à une institution, vos demandes apparaîtront ici.",
        "title": "Aucune demande pour l'instant"
      },
      "error": {
        "fetch": "Erreur lors du chargement des propositions : {{error}}"
      },
      "explainer": "Ici, vous suivez les œuvres proposées à une institution (musée, fondation, entreprise) pour exposition, acquisition, donation ou dation.",
      "help": {
        "point1": "Vous proposez une œuvre à une institution: exposition, achat, donation ou dation.",
        "point2": "On garde une trace des échanges et du statut (en attente, payé, annulation demandée).",
        "point3": "Vous pouvez annuler une demande en attente, ou demander l'annulation si elle est déjà payée.",
        "title": "À quoi servent ces 'Propositions' ?"
      },
      "learnMore": "En savoir plus",
      "loading": "Chargement des propositions en cours...",
      "title": "Tableau des propositions",
      "type": {
        "auction": "Vente",
        "institution": "Institution"
      },
      "value": {
        "blockchain": "Cette preuve renforce la traçabilité et l'authenticité de vos enregistrements.",
        "desc": "Avec Artkiv, vos œuvres ne sont pas seulement répertoriées : elles sont analysées, vérifiées et prêtes pour des actions concrètes — exposition, vente, don ou transmission.",
        "proposals": "Suivez les opportunités d'exposition, d'acquisition, de donation, de dation ou de dépôt longue durée.",
        "title": "Plus qu'un inventaire.",
        "vision": "L'IA aide à repérer les infos manquantes, vérifier les documents et préparer vos dossiers."
      }
    }
  },
  "collectionDetail": {
    "alt": {
      "image": "Image de la collection"
    },
    "back": "Retour",
    "backToCollections": "Retour aux collections",
    "button": {
      "delete": "Supprimer",
      "edit": "Modifier",
      "export": "Exporter",
      "generateForThis": "Générer pour cette collection",
      "generateReport": "Générer un rapport",
      "seeReports": "Voir mes rapports",
      "shareAccess": "Partager l'accès"
    },
    "details": {
      "createdAt": "Créée le",
      "dateUnknown": "Date inconnue",
      "description": "Description",
      "owner": "Propriétaire",
      "ownerUnknown": "Propriétaire inconnu"
    },
    "loading": "Chargement de la collection...",
    "noBio": "Aucune biographie disponible pour cet artiste.",
    "noDescription": "Pas de description fournie.",
    "notFound": {
      "back": "← Retour aux collections",
      "id": "ID de la collection"
    },
    "section": {
      "about": "À propos",
      "artworks": "Œuvres",
      "details": "Détails",
      "reports": "Rapports",
      "servicesCuratorial": "Services curatoriaux",
      "summary": "Résumé"
    },
    "servicesCuratorial": {
      "description": "Accédez aux services curatoriaux associés : lecture curatoriale, cohérence d'ensemble, prêts institutionnels, dossiers d'exposition et accompagnement sur mesure.",
      "open": "Ouvrir le service curatoriel"
    },
    "shared": "Partagée avec vous",
    "summary": {
      "count": "Nombre d'œuvres",
      "estimatedValue": "Valeur estimée",
      "purchasePrice": "Prix d'achat"
    }
  },
  "collectionEdit": {
    "action": {
      "addArtwork": "Ajouter une œuvre",
      "create": "Créer",
      "delete": "Supprimer",
      "save": "Enregistrer"
    },
    "alt": {
      "preview": "Aperçu de l'image"
    },
    "artwork": {
      "dimensions": "Dimensions",
      "label": "Œuvre",
      "manage": "Gérer l'œuvre",
      "medium": "Technique",
      "new": "Nouvelle",
      "saveFirst": "Enregistrez d'abord la collection",
      "title": "Titre",
      "year": "Année"
    },
    "cancel": "Annuler",
    "empty": {
      "artworks": "Aucune œuvre dans cette collection."
    },
    "error": {
      "auth": "Vous devez être connecté pour effectuer cette action.",
      "deleteArtwork": "Erreur lors de la suppression de l'œuvre.",
      "load": "Erreur lors du chargement de la collection.",
      "save": "Erreur lors de l'enregistrement.",
      "upload": "Erreur lors de l'envoi de l'image."
    },
    "field": {
      "addImage": "Ajouter une image",
      "changeImage": "Changer l'image",
      "comments": "Commentaires",
      "curator": "Artiste / Curateur",
      "description": "Description",
      "image": "Image de la collection",
      "title": "Titre de la collection"
    },
    "page": {
      "create": "Créer une collection",
      "edit": "Modifier la collection"
    },
    "saving": "Enregistrement…",
    "section": {
      "artworks": "Œuvres de la collection",
      "general": "Informations générales"
    }
  },
  "collectionsListSidebar": {
    "title": "Actions",
    "createCollection": { "desc": "Ajouter une nouvelle collection à votre patrimoine." },
    "importZip": { "desc": "Importer plusieurs œuvres à la fois depuis un dossier ZIP (photos, factures)." },
    "createReport": { "desc": "Générer un rapport (inventaire, valorisation, assurance, état de conservation…) — chaque type couvre un aspect différent, combinez-les pour une vue complète. Par lots de moins de 50 œuvres pour un PDF fiable." },
    "reports": { "desc": "Consulter les rapports déjà générés précédemment." },
    "exportAll": { "desc": "Données uniquement (CSV), sans les photos. Pour les images, utilisez « Créer un rapport »." }
  },
  "collectionsList": {
    "artworkCount": "{{count}} œuvre(s)",
    "createCollection": "Créer une collection",
    "createFirst": "Créer ma première collection",
    "createReport": "Créer un rapport",
    "defaultTitle": "À classer",
    "deleteCollection": "Supprimer cette collection",
    "exportAll": "Exporter (toutes)",
    "filter": "Filtrer",
    "noneSubtitle": "Commencez par créer votre première collection pour organiser vos œuvres d'art.",
    "noneTitle": "Aucune collection disponible",
    "reports": "Rapports",
    "title": "Toutes les collections",
    "viewCollection": "Voir la collection",
    "importZip": "Importer un dossier ZIP",
    "editCollection": "Modifier",
    "downloadReport": "↓ Rapport PDF",
    "sharedBadge": "Partagé",
    "accessEdit": "Modification",
    "accessView": "Lecture",
    "noTypeTitle": "Aucune collection de ce type",
    "noTypeSubtitle": "Vous n'avez pas encore de collection avec ce statut. Revenez à « Toutes » pour voir l'ensemble de vos collections.",
    "showAll": "Voir toutes les collections",
    "collectionCount_one": "{{count}} collection",
    "collectionCount_other": "{{count}} collections",
    "stats": {
      "patrimonialValue": "Patrimoine artistique",
      "foundationValue": "Valeur propriété propre",
      "excludeDeposits": "hors dépôts",
      "excludeLoans": "hors prêts et dépôts",
      "totalArtworks": "Œuvres totales",
      "inalienable": "Inaliénables",
      "foundationOwned": "Propriété propre",
      "inalienableSubtitle": "régime protégé",
      "foundationOwnedSubtitle": "acquis par la fondation",
      "deposit": "En dépôt",
      "foundationLoans": "Prêts et dépôts",
      "nonPatrimonial": "non patrimoniales"
    },
    "tabs": {
      "all": "Toutes",
      "private": "Privée",
      "inalienable": "Inaliénables",
      "deposit": "Dépôt",
      "foundationOwned": "Propriété propre",
      "foundationFounder": "Prêt fondateur",
      "foundationDonation": "Donations / legs",
      "foundationDeposit": "Dépôts institution"
    }
  },
  "common": {
    "accept": "Accepter",
    "close": "Fermer",
    "comingSoon": "Bientôt",
    "error": {
      "fallback": "Un souci d'affichage, rechargez la page"
    },
    "hide": "Masquer",
    "loading": {
      "fallback": "On prépare l'affichage",
      "safe": "Chargement en cours…"
    },
    "okUnderstood": "OK, compris",
    "refresh": "Rafraîchir",
    "reject": "Refuser",
    "revoke": "Révoquer",
    "share": "Partager",
    "unknown": "Inconnu",
    "untitled": "Sans titre",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "back": "Retour",
    "notSpecified": "Non renseigné"
  },
  "comparePlans": {
    "cat": {
      "ai": "Intelligence artificielle",
      "collection": "Gestion de collection",
      "integrations": "Intégrations & API",
      "multiClient": "Multi-clients & professionnel",
      "reporting": "Reporting & exports",
      "support": "Support & services"
    },
    "cta": {
      "details": "Voir le détail des abonnements",
      "expert": "Parler à un expert Artkiv",
      "subtitle": "Nous pouvons vous aider à structurer votre besoin, que vous soyez collectionneur privé, conseiller, galerie ou family office.",
      "title": "Vous hésitez entre plusieurs plans ?"
    },
    "faq": {
      "a1": "Oui, à tout moment. Le prorata est automatiquement calculé et appliqué dès le changement d'abonnement.",
      "a2": "Non. Le prix affiché est le prix final, aucun frais supplémentaire n'est ajouté en dehors de votre abonnement.",
      "a3": "Oui, le plan Standard offre 14 jours d'essai gratuit. Pour les plans professionnels, contactez-nous pour une démo personnalisée.",
      "a4": "Absolument. Vos données sont chiffrées, hébergées en Europe, conformes RGPD, et ne sont jamais revendues à des tiers.",
      "q1": "Puis-je upgrader ou downgrader mon plan ?",
      "q2": "Y a-t-il des frais cachés ?",
      "q3": "Puis-je essayer avant de m'engager ?",
      "q4": "Mes données sont-elles sécurisées ?",
      "title": "Questions fréquentes"
    },
    "features": {
      "ai": {
        "conservation": "Recommandations conservation",
        "inheritanceMatching": "Matching successoral",
        "mediaWatch": "Veille média & marché",
        "visualAnalysis": "Analyse visuelle IA"
      },
      "collection": {
        "artistsLocations": "Gestion artistes & localisation",
        "artworks": "Nombre d'œuvres",
        "photosMultiple": "Photos multiples par œuvre",
        "provenance": "Historique & provenance"
      },
      "integrations": {
        "api": "API REST",
        "erp": "Intégration ERP / PMS",
        "sso": "SSO / SAML",
        "webhooks": "Webhooks"
      },
      "multiClient": {
        "clientInvites": "Gestion des invitations clients",
        "coBrandedReports": "Rapports co-marqués",
        "collectionsCount": "Nombre de collections gérées",
        "multiPortfolio": "Interface multi-portefeuilles"
      },
      "reporting": {
        "accountingExports": "Exports comptabilité",
        "customDashboards": "Tableaux de bord personnalisés",
        "pdfExports": "Exports PDF standards",
        "taxReports": "Rapports fiscaux"
      },
      "support": {
        "accountManager": "Account Manager dédié",
        "email": "Support email (temps de réponse max)",
        "sla": "SLA garanti",
        "training": "Formation incluse"
      }
    },
    "plan": {
      "foundation": {
        "name": "Foundation",
        "target": "Institutions & fondations culturelles",
        "price": "Sur devis",
        "contact": "Nous contacter"
      },
      "artAdvisor": {
        "name": "Art Advisor",
        "target": "Professionnels (5 clients max)"
      },
      "artAdvisorPremium": {
        "name": "Art Advisor Premium",
        "target": "Professionnels (clients illimités)"
      },
      "familyOffice": {
        "name": "Family Office",
        "target": "Institutions et family offices"
      },
      "premium": {
        "name": "Premium",
        "target": "Collectionneurs avancés"
      },
      "standard": {
        "name": "Standard",
        "target": "Collectionneurs individuels"
      }
    },
    "showAll": "Afficher toutes les fonctionnalités",
    "subtitle": "Choisissez le plan adapté à votre collection, à votre activité professionnelle ou à votre family office.",
    "title": "Comparer les abonnements Artkiv",
    "value": {
      "advanced": "Avancé",
      "basic": "Basic",
      "custom": "Sur-mesure",
      "france": "France",
      "france_ch": "France + CH",
      "limited": "Limité",
      "multiCountry": "Multi-pays",
      "session1": "1 session",
      "session2": "2 sessions",
      "unlimited": "Illimité",
      "videos": "Vidéos"
    }
  },
  "consentIA": {
    "checkboxLabel": "Je choisis d’activer les fonctionnalités IA d’Artkiv décrites ci-dessus et j’accepte le traitement nécessaire des données de mes œuvres pour les fournir.",
    "description": "Les fonctionnalités IA d’Artkiv sont des outils d’assistance. Elles peuvent analyser les informations que vous leur soumettez afin de proposer des enrichissements, des observations ou des estimations. Vous gardez la décision finale.",
    "error": {
      "load": "Impossible de charger l’état de votre consentement IA.",
      "save": "Impossible de sauvegarder votre consentement sur le serveur."
    },
    "loading": "Chargement du consentement…",
    "saving": "Enregistrement du consentement…",
    "success": {
      "enabled": "Fonctionnalités IA activées.",
      "disabled": "Fonctionnalités IA désactivées."
    },
    "signedAt": "Activation enregistrée le {{date}}.",
    "previousConsent": "Dernier accord enregistré le {{date}}. L’IA est actuellement désactivée.",
    "controlHint": "Vous pouvez retirer votre accord à tout moment depuis ce réglage. Le retrait désactive les fonctions IA pour les traitements futurs.",
    "detailsToggle": "Voir le détail des traitements",
    "withoutAI": "Sans activation, vous pouvez continuer à gérer manuellement votre collection ; les fonctions nécessitant l’IA restent indisponibles.",
    "purposes": {
      "title": "Ce que les modules IA peuvent faire",
      "visual": {
        "title": "Analyse visuelle",
        "body": "Analyser les images d’une œuvre pour proposer des éléments de classification, de style ou de description."
      },
      "documents": {
        "title": "Documents & OCR",
        "body": "Lire une facture, un certificat ou un autre document et proposer des informations à reporter dans la fiche."
      },
      "conservation": {
        "title": "Conservation",
        "body": "Aider à repérer et structurer des observations utiles au suivi de l’état de l’œuvre à partir des éléments fournis."
      },
      "valuation": {
        "title": "Valorisation",
        "body": "Aider à produire des indications de valeur à partir des données disponibles, des comparables et des informations de marché utilisées par ARTKIV."
      }
    },
    "data": {
      "title": "Données susceptibles d’être traitées",
      "body": "Selon le module utilisé : images de l’œuvre, documents et texte extrait, métadonnées de la fiche, informations de conservation, données de valorisation et comparables que vous fournissez à ARTKIV."
    },
    "guardrails": {
      "title": "Ce que l’IA ne décide pas à votre place",
      "suggestions": "Les résultats IA sont des suggestions ou des indications : ils ne constituent pas, à eux seuls, une conclusion définitive.",
      "noAuthentication": "L’analyse IA ne vaut pas authentification ni certification d’une œuvre.",
      "humanValidation": "Les informations proposées par OCR ou IA doivent pouvoir être vérifiées, corrigées, acceptées ou ignorées avant d’alimenter les données métier sensibles.",
      "professional": "Les analyses IA ne remplacent pas l’intervention d’un expert, restaurateur, assureur, notaire ou autre professionnel lorsque son avis est requis."
    },
    "access": {
      "standard": {
        "title": "Fonctionnalités IA indisponibles avec votre offre actuelle",
        "body": "Votre collection reste entièrement gérable sans IA. Les modules Vision et les traitements IA nécessitent une offre qui les inclut ; ce réglage ne peut pas les activer à lui seul."
      },
      "waitingConsent": {
        "title": "Accord requis avant toute analyse IA",
        "body": "Votre offre donne accès aux fonctionnalités IA, mais elles restent désactivées tant que vous ne les activez pas explicitement. Aucune œuvre ne doit être analysée par ces modules sans cet accord."
      },
      "enabled": {
        "title": "Fonctionnalités IA activées",
        "body": "Votre accord autorise le traitement nécessaire lorsque vous utilisez une fonctionnalité IA. Il ne signifie pas que toutes vos œuvres sont analysées automatiquement."
      },
      "viewPlans": "Voir les offres incluant l’IA →",
      "upgradeRequired": "Votre offre actuelle ne permet pas d’activer les fonctionnalités IA."
    },
    "scope": {
      "title": "Deux choix distincts",
      "account": "Ce réglage concerne l’utilisation des fonctions IA au niveau de votre compte. Il est enregistré dans votre profil et peut être retiré à tout moment.",
      "artworkOptIn": "L’inclusion d’une œuvre dans les statistiques et analyses agrégées anonymisées Artkiv reste un choix séparé, géré sur la fiche de l’œuvre. Activer l’IA ne l’active jamais automatiquement."
    },
    "moreInfo": {
      "text": "Finalités détaillées, fonctionnement, données, prestataires et droits :",
      "link": "Consulter l’information complète sur l’IA"
    },
    "title": "Fonctionnalités IA & consentement"
  },
  "contact": {
    "back": "Retour",
    "familyOffice": {
      "next": {
        "title": "Ce qui se passe ensuite"
      }
    },
    "form": {
      "clientCount": "Nombre de clients/collections gérés",
      "company": "Nom de l'entreprise",
      "email": "Email professionnel",
      "employees": "Collaborateurs utilisant la plateforme",
      "firstname": "Prénom",
      "lastname": "Nom",
      "location": "Localisation",
      "message": "Message",
      "phone": "Téléphone"
    },
    "sent": {
      "back": "Retour à l'accueil",
      "text": "Merci pour votre demande. Notre équipe vous contactera sous 24h.",
      "title": "Message envoyé !"
    },
    "submit": {
      "demo": "Demander une démo",
      "quote": "Demander un devis",
      "send": "Envoyer",
      "sending": "Envoi en cours..."
    }
  },
  "contacts": {
    "action": {
      "manageAccess": "Gérer les accès",
      "remove": "Retirer",
      "share": "Partager"
    },
    "add": {
      "advisor": {
        "browse": "Parcourir le répertoire",
        "desc": "Partagez votre collection avec votre conseiller artistique",
        "title": "Inviter un conseiller de votre réseau"
      },
      "button": "Ajouter",
      "expert": {
        "browse": "Parcourir le répertoire",
        "desc": "Référencez vos experts en évaluation, restauration ou authentification",
        "title": "Ajouter un expert"
      },
      "insurer": {
        "browse": "Voir les partenaires",
        "desc": "Enregistrez vos contacts en assurance d'œuvres d'art",
        "title": "Ajouter un assureur"
      },
      "satellite": "Ajouter en satellite"
    },
    "advisors": {
      "active": {
        "title": "Conseillers artistiques"
      },
      "confirmed": {
        "separator": "Conseillers confirmés"
      },
      "declined": {
        "title": "Invitations refusées"
      },
      "pendingInvites": {
        "title": "Invitations en attente"
      },
      "pendingShare": {
        "title": "En attente de partage"
      }
    },
    "alert": {
      "accessRevoked": "Accès révoqué ✅",
      "advisorAdded": "Conseiller ajouté avec succès ! Vous pourrez maintenant le sélectionner quand vous partagerez votre collection.",
      "advisorEmailRequired": "L'email du conseiller est obligatoire",
      "deleteError": "Erreur lors de la suppression",
      "expertAdded": "Expert ajouté avec succès !",
      "expertRevoked": "Expert révoqué ✅",
      "insurerAdded": "Assureur ajouté avec succès !",
      "insurerRevoked": "Assureur révoqué ✅",
      "invitationDeleted": "Invitation supprimée",
      "missingId": "Impossible de révoquer : identifiant manquant.",
      "satelliteInviteSent": "Invitation satellite envoyée ✅"
    },
    "anonymous": "Anonyme",
    "delete": {
      "confirm": "Êtes-vous sûr de vouloir supprimer cette invitation ?",
      "error": "Erreur lors de la suppression",
      "invitation": "Supprimer l'invitation",
      "success": "Invitation supprimée avec succès"
    },
    "empty": {
      "advisors": {
        "helper": "Invitez un expert pour commencer à structurer votre collection."
      },
      "experts": "Aucun expert référencé",
      "insurers": "Aucun assureur enregistré"
    },
    "invite": {
      "declined": "Invitation refusée",
      "pending": {
        "helper": "En attente d'acceptation de l'expert."
      }
    },
    "list": {
      "advisors": "Conseillers artistiques",
      "experts": "Experts",
      "insurers": "Assureurs"
    },
    "loading": "Chargement de vos contacts...",
    "pendingShare": {
      "cta": "Partager maintenant",
      "helper": "Ils ont accepté votre invitation. Il ne manque plus que le partage de collection.",
      "subtitle": "Ces experts sont prêts à commencer",
      "title": "En attente de partage"
    },
    "satelliteDrawer": {
      "title": "Collaborateur satellite"
    },
    "serviceRequest": {
      "sent": "Demande de conseil artistique envoyée.",
      "status": {
        "active": "Mission en cours",
        "waiting": "En attente d'accès"
      },
      "waitingAccess": "L'expert attend l'accès à vos collections pour démarrer."
    },
    "sharedSince": "Partage depuis le",
    "stats": {
      "advisors": "Conseillers",
      "experts": "Experts",
      "insurers": "Assureurs",
      "total": "Tous les contacts"
    },
    "subtitle": "Gérez vos conseillers, experts et assureurs. Ces contacts restent strictement personnels et confidentiels.",
    "title": "Carnet d'adresses",
    "type": {
      "advisor": "Conseiller",
      "expert": "Expert",
      "insurer": "Assureur"
    },
    "viewAll": "Voir tout"
  },
  "cta": {
    "back": {
      "dashboard": "Retour au tableau de bord"
    },
    "invite": {
      "expert": "Inviter un expert"
    },
    "share": {
      "collection": "Partager ma collection"
    }
  },
  "dashboard": {
    "access": {
      "ctaOpen": "Gérer les accès",
      "desc": "Invitez vos collaborateurs, suivez les accès et partagez des œuvres avec vos experts, au même endroit.",
      "drawerTitle": "Accès & collaboration",
      "hint": "Partagez vos œuvres avec qui vous voulez, quand vous voulez.",
      "mobileSummary": "Voir / gérer",
      "tap": "Toucher pour ouvrir",
      "title": "Accès & collaboration",
      "ctaFindExpert": "Trouver un expert",
      "ctaShareAccess": "Partager l’accès",
      "ctaManage": "Gérer",
      "freeConnection": {
        "title": "✓ Mise en relation gratuite (incluse)",
        "description": "La mise en relation avec un conseiller personnel Artkiv est 100 % gratuite.",
        "paidLabel": "Missions payantes :",
        "paidText": "prix affiché, sans frais supplémentaires (ex. : estimation à 149 € → vous payez 149 € HT)."
      }
    },
    "actions": {
      "title": "Actions",
      "subtitle": "Protégez, faites expertiser, partagez et préparez la suite pour vos œuvres.",
      "protect": "Protéger",
      "assess": "Expertiser",
      "certify": "Certifier",
      "opportunities": "Opportunités institutionnelles",
      "expertise": {
        "title": "Expertise & estimation",
        "desc": "Trouvez un professionnel pour expertiser, estimer ou obtenir un avis spécialisé sur une œuvre."
      },
      "authenticity": {
        "title": "Authenticité — soumettre un dossier",
        "desc": "Soumettez l’œuvre et ses pièces justificatives pour un examen humain par un expert compétent.",
        "note": "La soumission du dossier ne constitue pas, à elle seule, un certificat d’authenticité.",
        "cta": "Soumettre un dossier"
      },
      "fingerprint": {
        "title": "Empreinte numérique",
        "desc": "Créez une empreinte SHA-256 datée de la fiche œuvre afin de vérifier l’intégrité des données enregistrées.",
        "note": "Phase actuelle : empreinte ARTKIV. L’ancrage public sur Tezos n’est pas encore actif.",
        "cta": "Voir l’empreinte numérique"
      },
      "future": "Préparer l’avenir",
      "succession": {
        "title": "Transmission & succession",
        "desc": "Préparez les bénéficiaires, les situations de propriété et des scénarios privés pour l’avenir de votre collection.",
        "note": "ARTKIV fournit un cadre de préparation et de simulation, pas un conseil juridique ou fiscal.",
        "cta": "Préparer ma transmission"
      }
    },
    "addArtwork": "Ajouter une œuvre",
    "buy": "Achat",
    "confidenceIndex": {
      "high": "Élevé",
      "label": "Indice de confiance",
      "low": "Faible",
      "medium": "Moyen",
      "tooltip": "Indice calculé selon les informations renseignées : artiste, année, médium, prix d'achat et visuel."
    },
    "contacts": {
      "sub": "Carnet d'adresses"
    },
    "cta": {
      "addFirst": "Ajouter ma première œuvre"
    },
    "details": "Voir détails",
    "empty": {
      "subtitle": "Ajoutez votre première œuvre pour commencer à structurer votre collection.",
      "title": "Aucune œuvre pour le moment"
    },
    "emptyShared": {
      "cta": "Gérer les accès",
      "ctaPrimary": "Partager l'accès",
      "ctaSecondary": "Trouver un expert",
      "desc": "Invitez un expert ou un conseiller, ou demandez à un proche de vous donner accès à sa collection.",
      "hint": "Vous gardez le contrôle : lecture seule ou édition, à tout moment.",
      "title": "Pas encore de collection partagée"
    },
    "emptyWorks": {
      "cta": "Ajouter une œuvre",
      "ctaPrimary": "Ajouter ma première œuvre",
      "ctaSecondary": "Suivre des galeries",
      "desc": "Ajoutez une première œuvre (photo + infos) et Artkiv pourra suivre sa valeur, ses documents et vos prochaines alertes.",
      "hint": "Astuce : une œuvre = une photo + un titre + un artiste. Le reste peut venir plus tard.",
      "title": "Votre collection commence ici ✨"
    },
    "error": {
      "reload": "Recharger la page",
      "title": "Erreur de chargement"
    },
    "estimate": {
      "sub": "Faire évaluer",
      "value": "Estimation"
    },
    "forSale": "En vente",
    "galleries": "Galeries",
    "insurance": {
      "sub": "Protéger",
      "summary": {
        "answered": "Réponse reçue",
        "ctaFollow": "Suivre",
        "ctaNew": "Assurer une œuvre",
        "desc": "Protégez vos œuvres et suivez les propositions en cours, dans la durée.",
        "latestStatus": "Dernier statut",
        "pending": "En cours",
        "seen": "Consulté",
        "title": "Assurance",
        "total": "Total"
      }
    },
    "loading": {
      "auth": "Vérification de votre session...",
      "collection": "Chargement de votre collection..."
    },
    "manageCollections": "Gérer mes collections",
    "marketplace": {
      "empty": "Aucune œuvre en vente pour le moment.",
      "loading": "Chargement des œuvres en vente..."
    },
    "news": {
      "subtitle": "Suivez les actualités des artistes de votre collection",
      "tabs": {
        "alerts": "Mes alertes",
        "fairs": "Foires d'art",
        "sales": "Ventes & Records",
        "artists": "Artistes & foires",
        "galleries": "Galeries"
      },
      "grouped": {
        "title": "Mes actualités",
        "subtitle": "Suivez les artistes de votre collection, les foires d’art et vos galeries préférées"
      },
      "switchToGalleries": "Voir les galeries",
      "switchToArtists": "Voir les artistes",
      "stats": {
        "artists": "Artistes suivis",
        "galleries": "Galeries",
        "fairs": "Foires à venir",
        "alerts": "Alertes actives"
      }
    },
    "noSharedCollections": "Aucune collection partagée pour le moment",
    "notAvailable": "Non disponible",
    "noWorks": "Votre collection est vide pour l'instant",
    "plusValue": "Plus-value",
    "proposals": {
      "title": "Vos démarches",
      "subtitle": "Suivez vos démarches liées à vos œuvres, avec une vue claire pour aujourd'hui et pour la transmission."
    },
    "propose": {
      "sub": "Musée / Vente"
    },
    "purchase": "Prix d'achat",
    "purchaseMissingCta": "Ajouter le prix d'achat",
    "purchaseMissingReadonly": "Prix d'achat non renseigné",
    "putForSale": "Mettre en vente",
    "share": {
      "sub": "Inviter un conseiller"
    },
    "shareAccess": "Partager l'accès",
    "shared": {
      "title": "Collections partagées avec moi"
    },
    "sharedByMe": {
      "access": {
        "edit": "Édition",
        "view": "Lecture"
      },
      "accessLabel": "Accès: {{access}}",
      "collectionsCount": "{{count}} collection(s) concernée(s)",
      "cta": {
        "editAccess": "Modifier",
        "manage": "Gérer les accès",
        "refresh": "Actualiser"
      },
      "empty": {
        "cta": "Partager un accès",
        "desc": "Invite un conseiller, un expert ou un assureur et choisis exactement ce qu'ils peuvent voir.",
        "title": "Aucun accès partagé (pour l'instant)."
      },
      "hint": "Astuce: chaque accès laisse une trace (utile pour le suivi et la sécurité).",
      "loading": "On prépare la liste…",
      "stats": {
        "people": "{{count}} personne(s)",
        "shares": "{{count}} partage(s)"
      },
      "subtitle": "Ici, tu vois qui a accès à ta collection. Simple, traçable, et clean.",
      "title": "Ton cercle privé",
      "withYou": "a accès chez toi"
    },
    "sharedCollections": "Collections partagées",
    "sincePurchase": "depuis l'achat",
    "stats": {
      "sub": "Analyser"
    },
    "subtitle": "Gérez et valorisez votre patrimoine artistique",
    "title": "Votre Carnet de vie",
    "totalEstimate": "Valeur estimée actuelle",
    "totalPurchase": "Valeur d'achat totale",
    "ungrouped": "Œuvres non rattachées",
    "viewDetails": "Voir la fiche",
    "works": "Mes œuvres",
    "errors": {
      "module": "Une erreur s’est produite dans ce module.",
      "delegatedMissing": "Accès délégué introuvable ou expiré.",
      "delegatedForbidden": "Vous n’avez plus les droits de visualisation.",
      "collectionsLoad": "Erreur lors du chargement des collections.",
      "sharedCollectionsLoad": "Erreur lors du chargement des collections partagées."
    },
    "navigation": {
      "overview": "Vue d’ensemble",
      "overviewHint": "Où en est ma collection ?",
      "contactsAccess": "Contacts & accès",
      "contactsAccessHint": "Avec qui je travaille et qui voit quoi ?",
      "collection": "Mes œuvres",
      "collectionHint": "Qu’est-ce que je possède ?",
      "sharing": "Partages",
      "marketNews": "Marché & actualités",
      "marketNewsHint": "Que se passe-t-il autour de mes artistes et du marché ?",
      "proposals": "Propositions",
      "actions": "Actions",
      "actionsHint": "Que puis-je faire de mes œuvres ?"
    },
    "collectionSummary": {
      "summary": "Résumé de votre collection",
      "artworks": "œuvres",
      "collections": "collections",
      "note": "Pour garder un tableau de bord lisible, l’affichage complet se trouve dans « Collections » (menu).",
      "ctaAdd": "Ajouter une œuvre"
    },
    "breakdown": {
      "title": "Positionnement de la collection",
      "subtitle": "Répartition par médium, type, période et lieu",
      "hide": "Masquer",
      "show": "Analyser ma collection"
    },
    "losses": {
      "title": "Pertes & vols",
      "description": "Déclarez une œuvre disparue, volée ou détruite pour votre suivi fiscal et assurantiel.",
      "cta": "Voir le registre"
    }
  },
  "authenticityRequest": {
    "eyebrow": "Authenticité",
    "title": "Soumettre un dossier d’authenticité",
    "intro": "Rassemblez les informations et documents utiles à l’examen de l’œuvre. Le dossier pourra ensuite être orienté vers un expert compétent.",
    "notice": "ARTKIV organise et transmet le dossier. La soumission ne vaut pas certificat : seul un expert habilité peut rendre un avis ou émettre un document d’authenticité.",
    "artwork": {
      "label": "Œuvre concernée",
      "placeholder": "Choisir une œuvre…",
      "empty": "Ajoutez d’abord l’œuvre à votre collection avant de constituer son dossier.",
      "add": "Ajouter une œuvre",
      "existingCertificate": "Un certificat est déjà signalé sur cette fiche."
    },
    "provenance": {
      "label": "Contexte & provenance",
      "help": "Indiquez ce que vous savez : origine de l’acquisition, galerie, maison de vente, artiste, famille, exposition, publication ou historique connu.",
      "placeholder": "Ex. : acquise auprès de la galerie…, facture datée du…, provenance familiale depuis…"
    },
    "documents": {
      "label": "Pièces du dossier",
      "help": "Ajoutez les éléments disponibles : facture, certificat existant, photo recto/verso, signature, inscriptions, étiquettes, provenance, publication ou rapport antérieur.",
      "cta": "Ajouter des documents"
    },
    "notes": {
      "label": "Votre demande",
      "placeholder": "Précisez votre question, un doute particulier ou le contexte de la demande."
    },
    "declaration": "Je confirme que les informations transmises sont exactes à ma connaissance et que je suis autorisé(e) à soumettre ces documents à l’examen.",
    "submit": "Soumettre le dossier",
    "submitting": "Envoi du dossier…",
    "errors": {
      "artworks": "Impossible de charger vos œuvres.",
      "artworkRequired": "Choisissez l’œuvre concernée.",
      "declarationRequired": "Confirmez la déclaration avant l’envoi.",
      "fileType": "Format non accepté. Utilisez PDF, JPG, PNG ou WebP.",
      "fileSize": "Un fichier dépasse la limite de 15 Mo.",
      "submit": "Le dossier n’a pas pu être envoyé. Vérifiez la configuration Supabase et réessayez."
    },
    "success": {
      "title": "Dossier transmis",
      "text": "Votre dossier a bien été enregistré. Son statut passera à « en cours d’examen » lorsqu’il sera pris en charge.",
      "dashboard": "Retour aux Actions",
      "collection": "Voir ma collection"
    }
  },
  "demo": {
    "advisor": {
      "badge": "PLAN ART ADVISOR",
      "cta": {
        "demo": "Demander une démo live",
        "start": "Démarrer maintenant"
      },
      "final": {
        "cta": {
          "start": "Commencer gratuitement",
          "team": "Parler à l'équipe"
        },
        "note": "Sans engagement • Annulable à tout moment",
        "subtitle": "Rejoignez les art advisors qui gèrent leurs collections clients avec Artkiv",
        "title": "Prêt à transformer votre activité ?"
      },
      "hero": {
        "subtitle": "Les outils essentiels pour les art advisors qui accompagnent jusqu'à 5 collectionneurs simultanément",
        "title": "Gérez plusieurs collections clients comme un pro"
      },
      "price": "99 €",
      "section": {
        "compare": {
          "title": "Besoin de plus ? Passez en Art Advisor Premium"
        },
        "features": {
          "subtitle": "Des fonctionnalités pensées pour votre métier d'art advisor",
          "title": "Tout ce dont vous avez besoin"
        },
        "screenshots": {
          "subtitle": "Découvrez comment Artkiv simplifie votre quotidien",
          "title": "L'interface en images"
        }
      },
      "testimonials": {
        "title": "Ils nous font confiance"
      }
    },
    "advisorPremium": {
      "api": {
        "badge": "EN COURS DE DÉVELOPPEMENT"
      },
      "badge": "PLAN ART ADVISOR PREMIUM",
      "cta": {
        "compare": "Comparer les plans",
        "demo": "Demander une démo personnalisée"
      },
      "features": {
        "subtitle": "Tout ce que contient le plan Art Advisor, et plus encore",
        "title": "Fonctionnalités Premium"
      },
      "final": {
        "cta": {
          "demo": "Réserver une démo personnalisée",
          "plans": "Voir tous les plans"
        },
        "note": "Nous cadrons ensemble votre usage avant tout engagement.",
        "subtitle": "Parlons de votre portefeuille de clients et de vos rapports.",
        "title": "Prêt à passer à l'échelle supérieure ?"
      },
      "hero": {
        "subtitle": "Clients illimités, analyses Vision pour chacun, rapports à votre image.",
        "title": "La solution complète pour les professionnels"
      },
      "price": "199 €",
      "roi": {
        "title": "Calculez votre retour sur investissement"
      },
      "testimonial": {
        "title": "Ils nous font confiance"
      },
      "usecases": {
        "subtitle": "Des profils variés, une solution commune",
        "title": "Qui utilise Art Advisor Premium ?"
      },
      "why": {
        "subtitle": "Les avantages qui font toute la différence",
        "title": "Pourquoi passer Premium ?"
      }
    },
    "fo": {
      "badge": "ENTERPRISE SOLUTION",
      "features": {
        "title": "Fonctionnalités Enterprise"
      },
      "final": {
        "title": "Discutons de vos besoins"
      },
      "hero": {
        "cta": {
          "demo": "Planifier une présentation",
          "quote": "Demander un devis personnalisé"
        },
        "subtitle": "La plateforme de gestion d'art patrimonial pour family offices, banques privées et institutions exigeantes.",
        "title": "Artkiv Family Office"
      },
      "industries": {
        "title": "Nos clients institutionnels"
      },
      "onboarding": {
        "title": "Processus d'onboarding Enterprise"
      },
      "pricing": {
        "title": "Formules tarifaires"
      },
      "security": {
        "title": "Sécurité & Conformité de niveau bancaire"
      },
      "why": {
        "title": "Pourquoi Artkiv pour votre Family Office ?"
      }
    }
  },
  "edition": {
    "detailsHelp": "Indiquez le numéro d’édition, le tirage total, la présence d’épreuves d’artiste (EA/AP), HC, etc. Vous pouvez aussi préciser l’édition pour une vidéo (ex. : « Édition de 3 coffrets vidéo + 1 EA »).",
    "detailsLabel": "Détails de l’édition",
    "detailsPlaceholder": "Exemples : « 2/6 + 2 EA », « Édition de 3 », « HC, tirage pigmentaire », « 1/3 + 1 EA », etc.",
    "isEditionLabel": "Cette œuvre fait partie d’une édition, d’un tirage ou d’un multiple (lithographie, photographie, sculpture, etc.).",
    "loading": "Chargement…",
    "readOnlyDetailsTitle": "Détails de l’édition :",
    "readOnlyEditionTitle": "Édition / multiples",
    "readOnlyIsEdition": "Œuvre en édition :",
    "readOnlyNo": "Non, pièce unique",
    "readOnlyYes": "Oui (multiple / édition)"
  },
  "estimation": {
    "artwork": {
      "badge": {
        "estimated": "✓ Estimée"
      },
      "lastEstimate": "Dernière estimation : {{value}} €",
      "noEstimate": "Non estimée",
      "untitled": "Sans titre"
    },
    "guide": {
      "assurance": {
        "text": "Utilisez la méthode par points ou œuvres comparables, puis complétez avec le module Estimation assurance pour constituer votre dossier justificatif.",
        "title": "Pour votre assurance"
      },
      "highValue": {
        "text": "L'expertise CNES en France est obligatoire pour l'assurance et fortement recommandée pour toute transaction importante. Contactez nos experts agréés.",
        "title": "Pour une œuvre de grande valeur (> 80 k€)"
      },
      "note": "💡 Vous pouvez utiliser plusieurs méthodes pour la même œuvre. Chaque estimation est archivée dans l'historique de l'œuvre pour un suivi complet de sa valorisation.",
      "sale": {
        "text": "Privilégiez Œuvres comparables pour connaître le prix du marché actuel. Si votre artiste est peu coté, la méthode par points donne une base solide.",
        "title": "Pour vendre votre œuvre"
      },
      "succession": {
        "text": "Utilisez le module Estimation succession qui applique automatiquement les règles fiscales selon votre juridiction (France, Belgique, Suisse).",
        "title": "Pour une succession"
      },
      "title": "💡 Besoin d'aide pour choisir ?"
    },
    "methods": {
      "assurance": {
        "cost": "Gratuit (expertise en option)",
        "description": "Constituez un dossier complet de justificatifs pour votre assurance : valeur déclarée, preuves d'achat, comparables, expertise si nécessaire.",
        "duration": "15-20 min",
        "feature1": "Dossier justificatif complet",
        "feature2": "Valeur de remplacement calculée",
        "feature3": "Recommandations expertise CNES (France) si > 80 k€",
        "feature4": "Prêt pour votre assureur",
        "title": "Estimation pour assurance",
        "whenToUse": "Pour souscrire ou renouveler votre assurance œuvres d'art. Calcule la valeur de remplacement (majoration 20-30 % sur valeur marché)."
      },
      "button": {
        "quote": "Demander un devis",
        "start": "Démarrer cette méthode"
      },
      "comparables": {
        "cost": "Gratuit",
        "description": "Analyse de marché basée sur des ventes similaires : même artiste, médium, dimensions, période...",
        "duration": "10-15 min",
        "feature1": "Données du marché réel",
        "feature2": "Filtrage des outliers",
        "feature3": "Reflète la demande actuelle",
        "feature4": "Sources multiples (Artprice, Artnet, galeries)",
        "title": "Œuvres comparables",
        "whenToUse": "Idéal pour préparer une vente ou pour les artistes avec un marché actif. C'est à vous de renseigner les ventes comparables récentes (enchères, galeries) — sauf si un expert Art Advisor s'en occupe pour vous."
      },
      "points": {
        "cost": "Gratuit",
        "description": "Évaluation basée sur des critères objectifs : technique, dimensions, période, état, signature, rareté...",
        "duration": "5 min",
        "feature1": "Score calculé automatiquement",
        "feature2": "Fourchette d'estimation précise",
        "feature3": "Accepté par les assureurs",
        "feature4": "Méthodologie transparente",
        "title": "Méthode par points",
        "whenToUse": "Idéal pour l'assurance ou une première estimation quand vous n'avez pas de ventes comparables récentes. Particulièrement adapté aux œuvres classiques ou d'artistes moins cotés."
      },
      "recommended": {
        "badge": "Recommandé"
      },
      "subtitle": "Chaque méthode répond à un objectif spécifique. Sélectionnez celle qui correspond à vos besoins.",
      "succession": {
        "cost": "Gratuit",
        "description": "Outil d'aide à la planification successorale et déclaration fiscale selon la juridiction : France (forfait 5 %), Belgique (dation 120 %), Suisse (26 cantons).",
        "duration": "20-30 min",
        "feature1": "Barèmes fiscaux par pays",
        "feature2": "Simulation des droits de succession",
        "feature3": "Recommandations de dation (> 150 k€)",
        "feature4": "Rapport pour notaire",
        "title": "Estimation pour succession",
        "whenToUse": "Pour anticiper les droits de succession, préparer une donation ou travailler avec votre notaire/family office. Calculs fiscaux conformes à la législation."
      },
      "title": "Choisissez votre méthode d'estimation",
      "whenToUseLabel": "Quand l'utiliser ?"
    },
    "page": {
      "subtitle": "Choisissez la méthode adaptée à votre objectif",
      "title": "Estimer une œuvre"
    },
    "pro": {
      "expertise": {
        "button": "Demander un devis",
        "desc": "Expertise physique par un expert agréé CNES (obligatoire > 80 000 € en France). Déplacement, examen approfondi, rapport certifié.",
        "point1": "Examen physique de l'œuvre",
        "point2": "Valeur agréée garantie",
        "point3": "À partir de 300 € (commission Artkiv incluse)",
        "title": "Expertise complète CNES France"
      },
      "footer": "💡 Artkiv perçoit une commission sur les services experts pour maintenir la qualité de la plateforme et développer de nouveaux outils",
      "subtitle": "Pour les œuvres nécessitant une validation experte ou une expertise officielle",
      "title": "Services professionnels Artkiv",
      "validation": {
        "button": "Demander une validation",
        "desc": "Un expert Artkiv vérifie votre estimation (points ou comparables) et valide sa cohérence avec le marché. Idéal pour renforcer votre dossier assurance.",
        "point1": "Validation sous 48 h",
        "point2": "Attestation signée fournie",
        "point3": "150 € (commission Artkiv incluse)",
        "title": "Validation par expert Artkiv"
      }
    },
    "selected": {
      "changeArtwork": "Changer d'œuvre"
    },
    "step1": {
      "addArtwork": "Ajouter une œuvre",
      "empty": "Vous n'avez pas encore d'œuvre dans votre collection.",
      "title": "Sélectionnez l'œuvre à estimer"
    },
    "steps": {
      "chooseArtwork": "Choisir l'œuvre",
      "chooseMethod": "Choisir la méthode"
    },
    "ui": {
      "filtrerLaSelection": "Filtrer la sélection",
      "retrouvezRapidementUneUvreParTitreArtisteTechniqueOu": "Retrouvez rapidement une œuvre par titre, artiste, technique ou sous-collection.",
      "reinitialiser": "Réinitialiser",
      "rechercherTitreArtiste": "Rechercher titre, artiste…",
      "tousLesArtistes": "Tous les artistes",
      "toutesLesTechniques": "Toutes les techniques",
      "toutesLesSousCollections": "Toutes les sous-collections",
      "uvreSAfficheeSSur": "œuvre(s) affichée(s) sur",
      "aucuneUvreNeCorrespondAuxFiltres": "Aucune œuvre ne correspond aux filtres.",
      "voirToutesLesUvres": "Voir toutes les œuvres",
      "filterResults": "{{shown}} œuvre(s) affichée(s) sur {{total}}"
    }
  },
  "expert": {
    "add": {
      "title": "Ajouter un expert"
    },
    "alert": {
      "error": "Erreur lors de l'ajout de l'expert : {{error}}",
      "mustBeLoggedIn": "Vous devez être connecté pour ajouter un expert.",
      "success": "Expert ajouté avec succès."
    },
    "button": {
      "submit": "Enregistrer"
    },
    "clients": {
      "cockpitDescription": "Vous retrouvez ici deux flux réunis : (1) des collectionneurs de votre réseau vous invitent à accéder à leur collection, (2) vos demandes d'accès envoyées à des collectionneurs déjà présents sur Artkiv. Tout est centralisé pour garder un historique clair."
    },
    "Dashboard": {
      "complete": {
        "common": {
          "expert": "Expert",
          "userNotLoggedIn": "Utilisateur non connecté",
          "errorWithMessage": "Erreur : {{message}}",
          "loading": "Chargement…",
          "cancel": "Annuler",
          "send": "Envoyer",
          "sending": "Envoi…"
        },
        "errors": {
          "sharedDashboardLoad": "Le module des collections partagées n’a pas pu être chargé."
        },
        "profile": {
          "updated": "Profil mis à jour.",
          "saveError": "Erreur lors de l’enregistrement du profil.",
          "visibilityError": "Erreur lors du changement de visibilité.",
          "photoUpdated": "Photo mise à jour.",
          "photoUploadError": "Erreur lors de l’envoi de la photo.",
          "cvUploaded": "CV envoyé.",
          "cvUploadError": "Erreur lors de l’envoi du CV."
        },
        "invites": {
          "emailPlaceholder": "Email du client",
          "notePlaceholder": "Petit mot (optionnel)"
        },
        "sidebar": {
          "plan": "Plan {{plan}}",
          "features": {
            "unlimitedClients": "Clients illimités",
            "fullAi": "Analyses IA complètes",
            "customReports": "Rapports personnalisés",
          },
          "manageSubscription": "Gérer mon abonnement"
        },
        "services": {
          "pageTitle": "Demandes de services",
          "pageSubtitle": "Gérez les demandes d’expertise, d’évaluation et de services spécialisés de vos clients.",
          "types": {
            "custom": "Demande",
            "validation": "Estimation / validation",
            "authentication": "Authentification",
            "placementInstitution": "Proposition à un musée",
            "placementAuction": "Vente aux enchères",
            "service": "Service"
          },
          "collector": "Collectionneur",
          "collectorWithId": "Collectionneur ({{id}}…)",
          "invitation": "Invitation",
          "newMessages": "Nouveaux messages",
          "openArtwork": "Ouvrir l’œuvre",
          "start": "Démarrer",
          "markReflection": "Marquer comme soumis",
          "submittedForReview": "Demande soumise au client. Vous pourrez échanger via la messagerie.",
          "awaitingClientFeedback": "En attente du retour client",
          "accept": "Accepter",
          "reject": "Refuser",
          "chatWithClient": "Discuter avec le client",
          "completedOn": "Service terminé le {{date}}",
          "acceptLoading": "Acceptation en cours…",
          "acceptedClosed": "Client accepté. La demande est clôturée.",
          "rejectConfirm": "Êtes-vous sûr de vouloir refuser ce client ?",
          "rejectLoading": "Refus en cours…",
          "rejected": "Demande refusée.",
          "conversationOpening": "Ouverture de la conversation…",
          "conversationOpened": "Conversation ouverte",
          "conversationOpenError": "Impossible d’ouvrir la conversation.",
          "columns": {
            "new": "Nouveau",
            "inProgress": "En cours",
            "awaitingFeedback": "Attente retour",
            "completed": "Terminé",
            "cancelled": "Annulé"
          },
          "empty": {
            "new": "Rien de nouveau ici",
            "inProgress": "Aucune demande en cours",
            "awaitingFeedback": "Aucune attente",
            "completed": "Aucun service terminé pour le moment",
            "cancelled": "Rien à signaler (bonne nouvelle)"
          },
          "status": {
            "pending": "Nouveau",
            "in_progress": "En cours",
            "awaiting_feedback": "Attente retour",
            "completed": "Terminé",
            "cancelled": "Annulé"
          }
        },
        "overview": {
          "noRecentActivity": "Aucune activité récente",
          "quickActions": {
            "requests": "Voir les demandes",
            "clientCollections": "Collections clients",
            "inventoryReport": "Rapport inventaire PDF",
            "valuationReport": "Rapport de valorisation",
            "inflationReport": "Rapport inflation (IPC)",
            "artistQuotes": "Cotations artistes",
            "warehouseVisit": "Visite entrepôt",
            "inviteClient": "Inviter un client",
            "profile": "Mon profil Artkiv"
          },
          "completionRate": "Taux de complétion",
          "averageTime": "Temps moyen",
          "averageTimeValue": "2,5 jours",
          "visionQuote": "Analysez l’état de conservation, le style et les anomalies de chaque œuvre, directement depuis les collections de vos clients.",
          "visionTool": "Outil Vision IA — Artkiv",
          "openVision": "Ouvrir Vision IA"
        },
        "collections": {
          "title": "Collections enregistrées",
          "description": "Les collections enregistrées représentent les inventaires d’œuvres d’art que vos clients ont choisi de partager avec vous. Vous pouvez consulter les détails des œuvres, leur provenance, leur état de conservation et les documents associés. Cet accès vous permet de proposer des conseils personnalisés, des services adaptés et de suivre l’évolution des collections de vos clients."
        },
        "portfolio": {
          "clientFallback": "Client",
          "clientWithId": "Client {{id}}…",
          "collectionFallback": "Collection",
          "untitled": "Sans titre",
          "noAccessibleCollection": "Aucune collection client accessible pour l’instant",
          "inviteFromClientsTab": " Invitez un client depuis l’onglet Clients pour démarrer.",
          "analysisTitles": {
            "ai": "Analyse augmentée par signaux IA • Vérification de conformité à prévoir",
            "rules": "Analyse par code, règles et agrégations"
          },
          "readyDescription": "Le périmètre est assez dense pour une lecture portefeuille crédible : concentration, diversification et arbitrage deviennent lisibles.",
          "structuringDescription": "La collection reste dans une logique de structuration. On suit la matière, la documentation et la montée en densité avant de parler d’allocation patrimoniale.",
          "metrics": {
            "trackedValue": "Valeur suivie (estimation)",
            "valuationCoverageNote": "{{coverage}} % des œuvres disposent d’une base de valorisation",
            "artworks": "Œuvres",
            "artistsCategoriesNote": "{{artists}} artistes • {{categories}} catégories",
            "artistConcentration": "Concentration artistes",
            "topThreeShare": "Part des 3 artistes dominants dans la valeur totale",
            "dominantArtistsShare": "Part des artistes dominants",
            "technicalDiversity": "Diversité technique",
            "techniquesCount": "{{count}} techniques",
            "techniquesRecorded": "Techniques recensées",
            "documentationCoverage": "Couverture documentaire",
            "documentationNote": "Certificats, constats d’état et documents présents"
          },
          "volumeWarning": "volume",
          "artworkCount": "{{count}} œuvre",
          "artworkCount_plural": "{{count}} œuvres",
          "artworkCount_one": "{{count}} œuvre",
          "artworkCount_other": "{{count}} œuvres",
          "artistsEmpty": "Ajoutez des valorisations pour faire émerger le poids des artistes.",
          "categoryChartAria": "Répartition des œuvres par catégorie",
          "dominantCategoryNote": "Catégorie dominante en nombre d’œuvres. {{count}} catégories identifiées.",
          "categoryDistributionEmpty": "La répartition apparaîtra quand des œuvres seront partagées.",
          "categoryAllocationEmpty": "Ajoutez des valeurs pour lire le poids économique par catégorie.",
          "valueVsArtworks": "{{valueShare}} % valeur • {{artworkShare}} % œuvres",
          "artworksShareTitle": "Part des œuvres",
          "valueShareTitle": "Part de valeur",
          "valueVolumeEmpty": "Les écarts valeur / volume apparaîtront avec les valorisations.",
          "techniquesEmpty": "Les techniques apparaîtront quand les œuvres partagées seront renseignées."
        },
        "tools": {
          "title": "Outils professionnels",
          "subtitle": "Vos outils d’expert pour générer des rapports, estimer des œuvres et gérer vos visites de terrain.",
          "organizedSubtitle": "Préparez vos données, construisez votre analyse, puis générez les livrables destinés à vos clients.",
          "sections": {
            "prepare": {
              "title": "Préparer le dossier",
              "description": "Importez vos références, organisez vos cotations et recueillez les informations de terrain."
            },
            "analyze": {
              "title": "Analyser et estimer",
              "description": "Croisez les données disponibles pour construire votre analyse professionnelle."
            },
            "deliver": {
              "title": "Produire un livrable",
              "description": "Transformez votre travail en un document clair, personnalisable et partageable avec votre client."
            }
          },
          "categories": {
            "prepare": "Préparation",
            "analysis": "Analyse",
            "report": "Rapport"
          },
          "badges": {
            "vision": "Vision ARTKIV",
            "advisorPremium": "Art Advisor Premium"
          },
          "inventory": {
            "title": "Rapport d’inventaire",
            "kicker": "PDF personnalisé",
            "description": "Générez un rapport PDF de la collection d’un client avec votre identité visuelle. Sélectionnez les champs à inclure et exportez le document en un clic.",
            "cta": "Ouvrir le générateur"
          },
          "valuation": {
            "title": "Rapport de valorisation",
            "description": "Construisez un rapport d’estimation structuré pour l’assurance, la succession, la vente ou la garantie, avec fourchette, sources et justification. Export PDF et Word éditable.",
            "cta": "Créer un rapport"
          },
          "inflation": {
            "title": "Valeur actualisée à l’inflation",
            "description": "Revalorisez le prix d’achat selon l’évolution du coût de la vie. Disponible dès qu’un prix et une date d’acquisition sont renseignés, sans estimation CUP requise. Export PDF et Word.",
            "cta": "Générer le rapport",
            "calculateCta": "Calculer la valeur actualisée"
          },
          "artistQuotes": {
            "title": "Cotations artistes",
            "kicker": "Bibliothèque privée expert",
            "description": "Reprenez vos profils artistes A/B/C et vos fourchettes personnelles par médium et format. Les cotations restent liées à votre compte expert et peuvent préremplir vos prochains rapports.",
            "cta": "Reprendre mes cotations"
          },
          "warehouse": {
            "title": "Visite entrepôt",
            "kicker": "Inspection terrain",
            "description": "Utilisez l’interface mobile pendant vos visites de dépôt. Parcourez les œuvres par emplacement, notez leur état et leur niveau de risque, puis ajoutez vos observations sur le terrain.",
            "cta": "Démarrer une visite"
          },
          "artprice": {
            "title": "Import Artprice",
            "kicker": "Données marché",
            "description": "Importez les données de ventes aux enchères depuis Artprice pour enrichir les fiches œuvres avec des références de marché.",
            "cta": "Importer les données"
          },
          "curatorial": {
            "title": "Note curatoriale IA",
            "description": "Générez une note curatoriale structurée par axes thématiques à partir des données de la collection. Export PDF et Word éditable.",
            "cta": "Ouvrir Vision IA"
          },
          "conservation": {
            "title": "État de conservation",
            "kicker": "Rapport complet",
            "description": "Accédez au rapport d’inventaire filtré par état de conservation pour identifier les œuvres nécessitant une attention particulière.",
            "cta": "Rapport conservation"
          },
          "comparables": {
            "title": "Estimation par comparables",
            "kicker": "Valorisation expert",
            "description": "Estimez une œuvre selon la méthode des comparables internes et externes. L’affinage Vision IA est réservé aux experts.",
            "cta": "Lancer une estimation"
          }
        },
        "acceptContact": {
          "title": "Clôturer cette demande",
          "body": "Vous confirmez la clôture de cette demande. <free>Aucun frais n'est ajouté à la clôture</free> : les frais de mise en relation, s'il y en a, sont réglés à l'acceptation du collectionneur.",
          "confirm": "Confirmer la clôture"
        }
      },
      "actions": {
        "addNote": "Ajouter une note",
        "inviteExpert": "Inviter un expert",
        "removeAccess": "Retirer l'accès",
        "overview": "Tableau de bord",
        "clients": "Clients",
        "collections": "Collections",
        "invitations": "Invitations",
        "activity": "Activité",
        "aiAnalyses": "Analyses IA",
        "reports": "Rapports",
        "new": "NOUVEAU",
        "services": "Demandes",
        "outils": "Outils",
        "billing": "Facturation",
        "profile": "Profil pro",
        "manageSubscription": "Gérer mon abonnement",
        "collaborateurs": "Collaborateurs",
        "missions": "Missions"
      },
      "alerts": {
        "none": "Aucune alerte pour le moment.",
        "title": "Alertes et notifications"
      },
      "clientInvites": {
        "introFee": {
          "feeBadge": "Mise en relation : 49 € HT, payée une seule fois pour ce collectionneur",
          "includedBadge": "Mise en relation incluse dans votre abonnement",
          "modalTitle": "Accepter ce collectionneur",
          "modalBody": "Ce collectionneur vous a contacté via la plateforme. Pour l'accepter et lui répondre, vous réglez des frais de mise en relation uniques de <price>49 € HT (58,80 € TTC)</price>, par carte. Ensuite, la relation vous appartient : aucun autre frais pour ce collectionneur.",
          "modalSubscribe": "Avec un abonnement Art Advisor, les mises en relation sont incluses et illimitées.",
          "seePlans": "Voir les abonnements",
          "pay": "Payer 49 € HT par carte",
          "paying": "Redirection vers le paiement…",
          "paidAccepted": "Paiement reçu : le collectionneur est accepté.",
          "notPaidYet": "Le paiement n'est pas encore confirmé. Réessayez dans un instant.",
          "confirmError": "Impossible de confirmer le paiement. Contactez le support si vous avez été débité.",
          "canceled": "Paiement annulé. Le collectionneur reste en attente.",
          "error": "Impossible de lancer le paiement. Réessayez."
        },
        "accepted": "Etude de dossier acceptée.",
        "acceptError": "Erreur lors de l'acceptation.",
        "declined": "Invitation refusée.",
        "declineError": "Erreur lors du refus.",
        "empty": "Aucune invitation en attente pour le moment.",
        "expires": "Expire le",
        "invitedAt": "Reçue le",
        "loadError": "Impossible de charger les invitations.",
        "messageLabel": "Message",
        "subtitle": "Acceptez ou refusez l'accès à une collection partagée.",
        "title": "Invitations de collectionneurs",
        "unknownClient": "Collectionneur"
      },
      "clients": {
        "empty": "Aucun client pour le moment.",
        "loading": "Chargement de vos clients…",
        "none": "Aucun client associé pour le moment.",
        "search": "Rechercher un client…",
        "subtitle": "Consultez vos clients, les familles associées et les collections sous gestion.",
        "title": "Gestion de vos clients",
        "viewAnalyses": "Voir les analyses IA",
        "viewCollection": "Voir la collection",
        "viewDocuments": "Voir les documents partagés"
      },
      "invitations": {
        "accept": "Accepter",
        "decline": "Refuser",
        "none": "Aucune invitation pour le moment.",
        "title": "Invitations reçues"
      },
      "invites": {
        "emailInvalid": "Email invalide.",
        "emailLabel": "Email du client",
        "error": "Échec de l'invitation. Merci de réessayer.",
        "list": {
          "empty": "Aucune invitation envoyée pour le moment.",
          "title": "Invitations envoyées"
        },
        "noteLabel": "Message personnel (optionnel)",
        "send": "Envoyer l'invitation",
        "sending": "Envoi en cours…",
        "subtitle": "Invitez vos clients à créer leur propre compte ArtKiv et à vous partager leurs collections.",
        "success": "Invitation envoyée avec succès.",
        "title": "Inviter un client"
      },
      "modal": {
        "confirmDecline": {
          "cancel": "Annuler",
          "confirm": "Refuser",
          "text": "Voulez-vous vraiment refuser cette invitation ?",
          "title": "Refuser l'invitation"
        },
        "removeAccess": {
          "cancel": "Annuler",
          "confirm": "Retirer",
          "text": "Voulez-vous retirer l'accès à ce client ?",
          "title": "Retirer l'accès"
        }
      },
      "notes": {
        "add": "Ajouter la note",
        "none": "Aucune note enregistrée.",
        "placeholder": "Écrire une note…",
        "title": "Notes internes"
      },
      "overview": {
        "activeCollections": "Collections actives",
        "currentRequests": "Demandes en cours",
        "activeClients": "Clients actifs",
        "completedServices": "Services complétés",
        "recentActivity": "Activité récente",
        "portfolioAnalysisTitle": "Analyse du portefeuille client",
        "portfolioAnalysisHint": "Valeur, artistes, documentation et conservation — en détail.",
        "quickActions": "Actions rapides",
        "performance": "Performance",
        "completionRate": "Taux de complétion",
        "avgTime": "Temps moyen",
        "noRecentActivity": "Aucune activité récente",
        "trendThisMonthPlus2": "+2 ce mois",
        "trendThisMonthPlus5": "+5 ce mois"
      },
      "kanban": {
        "new": "Nouveau",
        "inProgress": "En cours",
        "awaitingFeedback": "Attente retour",
        "completed": "Terminé",
        "cancelled": "Annulé",
        "emptyNew": "Rien de nouveau ici",
        "emptyInProgress": "Aucune demande en cours",
        "emptyAwaiting": "Aucune attente",
        "emptyCompleted": "Aucun service terminé pour le moment",
        "emptyCancelled": "Rien à signaler (bonne nouvelle)"
      },
      "quickActions": {
        "requests": "Voir les demandes",
        "collections": "Collections clients",
        "inventory": "Rapport inventaire PDF",
        "valuation": "Rapport de valorisation",
        "warehouse": "Visite entrepôt",
        "invite": "Inviter un client",
        "profile": "Mon profil Artkiv"
      },
      "plan": {
        "feature1": "Clients illimités",
        "feature2": "Analyses IA complètes",
        "feature3": "Rapports personnalisés",
      },
      "outils": {
        "title": "Outils professionnels",
        "subtitle": "Vos outils d'expert pour générer des rapports, estimer des œuvres et gérer vos visites de terrain."
      },
      "permissions": {
        "expired": "Accès expiré",
        "expires": "Expire le {{date}}",
        "fullAccess": "Accès complet",
        "readOnly": "Lecture seule",
        "renew": "Renouveler l'accès",
        "title": "Accès et permissions"
      },
      "portfolio": {
        "kpiValueTracked": "Valeur suivie (estimation)",
        "kpiValueNote": "des œuvres avec base de valorisation",
        "kpiArtworks": "Œuvres",
        "artists": "artistes",
        "mediums": "techniques",
        "kpiArtistConcentration": "Concentration artistes",
        "kpiArtistNote": "Part des 3 artistes dominants dans la valeur totale",
        "kpiArtistNoteAlt": "Part des artistes dominants",
        "kpiMediumDiversity": "Diversité médiums",
        "kpiMediumOk": "Répartition équilibrée",
        "kpiMediumWeak": "Diversification à développer",
        "kpiDocCoverage": "Couverture documentaire",
        "kpiDocNote": "Certificats, condition reports et documents présents",
        "liquidityPotential": "Liquidité potentielle",
        "liquidityNote": "Score calculé depuis valeur, artiste, documents, comparables, médium, photos, certificat et condition report",
        "titleLabel": "Lecture portefeuille expert",
        "title": "Regard expert entre client sélectionné et client majeur",
        "subtitle": "Par défaut, le dashboard se cale sur le client majeur, c’est-à-dire celui qui offre aujourd’hui la lecture patrimoniale la plus riche. Vous pouvez ensuite affiner l’analyse par collection.",
        "focus": "Focalisation",
        "autoMajorClient": "Client majeur automatique",
        "noSharedCollection": "Aucune collection partagée",
        "noAccessibleCollection": "Aucune collection accessible",
        "updating": "Mise à jour…",
        "artworksAnalyzedTotal": "{{count}} œuvres analysées au total",
        "collection": "Collection",
        "allCollections": "Toutes les collections",
        "noClientCollectionTitle": "Aucune collection client accessible pour l’instant",
        "noClientCollectionText": "Les collections apparaîtront ici dès qu’un client aura partagé sa collection avec vous.",
        "inviteClient": "Inviter un client",
        "aiEnhancedTitle": "Analyse augmentée par signaux IA • Vérification conformité à prévoir",
        "ruleBasedTitle": "Analyse par code, règles et agrégations",
        "aiEnhancedText": "Cette vue exploite certains signaux issus de traitements IA présents dans les fiches œuvres. Elle reste une aide à la lecture portefeuille : toute recommandation patrimoniale, assurantielle ou d’investissement doit être relue et validée par l’expert avant diffusion au client.",
        "ruleBasedText": "Cette vue repose ici sur des calculs, seuils et agrégations internes. Elle peut être affichée sans revendiquer une analyse IA si aucun signal IA n’est effectivement mobilisé.",
        "majorClient": "Client majeur",
        "selectedClient": "Client sélectionné",
        "portfolioReadyRules": "Règles portfolio ready",
        "patrimonialLevel": "Niveau patrimonial",
        "dominantArtists": "Artistes dominants (par valeur)",
        "mediumBreakdown": "Répartition médiums",
        "signals": "Signaux à traiter",
        "showTopArtists": "Voir les {{count}} premiers ›",
        "reduce": "Réduire",
        "collectionUntitled": "Sans titre",
        "readablePortfolioText": "Le périmètre est assez dense pour une lecture portefeuille crédible : concentration, diversification et arbitrage deviennent lisibles.",
        "structuringPortfolioText": "La collection reste dans une logique de structuration. On suit la matière, la documentation et la montée en densité avant de parler d'allocation patrimoniale.",
        "ruleValue": "Valeur suivie ≥ 150 000 €",
        "ruleArtworks": "Nombre d'œuvres ≥ 12",
        "ruleArtists": "Au moins 3 artistes différents",
        "ruleMediums": "Au moins 2 médiums différents",
        "ruleValuationCoverage": "Couverture de valorisation ≥ 60%",
        "strongPatrimonyReached": "Niveau patrimoine fort atteint.",
        "closeToStrongPatrimony": "Proche du niveau patrimoine fort",
        "collectionStructuring": "Collection en structuration",
        "recommendedObjective": "Objectif recommandé :",
        "objectiveValue": "≥ 500 000 € de valeur suivie",
        "objectiveArtworks": "et ≥ 25 œuvres",
        "dominantArtistsByCount": "Artistes dominants (par nombre d'œuvres)",
        "showByArtworkCount": "Par nombre d'œuvres",
        "showByValue": "Par valeur",
        "topArtists": {
          "showMore": "Voir les {{count}} premiers ›",
          "showLess": "Réduire",
          "notEnough": "Moins de 6 artistes valorisés : la liste complète est déjà affichée."
        },
        "ruleCategories": "Au moins 2 catégories différentes",
        "categoryBreakdown": "Répartition par catégorie",
        "categoryValueAllocation": "Catégories : œuvres vs valeur",
        "techniqueBreakdown": "Techniques principales"
      },
      "services": {
        "badge": {
          "assignedToMe": "Attribuée à vous",
          "done": "Terminée",
          "in_progress": "En cours",
          "new": "Nouvelle"
        },
        "done": {
          "success": "Demande marquée terminée."
        },
        "empty": "Aucun service n'est encore associé à vos clients via Artkiv.",
        "filter": {
          "all": "Toutes",
          "done": "Terminées",
          "in_progress": "En cours",
          "new": "Nouvelles"
        },
        "filters": {
          "all": "Tous les services",
          "done": "Terminés",
          "inProgress": "En cours",
          "new": "Nouveaux"
        },
        "heading": "Demandes de services ArtKiv",
        "intro": "Ces demandes proviennent de clients ArtKiv recherchant votre expertise.En les prenant en charge, vous devenez leur interlocuteur privilégié.",
        "intro1": "Retrouvez ici toutes les demandes qui vous sont adressées via Artkiv.",
        "intro2": "Filtrez par statut pour organiser votre travail d'expert et prioriser les dossiers.",
        "loading": "Chargement des demandes…",
        "none": "Aucune demande de service pour le moment.",
        "request": {
          "markDone": "Marquer terminée",
          "take": "Prendre en charge",
          "title": "Demande de service"
        },
        "take": {
          "success": "Demande prise en charge."
        },
        "title": "Services autour des collections de vos clients",
        "errorMessage": "Impossible de charger les demandes de services.",
        "errorToast": "Erreur lors du chargement des demandes.",
        "toasts": {
          "taken": "Demande démarrée."
        }
      },
      "shared": {
        "description": "Les collections enregistrées regroupent les œuvres que vos clients ont choisi de partager avec vous. Vous pouvez consulter les détails, la provenance, l'état de conservation et les documents associés afin de proposer des recommandations adaptées et de suivre l'évolution de leur patrimoine.",
        "empty": "Aucune collection partagée pour le moment.",
        "error": "Le module des collections partagées n'a pas pu être chargé.",
        "heading": "Collections enregistrées",
        "loading": "Chargement des collections partagées…",
        "loadingCollections": "Chargement des collections partagées…"
      },
      "status": {
        "accepted": "Acceptée",
        "declined": "Refusée",
        "pending": "En attente"
      },
      "subtitle": "Suivez les collections partagées, vos demandes de services et vos invitations clients.",
      "tab": {
        "clients": "Clients",
        "invitations": "Invitations",
        "services": "Demandes de services",
        "shared": "Collections partagées"
      },
      "title": "Tableau de bord expert",
      "collaborateurs": {
        "title": "Mon équipe & accès",
        "subtitle": "Invitez des assistants ou des experts ponctuels pour accéder à vos collections. Chaque accès est traçable et révocable à tout moment.",
        "quotaLabel": "Votre plan",
        "quotaUnlimited": "collaborateurs illimités",
        "quotaMax": "jusqu'à {{count}} collaborateurs"
      },
      "news": {
        "loading": "Chargement des actualités…"
      }
    },
    "form": {
      "company": {
        "placeholder": "Entreprise"
      },
      "email": {
        "placeholder": "Email"
      },
      "name": {
        "placeholder": "Nom de l'expert"
      },
      "phone": {
        "placeholder": "Téléphone"
      },
      "speciality": {
        "placeholder": "Spécialité (ex : art moderne, photographie…)"
      },
      "specialty": {
        "placeholder": "Spécialité, par exemple art moderne ou photographie"
      },
      "years": {
        "placeholder": "Années d’expérience"
      },
      "certified": {
        "label": "Expert certifié"
      }
    }
  },
  "expertBilling": {
    "bicLabel": "BIC / SWIFT",
    "bicPlaceholder": "XXXXXXXXXXX",
    "ibanLabel": "IBAN",
    "ibanPlaceholder": "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
    "payouts": {
      "title": "Paiements à venir"
    },
    "save": "Enregistrer",
    "status": {
      "paid": "Payé",
      "pending": "En attente",
      "scheduledFor": "Paiement programmé",
      "paidOn": "Payé le {{date}}",
      "unknown": "Statut inconnu",
      "values": {
        "paid": "Payé",
        "scheduled": "Prévu",
        "pending": "En attente",
        "failed": "Échoué",
        "cancelled": "Annulé",
        "canceled": "Annulé"
      }
    },
    "ticketLabel": "Mission",
    "title": "Coordonnées de paiement",
    "stats": {
      "totalEarned": "Total gagné",
      "pending": "En attente",
      "nextPayout": "Prochain versement",
      "none": "Aucun"
    },
    "bank": {
      "title": "Coordonnées bancaires",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "security": {
      "title": "Sécurité des paiements",
      "description": "Vos coordonnées bancaires sont stockées de manière sécurisée et ne sont utilisées que pour les versements de vos honoraires. Les versements sont effectués automatiquement 7 jours après la complétion d’un service."
    },
    "history": {
      "title": "Historique des versements",
      "ticket": "Ticket n°{{id}}",
      "emptyTitle": "Aucun versement pour le moment",
      "emptyDescription": "Vos versements apparaîtront ici après la complétion de vos premiers services."
    },
    "fullBilling": {
      "title": "Gestion complète de la facturation",
      "description": "Accédez à votre tableau de bord complet pour gérer vos tarifs, voir vos statistiques détaillées et consulter l’historique de tous vos services.",
      "open": "Ouvrir la facturation complète"
    }
  },
  "family": {
    "dashboard": {
      "subtitle": "Vue consolidée de vos familles clientes, de leurs collections et des alertes prioritaires.",
      "title": "Dashboard Family Office"
    }
  },
  "familyOffice": {
    "dashboard": {
      "actions": {
        "viewCollection": "Voir la collection",
        "viewFamily": "Ouvrir la famille"
      },
      "buildSuccess": "Build réussi - {{date}}",
      "empty": "Aucune famille n'est encore configurée dans votre espace Family Office.",
      "filters": {
        "plan": "Plan",
        "status": "Statut"
      },
      "loading": "Chargement des familles…",
      "ok": "Dashboard Family Office fonctionne !",
      "plan": {
        "premium": "Premium",
        "standard": "Standard"
      },
      "stats": {
        "alerts": "Alertes prioritaires",
        "totalArtworks": "Œuvres sous gestion",
        "totalFamilies": "Familles actives",
        "totalValue": "Valeur agrégée"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "table": {
        "actions": "Actions",
        "artworks": "Œuvres",
        "family": "Famille",
        "lastActivity": "Dernière activité",
        "plan": "Plan",
        "valuation": "Valorisation"
      },
      "title": "Dashboard Family Office"
    }
  },
  "fiscal": {
    "client": {
      "add": "Ajouter",
      "adding": "Ajout…",
      "emptyList": "Aucune liste détectée (permissions). Ajoutez un client par email :",
      "label": "Client",
      "loading": "Chargement…",
      "placeholder": "client@email.com",
      "select": "— Choisir un client —"
    },
    "description": "Sélectionnez un client pour consulter ou définir son régime fiscal par défaut (utilisé dans les exports ventes/donations).",
    "error": {
      "emailNotFound": "Aucun profil avec cet email.",
      "loadClients": "Impossible de charger la liste des clients.",
      "save": "Impossible d'enregistrer (droits/RLS ?)."
    },
    "hint": "Astuce : cette préférence s'appliquera par défaut lors de vos exports (ventes/donations). Elle peut être ajustée par œuvre ou par opération.",
    "loading": {
      "pref": "Lecture…",
      "save": "Enregistrement…"
    },
    "notes": {
      "clientLabel": "Client :",
      "label": "Notes (optionnel)",
      "placeholder": "Ex : appliquer FR_PLUS_VALUE par défaut sauf œuvres acquises avant 2010…"
    },
    "regime": {
      "DE_PRIVATE_1Y_RULE": "Allemagne — Exonération si détention > 1 an",
      "FR_FORFAIT_6_5": "France — Forfait 6,5 %",
      "FR_PLUS_VALUE": "France — Plus-value (19 % + 17,2 %)",
      "label": "Régime fiscal",
      "none": "— Aucun (ne pas calculer) —",
      "UK_CGT_SIMPLE_20": "Royaume-Uni — CGT (20 % simplifié)"
    },
    "role": {
      "expert": "Expert",
      "fo": "Family Office"
    },
    "title": "Préférences fiscales — Gestion {{role}}"
  },
  "footer": {
    "copyright": "Tous droits réservés",
    "info": {
      "cookies": "Cookies",
      "legal": "Mentions légales",
      "privacy": "Confidentialité",
      "title": "Informations"
    },
    "newsletter": {
      "error": {
        "empty": "Veuillez entrer votre email",
        "generic": "Une erreur est survenue"
      },
      "placeholder": "votre@email.com",
      "subtitle": "Recevez les actualités du marché de l'art et les nouveautés Artkiv",
      "success": "Merci ! Vous êtes inscrit à la newsletter.",
      "title": "Restez informé"
    },
    "platform": {
      "insurance": "Assurance",
      "pricing": "Tarifs",
      "resources": "Ressources",
      "title": "Plateforme"
    }
  },
  "galleries": {
    "confirmUnfollow": "Arrêter de suivre cette galerie?",
    "followed": {
      "empty": {
        "subtitle": "Utilisez la recherche ci-dessus ou consultez nos suggestions.",
        "title": "Vous ne suivez encore aucune galerie."
      }
    },
    "links": {
      "instagram": "Instagram →",
      "newsletter": "Newsletter →",
      "website": "Site web →"
    },
    "modal": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "text": "Souhaitez-vous suivre cette galerie et recevoir ses actualités ?",
      "title": "Confirmer le suivi"
    },
    "news": {
      "empty": "Aucune actualité pour le moment.",
      "more": "Voir plus"
    },
    "newsletter": {
      "markAsSubscribed": "Marquer comme inscrit",
      "subscribed": "✓ Inscrit à la newsletter"
    },
    "search": {
      "follow": "Suivre",
      "placeholder": "Nom de la galerie...",
      "submit": "Rechercher",
      "title": "Rechercher une galerie"
    },
    "stats": {
      "currentExhibitions": "Expos en cours",
      "followed": "Galeries suivies",
      "news": "Actualités",
      "suggestions": "Suggestions"
    },
    "subtitle": "Suivez vos galeries préférées et recevez leurs actualités.",
    "suggestions": {
      "button": {
        "follow": "Suivre"
      },
      "commonArtists": "Artistes en commun : {{artists}}",
      "empty": {
        "subtitle": "Ajoutez des œuvres à votre collection pour générer des suggestions.",
        "title": "Aucune suggestion disponible."
      },
      "hint": "💡 Ces galeries représentent des artistes présents dans votre collection",
      "matchBadge": "{{score}} correspondance(s)"
    },
    "tabs": {
      "followed": "Mes galeries",
      "news": "Actualités",
      "search": "Résultats",
      "suggestions": "Suggestions"
    },
    "title": "Galeries",
    "unfollow": "Retirer"
  },
  "header": {
    "admin": "Admin",
    "login": "Connexion",
    "logout": "Déconnexion",
    "nav": {
      "collection": "Ma Collection",
      "dashboard": "Tableau de bord",
      "estimates": "Estimations",
      "analysesIA": "Analyses IA",
      "services": "Outils",
      "myAdvisor": "Mon conseiller",
      "importDoc": "Importer un document",
      "start": "Commencer"
    },
    "profile": "Mon Profil",
    "services": {
      "deposits": {
        "desc": "Collections confiées & œuvres en prêt",
        "title": "Dépôts & Prêts"
      },
      "estate": {
        "desc": "Transmission du patrimoine",
        "title": "Planification Successorale"
      },
      "insurance": {
        "desc": "Protection de vos œuvres",
        "title": "Assurance"
      },
      "locations": {
        "desc": "Géolocalisation précise",
        "title": "Localisations"
      },
      "sales": {
        "desc": "Gestion de transactions",
        "title": "Ventes & Donations"
      },
      "losses": "Pertes et vols",
      "lossesDesc": "Œuvre disparue, volée ou détruite"
    }
  },
  "insurance": {
    "addArtwork": "Ajouter une œuvre",
    "addInsurer": "Ajouter un nouvel assureur",
    "back": "Retour",
    "error": "Erreur",
    "form": {
      "insurer": "-- Sélectionner un assureur --",
      "policyPlaceholder": "Numéro de police d'assurance",
      "type": "-- Type de couverture --",
      "value": "Valeur assurée (€)"
    },
    "insuredWorks": "Couvertures enregistrées",
    "insurer": "Assureur",
    "loading": "Chargement...",
    "noArtworks": "Vous n'avez pas encore d'œuvres dans votre collection.",
    "noneYet": {
      "text": "Si une de vos œuvres est déjà assurée, enregistrez ici les informations de sa police afin de conserver l’assureur, la valeur assurée et les références du contrat dans le dossier de l’œuvre.",
      "title": "Aucune couverture enregistrée"
    },
    "notProvided": "Non renseigné",
    "notSpecified": "Non spécifié",
    "policyNumber": "Numéro de police",
    "section": {
      "new": "Ajouter une couverture existante"
    },
    "selectArtwork": "-- Sélectionner une œuvre --",
    "simulate": "Simuler une couverture",
    "status": {
      "answered": "Réponse reçue",
      "pending": "En cours",
      "seen": "Consulté"
    },
    "submit": "Enregistrer la couverture",
    "successAdded": "Couverture enregistrée avec succès !",
    "title": "Assurance & couvertures enregistrées",
    "type": "Type",
    "unknownArtwork": "Œuvre inconnue",
    "validUntil": "Contrat valide jusqu'au",
    "value": "Valeur assurée",
    "recordIntro": {
      "title": "Une œuvre est déjà assurée ?",
      "body": "Cette page vous permet d’enregistrer une couverture d’assurance déjà en place et de la rattacher au dossier de l’œuvre : assureur, valeur assurée, type de couverture, numéro de police et échéance.",
      "newInsurance": "Vous cherchez une nouvelle assurance ? Utilisez Actions → Assurance pour préparer et envoyer une demande à un partenaire."
    },
    "coverage": {
      "title": "Couverture vs valeur estimée",
      "totalEstimated": "Valeur estimée totale",
      "totalInsured": "Valeur assurée totale",
      "gap": "Écart de couverture",
      "underinsured": "{{count}} œuvre sous-assurée",
      "underinsured_plural": "{{count}} œuvres sous-assurées",
      "wellCovered": "{{count}} œuvre correctement couverte",
      "wellCovered_plural": "{{count}} œuvres correctement couvertes",
      "insuredLabel": "Assuré",
      "estimatedLabel": "Estimé",
      "gapLabel": "Écart",
      "covered": "{{pct}}% couvert",
      "update": "Mettre à jour →",
      "expired": "EXPIRÉE",
      "expireSoon": "EXPIRE BIENTÔT",
      "cloaAClou": "Clou à clou",
      "percentCovered": "{{percent}} % couvert"
    },
    "authRequired": "Veuillez vous connecter pour accéder à cette page.",
    "notConnected": "Non connecté",
    "types": {
      "theft": "Vol",
      "fire": "Incendie",
      "waterDamage": "Dégâts des eaux",
      "transport": "Transport",
      "allRisks": "Tous risques",
      "nailToNail": "Clou à clou"
    },
    "addError": "Erreur lors de l’ajout de la couverture.",
    "currency": "EUR"
  },
  "insurer": {
    "add": {
      "title": "Ajouter un assureur"
    },
    "alert": {
      "error": "Erreur lors de l'ajout de l'assureur : {{error}}",
      "mustBeLoggedIn": "Vous devez être connecté pour ajouter un assureur.",
      "success": "Assureur ajouté avec succès."
    },
    "button": {
      "submit": "Enregistrer"
    },
    "form": {
      "company": {
        "placeholder": "Entreprise"
      },
      "email": {
        "placeholder": "Email du contact"
      },
      "name": {
        "placeholder": "Nom du contact"
      },
      "phone": {
        "placeholder": "Téléphone du contact"
      },
      "reputation": {
        "placeholder": "Indice de réputation (0–10)"
      }
    }
  },
  "bienvenue": {
    "meta": {
      "title": "Bienvenue — Votre Studio Transmission | Artkiv"
    },
    "connecting": "Connexion en cours…",
    "expired": {
      "title": "Ce lien n'est plus valide",
      "body": "Votre lien de connexion a expiré ou a déjà été utilisé. Reconnectez-vous pour accéder à votre espace.",
      "cta": "Se connecter"
    },
    "eyebrow": "Votre Studio Transmission est prêt",
    "hello": "Bienvenue, {{name}}.",
    "helloNoName": "Bienvenue.",
    "yourProfile": "Votre profil",
    "archetype": {
      "batisseur": "Le Bâtisseur",
      "passionne": "Le Passionné",
      "connecteur": "Le Connecteur",
      "gardien": "Le Gardien",
      "mecene": "Le Mécène"
    },
    "trial": {
      "title": "Vos 14 jours offerts commencent maintenant.",
      "until": "Accès complet jusqu'au {{date}}.",
      "generic": "Accès complet pendant 14 jours.",
      "noCard": "Aucune carte bancaire requise."
    },
    "mission": {
      "label": "Votre première étape",
      "text": "Ajoutez la première œuvre que vous ne voudriez jamais voir mal comprise par vos héritiers.",
      "cta": "Ajouter une œuvre"
    },
    "skip": "Explorer mon espace d'abord"
  },
  "landing": {
    "gestures": {
      "label": "Ce que vous ferez",
      "title": "Un geste simple à chaque étape",
      "intro": "Pas de jargon technique. Vous photographiez, ARTKIV comprend et vous propose — vous gardez la main.",
      "flow": {
        "gather": "Rassembler",
        "document": "Documenter",
        "understand": "Comprendre",
        "protect": "Protéger",
        "value": "Valoriser",
        "transmit": "Transmettre"
      },
      "cards": {
        "addArtwork": {
          "title": "Ajoutez une œuvre",
          "text": "Photographiez une œuvre : ARTKIV crée sa fiche et l'enrichit."
        },
        "scanDocs": {
          "title": "Scannez vos documents",
          "text": "Photographiez une facture ou un certificat. ARTKIV en extrait les informations et vous propose de compléter la fiche."
        },
        "documentState": {
          "title": "Documentez son état",
          "text": "Photographiez détails et altérations : images et analyse restent rattachées à l'œuvre."
        },
        "trackValue": {
          "title": "Suivez sa valeur",
          "text": "Œuvre et comparables réunis : une fourchette de valeur, suivie dans le temps."
        },
        "prepareFuture": {
          "title": "Préparez son avenir",
          "text": "Collection et transmission structurées, prêtes pour votre notaire."
        },
        "advisor": {
          "title": "Travaillez avec votre Art Advisor",
          "text": "Partage sécurisé : chacun accède à ce que ses permissions autorisent."
        },
        "phone": {
          "title": "Continuez sur votre téléphone",
          "text": "Scannez un QR depuis votre ordinateur : votre téléphone ouvre directement la bonne tâche."
        }
      }
    },
    "archetypes": {
      "label": "Les cinq profils",
      "title": "Cinq façons de collectionner. Cinq angles morts.",
      "intro": "La façon dont on collectionne détermine la façon dont il faut documenter, valoriser et transmettre. Chaque profil a ses forces — et son point aveugle.",
      "riskLabel": "Point de vigilance",
      "batisseur": {
        "name": "Le Bâtisseur",
        "text": "Il suit les cotes, les carrières, les tendances. Sa collection est pensée comme un portefeuille.",
        "risk": "Une documentation centrée sur la valeur de revente, qui néglige la provenance et l'état — tout ce qui, un jour, justifiera le prix."
      },
      "passionne": {
        "name": "Le Passionné",
        "text": "Il achète au coup de cœur, sans calcul. Sa collection raconte une histoire personnelle.",
        "risk": "Peu de traçabilité, des acquisitions dispersées. Le jour venu, les héritiers reçoivent une collection sans mode d'emploi."
      },
      "connecteur": {
        "name": "Le Connecteur",
        "text": "Il collectionne au fil de ses rencontres : artistes, curateurs, marchands. Sa collection est le miroir de son réseau.",
        "risk": "Une documentation qui vit dans sa mémoire et ses relations, plutôt que sur le papier."
      },
      "gardien": {
        "name": "Le Gardien",
        "text": "Il pense déjà legs, institution, fondation. C'est le profil le plus proche, spontanément, des exigences patrimoniales.",
        "risk": "Une intention forte, mais rarement formalisée en dossier juridique et fiscal réellement constitué."
      },
      "mecene": {
        "name": "Le Mécène",
        "text": "Il collectionne pour soutenir : artistes, institutions, causes.",
        "risk": "Une collection dispersée en dons et en prêts, dont la valeur patrimoniale globale devient illisible."
      },
      "punchline": "Aucun de ces profils — pas même le plus méthodique — n'a, par défaut, une collection prête à être transmise.",
      "punchlineSub": "C'est précisément cet angle mort qu'Artkiv adresse, sans vous demander de changer votre façon de collectionner.",
      "cta": "Découvrir mon profil"
    },
    "badge": "Essai du plan Standard 14 jours offert",
    "meta": {
      "title": "ARTKIV — La collection après vous",
      "description": "Documentez, valorisez et transmettez votre collection. Découvrez votre profil de collectionneur en 2 minutes."
    },
    "nav": {
      "explore": "La plateforme",
      "how": "Comment ça marche",
      "login": "Connexion"
    },
    "cta": {
      "button": {
        "createAccount": "Créer un compte",
        "quiz": "Faire le test du collectionneur",
        "note": "Essai Standard 14 jours offert. Sans carte bancaire.",
        "privacy": "Politique de confidentialité"
      },
      "text": "Vos œuvres restent privées, mais vos preuves deviennent solides. Collection, certificats, estimations, partage sécurisé : au même endroit, pour vous aujourd'hui et pour vos proches ensuite.",
      "title": "La collection après vous"
    },
    "footer": {
      "cookies": "Cookies",
      "copyright": "© {{year}} Artkiv — Tous droits réservés",
      "legal": "Mentions légales",
      "privacy": "Confidentialité"
    },
    "hero": {
      "button": {
        "demo": "Demander une démo",
        "start": "Commencer avec Artkiv"
      },
      "eyebrow": "The Collection After You",
      "explore": "Voir la plateforme",
      "login": "Connexion",
      "quiz": "Faire le test du collectionneur",
      "quizNote": "3 minutes. Votre archétype s'affiche aussitôt ; votre carte complète vous est envoyée par email.",
      "subtitle": "Chaque œuvre porte une histoire que vous êtes seul à connaître : sa provenance, son prix, la raison de son achat. Artkiv réunit ces preuves en un dossier clair — pour vous aujourd'hui, pour vos proches ensuite.",
      "title": "Vous savez pourquoi vous collectionnez. Savez-vous ce qui arrivera ensuite ?",
      "trial": "Essai Standard 14 jours offert.",
      "trust": "Conçu avec des experts de l'art, de l'assurance et de la transmission patrimoniale."
    },
    "quiz": {
      "label": "Carte de transmission",
      "title": "Quel type de collectionneur êtes-vous ?",
      "text": "Quatorze questions, trois minutes. Votre archétype de collectionneur s'affiche immédiatement. Vos cinq axes, votre point de vigilance et l'indice de préparation de votre collection vous sont envoyés par email.",
      "cta": "Faire le test du collectionneur",
      "note": "Gratuit, sans création de compte.",
      "archetype": {
        "builder": {
          "name": "Le Bâtisseur",
          "text": "Vous construisez un ensemble cohérent, pensé pour durer."
        },
        "aficionado": {
          "name": "Le Passionné",
          "text": "Vous achetez au coup de cœur, et chaque œuvre a son histoire."
        },
        "connector": {
          "name": "Le Connecteur",
          "text": "Votre collection vit à travers les artistes et les rencontres."
        },
        "keeper": {
          "name": "Le Gardien",
          "text": "Vous préservez, documentez, protégez ce qui vous a été confié."
        },
        "benefactor": {
          "name": "Le Mécène",
          "text": "Vous soutenez, prêtez, donnez : la collection sert au-delà de vous."
        }
      }
    },
    "section": {
      "how": {
        "ctaPrimary": "Découvrir la plateforme",
        "ctaSecondary": "Créer mon compte",
        "step1": {
          "text": "Parcourez l'interface et les modules : collection, documents, analyses IA, certificats.",
          "title": "Explorez"
        },
        "step2": {
          "text": "Voyez comment une œuvre devient un dossier complet, clair et partageable.",
          "title": "Voyez un exemple réel"
        },
        "step3": {
          "text": "Créez votre compte et commencez par l'œuvre qui compte le plus.",
          "title": "Passez à votre collection"
        },
        "stepLabel": "Étape {{n}}",
        "text": "Vous pouvez tout parcourir sans créer de compte. Vous activez l'essai quand vous le décidez.",
        "title": "Trois étapes, sans engagement"
      },
      "who1": {
        "text": "Le carnet de vie de chaque œuvre : provenance, factures, certificats, restaurations, valeur. Tout ce qui prouve, réuni au même endroit.",
        "title": "Collectionneurs privés"
      },
      "who2": {
        "text": "Vous héritez d'une collection ? Comprenez ce que vous avez, ce qu'elle vaut et ce qu'elle représentait, sans repartir de zéro.",
        "title": "Familles et héritiers"
      },
      "who3": {
        "text": "Un dossier traçable et partageable. Moins d'incertitude, une assurance plus rapide, un risque anticipé.",
        "title": "Family offices, assureurs, conseils"
      },
      "why": {
        "point1": "Retrouvez une facture ou un certificat en quelques secondes.",
        "point2": "Partagez un dossier sécurisé avec un expert, un assureur ou un proche.",
        "point3": "Suivez la valeur et les événements : ventes, estimations, restaurations.",
        "point4": "Ajoutez, en option, une preuve d'authenticité datée et infalsifiable à l'historique d'une œuvre.",
        "text": "Une œuvre survit à son propriétaire. Le certificat, la facture, le nom du restaurateur, la raison de l'achat : eux, non. Sans ces preuves, une collection se transmet comme un inventaire d'objets — et se règle parfois comme un litige.",
        "title": "Ce qui se perd, ce n'est jamais l'œuvre"
      }
    },
    "title": "ARTKIV — gérez, valorisez et sécurisez votre collection"
  },
  "lang": {
    "selector": {
      "currency": "Devise",
      "eur": "€ EUR",
      "france": "FR - France",
      "language": "Langue",
      "location": "Emplacement"
    }
  },
  "location": {
    "add": {
      "title": "Ajouter un nouvel emplacement"
    },
    "alert": {
      "error": "Erreur lors de l'ajout du lieu : {{error}}",
      "mustBeLoggedIn": "Vous devez être connecté pour ajouter un lieu.",
      "success": "Lieu ajouté avec succès."
    },
    "button": {
      "create": "Créer",
      "submit": "Enregistrer"
    },
    "error": {
      "auth": "Erreur d'authentification : {{error}}",
      "create": "Erreur lors de la création de l'emplacement : {{error}}"
    },
    "form": {
      "address": {
        "placeholder": "Adresse"
      },
      "city": {
        "placeholder": "Ville"
      },
      "country": {
        "placeholder": "Pays"
      },
      "name": {
        "placeholder": "Nom du lieu (ex : Salon, Dépôt, Galerie…) "
      },
      "notes": {
        "placeholder": "Notes (optionnel)"
      },
      "type": "Type",
      "types": {
        "exhibition": "Exposition",
        "loan": "Prêt",
        "main": "Résidence principale",
        "office": "Bureau",
        "other": "Autre",
        "secondary": "Résidence secondaire",
        "storage": "Stockage"
      }
    }
  },
  "login": {
    "create": "Créer un compte",
    "email": {
      "label": "Email",
      "placeholder": "votre@email.com",
      "hint": "Vérifiez le format de l'email."
    },
    "error": {
      "default": "Email ou mot de passe incorrect",
      "loadProfile": "Impossible de charger votre profil. Veuillez réessayer.",
      "noProfile": "Profil utilisateur introuvable."
    },
    "forgot": "Mot de passe oublié ?",
    "security": {
      "hint": "Connexion sécurisée. Vos données restent privées."
    },
    "altCta": "Je veux d'abord explorer la plateforme",
    "softNote": "Vous pouvez explorer sans vous inscrire. L'essai se déclenche quand vous êtes prêt·e.",
    "hero": {
      "alt": "Galerie d'art",
      "copy": "La plateforme qui vous aide à gérer, protéger et valoriser votre collection d'art.",
      "exploreCta": "Voir comment ça marche",
      "pricingCta": "Comparer les plans",
      "proHint": "Family Office, expert, partenaire : vous vous connectez ici aussi."
    },
    "loading": "Connexion en cours...",
    "mobile": {
      "subtitle": "Connectez-vous, ou explorez la plateforme en 2 minutes.",
      "explore": "Voir comment ça marche",
      "compare": "Comparer les plans"
    },
    "noAccount": "Vous n'avez pas encore de compte ?",
    "password": {
      "label": "Mot de passe",
      "placeholder": "Votre mot de passe",
      "show": "Afficher",
      "hide": "Masquer"
    },
    "submit": "Se connecter",
    "subtitle": "Accédez à votre espace personnel",
    "title": "Connexion"
  },
  "mesDemandes": {
    "error": "Impossible de charger vos demandes pour le moment.",
    "empty": "Vous n'avez pas encore de demande. Lancez une proposition depuis une œuvre (bouton « Proposer musée » ou « Vente »).",
    "institutionFallback": "Institution non renseignée",
    "loading": "Chargement…",
    "seeAll": "Tout voir",
    "sendMethod": {
      "email": "Envoi par email",
      "self": "Envoi autonome",
      "unknown": "Mode d’envoi non renseigné",
      "service": "Service Pro"
    },
    "stats": {
      "draft": "Brouillons : {{count}}",
      "pending_one": "En cours : {{count}}",
      "pending_other": "En cours : {{count}}",
      "sent_one": "Envoyée : {{count}}",
      "sent_other": "Envoyées : {{count}}",
      "paid_one": "Payée : {{count}}",
      "paid_other": "Payées : {{count}}",
      "draft_one": "Brouillon : {{count}}",
      "draft_other": "Brouillons : {{count}}",
      "paid": "Payées : {{count}}",
      "pending": "En cours : {{count}}",
      "sent": "Envoyées : {{count}}"
    },
    "status": {
      "awaiting_payment": "En attente de paiement",
      "canceled": "Annulée",
      "completed": "Terminée",
      "in_progress": "En cours",
      "cancelled": "Annulée",
      "draft": "Brouillon",
      "paid": "Payée",
      "pending": "En cours",
      "rejected": "Refusée",
      "sent": "Envoyée",
      "unknown": "Statut : {{status}}"
    },
    "title": "Mes demandes",
    "subtitle": "Vos propositions envoyées à des musées, institutions ou maisons de vente (don, prêt, enchères) depuis vos œuvres.",
    "type": {
      "auction": "Vente aux enchères",
      "auction_sale": "Vente aux enchères",
      "institution": "Institution",
      "institution_gift": "Don à une institution",
      "institution_loan": "Prêt à une institution",
      "unknown": "Autre proposition",
      "museum": "Institution / Musée"
    },
    "backDashboard": "← Retour au tableau de bord",
    "listTitle": "Toutes mes propositions",
    "listSubtitle": "Propositions envoyées à des musées, institutions ou maisons de vente (don, prêt, enchères) depuis vos œuvres.",
    "filters": {
      "all": "Toutes"
    },
    "view": {
      "label": "Voir",
      "title": "Ouvrir la demande"
    }
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "logout": "Déconnexion",
    "profile": "Mon profil"
  },
  "news": {
    "alerts": {
      "collection": {
        "empty": "Aucun artiste dans votre collection",
        "follow": "Suivre",
        "followed": "Suivi",
        "title": "Artistes de ma collection"
      },
      "follow": {
        "button": "Suivre",
        "placeholder": "Nom de l'artiste...",
        "title": "Suivre un artiste"
      },
      "followed": {
        "empty": "Vous ne suivez encore aucun artiste. Utilisez le formulaire ci-dessus pour commencer.",
        "title": "Artistes suivis",
        "unfollow": "Ne plus suivre"
      },
      "stats": {
        "collection": "Dans ma collection",
        "followed": "Artiste suivi"
      }
    },
    "auctions": {
      "subtab": {
        "myArtists": "Mes artistes",
        "topTen": "Top 10 mondial"
      },
      "upcoming": {
        "dateUnknown": "Date à confirmer",
        "empty": "Aucune vente à venir sur vos artistes suivis.",
        "fallbackTitle": "Vente",
        "title": "Ventes à venir"
      }
    },
    "exhibitions": {
      "dateArrow": "→",
      "dateRangeBoth": "Dates à confirmer",
      "dateRangeStart": "—",
      "empty": "Aucune exposition à venir détectée.",
      "rpcHint": "La fonction RPC get_client_exhibitions doit être créée dans Supabase",
      "sourceLink": "Voir l'exposition",
      "title": "Expositions"
    },
    "fairs": {
      "empty": "Aucune foire à venir pour le moment.",
      "link": "Voir le site",
      "title": "Foires d'art à venir"
    },
    "loading": "Chargement des actualités...",
    "records": {
      "empty": "Aucun record récent.",
      "estimatePrefix": "Est.",
      "noPrice": " Prix non communiqué",
      "saleFallback": "Vente",
      "sourceLink": "Voir la source",
      "title": "Records de vente",
      "unknownCity": "—",
      "unknownCountry": "—",
      "unknownDate": "Date inconnue"
    },
    "subtitle": "Suivez les actualités des artistes de votre collection",
    "tabs": {
      "alerts": "Mes alertes",
      "auctions": "Ventes & Records",
      "fairs": "Foires d'art"
    },
    "title": "Actualités"
  },
  "payment": {
    "success": {
      "button": {
        "invoices": "Mes factures",
        "profile": "Mon profil"
      },
      "institution": {
        "label": "Destination"
      },
      "invoice": {
        "amount": "Montant",
        "downloadPdf": "Télécharger la facture (PDF)",
        "label": "Facture",
        "none": "Aucune facture récupérée.",
        "viewOnline": "Voir en ligne"
      },
      "invoiceError": "Erreur facture : {{error}}",
      "loadingInvoice": "Préparation de votre facture…",
      "subtitle": "Merci ! Votre mission a bien été enregistrée. Notre expert va prendre le relais.",
      "title": "Paiement confirmé",
      "work": {
        "fallback": "Œuvre",
        "label": "Œuvre"
      }
    }
  },
  "pricing": {
    "alert": {
      "confirm": {
        "change": "Voulez-vous changer votre abonnement vers {{plan}} ?\n\nLe prorata sera calculé automatiquement et appliqué dès maintenant."
      },
      "demo": {
        "change": "Changer votre plan démo vers {{plan}} ?",
        "success": "Plan démo modifié avec succès !"
      },
      "error": {
        "change": "Erreur lors du changement de plan : {{error}}",
        "generic": "Une erreur est survenue. Veuillez réessayer.",
        "subscription": "Erreur : {{error}}"
      },
      "success": {
        "change": "Votre forfait a été modifié avec succès !"
      }
    },
    "compare": {
      "button": {
        "compare": "Comparer les offres",
        "expert": "Parler à un expert"
      },
      "subtitle": "Consultez notre tableau comparatif détaillé ou contactez notre équipe",
      "title": "Besoin d'aide pour choisir ?"
    },
    "currentPlan": {
      "bannerTitle": "Vous avez un abonnement actif",
      "text": "Votre plan actuel : {{plan}}. Vous pouvez changer de plan à tout moment. Le prorata sera automatiquement calculé."
    },
    "faq": {
      "a1": "Oui, vous pouvez upgrader ou downgrader votre plan à tout moment. Le prorata est automatiquement calculé.",
      "a2": "Art Advisor permet de gérer jusqu'à 5 collections clients, tandis que Premium offre un nombre illimité de clients avec toutes les fonctionnalités IA.",
      "a3": "Oui, chaque souscription Family Office inclut un onboarding personnalisé et un account manager dédié.",
      "q1": "Puis-je changer de plan à tout moment ?",
      "q2": "Quelle est la différence entre Art Advisor et Art Advisor Premium ?",
      "q3": "Le plan Family Office inclut-il une formation ?",
      "title": "Questions fréquentes"
    },
    "hero": {
      "subtitle": "De la collection personnelle aux portefeuilles institutionnels, choisissez l'offre adaptée à votre activité",
      "title": "Une solution pour chaque besoin"
    },
    "period": {
      "month": "/mois"
    },
    "plan": {
      "artAdvisor": {
        "badge": "PRO",
        "cta": "Découvrir",
        "feature1": "Accès aux collections de vos clients",
        "feature2": "Interface multi-portefeuilles",
        "feature3": "Rapports exportables à votre image",
        "feature4": "Outils de présentation",
        "tagline": "Tableau de bord centralisé multi-clients"
      },
      "artAdvisorPremium": {
        "badge": "PRO+",
        "cta": "Découvrir",
        "feature1": "Collections clients illimitées",
        "feature2": "Lancement d'analyses Vision pour tous vos clients",
        "feature3": "Co-marquage rapports",
        "feature4": "Tableau de bord agrégé",
        "tagline": "Clients illimités & analyses Vision"
      },
      "badge": {
        "current": "PLAN ACTUEL"
      },
      "button": {
        "current": "Plan actuel",
        "downgrade": "Revenir à {{title}}",
        "upgrade": "Passer à {{title}}"
      },
      "currentNote": "Vous utilisez actuellement ce plan",
      "familyOffice": {
        "badge": "ENTERPRISE",
        "cta": "S'abonner",
        "feature1": "Portefeuilles illimités",
        "feature2": "Reporting personnalisé avancé",
        "feature3": "Intégration ERP/PMS",
        "feature4": "Conformité réglementaire",
        "feature5": "Account manager dédié",
        "feature6": "SLA garanti",
        "tagline": "Solution institutionnelle sur-mesure"
      },
      "fondation": {
        "badge": "INSTITUTION",
        "cta": "S'abonner",
        "feature1": "Inventaire institutionnel illimité",
        "feature2": "Gestion des prêts, dépôts et expositions",
        "feature3": "Accès multi-utilisateurs & équipes curatoriales",
        "feature4": "Rapports institutionnels et publics",
        "feature5": "Vision IA sur l'ensemble de la collection",
        "feature6": "Conformité patrimoniale et réglementaire",
        "tagline": "Gestion patrimoniale pour institutions culturelles"
      },
      "premium": {
        "cta": "Passer en Premium",
        "feature1": "Analyse visuelle IA avancée",
        "feature2": "Recommandations conservation",
        "feature3": "Matching successoral",
        "feature4": "Veille média & alertes marché",
        "feature5": "Rapports détaillés",
        "tagline": "Intelligence artificielle & insights"
      },
      "standard": {
        "cta": "Commencer",
        "feature1": "Inventaire illimité d'œuvres",
        "feature2": "Gestion artistes & localisation",
        "feature3": "Fiscalité & conservation de base",
        "feature4": "Exports et rapports PDF",
        "tagline": "Inventaire & gestion essentielle"
      },
      "trialBadge": "14 jours gratuits"
    },
    "section": {
      "collectors": {
        "subtitle": "Gérez votre collection personnelle avec simplicité et intelligence",
        "title": "Pour les collectionneurs"
      },
      "pro": {
        "subtitle": "Outils avancés pour art advisors, family offices et institutions",
        "title": "Pour les professionnels"
      }
    },
    "trial": {
      "text": "Profitez de 14 jours d'essai gratuit sur le plan Standard pour toute inscription avant le 15 février 2026. Découvrez toutes les fonctionnalités sans engagement.",
      "title": "Offre de lancement exclusive"
    }
  },
  "ocr": {
    "enrich": {
      "button": "Analyser le document",
      "loading": "Analyse en cours…",
      "success": "Document analysé avec succès",
      "error": "Erreur lors de l’analyse",
      "noFile": "Aucun document sélectionné",
      "unsupported": "Format non supporté"
    },
    "fields": {
      "title": "Titre",
      "artist": "Artiste",
      "year": "Année",
      "medium": "Technique",
      "dimensions": "Dimensions",
      "price": "Prix",
      "currency": "Devise",
      "source": "Source",
      "auctionHouse": "Maison de vente",
      "saleDate": "Date de vente"
    },
    "invoice": {
      "label": "Facture",
      "detected": "Facture détectée",
      "number": "Numéro de facture",
      "total": "Montant total",
      "buyer": "Acheteur",
      "seller": "Vendeur"
    }
  },
  "profile": {
    "demo": {
      "ribbon": {
        "label": "PROFIL DÉMO",
        "text": "Vous naviguez sur un compte de démonstration. Certaines actions (paiement, emails, abonnements) sont simulées."
      }
    },
    "edit": {
      "birthYear": "Année de naissance",
      "company": "Entreprise",
      "confirmPassword": "Confirmer le mot de passe",
      "error": {
        "birthYear": "Veuillez entrer une année de naissance valide entre 1900 et {{currentYear}}.",
        "generic": "Une erreur est survenue : {{message}}",
        "passwordMatch": "Les mots de passe ne correspondent pas.",
        "required": "Veuillez remplir les champs nom et prénom."
      },
      "firstName": "Prénom",
      "lastName": "Nom",
      "password": "Nouveau mot de passe",
      "save": "Enregistrer",
      "success": "Profil mis à jour avec succès !",
      "title": "Modifier le profil"
    },
    "firstname": "Prénom",
    "fiscal": {
      "description": "Choisissez votre régime par défaut pour l'export PDF des ventes/donations. Sans choix, l'export affichera uniquement les montants (sans calcul d'impôt).",
      "error": {
        "save": "Impossible d'enregistrer la préférence fiscale."
      },
      "saving": "Enregistrement…",
      "select": {
        "DE_PRIVATE_1Y_RULE": "Allemagne — Exonération > 1 an",
        "FR_FORFAIT_6_5": "France — Forfait 6,5 %",
        "FR_PLUS_VALUE": "France — Plus-value (19 % + 17,2 %)",
        "none": "Aucun (ne pas calculer)",
        "UK_CGT_SIMPLE_20": "Royaume-Uni — CGT (20 % simplifié)"
      },
      "title": "Préférence fiscale"
    },
    "info": {
      "birthYear": "Année de naissance",
      "company": "Entreprise",
      "email": "Email",
      "firstName": "Prénom",
      "lastName": "Nom",
      "loading": "Chargement du profil…",
      "title": "Informations personnelles"
    },
    "page": {
      "title": "Mon profil",
      "eyebrow": "Espace personnel",
      "subtitle": "Gérez vos informations, votre abonnement et vos préférences de confidentialité."
    },
    "sections": {
      "identity": {
        "eyebrow": "Profil",
        "title": "Mon identité",
        "desc": "Vos informations personnelles et vos coordonnées."
      },
      "billing": {
        "eyebrow": "Réglages",
        "title": "Préférences & facturation",
        "desc": "Votre abonnement, vos préférences fiscales et vos informations de facturation."
      },
      "privacy": {
        "eyebrow": "Données",
        "title": "Confidentialité & IA",
        "desc": "Vos consentements pour les fonctionnalités d'intelligence artificielle."
      }
    },
    "subscription": {
      "beta": {
        "confirm": {
          "cta": "Confirmer mon abonnement"
        },
        "discount": {
          "hint": "Réduction",
          "lifetime": "à vie après confirmation",
          "text": "Votre réduction bêta est activée sur vos abonnements.",
          "title": "Bêta : -30% à vie"
        },
        "ended": {
          "text": "Votre accès gratuit est terminé. Confirmez pour conserver -30% à vie.",
          "title": "Fin de période bêta"
        },
        "free": {
          "text": "Votre compte est dans le programme bêta.",
          "title": "Bêta : 6 mois offerts"
        },
        "title": "Programme bêta"
      },
      "billingButton": "Facturation",
      "currentPlan": {
        "none": "Aucun plan"
      },
      "currentPlanLabel": "Plan actuel",
      "demo": {
        "actionsDisabled": "Les actions de paiement sont désactivées sur ce compte de démonstration.",
        "info": {
          "text": "Vous utilisez un compte de démonstration. Pour accéder aux fonctionnalités complètes, créez un compte réel.",
          "title": "Compte démo :"
        },
        "mode": "🎭 Mode démonstration",
        "note": "Note : Ceci est un abonnement de démonstration. Les factures et paiements sont simulés à des fins de test.",
        "planLabel": "Plan {{plan}}",
        "portalButton": "Portail de facturation (démo)",
        "portalDisabledTooltip": "Fonctionnalité désactivée en mode démo",
        "status": {
          "active": "Actif (simulé)",
          "canceled": "Annulé (simulé)",
          "none": "Aucun abonnement",
          "past_due": "Paiement en retard (simulé)",
          "trialing": "Essai gratuit (simulé)"
        }
      },
      "demoNoSub": {
        "badge": "🎭 Compte de démonstration",
        "help": "Pour tester l'affichage d'un abonnement actif, contactez l'administrateur pour activer un abonnement simulé sur ce compte démo.",
        "text": "Ce compte ne nécessite pas d'abonnement réel. Toutes les fonctionnalités sont accessibles en mode démo.",
        "title": "Abonnement (Démo)"
      },
      "demoWithSub": {
        "title": "Abonnement & facturation"
      },
      "error": {
        "payment": "Erreur de paiement : {{message}}",
        "portal": "Erreur du portail de facturation : {{message}}",
        "portalUnavailable": "Le portail de facturation Stripe est indisponible.",
        "missingPrice": "Identifiant de prix Stripe manquant pour ce plan.",
        "stripeUnavailable": "Stripe n’est pas initialisé.",
        "checkoutUnavailable": "Impossible de créer la session de paiement Stripe."
      },
      "freeAccess": {
        "noBilling": "Facturation désactivée pour ce compte.",
        "note": "Accès complet débloqué pour test. Aucun paiement requis.",
        "until": "Valable jusqu'au"
      },
      "loading": "Chargement...",
      "manageButton": "Gérer mon abonnement",
      "satellite": {
        "text": "La facturation est gérée par le titulaire du compte.",
        "title": "👤 Compte collaborateur",
        "textNamed": "Votre accès est inclus dans l’abonnement de {{name}}. Aucun paiement n’est requis de votre part.",
        "caption": "Compte collaborateur · aucun abonnement requis"
      },
      "sectionTitle": "Mon abonnement",
      "status": {
        "active": "Actif",
        "demo": "Démo",
        "freeAccess": "Accès offert",
        "inactive": "Inactif",
        "trialing": "Essai gratuit"
      },
      "sectionSubtitle": "Plans, facturation Stripe et accès aux modules Artkiv.",
      "currentPlanButton": "Plan actuel",
      "processing": "Redirection…",
      "choosePlan": "Choisir ce plan",
      "compareButton": "Comparer les plans",
      "portalProcessing": "Ouverture…",
      "billingPortalButton": "Portail Stripe"
    },
    "title": "Informations de votre profil",
    "update": {
      "help": "Mettez à jour les informations de votre profil pour tirer le meilleur parti de votre compte."
    },
    "plans": {
      "standard": {
        "label": "Standard",
        "description": "Inventaire, géolocalisation, exports et gestion essentielle."
      },
      "premium": {
        "label": "Premium",
        "description": "Vision IA, collaborateurs, experts, assurance et transmission."
      },
      "artAdvisor": {
        "label": "Art Advisor",
        "description": "Gestion multi-clients jusqu’à 20 collections, avec accès IA limité."
      },
      "artAdvisorPremium": {
        "label": "Art Advisor Premium",
        "description": "Clients illimités, IA complète, lecture curatoriale et rapports avancés."
      },
      "familyOffice": {
        "label": "Family Office",
        "description": "Vue multi-familles, reporting patrimonial, gouvernance et piste d’audit."
      }
    },
    "ia": {
      "error": {
        "save": "Impossible d’enregistrer le choix IA."
      },
      "title": "Fonctionnalités IA & consentement",
      "description": "Choisissez si vous souhaitez activer les modules IA Artkiv et consultez précisément ce qu’ils font avant de donner votre accord.",
      "descriptionUnavailable": "Votre offre actuelle ne comprend pas les modules IA Artkiv. Vous pouvez continuer à gérer votre collection sans IA.",
      "status": {
        "active": "IA activée",
        "unavailable": "IA non incluse",
        "inactive": "IA désactivée"
      },
      "saving": "Enregistrement du choix…"
    },
    "loading": "Chargement du profil…",
    "error": {
      "missing": {
        "title": "Profil indisponible",
        "text": "Le profil n’a pas pu être récupéré. Vérifiez que l’utilisateur possède une ligne dans profiles et que la politique RLS autorise la lecture."
      }
    }
  },
  "questionnaire": {
    "comments": {
      "label": "Autres commentaires :",
      "placeholder": "Informations supplémentaires ou préférences spécifiques."
    },
    "interest": {
      "high": "Élevé",
      "label": "Votre niveau d'intérêt pour gérer la collection :",
      "low": "Faible",
      "medium": "Moyen"
    },
    "preferred": {
      "label": "Pièces préférées ou désirées :",
      "placeholder": "Décrivez les œuvres que vous aimeriez gérer ou hériter."
    },
    "select": "Sélectionnez...",
    "submit": "Soumettre",
    "title": "Questionnaire pour {{name}}"
  },
  "rapportValorisationAdvisor": {
    "common": {
      "noValue": "—",
      "unknownArtist": "Artiste inconnu",
      "untitled": "Sans titre"
    },
    "finality": {
      "assurance": {
        "badge": "Valeur de remplacement",
        "description": "Détermine la valeur de remplacement à neuf pour la couverture contractuelle. Retient généralement la valeur la plus haute du marché.",
        "label": "Évaluation d'assurance"
      },
      "marche": {
        "badge": "Valeur de cession",
        "description": "Fourchette réaliste pour une vente ou acquisition. Croise résultats d'enchères, marché privé et cote de l'artiste.",
        "label": "Juste valeur marchande"
      },
      "pret": {
        "badge": "Valeur de réalisation forcée",
        "description": "Valeur de réalisation forcée utilisée comme sûreté bancaire. Représente généralement 50 à 70 % de la valeur vénale.",
        "label": "Garantie de prêt"
      },
      "succession": {
        "badge": "Valeur vénale au jour J",
        "description": "Utilisée pour la déclaration patrimoniale ou la transmission. Doit être cohérente avec les barèmes fiscaux et notariaux en vigueur.",
        "label": "Évaluation successorale"
      }
    },
    "header": {
      "badge": "Rapport · Art Advisor Premium",
      "subtitle": "Construisez un rapport d'estimation professionnel pour votre client. Choisissez la finalité, sélectionnez les œuvres, renseignez vos données, puis exportez en PDF ou Word éditable.",
      "title": "Rapport de Valorisation"
    },
    "methods": {
      "assurance_doc": "Document assureur / rapport d'assurance",
      "physique": "Expertise physique (externe)",
      "point": "Méthode du point (cotation artiste)",
      "semblables": "Estimation par œuvres semblables",
      "succession": "Module succession Artkiv"
    },
    "sources": {
      "artnet": "Artnet",
      "artprice": "Artprice",
      "bonhams": "Bonhams",
      "christies": "Christie's",
      "drouot": "Drouot",
      "insuranceReport": "Rapport d'assurance",
      "other": "Autre",
      "primaryGallery": "Galerie (marché primaire)",
      "privateMarket": "Marché privé",
      "sothebys": "Sotheby's"
    },
    "step1": {
      "advisorName": "Votre nom (advisor signataire)",
      "clientName": "Nom du client (facultatif)",
      "clientNamePlaceholder": "Ex. : Collection Dupont",
      "continue": "Continuer →",
      "subtitle": "La finalité détermine la méthode de référence et le niveau de valeur à retenir.",
      "title": "Quelle est la finalité de cette évaluation ?"
    },
    "step2": {
      "allCollections": "Toutes les collections",
      "artworksCount": "{{count}} œuvre",
      "artworksCount_plural": "{{count}} œuvres",
      "back": "← Retour",
      "chosenFinality": "Finalité choisie :",
      "emptySearch": "Aucune œuvre ne correspond à la recherche.",
      "emptySource": "Aucune œuvre dans cette collection.",
      "next": "Suivant →",
      "nextManual": "Continuer → (saisie manuelle)",
      "nextWithCount": "Continuer → ({{count}} œuvre)",
      "nextWithCount_plural": "Continuer → ({{count}} œuvres)",
      "noEstimate": "Pas d’estimation",
      "noSourceSelected": "Choisissez une source ci-dessus pour afficher les œuvres.",
      "offPlatformHint": "Les œuvres seront saisies manuellement à l’étape suivante.",
      "offPlatformPlaceholder": "Ex. : Famille Martin",
      "offPlatformTitle": "Nom du client hors plateforme",
      "pageSelection": "Page ({{count}})",
      "paginationSummary": "{{count}} œuvre · p.{{page}}/{{total}}",
      "paginationSummary_plural": "{{count}} œuvres · p.{{page}}/{{total}}",
      "previous": "← Précédent",
      "searchPlaceholder": "Rechercher titre, artiste, n° inventaire…",
      "selectAll": "Tout sélectionner ({{count}})",
      "selectedCount": "{{count}} sélectionnée(s)",
      "sourceOffPlatform": "Client hors plateforme",
      "sourceOwn": "Mes collections",
      "sourceSharedClient": "Client partagé",
      "sourceTitle": "Source de la collection",
      "title": "Sélectionnez les œuvres à évaluer",
      "unselectAll": "Désélectionner tout"
    },
    "step3": {
      "addArtwork": "+ Ajouter une œuvre",
      "artkivReference": "Référence Artkiv",
      "back": "← Retour",
      "delete": "Supprimer",
      "finalValuePlaceholder": "Valeur finale",
      "highRange": "Fourchette haute (€)",
      "justification": "Justification de la valeur retenue",
      "justificationPlaceholder": "Ex. : Comparable direct vendu chez Drouot en 2024 pour 18 000 €. Légère décote de 10% appliquée compte tenu de l'état de conservation.",
      "lowRange": "Fourchette basse (€)",
      "manualArtistPlaceholder": "Artiste",
      "manualEmpty": "Cliquez sur “+ Ajouter une œuvre” pour saisir les œuvres de ce client.",
      "manualTitlePlaceholder": "Titre",
      "method": "Méthode utilisée",
      "next": "Voir la synthèse →",
      "notes": "Recommandations globales de l'Advisor (optionnel)",
      "notesPlaceholder": "Vos recommandations générales : stratégie de cession, alertes de conservation, pistes d'acquisition complémentaires…",
      "required": "*",
      "retainedValue": "Valeur retenue (€)",
      "sources": "Sources consultées",
      "subtitle": "Pour chaque œuvre, indiquez la fourchette, la valeur retenue, la méthode et les sources. Les références Artkiv existantes apparaissent automatiquement.",
      "title": "Renseignez les données d'estimation",
      "totalDraft": "Valeur totale provisoire"
    },
    "step4": {
      "disclaimer": "Ce rapport est établi à titre indicatif. Il ne constitue pas une expertise juridiquement opposable. Une expertise physique par un expert agréé reste nécessaire pour toute transaction, succession ou litige.",
      "disclaimerItalic": "Artkiv accompagne l'Advisor sans se substituer à son expertise.",
      "downloadPdf": "Télécharger le PDF",
      "downloadWord": "Télécharger en Word (.docx)",
      "editData": "← Modifier les données",
      "generating": "Génération…",
      "newReport": "Nouveau rapport",
      "subtitle": "Vérifiez la synthèse, puis téléchargez en PDF (remise client) ou Word (édition libre).",
      "summary": {
        "artworks": "Œuvres",
        "date": "Date",
        "finality": "Finalité",
        "totalValue": "Valeur totale"
      },
      "title": "Rapport prêt à l'export"
    },
    "stepper": {
      "artworks": "Œuvres",
      "data": "Données",
      "export": "Export",
      "finality": "Finalité"
    }
  },
  "reports": {
    "data": {
      "includeArtist": "Nom de l'artiste",
      "includeLocation": "Localisation",
      "includeMedium": "Médium",
      "includePrice": "Prix / Valeur estimée",
      "includeSize": "Dimensions",
      "title": "Données à inclure"
    },
    "error": "Erreur :",
    "generate": {
      "button": "Générer le PDF",
      "loading": "Génération en cours..."
    },
    "layout": {
      "groupBy": {
        "artist": "Artiste",
        "location": "Localisation",
        "medium": "Médium",
        "none": "Aucun groupement",
        "year": "Année"
      },
      "sortBy": {
        "acquisitionDate": "Date d'acquisition",
        "artist": "Artiste",
        "creationYear": "Année de création",
        "name": "Titre",
        "value": "Valeur"
      },
      "title": "Mise en page"
    },
    "name": {
      "label": "Nom du rapport"
    },
    "options": {
      "includeDate": "Inclure la date d'aujourd'hui",
      "includePurchaseValue": "Valeur d'achat totale",
      "includeThumbnails": "Inclure les miniatures (images des œuvres)",
      "includeValueTotal": "Totaux de valeur des œuvres",
      "title": "Options du rapport"
    },
    "title": "Créer un rapport",
    "type": {
      "acquisition": "Historique d'acquisition",
      "artist": "Rapport par artiste",
      "condition": "Rapport d'état des œuvres",
      "exhibition": "Catalogue d'exposition",
      "insurance": "Rapport pour assurance",
      "inventory": "Rapport d'inventaire",
      "label": "Type de rapport",
      "location": "Rapport par localisation",
      "valuation": "Rapport d'évaluation"
    },
    "viewExisting": "Voir les rapports existants",
    "whiteLabel": {
      "companyName": {
        "current": "Actuellement : {{name}}",
        "label": "Nom de votre entreprise ou cabinet",
        "notSet": "Non renseigné"
      },
      "editProfile": "Modifier dans mon profil →",
      "enable": "Activer",
      "info": "💡 Vos rapports seront générés avec votre identité professionnelle au lieu de la marque Artkiv. Idéal pour présenter à vos clients.",
      "logo": {
        "add": "Ajouter un logo →",
        "change": "Changer le logo →",
        "label": "Votre logo",
        "notSet": "Aucun logo uploadé. Ajoutez votre logo dans votre profil pour personnaliser vos rapports."
      },
      "subtitle": "Générez un rapport avec votre identité professionnelle",
      "title": "Rapport personnalisé"
    }
  },
  "sale": {
    "conditionNotes": {
      "title": "Notes sur l'état"
    },
    "description": {
      "title": "Description"
    },
    "details": {
      "condition": "État",
      "dimensions": "Dimensions (LxH)",
      "signature": "Signature",
      "subject": "Sujet",
      "technique": "Technique",
      "title": "Détails",
      "type": "Type d'art",
      "year": "Année"
    },
    "dimensions": "Dimensions : {{value}}",
    "loading": "Chargement...",
    "none": "Aucune œuvre trouvée.",
    "notAvailable": "Œuvre non disponible à la vente.",
    "notFound": "Œuvre introuvable.",
    "options": "Options : Livraison / Transport sur demande.",
    "price": {
      "label": "Prix de vente",
      "note": "(hors taxes, frais de transport et de douane)",
      "undefined": "Non défini"
    },
    "request": {
      "button": "Demander des informations (état, provenance, etc.)",
      "checkbox": "Je comprends que ces informations sont confidentielles et resteront privées.",
      "errorCheckbox": "Veuillez cocher la case de confidentialité avant de soumettre.",
      "success": "Votre demande d'information a été envoyée. Un conseiller vous répondra sous peu.",
      "title": "Demande d'informations complémentaires"
    },
    "tags": {
      "title": "Tags"
    },
    "yearMedium": "{{year}} — {{medium}}",
    "imageAlt": "Œuvre d’art"
  },
  "salesDonations": {
    "addModal": {
      "addDocuments": "Ajouter des documents",
      "documentsHelper": "Ajoutez des factures, reçus fiscaux ou certificats",
      "field": {
        "amount": "Montant de la vente (€)",
        "artist": "Artiste",
        "artwork": "Nom de l'œuvre",
        "buyer": "Acheteur",
        "date": "Date de la transaction",
        "details": "Détails",
        "documents": "Documents",
        "recipient": "Bénéficiaire",
        "taxYear": "Année fiscale",
        "type": "Type de transaction",
        "valuation": "Valeur estimée (€)"
      },
      "title": "Nouvelle transaction",
      "type": {
        "donation": "Donation",
        "sale": "Vente"
      }
    },
    "details": {
      "field": {
        "amount": "Montant",
        "artist": "Artiste",
        "artwork": "Œuvre",
        "buyer": "Acheteur",
        "date": "Date",
        "details": "Détails",
        "documents": "Documents",
        "estimatedValue": "Valeur estimée",
        "recipient": "Bénéficiaire",
        "taxYear": "Année fiscale",
        "type": "Type"
      },
      "title": "Détails de la transaction",
      "viewDocument": "Voir"
    },
    "export": {
      "button": "GÉNÉRER LE PDF",
      "yearAll": "Toutes",
      "yearToGenerate": "Année fiscale à générer"
    },
    "filters": {
      "taxYear": {
        "all": "Toutes les années fiscales",
        "label": "Année fiscale"
      },
      "transactionType": {
        "all": "Toutes les transactions",
        "donation": "Donations",
        "donations": "Donations uniquement",
        "lossVol": "Pertes & Vols",
        "sale": "Ventes",
        "sales": "Ventes uniquement",
        "label": "Type de transaction"
      },
      "taxYearOptions": {
        "all": "Toutes"
      },
      "transactionTypeOptions": {
        "all": "Toutes",
        "donation": "Donations",
        "sale": "Ventes"
      }
    },
    "history": {
      "addTransaction": "Ajouter une transaction",
      "col": {
        "actions": "Actions",
        "amount": "Montant",
        "artist": "Artiste",
        "artwork": "Œuvre",
        "counterparty": "Acheteur / Bénéficiaire",
        "date": "Date",
        "police": "Plainte",
        "taxYear": "Année fiscale",
        "type": "Type"
      },
      "noEvent": "Aucun événement pour ce filtre.",
      "title": "Historique des transactions",
      "viewDetails": "Détails",
      "noTransaction": "Aucune transaction pour ce filtre."
    },
    "losses": {
      "badge": {
        "noPolice": "Sans plainte",
        "policeNo": "Non",
        "policeYes": "✓ Déposée",
        "recovered": "Récupérée",
        "withPolice": "✓ Plainte déposée"
      },
      "events": "{{count}} événement",
      "events_plural": "{{count}} événements",
      "modal": {
        "ctaRecover": "✓ Œuvre retrouvée",
        "fiscalNoteNoPolice": "⚠ Sans plainte déposée, la déductibilité fiscale de cette perte n'est généralement pas applicable en France.",
        "fiscalNoteWithPolice": "✓ Plainte déposée — cette perte peut être déductible fiscalement. Consultez votre expert-comptable.",
        "insuranceNo": "Non",
        "insuranceYes": "✓ Oui",
        "notRecovered": "Non récupérée",
        "policeNo": "Non — perte non déductible",
        "policeYes": "✓ Oui",
        "recovered": "✓ Récupérée le {{date}}",
        "recovering": "En cours…",
        "title": "Perte / Vol — Détail",
        "reference": "Réf. {{reference}}",
        "fields": {
          "type": "Type",
          "artwork": "Œuvre",
          "artist": "Artiste",
          "date": "Date",
          "declaredValue": "Valeur déclarée",
          "indemnity": "Indemnisation",
          "taxYear": "Année fiscale",
          "location": "Lieu",
          "policeReport": "Plainte déposée",
          "insuranceClaim": "Déclaration assurance",
          "status": "Statut",
          "notes": "Notes"
        }
      },
      "recovered": "{{count}} récupérée",
      "recovered_plural": "{{count}} récupérées",
      "deductionPrefix": "−",
      "taxYear": "Année fiscale {{year}}",
      "events_one": "{{count}} événement",
      "events_other": "{{count}} événements",
      "recovered_one": "{{count}} récupérée",
      "recovered_other": "{{count}} récupérées",
      "types": {
        "theft": "Vol",
        "loss": "Perte",
        "destruction": "Destruction",
        "disappearance": "Disparition",
        "generic": "Perte / Vol"
      }
    },
    "pdf": {
      "column": {
        "amount": "Montant (€)",
        "count": "Nombre",
        "section": "Rubrique"
      },
      "disclaimer": {
        "body": "Ce document est généré à partir des informations que vous avez saisies dans Artkiv (montants, dates, pièces justificatives, sélections de régime fiscal). Artkiv ne fournit pas de conseil fiscal, ne garantit pas l'exactitude, l'exhaustivité ni la mise à jour des données, et ne saurait être tenue responsable d'erreurs de saisie, d'interprétation ou d'utilisation du présent document. Les calculs et estimations ont une valeur indicative et doivent être validés par votre conseiller fiscal/avocat. Les règles fiscales peuvent varier selon le pays, la situation du contribuable et l'évolution des lois en vigueur.",
        "title": "Disclaimer / Limitation de responsabilité."
      },
      "donationsDetails": {
        "artist": "Artiste",
        "artwork": "Œuvre",
        "date": "Date",
        "estimatedValue": "Valeur estimée (€)",
        "none": "Aucune donation déclarée pour {{year}}.",
        "recipient": "Bénéficiaire",
        "title": "Détails des donations"
      },
      "error": "Impossible de générer le PDF.",
      "generatedFromArtkiv": "Document préparé automatiquement à partir des données de ventes et donations enregistrées dans Artkiv.",
      "notes": {
        "de": "Note : DE – vente privée exonérée si détention > 1 an ; sinon l'imposition dépend de l'IR, non estimée ici.",
        "frForfait": "Note : FR – taxe forfaitaire 6 % + 0,5 % CRDS appliquée par cession si le prix > 5 000 €.",
        "frPlusValue": "Note : FR – plus-value imposée à 19 % + 17,2 % (PS) avec abattement de 5 %/an à partir de la 3ᵉ année (exonération à 22 ans).",
        "none": "Note : aucun régime n'est sélectionné — ce récapitulatif présente les montants sans calcul d'impôt.",
        "uk": "Note : UK – estimation simplifiée à 20 % sur la plus-value (hors abattement annuel et banding)."
      },
      "row": {
        "donations": "Donations",
        "estimatedTax": "Impôt estimé (si calculable)",
        "regime": "Régime fiscal sélectionné",
        "sales": "Ventes",
        "totalOperations": "Total opérations"
      },
      "salesDetails": {
        "artist": "Artiste",
        "artwork": "Œuvre",
        "buyer": "Acheteur",
        "date": "Date",
        "none": "Aucune vente déclarée pour {{year}}.",
        "price": "Prix (€)",
        "purchaseDate": "Date d'acquisition",
        "purchasePrice": "Prix d'achat",
        "title": "Détails des ventes"
      },
      "titleAllYears": "Rapport fiscal – Toutes années",
      "titleYear": "Rapport fiscal – {{year}}",
      "yearTitle": "Année fiscale {{year}}"
    },
    "regime": {
      "de": "Allemagne – Exonéré si détention > 1 an",
      "frForfait": "France – Taxe forfaitaire 6,5% (par cession > 5 000€)",
      "frPlusValue": "France – Plus-value (19% + 17,2%, abattement 5%/an après 2 ans)",
      "none": "Aucun régime sélectionné",
      "uk": "Royaume-Uni – CGT estimée 20% (simplifié)"
    },
    "summary": {
      "col": {
        "actions": "Actions",
        "donations": "Total donations",
        "losses": "Pertes déductibles",
        "lossesTooltip": "Pertes/vols avec plainte déposée, non récupérées",
        "sales": "Total ventes",
        "total": "Total",
        "year": "Année fiscale"
      },
      "estimatedTax": "Impôt estimé :",
      "exportYear": "Exporter PDF",
      "noRegime": "Aucun régime fiscal n'est défini pour votre compte. Rendez-vous dans Mon Profil > Préférence fiscale pour choisir (FR / UK / DE). L'export PDF affichera les montants sans calcul d'impôt tant que rien n'est sélectionné.",
      "regimeLabel": {
        "frForfait": "Forfait 6,5% (par cession > 5 000€)",
        "frPlusValue": "Plus-value (19% + 17,2%, abattement 5%/an après 2 ans)"
      },
      "title": "Résumé fiscal"
    },
    "title": "Ventes & Donations",
    "eyebrow": "Patrimoine · Transactions",
    "errors": {
      "updateLoss": "Erreur lors de la mise à jour : {{message}}"
    }
  },
  "sharedAccess": {
    "collection": {
      "all": "Toutes les collections",
      "sharedOn": "Partage activé par le client le {date}",
      "unnamed": "Collection sans nom"
    },
    "empty": "Aucun accès partagé pour le moment",
    "error": "Impossible de charger les accès partagés",
    "expert": {
      "certified": "Certifié",
      "collections": "Collections partagées ({count})"
    },
    "loading": "Chargement...",
    "permission": {
      "edit": "Édition",
      "read": "Lecture"
    },
    "role": {
      "expert": "Expert",
      "familyOffice": "Family Office",
      "team": "Équipe",
      "user": "Utilisateur"
    },
    "section": {
      "experts": "Experts ({count})",
      "users": "Autres utilisateurs ({count})"
    },
    "subtitle": "{experts} expert(s) • {users} utilisateur(s)",
    "title": "Accès partagés"
  },
  "signature": {
    "title": "Signature & authentification",
    "authLabel": "Certificat / authentification",
    "authPlaceholder": "Certificat de galerie, archive de l’artiste…",
    "description": "Décrivez la signature, les éléments d’authentification et tout indice de traçabilité.",
    "notesLabel": "Notes complémentaires",
    "notesPlaceholder": "Mention manuscrite, tampon, sceau…",
    "signatureLabel": "Signature",
    "signatureBooleanLabel": "Œuvre signée",
    "signaturePlaceholder": "Signé en bas à droite, daté…",
    "certificateLabel": "Certificat d’authenticité",
    "certificatePresent": "Certificat présent",
    "certificateInDocuments": "Disponible dans les documents :",
    "certificateFallbackName": "Certificat d’authenticité",
    "noCertificate": "Aucun certificat renseigné",
    "lotHelp": "Cette œuvre fait partie d’un lot. Vous pouvez appliquer cette signature à toutes les œuvres du lot.",
    "applyToLot": "Appliquer à tout le lot",
    "applyToLotLoading": "Application…",
    "applyToLotConfirm": "Appliquer cette signature à toutes les œuvres du lot ?",
    "applyToLotError": "Échec de l’application au lot.",
    "applyToLotSuccess": "Signature appliquée à {{count}} œuvre(s) du lot."
  },
  "subscriptionGuard": {
    "currentStatus": "Statut actuel :",
    "explanation": "Veuillez finaliser votre paiement pour accéder à toutes les fonctionnalités.",
    "invoices": "Mes factures",
    "openPortal": "Ouvrir le portail de facturation",
    "payNow": "Régler mon abonnement",
    "plan": "Plan",
    "title": "Abonnement requis",
    "processing": "Traitement…",
    "freeUntil": "Accès gratuit jusqu’au {{date}}.",
    "demo": {
      "noStripe": "Compte démo : aucun paiement Stripe.",
      "noPaymentRequired": "Mode démo : aucun paiement requis."
    },
    "errors": {
      "checkout": "Impossible de démarrer le paiement. Réessayez dans quelques instants.",
      "portal": "Impossible d’ouvrir le portail de facturation.",
      "stripeUnavailable": "Stripe n’est pas disponible pour le moment."
    },
    "status": {
      "demo": "démo",
      "free": "gratuit",
      "active": "actif",
      "trialing": "période d’essai",
      "past_due": "paiement en retard",
      "canceled": "annulé",
      "cancelled": "annulé",
      "unpaid": "impayé",
      "none": "inactif"
    },
    "plans": {
      "standard": "Standard",
      "premium": "Premium",
      "demo": "Démo",
      "internal_demo": "Démo interne",
      "beta_demo": "Bêta démo"
    }
  },
  "estimationSemblables": {
    "methodology": {
      "toDefine": {
        "badge": "À cataloguer",
        "socle": "Aucune cotation personnelle artiste n'est encore attachée à cette oeuvre.",
        "signal": "Ajoutez ou importez des comparables, puis cataloguez l'artiste pour verrouiller la méthode.",
        "adjustment": "Le moteur ne peut pas encore distinguer une CUP directe, une CUP par analogie ou une méthode à points.",
        "conclusion": "L'estimation reste préparatoire tant que le socle méthodologique n'est pas défini."
      },
      "pointMethod": {
        "badge": "Méthode à points",
        "socle": "Groupe C — absence de marché secondaire suffisamment constitué.",
        "signal": "La valorisation repose sur la grille expert : médium, dimensions, état de conservation et éventuels bonus documentaires.",
        "adjustment": "Les prix de galerie ou signaux externes servent de contexte mais ne remplacent pas la méthode à points.",
        "conclusion": "La valeur affichée est une juste valeur indicative, fondée sur un marché primaire encadré et non sur une liquidité d'enchères."
      },
      "quasiDirectCup": {
        "badge": "Quasi CUP directe",
        "socle": "Groupe B — CUP par analogie dans la cotation initiale.",
        "adjustment": "Les ventes récentes deviennent suffisamment nombreuses et cohérentes pour réduire la décote prudentielle initiale.",
        "conclusion": "L'estimation reste rattachée au Groupe B, mais la lecture du moteur se rapproche d'une CUP directe partielle."
      },
      "hybridReinforced": {
        "badge": "Hybride renforcé",
        "socle": "Groupe B — CUP par analogie : marché secondaire historiquement limité ou peu homogène.",
        "adjustment": "Ces ventes fraîches renforcent partiellement la fiabilité de la valorisation et corrigent la lecture prudente initiale.",
        "conclusion": "Le moteur combine cotation expert, résultats propres récents, fraîcheur, proximité technique et médiane pondérée."
      },
      "analogyPrudent": {
        "badge": "Analogie prudente",
        "socle": "Groupe B — CUP par analogie : les résultats propres récents restent insuffisants.",
        "signalOne": "Un seul comparable récent est présent : il sert de signal, pas de base autonome.",
        "signalNone": "Aucun signal récent suffisant n'a encore été détecté dans les comparables complets.",
        "adjustment": "La décote prudentielle reste majoritairement active tant que le marché récent n'est pas mieux documenté.",
        "conclusion": "L'estimation doit être lue comme une valorisation analogique, avec prudence sur la liquidité."
      },
      "directCupActive": {
        "badge": "CUP directe active",
        "socle": "Groupe A — CUP directe : marché secondaire documenté.",
        "adjustment": "Les ventes récentes sont pondérées par dimensions, technique, proximité artiste et fraîcheur.",
        "conclusion": "La médiane pondérée retient les comparables les plus fiables sans modifier directement les prix observés."
      },
      "directCupIncomplete": {
        "badge": "CUP directe à compléter"
      },
      "dynamic": {
        "badge": "Lecture dynamique",
        "adjustment": "Le moteur pondère les résultats selon la fraîcheur, la proximité technique et la cohérence dimensionnelle.",
        "conclusion": "La valorisation finale reste une aide à la décision et doit être validée par l'expert."
      },
      "groupB": {
        "b1label": "Hybride renforcé",
        "b1desc": "Des résultats propres récents existent mais restent insuffisants pour une CUP directe. Le moteur pondère résultats propres et analogies, avec prudence allégée (-8%).",
        "b2label": "Analogie prudente",
        "b2desc": "Aucun résultat propre récent suffisant. La valorisation repose sur des artistes analogues de profil similaire. Décote prudentielle standard de -15% appliquée conformément à la méthodologie CUP.",
        "b3label": "Quasi CUP directe",
        "b3desc": "Les résultats propres récents sont suffisants et cohérents pour une lecture proche d'une CUP directe partielle. La décote prudentielle est levée."
      }
    },
    "memory": {
      "addFromCup": "Cliquez sur Ajouter à l'estimation depuis l'assistant CUP ou l'outil de ratio. Les choix apparaîtront ici à la prochaine ouverture aussi.",
      "extrapolation": "Extrapolation",
      "retainedSale": "Vente retenue",
      "untitledExtrapolation": "Extrapolation sans titre",
      "untitledComparable": "Comparable sans titre",
      "artistMissing": "Artiste non renseigné",
      "sourceMissing": "Source non renseignée",
      "weight": "poids {{value}}",
      "remove": "Retirer",
      "low": "Bas",
      "high": "Haut"
    },
    "save": {
      "missingId": "Impossible d'enregistrer : estimation_id ou utilisateur manquant.",
      "valuationError": "Erreur lors de la sauvegarde de l'estimation.",
      "resolveFailed": "Impossible de résoudre l'estimation.",
      "irreparableAlert": "Cette oeuvre est classée Irréparable — dépréciation totale. Aucune valeur ne peut être enregistrée. Documentez la décision dans les notes de la fiche oeuvre.",
      "missingQuote": "La cotation artiste existe, mais il manque une fourchette ou des comparables exploitables.",
      "catalogFirst": "Cataloguez d'abord cet artiste dans vos cotations personnelles."
    },
    "ui": {
      "donationDirecteDeLArtisteEquivCertificat": "Donation directe de l'artiste (équiv. certificat)",
      "certificatDAuthenticite": "Certificat d'authenticité",
      "provenanceArtiste1erMarche": "Provenance artiste / 1er marché",
      "suiviDocumentaireComplet": "Suivi documentaire complet",
      "irreparableWriteOff": "Irréparable — write-off",
      "partiellementRestaurable65": "Partiellement restaurable −65%",
      "tresAbimeRestaurable50": "Très abîmé restaurable −50%",
      "tresMoyen30": "Très moyen −30%",
      "etatMoyen20": "État moyen −20%",
      "etatDeConservation": "État de conservation",
      "decotePrudentielle": "Décote prudentielle",
      "abattementLiquidite": "Abattement liquidité",
      "bonificationsDocumentaires": "Bonifications documentaires",
      "decotePrudentielleGroupeB": "Décote prudentielle Groupe B",
      "abattementDeLiquiditeGroupeC": "Abattement de liquidité Groupe C",
      "aucunAjustementMethodologiqueApplicable": "Aucun ajustement méthodologique applicable",
      "ajustementsAppliques": "Ajustements appliqués",
      "aucunAjustement": "Aucun ajustement",
      "groupeB": "Groupe B ·",
      "baseBruteAvantDecotes": "Base brute (avant décotes)",
      "valeurApresAjustements": "Valeur après ajustements",
      "valeurRetenue": "Valeur retenue",
      "ordreAppliqueEtatDeConservationDecotePrudentielleLiquiditeBonus": "Ordre appliqué : état de conservation → décote prudentielle / liquidité → bonus documentaires.",
      "methodologieADefinir": "Méthodologie à définir",
      "lectureMethodologiqueArtkiv": "Lecture méthodologique ARTKIV",
      "socleMethodologique": "Socle méthodologique",
      "signalMarcheRecent": "Signal marché récent",
      "ajustementDynamique": "Ajustement dynamique",
      "conclusionMoteur": "Conclusion moteur",
      "comparablesComplets": "Comparables complets :",
      "recents": "· récents :",
      "confiance": "· confiance :",
      "irreparableValeurNulleDepreciationTotale": "Irréparable — valeur nulle (dépréciation totale)",
      "lectureJustificationMarche": "lecture justification marché",
      "sauvegardeJustificationMarche": "sauvegarde justification marché",
      "lectureExpertDuMarche": "Lecture expert du marché",
      "ventesDirectes": "Ventes directes :",
      "extrapolations": "· extrapolations :",
      "analogies": "· analogies :",
      "enregistrement": "Enregistrement…",
      "enregistrerLaJustification": "Enregistrer la justification",
      "lesExtrapolationsEtAnalogiesConstituentDesOutilsDAide": "Les extrapolations et analogies constituent des outils d'aide à la décision expert et non des garanties de réalisation de prix.",
      "enregistreLe": "enregistré le",
      "memoireExpertDeCetteEstimation": "Mémoire expert de cette estimation",
      "aucunChoixExpertEnregistre": "Aucun choix expert enregistré",
      "ceBlocRecapituleLesVentesEtExtrapolationsReellementRetenues": "Ce bloc récapitule les ventes et extrapolations réellement retenues par l'expert pour justifier cette expertise.",
      "mediane": "Médiane",
      "extrapolationse5783c": "Extrapolations :",
      "fourchetteMemoire": "Fourchette mémoire :",
      "sauvegardeValuationArtwork": "sauvegarde valuation artwork",
      "creationComparablesManuelsNeutres": "création comparables manuels neutres",
      "sauvegardeComparablesRetenus": "sauvegarde comparables retenus",
      "cetteFonctionnaliteEstReserveeAuxComptesArtAdvisorPremium": "Cette fonctionnalité est réservée aux comptes Art Advisor Premium.",
      "ajoutezAuMoins3ComparablesCompletsAvantDeLancer": "Ajoutez au moins 3 comparables complets avant de lancer Vision.",
      "impossibleDeLancerLAnalyseVisionPourLeMoment": "Impossible de lancer l'analyse Vision pour le moment.",
      "veuillezDAbordSelectionnerUneUvreDepuisLa": "Veuillez d'abord sélectionner une œuvre depuis la",
      "pageDEstimation": "page d'estimation",
      "retourAuxEstimations": "Retour aux estimations",
      "estimationParUvresComparables": "Estimation par œuvres comparables",
      "comparezVotreUvreAvecDesVentesRecentesSimilaires": "Comparez votre œuvre avec des ventes récentes similaires",
      "commentCaMarche": "💡 Comment ça marche ?",
      "recherchezDes": "Recherchez des",
      "uvresSimilaires": "œuvres similaires",
      "venduesRecemmentMemeArtisteStylePeriodeDimensions": "vendues récemment (même artiste, style, période, dimensions)",
      "auMoins3Comparables": "au moins 3 comparables",
      "avecLeurPrixDeVente": "avec leur prix de vente",
      "indiquezVos": "Indiquez vos",
      "artpriceChristieSSothebySGaleries": "(Artprice, Christie's, Sotheby's, galeries...)",
      "lEquipeArtkiv": "L'équipe Artkiv",
      "valideEtAffine": "valide et affine",
      "votreEstimationSous4872h": "votre estimation sous 48-72h",
      "votreUvre": "Votre œuvre",
      "uvre": "Œuvre",
      "sansTitre": "Sans titre",
      "artiste": "Artiste :",
      "technique": "Technique :",
      "dimensions": "Dimensions :",
      "cetteUvreFaitPartie": "Cette œuvre fait partie",
      "dUnLot": "d'un lot",
      "pasBesoinDEstimerChaqueExemplaireSeparementALa": "Pas besoin d'estimer chaque exemplaire séparément. À la fin de ce parcours, vous pourrez",
      "appliquerCetteEstimationAToutLeLotEnUn": "appliquer cette estimation à tout le lot en un clic",
      "laDecoteSelonLEtatDeConservationSeraAppliquee": ". La décote selon l'état de conservation sera appliquée individuellement à chaque pièce (état moyen –20 %, très moyen –30 %, etc.).",
      "allerAuBoutonDApplicationAuLot": "Aller au bouton d'application au lot ↓",
      "chargementDesAutresExemplaires": "Chargement des autres exemplaires…",
      "aucunAutreExemplaireDetectePourCeLotVerifiezLes": "Aucun autre exemplaire détecté pour ce lot. Vérifiez les permissions ou la jointure lot_id.",
      "trouverDesUvresComparables": "Trouver des œuvres comparables",
      "recherchezSurArtpriceMaisonsDeVentesGaleries": "Recherchez sur Artprice, maisons de ventes, galeries...",
      "forfaitUvreTemporelle": "Forfait — œuvre temporelle",
      "groupeCMethodeAPoints": "Groupe C — méthode à points",
      "ouChercher": "🔍 Où chercher ?",
      "artpriceBaseDeDonneesMondiale": "→ Artprice (base de données mondiale)",
      "christieSVentesAuxEncheres": "→ Christie's (ventes aux enchères)",
      "sothebySVentesAuxEncheres": "→ Sotheby's (ventes aux enchères)",
      "artsyGaleries": "→ Artsy (galeries)",
      "verificationDeVotreCotationPersonnelleArtiste": "Vérification de votre cotation personnelle artiste…",
      "artisteNonEncoreCatalogueDansVosCotationsPersonnelles": "Artiste non encore catalogué dans vos cotations personnelles.",
      "classezDAbordLArtisteDansVosCotationsExpert": "Classez d'abord l'artiste dans vos cotations expert — Groupe A, B ou C — puis revenez ici pour lancer l'estimation adaptée.",
      "cataloguerCetArtiste": "Cataloguer cet artiste",
      "cotationPersonnelleDetectee": "Cotation personnelle détectée :",
      "mediumNonRenseigne": "Médium non renseigné",
      "segmentSpecifiqueDetecte": "Segment spécifique détecté :",
      "choisirUneCotationSegmentExpert": "Choisir une cotation / segment expert",
      "a": "à",
      "ajustementsAppliquesALaCotationPersonnelle": "Ajustements appliqués à la cotation personnelle :",
      "base": "· base",
      "final": "→ final",
      "bonusDocumentairesDetectes": "Bonus documentaires détectés :",
      "total": "→ total",
      "integreALaMethodologieFinale": "intégré à la méthodologie finale.",
      "irreparableDepreciationTotaleValeurNulle": "Irréparable — dépréciation totale · valeur nulle",
      "uvreTemporelleVideoInstallationFormulePointsInapplicable": "Œuvre temporelle (vidéo/installation) — formule points inapplicable.",
      "forfait": "Forfait :",
      "forfaitCotationHorsFormulePoints": "Forfait cotation — hors formule points :",
      "retenu": "· retenu",
      "formule": "Formule : (",
      "cm": ") cm",
      "text": "×",
      "pt": "€/pt",
      "forfaitExpert": "Forfait expert :",
      "dimensionsAbsentesFormuleNonApplicable": "(dimensions absentes — formule non applicable)",
      "overrideExpertActifPriceLowPriceHighExclusDu": "Override expert actif · price_low/price_high exclus du calcul.",
      "decoteConservation": "Décote conservation :",
      "apresDecote": "→ après décote",
      "bonusDocumentairesAppliques": "Bonus documentaires appliqués :",
      "integreDansLaValeurFinale": "% intégré dans la valeur finale",
      "methodologieFinaleGroupeC": "Méthodologie finale Groupe C",
      "prixGalerieActuelArtsyArtsperGalerieBorneHauteIndicative": "Prix galerie actuel (Artsy, Artsper, galerie…) — borne haute indicative",
      "jamaisIntegreDansLaMoyennePondereeSertDePlafond": "Jamais intégré dans la moyenne pondérée. Sert de plafond de lecture et est conservé dans la fiche pour traçabilité.",
      "ex23000": "Ex. 23 000",
      "borneGalerie": "⚠ Borne galerie (",
      "inferieureALaFourchetteHauteCalculee": ") inférieure à la fourchette haute calculée (",
      "coherenceAVerifier": ") — cohérence à vérifier",
      "borneGalerie0f2755": "Borne galerie",
      "auDessusDeLaFourchetteCalculee": "— au-dessus de la fourchette calculée ✓",
      "modeActuel": "Mode actuel :",
      "fourchetteCalculee": "fourchette calculée",
      "viaComparablesEncheres": "via comparables enchères",
      "cotationPersonnelle": "cotation personnelle",
      "expert": "expert (",
      "ajustements": "· ajustements :",
      "partirSurLaCotationPersonnelle": "Partir sur la cotation personnelle →",
      "revenirAuxComparablesCalcules": "← Revenir aux comparables calculés",
      "b3": "· B3",
      "b1HybrideRenforce": "· B1 Hybride renforcé",
      "b2AnalogiePrudente": "· B2 Analogie prudente",
      "methodologieFinaleCotationPersonnelleGroupeA": "Méthodologie finale cotation personnelle Groupe A",
      "estimationIdComparableId": "estimation_id,comparable_id",
      "sauvegardeComparablesRetenusAutocup": "sauvegarde comparables retenus AutoCUP",
      "sauvegardeComparablesRetenusb4562d": "Sauvegarde comparables retenus:",
      "sauvegardeComparablesRetenusNonBloquanteRequeteAnnulee": "Sauvegarde comparables retenus non bloquante : requête annulée.",
      "sauvegardeComparablesRetenusNonBloquante": "Sauvegarde comparables retenus non bloquante :",
      "b3QuasiCupDirecte": "· B3 Quasi CUP directe",
      "methodologieFinaleGroupeA": "Méthodologie finale Groupe A",
      "artistesAnaloguesRetenusSaisissezLeursResultatsAuxEncheresCi": "Artistes analogues retenus — saisissez leurs résultats aux enchères ci-dessous",
      "cliquezSurUnNomPourPreRemplirLeChamp": "Cliquez sur un nom pour pré-remplir le champ artiste. Trouvez leurs résultats sur Artprice, Artnet ou Christie's.",
      "comparable": "Comparable #",
      "decesRecent": "Décès récent",
      "titreDeLUvre": "Titre de l'œuvre",
      "exSansTitreSerieAbstraite": "Ex: Sans titre (série abstraite)",
      "nomDeLArtiste": "Nom de l'artiste",
      "prixDeVente": "Prix de vente (€)",
      "ex15000": "Ex: 15000",
      "dateDeVente": "Date de vente",
      "exArtpriceChristieS": "Ex: Artprice, Christie's...",
      "lienOptionnel": "Lien (optionnel)",
      "ajouterUneUvreComparable": "+ Ajouter une œuvre comparable (",
      "validationParLEquipeArtkiv": "📋 Validation par l'équipe Artkiv",
      "votreAbonnement": "Votre abonnement",
      "inclutUneValidationHumaineUneFoisVosComparablesAjoutes": "inclut une validation humaine. Une fois vos comparables ajoutés, notre équipe analysera et vous enverra une estimation validée sous",
      "validationPrioritairePremium": "✅ Validation prioritaire Premium",
      "vousDonneAccesAUneValidation": "vous donne accès à une validation",
      "sous24h": "sous 24h",
      "parNotreEquipeDExperts": "par notre équipe d'experts.",
      "affinageVision": "Affinage Vision",
      "outilExpertPourAffinerLesComparablesEtEnrichirL": "Outil expert pour affiner les comparables et enrichir l'analyse.",
      "accesVisionCompletRequis": "Accès Vision complet requis",
      "votreCompteExpertEstReconnuMaisLAnalyseVision": "Votre compte expert est reconnu, mais l'analyse Vision complète est réservée aux comptes",
      "artAdvisorPremium": "Art Advisor Premium",
      "lAnalyseVisionSeraDisponibleDesQueVousAurez": "L'analyse Vision sera disponible dès que vous aurez au moins",
      "3ComparablesComplets": "3 comparables complets",
      "importezDesFichesArtpriceOuAjoutezManuellementDesComparables": "Importez des fiches Artprice ou ajoutez manuellement des comparables avec titre, artiste et prix pour activer l'affinage automatique.",
      "lancezUneAnalyseVisionPourAffinerLaCoherenceDes": "Lancez une analyse Vision pour affiner la cohérence des comparables, repérer les écarts de médium, période, format ou proximité marché, et renforcer votre lecture experte avant validation.",
      "analyseVisionEnCours": "Analyse Vision en cours...",
      "analyserAvecVision": "Analyser avec Vision",
      "resultatVision": "Résultat Vision",
      "fourchetteSuggeree": "Fourchette suggérée :",
      "recapitulatifFinalGroupeC": "Récapitulatif final Groupe C",
      "recapitulatifFinalCotationPersonnelle": "Récapitulatif final cotation personnelle",
      "recapitulatifFinalGroupeA": "Récapitulatif final Groupe A",
      "etatDeConservationNonReconnu": "⚠ État de conservation non reconnu :",
      "laValeurStockeeEnBaseEst": "la valeur stockée en base est",
      "laquoNbsp": "« ",
      "nbspRaquo": " »",
      "aucuneDecoteNEstAppliqueeValeursAttendues": "Aucune décote n'est appliquée. Valeurs attendues :",
      "writeOff": "(write-off).",
      "corrigerLaFicheUvrePourAppliquerLaDecoteCorrectement": "Corriger la fiche œuvre pour appliquer la décote correctement.",
      "noteDeLExpertJustificationDeLEstimation": "Note de l'expert — justification de l'estimation",
      "cetteNoteApparaitDansLeRapportDExpertiseElle": "Cette note apparaît dans le rapport d'expertise. Elle complète les ajustements techniques. Pré-remplie depuis la dernière note enregistrée — modifiable.",
      "exUvreEstimeeParAnalogieAvecLesSerigraphiesDu": "Ex : Œuvre estimée par analogie avec les sérigraphies du même format. Décote de 15 % appliquée en raison de l'absence de certificat d'authenticité. Marché secondaire actif pour cet artiste en 2024–2025.",
      "classementIrreparableValeurNulle": "Classement Irréparable — valeur nulle",
      "cetteActionEnregistre": "Cette action enregistre",
      "commeValeurRetenueEtAppliqueLaMethode": "comme valeur retenue et applique la méthode",
      "surLaFicheOeuvreDocumentezObligatoirementLaDecisionCi": "sur la fiche oeuvre. Documentez obligatoirement la décision ci-dessous.",
      "noteDeJustification": "Note de justification",
      "exEtatIrreparableConstateLorsDeLaVisiteDu": "Ex : État irréparable constaté lors de la visite du 01/06/2025. Toile lacérée sur 60 % de la surface, châssis cassé. Aucune restauration possible selon les constatations.",
      "confirmerValeur0": "Confirmer — valeur 0 €",
      "documenterLeWriteOffValeur0": "Documenter le write-off — valeur 0 €",
      "enregistrerLEstimation": "Enregistrer l'estimation",
      "continuerVersLaValidation": "Continuer vers la validation",
      "appliquerCetteEstimationAToutesLesUvresDuLot": "Appliquer cette estimation à toutes les œuvres du lot, avec décote individuelle selon l'état de chacune",
      "enregistrerAppliquerAuLot": "Enregistrer + appliquer au lot (",
      "serviceDeValidation": "💳 Service de validation",
      "10ValidationsGratuitesMoisPuis150ParValidation": ": 10 validations gratuites/mois, puis 150 € par validation",
      "50ValidationsGratuitesMoisPuis150ParValidation": ": 50 validations gratuites/mois, puis 150 € par validation",
      "nosExpertsVerifierontVosComparablesSous4872hOuvres": "Nos experts vérifieront vos comparables sous 48-72h ouvrés",
      "questionsFrequentes": "Questions fréquentes",
      "combienDeComparablesDoisJeAjouter": "Combien de comparables dois-je ajouter ?",
      "groupeAMinimum3ComparablesGroupeBIdealement5": "Groupe A : minimum 3 comparables. Groupe B : idéalement 5 références croisées. Groupe C : la méthode à points peut s'appliquer directement depuis la cotation artiste.",
      "quelsCriteresPourChoisirUneUvreComparable": "Quels critères pour choisir une œuvre comparable ?",
      "privilegiezMemeArtisteMemePeriodeStyleDimensionsSimilairesTechni": "Privilégiez : même artiste > même période/style > dimensions similaires > technique identique > ventes récentes (< 2 ans).",
      "combienDeTempsPourRecevoirLEstimationValidee": "Combien de temps pour recevoir l'estimation validée ?",
      "standard4872hPremiumSous24hJoursOuvres": "Standard : 48-72h | Premium : sous 24h (jours ouvrés)",
      "applicationAuLot": "Application au lot",
      "appliquerLEstimationA": "— appliquer l'estimation à",
      "uvres": "œuvres",
      "lEstimationDeReferenceEstDupliqueeSurToutesLes": "L'estimation de référence est dupliquée sur toutes les œuvres du lot. La décote selon l'état de conservation est appliquée individuellement à chaque œuvre.",
      "estimationDeReferenceAvantDecoteEtat": "Estimation de référence (avant décote état)",
      "repartitionParEtatDeConservation": "Répartition par état de conservation",
      "etat": "État",
      "nbUvres": "Nb œuvres",
      "valeurRetenueUnite": "Valeur retenue / unité",
      "1d9e75": "#1D9E75",
      "ef9f27": "#EF9F27",
      "d85a30": "#D85A30",
      "1a1a1a": "#1A1A1A",
      "a32d2d": "#A32D2D",
      "totalLot": "Total lot",
      "fourchetteTotaleLot": "Fourchette totale lot :",
      "voirLeDetailUvreParUvre": "Voir le détail œuvre par œuvre (",
      "nInv": "N° inv.",
      "uvreSource": "œuvre source",
      "estimationAppliqueeA": "Estimation appliquée à",
      "chaqueUvreAEteMiseAJourAvecSa": "Chaque œuvre a été mise à jour avec sa propre décote selon son état.",
      "appliquees": "appliquées,",
      "enErreur": "en erreur",
      "echecSauvegardeUvreSourceLotNonModifie": "Échec sauvegarde œuvre source. Lot non modifié.",
      "applicationEnCours": "Application en cours…"
    },
    "segment": {
      "primary": "Comparable principal",
      "secondary": "Comparable secondaire",
      "analogTrend": "Analogue de tendance",
      "analogContext": "Analogue contextuel"
    },
    "dynamic": {
      "groupCLiquidityNote": "Pour les artistes du Groupe C, la méthode par points donne une valeur primaire encadrée. Cette valeur est ensuite ajustée par un abattement de liquidité afin de refléter l’absence de marché secondaire constitué et la dépendance à la stratégie galerie. L’abattement standard retenu est de 45 %, modulable entre 30 % et 55 % selon le degré de reconnaissance institutionnelle, la documentation et la liquidité présumée.",
      "writeOffNote": "Œuvre indiquée comme irréparable. Conformément à la grille d’ajustement de valeur, l’état irréparable entraîne une dépréciation totale : valeur actuelle retenue 0 EUR.",
      "conditionDiscount": "Décote conservation : {{label}}",
      "prudenceDiscount": "Décote prudentielle Groupe B : −{{pct}}%",
      "liquidityDiscount": "Abattement de liquidité : −{{pct}}%",
      "documentaryBonuses": "Bonifications documentaires : {{bonuses}}",
      "recentArtistDeath": "Décès récent de l'artiste ({{year}}) : signal de marché à surveiller.",
      "ownRecentResults": "{{count}} résultats propres récents ont été détectés parmi les comparables complets.",
      "recentImported": "{{count}} comparable(s) récent(s) importé(s) sur les 3 dernières années.",
      "recentDetectedThreeYears": "{{count}} comparable(s) récent(s) détecté(s) sur les 3 dernières années.",
      "recentDetected": "{{count}} comparable(s) récent(s) détecté(s).",
      "pointFlatRateSummary": "Groupe C — Forfait : {{low}} – {{high}}",
      "pointFormulaSummary": "Groupe C — ({{height}} + {{width}}) × {{lowRate}}–{{highRate}} €/pt{{condition}}",
      "pointExpertFlatRateSummary": "Groupe C — forfait expert : {{low}} – {{high}}",
      "savedChoices": "{{count}} choix déjà enregistré(s)",
      "lotOf": "d'un lot de {{count}} exemplaires",
      "minimum": "{{count}} minimum",
      "quoteDate": " · date : {{date}}",
      "segment": " · segment {{segment}}",
      "theoreticalBase": " (base théorique avant abattement : {{low}} – {{high}})",
      "finalPersonalGroupB": "Méthodologie finale cotation personnelle Groupe B{{suffix}}",
      "finalGroupB": "Méthodologie finale Groupe B{{suffix}}",
      "finalSummaryGroupB": "Récapitulatif final Groupe B{{suffix}}",
      "confirmApplyLot": "Confirmer — appliquer à {{count}} œuvres",
      "appliedLot": "Estimation appliquée à {{count}} œuvres du lot.",
      "loading": "Chargement…",
      "example": "ex.",
      "maximumComparables": "Maximum {{count}} œuvres comparables",
      "goodVeryGood": "Bon / Très bon",
      "defaultWriteOffNote": "État irréparable — dépréciation totale. Write-off documenté.",
      "writeOffSaved": "Œuvre classée irréparable — valeur 0 enregistrée.",
      "estimationSaved": "Estimation enregistrée sur la fiche œuvre.",
      "lot": "Lot"
    },
    "adjustmentType": {
      "bonus": "Bonus",
      "discount": "Décote",
      "neutral": "Neutre"
    },
    "medium": {
      "painting": "Peinture",
      "sculpture": "Sculpture",
      "photography": "Photographie",
      "drawing": "Dessin",
      "print": "Estampe",
      "mixed_media": "Technique mixte",
      "installation": "Installation",
      "video": "Vidéo",
      "textile": "Textile",
      "ceramic": "Céramique",
      "nft": "NFT / Art numérique",
      "other": "Autre",
      "oil_on_canvas": "Huile sur toile",
      "acrylic_on_canvas": "Acrylique sur toile",
      "ink_on_paper": "Encre sur papier",
      "watercolor_on_paper": "Aquarelle sur papier",
      "pencil_on_paper": "Crayon sur papier",
      "charcoal_on_paper": "Fusain sur papier",
      "mixed_media_on_paper": "Technique mixte sur papier"
    },
    "methodGroup": {
      "point_method": "Groupe C — Méthode à points",
      "analogy_cup": "Groupe B — CUP par analogie",
      "direct_cup": "Groupe A — CUP directe",
      "direct_cup_prudent": "CUP directe prudente",
      "analogy_cup_ratio": "CUP analogique par ratio",
      "hybrid_points_cup": "Hybride points + comparables",
      "personal_quote_analogy_cup": "Cotation experte par analogie de marché",
      "personal_quote_direct_segment": "Micro-segment marché identifié",
      "group_b_analogy": "Groupe B — CUP par analogie",
      "group_b_hybrid": "Groupe B — CUP mixte",
      "unknown": "Méthode non renseignée"
    },
    "humanMethod": {
      "direct_cup": "CUP directe",
      "analogy_cup": "CUP par analogie",
      "point_method": "Méthode par points",
      "points": "Méthode par points",
      "forfait": "Forfait expert"
    },
    "snapshot": {
      "manualDirect": "Résultat propre saisi manuellement",
      "manualAnalogy": "Analogie saisie manuellement",
      "autoAnalogy": "Analogie AutoCUP",
      "autoDirect": "Résultat propre AutoCUP",
      "summaryA": "Marché secondaire suffisamment documenté : {{direct}} adjudication(s) homogène(s) retenue(s). La fourchette repose principalement sur des résultats observés.",
      "summaryB": "Marché secondaire limité : {{direct}} résultat(s) propre(s) et {{analogies}} analogie(s) retenu(s), complétés par {{extrapolations}} extrapolation(s) expertale(s) lorsque nécessaire.",
      "summaryC": "Marché secondaire rare ou insuffisamment homogène : la valorisation repose principalement sur l'analyse qualitative, les analogies de marché et la prudence expertale.",
      "sourceMethod": "Méthode source : {{method}}.",
      "extrapolations": "{{count}} extrapolation(s) conservée(s) comme aide à la décision, non comme preuve de prix.",
      "depthWarning": "La profondeur de marché ne permet pas une lecture purement statistique ; l'expert retient une fourchette défendable plutôt qu'une précision mécanique."
    },
    "marketStrength": {
      "strong": "Marché solide",
      "limited": "Marché limité",
      "scarce": "Marché rare / extrapolation dominante"
    },
    "marketLabel": {
      "analogTrend": "Analogue de tendance · marché supérieur décoté",
      "comparable": "Comparable"
    }
  },
  "perteVol": {
    "title": "Pertes & Vols",
    "subtitle": "Enregistrez les œuvres perdues, volées ou détruites pour votre déclaration fiscale et vos démarches d’assurance.",
    "eyebrow": "Patrimoine · Événements",
    "declare": "+ Déclarer",
    "allClientLosses": "Toutes les pertes / vols du client",
    "clientLosses": "Pertes / vols du client",
    "artworkLosses": "Historique perte / vol de l’œuvre",
    "viewAllClientLosses": "Voir toutes les pertes / vols du client",
    "backToArtwork": "Retour à l’œuvre",
    "noLosses": "Aucune perte ni aucun vol enregistré",
    "noClientLosses": "Aucune perte ni aucun vol trouvé pour ce client",
    "lossType": "Type",
    "lossDate": "Date",
    "taxYear": "Année fiscale",
    "declaredValue": "Valeur déclarée",
    "inventoryNumber": "Référence inventaire",
    "artist": "Artiste",
    "artworkTitle": "Œuvre",
    "lossTypes": {
      "vol": "Vol",
      "perte": "Perte",
      "destruction": "Destruction",
      "incendie": "Incendie",
      "inondation": "Inondation",
      "autre": "Autre",
      "disparition": "Disparition"
    },
    "purchasePrice": "Prix d’acquisition",
    "indemnity": "Indemnisation",
    "netLoss": "Perte nette",
    "markRecovered": "Marquer comme retrouvée",
    "recovered": "Retrouvée",
    "recoveredOn": "Retrouvée le {{date}}",
    "recoveredBy": "Retrouvée par",
    "recoveredNotes": "Notes de récupération",
    "recoverConfirm": "Confirmer que cette œuvre a été retrouvée ?",
    "recoverError": "Impossible de mettre à jour l’œuvre",
    "recoveredHistory": "Historique des œuvres retrouvées",
    "exportPdf": "Exporter PDF",
    "stats": {
      "events": "Événements",
      "active": "Actifs",
      "recovered": "Retrouvés",
      "declaredValue": "Valeur déclarée",
      "purchasePrice": "Prix d’acquisition",
      "indemnities": "Indemnisations",
      "netLoss": "Perte nette"
    },
    "filters": {
      "allTypes": "Tous les types",
      "allYears": "Toutes les années"
    },
    "table": {
      "type": "Type",
      "date": "Date",
      "artwork": "Œuvre",
      "artist": "Artiste",
      "purchasePrice": "Prix d’achat",
      "declaredValue": "Valeur déclarée",
      "indemnity": "Indemnisation",
      "status": "Statut",
      "taxYear": "Année fiscale"
    },
    "status": {
      "active": "Active",
      "recovered": "Retrouvée"
    },
    "empty": {
      "all": "Aucun événement enregistré.",
      "filtered": "Aucun événement enregistré pour ce filtre."
    },
    "common": {
      "loading": "Chargement…",
      "details": "Détails",
      "detailsArrow": "Détails →",
      "untitled": "Sans titre",
      "uploading": "Import en cours…",
      "updating": "Mise à jour…",
      "delete": "Supprimer"
    },
    "mobile": {
      "purchasePrice": "Prix achat",
      "declared": "Déclarée",
      "indemnity": "Indemn."
    },
    "actor": {
      "user": "Utilisateur {{id}}…",
      "unknown": "Non renseigné"
    },
    "messages": {
      "saveError": "Erreur lors de l’enregistrement : {{message}}",
      "deleteConfirm": "Supprimer cet événement ?",
      "recoverConfirm": "Confirmer que cette œuvre a été retrouvée et doit réintégrer la collection active ?",
      "recoveryNotePrompt": "Note de récupération (facultatif)",
      "recoverError": "Impossible de marquer cette œuvre comme retrouvée."
    },
    "fiscalNote": {
      "title": "Note fiscale",
      "body": "En France, les pertes et vols d’œuvres d’art peuvent être déductibles sous certaines conditions. Une plainte déposée auprès des autorités est généralement requise pour une déduction fiscale ou une indemnisation d’assurance. Consultez votre notaire ou votre expert-comptable pour les démarches applicables à votre situation."
    },
    "addModal": {
      "title": "Déclarer un événement",
      "artwork": "Œuvre",
      "selectArtwork": "— Sélectionner une œuvre —",
      "artworkTitle": "Titre de l’œuvre",
      "inventoryNumber": "Référence inventaire",
      "eventDate": "Date de l’événement",
      "declaredValuePlaceholder": "Valeur estimée au jour de l’événement",
      "initialPurchasePrice": "Prix d’achat initial",
      "currency": "Devise",
      "indemnityReceived": "Indemnisation reçue",
      "indemnityPlaceholder": "Après assurance",
      "locationAtLoss": "Localisation au moment de l’événement",
      "locationPlaceholder": "Ex. : galerie, entrepôt, domicile…",
      "notes": "Notes / Circonstances",
      "notesPlaceholder": "Décrivez les circonstances…"
    },
    "duplicate": {
      "title": "Une déclaration active existe déjà pour cette œuvre",
      "createdBy": "Créée le {{date}} par {{actor}}"
    },
    "procedures": {
      "title": "Démarches officielles",
      "policeReport": "Plainte déposée",
      "policeReference": "Référence de la plainte",
      "insuranceClaim": "Déclaration d’assurance",
      "insuranceReference": "Référence de l’assurance"
    },
    "destructionProof": {
      "title": "Preuve de destruction",
      "selectFile": "Cliquez pour sélectionner un fichier",
      "helper": "PDF, image ou document justificatif",
      "remove": "Retirer",
      "viewDocument": "Voir le document",
      "none": "Aucune preuve fournie"
    },
    "details": {
      "location": "Localisation",
      "recoveredBy": "Retrouvée par {{actor}}.",
      "activeLoss": "Perte / vol actif",
      "traceability": "Traçabilité",
      "createdOn": "Déclaration créée le",
      "createdBy": "Créée par",
      "procedures": "Démarches",
      "circumstances": "Circonstances"
    },
    "pdf": {
      "title": "Rapport Pertes & Vols",
      "allYears": "Toutes les années",
      "taxYear": "Année fiscale {{year}}",
      "purchasePriceShort": "Prix acquisition",
      "activeRecovered": "Actives : {{active}} · Retrouvées : {{recovered}}",
      "theftAlert": "{{count}} vol — vérifiez le dépôt de plainte auprès des autorités compétentes",
      "theftAlert_plural": "{{count}} vols — vérifiez le dépôt de plainte auprès des autorités compétentes",
      "theftAlert_one": "{{count}} vol — vérifiez le dépôt de plainte auprès des autorités compétentes",
      "theftAlert_other": "{{count}} vols — vérifiez le dépôt de plainte auprès des autorités compétentes",
      "artworkArtist": "Œuvre / Artiste",
      "declaredShort": "Déclarée",
      "purchaseShort": "Achat",
      "indemnityShort": "Indemn.",
      "recoveredDate": "Retrouvée {{date}}",
      "recoveryNotesTitle": "Notes de récupération",
      "recoveryNoteLine": "{{artwork}} — retrouvée le {{date}}",
      "eventNotesTitle": "Notes par événement",
      "eventNoteLine": "{{artwork}} — {{artist}} ({{date}})",
      "disclaimer": "Ce document est établi à titre déclaratif. Les prix d’acquisition, valeurs déclarées, indemnisations et statuts de récupération proviennent des informations enregistrées dans Artkiv. Consultez votre notaire, expert-comptable ou avocat pour les implications fiscales et successorales.",
      "footer": "Document confidentiel — Généré via Artkiv",
      "page": "Page {{page}} / {{total}}",
      "filename": "rapport_pertes_vols_{{year}}.pdf",
      "filenameAll": "toutes",
      "acquisitionPrice": "Prix d’acquisition",
      "declaredValue": "Valeur déclarée",
      "indemnity": "Indemnisation",
      "netLoss": "Perte nette",
      "recoveredStatus": "Statut de récupération",
      "recoveredYes": "Retrouvée",
      "recoveredNo": "Non retrouvée"
    }
  },
  "succession": {
    "actions": {
      "assign": "Attribuer",
      "copyLink": "Copier le lien",
      "edit": "Modifier",
      "end": "Terminer",
      "missingEmail": "Email manquant",
      "removeAssignment": "Retirer cette œuvre",
      "sendQuestionnaire": "Envoyer le questionnaire"
    },
    "addBeneficiary": "Ajouter un bénéficiaire",
    "delegate": {
      "banner": "Vous consultez et complétez le dossier de {{name}} en tant que délégué."
    },
    "alert": {
      "linkCopied": "Lien copié. Vous pouvez le coller dans votre email.",
      "questionnaireAlreadyDone": "Questionnaire déjà rempli ✅",
      "questionnaireSent": "Questionnaire renvoyé à {{name}} ({{email}})",
      "updateLimited": "Coordonnées mises à jour (lecture limitée par permissions).",
      "updateOk": "Coordonnées mises à jour ✅"
    },
    "artwork": {
      "allAssigned": "Toutes vos œuvres sont déjà attribuées",
      "artistUnknown": "Artiste inconnu",
      "untitled": "Sans titre"
    },
    "assign": {
      "allAssigned": "Toutes vos œuvres sont déjà attribuées. Vous pouvez ajuster la répartition depuis chaque bénéficiaire.",
      "back": "Retour",
      "close": "Fermer la fenêtre",
      "end": "Terminer",
      "noneLeft": "Aucune œuvre restante à attribuer",
      "purchase": "Prix d'achat",
      "subtitle": "Sélectionnez les œuvres que vous souhaitez attribuer",
      "title": "Attribuer des œuvres à {{name}}",
      "value": "Valeur actuelle estimée"
    },
    "assignButton": "Attribuer",
    "balance": {
      "title": "Équilibre de la transmission",
      "subtitle": "Vue de synthèse : ce qui est attribué, à qui, et dans quelles proportions.",
      "collectionValue": "Valeur de la collection",
      "assigned": "Attribué",
      "unassigned": "Non attribué",
      "coverage": "{{pct}} % de la collection attribuée",
      "heirShare": "Part par héritier",
      "ofEstate": "du patrimoine global",
      "ofCollection": "de la collection",
      "reserveOk": "Répartition équilibrée au regard du seuil indicatif.",
      "reserveWarn": "Un héritier concentre {{pct}} % de la base : à vérifier au regard de la réserve héréditaire.",
      "reserveNote": "Indicateur, et non conseil juridique : la réserve héréditaire s'apprécie sur le patrimoine global (titres, immobilier, liquidités…) et selon votre situation familiale. À valider avec votre notaire.",
      "baseCollectionOnly": "Base de calcul = valeur de la collection uniquement.",
      "baseGlobal": "Base de calcul = patrimoine global (source : {{source}}).",
      "connectFO": "Connectez votre family office pour calculer les parts sur le patrimoine global.",
      "empty": "Ajoutez des bénéficiaires et attribuez des œuvres pour visualiser la répartition.",
      "valuationDated": "Valeurs les plus récentes au {{date}} ; la succession retient la valeur vénale au jour du décès.",
      "valuationNone": "Aucune œuvre n'a d'estimation datée ; la succession retient la valeur vénale au jour du décès.",
      "undatedCount": "{{count}} œuvre(s) sans estimation datée.",
      "estimateCta": "Estimer ces œuvres →"
    },
    "valuation": {
      "asOf": "au {{date}}",
      "undated": "non datée",
      "source": {
        "estimation": "Estimation",
        "declared": "Valeur déclarée",
        "purchase": "Prix d'achat",
        "none": "Non estimée"
      }
    },
    "dossier": {
      "cta": "Exporter le dossier de transmission (PDF)",
      "generating": "Génération du dossier…",
      "ctaXls": "Exporter en Excel (.xlsx)",
      "generatingXls": "Génération Excel…",
      "error": "Impossible de générer le dossier. Réessayez dans quelques instants.",
      "title": "Dossier de transmission",
      "client": "Collectionneur",
      "date": "Établi le",
      "synthesisTitle": "1. Synthèse patrimoniale",
      "heirsTitle": "2. Répartition & fiscalité par héritier",
      "heirsTitleNoTax": "2. Répartition par héritier",
      "xls": {
        "sheetSummary": "Synthèse",
        "sheetHeirs": "Répartition",
        "sheetInventory": "Inventaire",
        "sheetToEstimate": "À estimer",
        "coverage": "Couverture (%)",
        "colNum": "#",
        "colTitle": "Titre",
        "colArtist": "Artiste",
        "colDate": "Estimation datée",
        "colToEstimate": "À estimer",
        "colHeir": "Héritier",
        "colShareValue": "Part (€)",
        "colSharePct": "Part (%)",
        "colRegime": "Régime",
        "colDuties": "Droits estimés (€)",
        "yes": "Oui"
      },
      "inventoryTitle": "3. Inventaire des œuvres",
      "toEstimateTitle": "4. Œuvres à faire estimer",
      "toEstimateIntro": "{{count}} œuvre(s) sans estimation datée — liste à remettre à votre expert pour une valorisation au jour du décès.",
      "legalTitle": "Mentions",
      "value": "Valeur",
      "heirs": "Héritier(s)",
      "provenance": "Provenance",
      "location": "Localisation",
      "toEstimate": "à estimer",
      "none": "—",
      "confidential": "Document généré par Artkiv — indicatif et confidentiel, à valider avec votre notaire.",
      "page": "Page {{n}} / {{total}}"
    },
    "tax": {
      "estimatedLabel": "Droits estimés",
      "exempt": "Exonéré",
      "totalLabel": "Droits de succession estimés (total)",
      "note": "Ordre de grandeur (France) et non conseil fiscal : abattement et barème appliqués à la seule part artistique, alors qu'ils s'apprécient sur la totalité de ce que reçoit l'héritier. Régime supposé d'après la relation. À confirmer avec votre notaire.",
      "regime": {
        "directLine": "Ligne directe (supposé)",
        "spouse": "Conjoint / PACS",
        "sibling": "Frère / sœur",
        "nephew": "Neveu / nièce",
        "institution": "Institution (exonéré sous conditions)",
        "other": "Tiers"
      }
    },
    "legal": {
      "notice": "Les attributions saisies ici sont des souhaits d'organisation. Elles n'ont pas valeur de testament : pour être opposables, elles doivent être formalisées (legs, donation) avec votre notaire."
    },
    "beneficiaries": {
      "title": "Mes bénéficiaires et attributions"
    },
    "card": {
      "valueLabel": "Valeur : ",
      "worksLabel": "Œuvres : "
    },
    "edit": {
      "error": "Impossible de mettre à jour le bénéficiaire pour le moment. Réessayez dans quelques instants.",
      "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter pour modifier ce bénéficiaire.",
      "updated": "Le bénéficiaire a été mis à jour.",
      "updatedLimited": "Le bénéficiaire a été mis à jour, mais certaines informations n'étaient pas disponibles côté serveur."
    },
    "error": {
      "add": "Impossible d'ajouter le bénéficiaire. Vérifiez les informations et réessayez.",
      "addBeneficiary": "Impossible d'ajouter le bénéficiaire.",
      "assign": "Impossible d'attribuer cette œuvre. Réessayez dans quelques instants.",
      "assignArtwork": "Impossible d'attribuer l'œuvre.",
      "beneficiaryNotFound": "Bénéficiaire introuvable.",
      "copyLink": "Impossible de copier le lien.",
      "edit": "Une erreur est survenue lors de la mise à jour du bénéficiaire. Réessayez dans quelques instants.",
      "load": "Erreur lors du chargement des données. Réessayez ou contactez l'équipe Artkiv si le problème persiste.",
      "loading": "Erreur lors du chargement des données",
      "noEmail": "Ce bénéficiaire n'a pas d'email renseigné.",
      "remove": "Impossible de retirer l'attribution de cette œuvre. Réessayez dans quelques instants.",
      "removeArtwork": "Impossible de retirer l'œuvre.",
      "selectionNotAllowed": "Sélection introuvable ou non autorisée",
      "send": "Un problème est survenu lors de l'envoi du questionnaire. Vérifiez l'adresse e-mail ou contactez l'équipe Artkiv.",
      "sendQuestionnaire": "Erreur lors de l'envoi du questionnaire.",
      "sendQuestionnairePrefix": "Erreur lors de l'envoi : {{message}}",
      "sessionExpired": "Session expirée. Merci de vous reconnecter.",
      "updateFailed": "Échec de la mise à jour : {{message}}"
    },
    "heirStatus": {
      "completed": "Questionnaire complété",
      "inProgress": "Questionnaire en cours",
      "pending": "Questionnaire à envoyer"
    },
    "quiz": {
      "title": "Collection & transmission : votre profil",
      "body": "En 14 questions, découvrez votre archétype de collectionneur — et ce qu'il implique concrètement pour préparer votre transmission.",
      "cta": "Faire le test",
      "duration": "≈ 3 minutes"
    },
    "hint": {
      "emailRequiredAdd": "Nécessaire pour envoyer le questionnaire",
      "emailRequiredEdit": "L'email est nécessaire pour envoyer le questionnaire."
    },
    "loading": "Chargement de votre planification...",
    "menu": {
      "assignments": "Attribution des œuvres",
      "backToDashboard": "Retour au tableau de bord",
      "beneficiaries": "Bénéficiaires",
      "resources": "Ressources"
    },
    "modal": {
      "add": "Ajouter",
      "addTitle": "Nouveau bénéficiaire",
      "cancel": "Annuler",
      "editTitle": "Modifier l'héritier",
      "email": "Email (optionnel)",
      "emailHelp": "L'e-mail permet d'envoyer automatiquement le questionnaire de matching intergénérationnel.",
      "name": "Nom complet",
      "phone": "Téléphone (optionnel)",
      "relation": "Relation",
      "relationDaughter": "Fille",
      "relationFamily": "Famille (générique)",
      "relationFriend": "Ami(e)",
      "relationInstitution": "Institution / Fondation",
      "relationOther": "Autre",
      "relationPlaceholder": "Ex : Fille, fils, conjoint, ami, fondation…",
      "relationSon": "Fils",
      "relationSpouse": "Conjoint(e)",
      "save": "Enregistrer"
    },
    "noAssigned": "Aucune œuvre attribuée",
    "noBeneficiaries": {
      "text": "Ajoutez vos héritiers afin de commencer la planification successorale.",
      "title": "Aucun bénéficiaire pour le moment"
    },
    "premium": {
      "button": "Accéder au matching IA",
      "completed": "{{count}} questionnaire(s) complété(s).",
      "text": "Vous avez accès au matching intergénérationnel par IA sur vision.artkiv.com.",
      "title": "Matching IA activé"
    },
    "removeAssignment": "Retirer cette œuvre",
    "resources": {
      "dation": {
        "desc": "Comprendre comment utiliser des œuvres d'art pour payer une partie de vos droits de succession.",
        "title": "Dation en paiement"
      },
      "description": "Retrouvez ici les ressources essentielles pour préparer votre transmission patrimoniale.",
      "estimate": {
        "desc": "Préparer un dossier d'estimation structuré pour votre notaire ou votre conseil.",
        "title": "Estimation pour succession"
      },
      "title": "Ressources utiles pour votre planification"
    },
    "standard": {
      "premiumTeaser": {
        "button": "Passer au Premium",
        "paragraph": "Avec ArtKiv Premium, accédez à vision.artkiv.com et bénéficiez de notre système révolutionnaire de matching par IA qui analyse les profils psychologiques de vos héritiers pour attribuer intelligemment chaque œuvre.",
        "point1": "Questionnaires psychologiques sophistiqués pour chaque héritier",
        "point2": "Algorithme de matching basé sur les préférences artistiques et émotionnelles",
        "point3": "Données Art Market 2025 pour une évaluation patrimoniale précise",
        "point4": "Rapports détaillés avec scores de compatibilité",
        "sectionTitle": "Ce que vous obtiendrez :",
        "stat1": {
          "label": "Précision du matching psychologique"
        },
        "stat2": {
          "label": "Données du marché intégrées"
        },
        "stat3": {
          "label": "Critères d'analyse par héritier"
        },
        "subtitle": "Accédez à vision.artkiv.com",
        "title": "Passez au Premium pour le matching IA"
      },
      "text": "En version Standard, vous pouvez ajouter des bénéficiaires et leur attribuer manuellement vos œuvres. L'attribution est basée sur la valeur d'achat de vos œuvres.",
      "title": "Attribution manuelle de vos œuvres"
    },
    "stats": {
      "assignedWorks": "Œuvres attribuées",
      "beneficiaries": "Bénéficiaires",
      "completed": "Questionnaires complétés"
    },
    "subtitle": "Organisez la transmission de votre collection artistique de manière réfléchie et optimale.",
    "subtitleDelegate": "Consultez et complétez la transmission de la collection de {{name}}.",
    "title": "Planification successorale",
    "titleDelegate": "Dossier de succession — {{name}}",
    "why": {
      "p1": "Selon le rapport UBS Global Family Office 2025, seulement 53% des family offices ont établi un plan de succession. Cela signifie que près de la moitié des familles fortunées risquent un transfert désordonné de leur patrimoine.",
      "p2": "Les œuvres d'art représentent un héritage financier et émotionnel. Une transmission bien orchestrée garantit que vos œuvres trouvent leur place auprès des héritiers qui sauront les conserver et perpétuer votre vision.",
      "p2Delegate": "Les œuvres d'art représentent un héritage financier et émotionnel. Une transmission bien orchestrée garantit que les œuvres de {{name}} trouvent leur place auprès des héritiers qui sauront les conserver et en perpétuer l'esprit.",
      "title": "Pourquoi la planification successorale est essentielle"
    }
  },
  "conservationPage": {
    "title": "Fiche conservation & logistique",
    "tabs": {
      "storage": "Dernier état à jour",
      "ideal": "Conservation idéale",
      "transport": "Transport",
      "history": "Historique",
      "monitoring": "Dernier état à jour",
      "idealStorage": "Conservation idéale"
    },
    "history": {
      "subtitle": "Historique des interventions, mouvements et conditions d'exposition de l'œuvre.",
      "addEntry": "+ Ajouter une entrée",
      "empty": "Aucune entrée enregistrée. Ajoutez la première ci-dessus.",
      "loading": "Chargement…",
      "form": {
        "title": "Nouvelle entrée",
        "type": "Type *",
        "date": "Date *",
        "contact": "Intervenant / contact",
        "contactPlaceholder": "Studio, transporteur…",
        "cost": "Coût (€)",
        "notes": "Notes",
        "notesPlaceholder": "Description de l'intervention…",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "saving": "Enregistrement…"
      },
      "entryTypes": {
        "Acquisition": "Acquisition",
        "Inspection": "Inspection",
        "Restauration": "Restauration",
        "Nettoyage": "Nettoyage",
        "Encadrement": "Encadrement",
        "Transport": "Transport",
        "Accrochage": "Accrochage",
        "Décrochage": "Décrochage",
        "Traitement préventif": "Traitement préventif",
        "Autre": "Autre"
      },
      "intervenant": "Intervenant",
      "cost": "Coût"
    },
    "generatePdf": "GÉNÉRER FICHE COMPLÈTE PDF",
    "generating": "Génération…",
    "storage": {
      "title": "Conditions de conservation optimales",
      "specificBadge": "Instructions spécifiques",
      "genericBadge": "Fiche générique – {{type}}",
      "specificBody": "Ces recommandations sont spécifiques à cette œuvre et ont été fournies par l’artiste, le conservateur ou la galerie.",
      "genericBody": "Ces recommandations sont générées automatiquement selon le type d’œuvre, les matériaux et l’état de conservation.",
      "genericTitle": "Fiche générique :",
      "genericNotice": "Ces recommandations constituent une base de conservation préventive à utiliser uniquement en l’absence d’instructions spécifiques de l’artiste, du conservateur ou de la galerie.",
      "temperature": "Température",
      "humidity": "Humidité",
      "light": "Luminosité",
      "placement": "Emplacement",
      "rotation": "Rotation",
      "additional": "Recommandations supplémentaires – {{type}}",
      "specificActive": "Instructions spécifiques actives",
      "specificActiveBody": "Des instructions de conservation spécifiques sont actuellement utilisées pour cette œuvre.",
      "modify": "Modifier",
      "returnGeneric": "Revenir à la fiche générique",
      "specificAvailable": "Instructions spécifiques disponibles ?",
      "specificAvailableBody": "Si vous avez reçu des instructions spécifiques de l’artiste, d’un conservateur ou de la galerie, vous pouvez les ajouter pour remplacer cette fiche générique.",
      "addSpecific": "Ajouter des instructions spécifiques",
      "important": "Important",
      "importantBody": "Ces recommandations génériques doivent être adaptées selon les matériaux spécifiques de l’œuvre. En cas de doute, consultez toujours un conservateur-restaurateur qualifié.",
      "removed": "Instructions spécifiques supprimées. Retour à la fiche générique.",
      "removeError": "Erreur lors de la suppression des instructions.",
      "comingSoon": "Fonctionnalité en cours de développement.",
      "specificActiveTitle": "Instructions spécifiques actives",
      "edit": "Modifier",
      "backGeneric": "Revenir à la fiche générique",
      "specificAvailableTitle": "Instructions spécifiques disponibles ?",
      "importantTitle": "Important"
    },
    "monitoring": {
      "loading": "Chargement…",
      "overdue": "Échéance(s) dépassée(s) :",
      "visualInspection": "Inspection visuelle",
      "fullReport": "Rapport complet",
      "emptyTitle": "Aucun rapport de conservation",
      "emptyBody": "Créez le premier rapport pour commencer le suivi.",
      "update": "Mettre à jour",
      "create": "Créer un rapport"
    },
    "transport": {
      "title": "Logistique de transport",
      "body": "Ces spécifications sont recommandées pour assurer la sécurité de l’œuvre pendant le transport.",
      "requestQuote": "Demander un devis transporteur",
      "missingId": "ID de l’œuvre manquant",
      "openForm": "Ouvrir le formulaire transport",
      "qr": "Générer un QR code",
      "downloadPdf": "Télécharger le PDF",
      "pdfError": "Échec de la génération du PDF.",
      "generating": "Génération…",
      "generatePdf": "GÉNÉRER LA FICHE COMPLÈTE PDF",
      "fields": {
        "caseType": "Type de caisse",
        "caseSize": "Dimensions de la caisse",
        "packagingMethod": "Méthode d’emballage",
        "transportMode": "Mode de transport",
        "carrier": "Transporteur",
        "estimatedCost": "Coût estimé",
        "insurance": "Assurance",
        "customs": "Douanes",
        "temperatureControl": "Contrôle de température"
      },
      "values": {
        "caseType": "Caisse isotherme à double paroi avec mousse sur mesure",
        "packagingMethod": "Emballage avec papier de soie non acide et protection des coins",
        "transportMode": "Transport routier spécialisé œuvres d’art",
        "insurance": "Couverture recommandée : 150 000 €",
        "customs": "Carnet ATA requis pour les expositions temporaires internationales",
        "temperatureControl": "Contrôle actif de la température pendant le transport"
      },
      "generateQr": "Générer un QR code"
    },
    "qr": {
      "title": "QR Code d’accès rapide",
      "alt": "QR Code pour accès rapide",
      "body": "Ce QR code donne accès à la fiche complète de conservation et de transport de l’œuvre. Il est adapté aux transporteurs et conservateurs de musée.",
      "secure": "Sécurisé",
      "quick": "Accès rapide",
      "close": "Fermer",
      "download": "Télécharger",
      "description": "Ce QR code donne accès à la fiche complète de conservation et de transport de l’œuvre. Il est adapté aux transporteurs et aux conservateurs de musée.",
      "quickAccess": "Accès rapide"
    },
    "types": {
      "photographie": "Photographie",
      "peinture": "Peinture",
      "sculpture": "Sculpture",
      "art_interactif": "Art interactif / numérique",
      "generale": "Général"
    },
    "templates": {
      "photographie": {
        "light": "Maximum 50 lux, sans exposition directe aux UV",
        "placement": "Éviter les murs extérieurs et les sources de chaleur",
        "rotation": "Rotation recommandée tous les 3 mois",
        "recommendations": {
          "0": "Vérifier régulièrement la présence de poussière ou de décolorations",
          "1": "Utiliser des gants en coton lors de toute manipulation",
          "2": "Maintenir dans un environnement sans poussière avec filtration d’air",
          "3": "En cas de déplacement, attendre 24 h d’acclimatation avant de déballer",
          "4": "Éviter les variations brusques de température et d’humidité",
          "5": "Conserver dans des boîtes sans acide ou des pochettes en polyester",
          "6": "Protection UV obligatoire (verre ou plexiglas filtrant)",
          "7": "Éviter tout contact direct avec des adhésifs ou matériaux acides"
        }
      },
      "peinture": {
        "light": "Maximum 150 lux, sans exposition directe aux UV",
        "placement": "Éviter les murs extérieurs et les sources de chaleur",
        "rotation": "Rotation recommandée tous les 6 mois",
        "recommendations": {
          "0": "Vérifier régulièrement les fissures, écaillages ou décolorations",
          "1": "Utiliser des gants en coton lors de toute manipulation",
          "2": "Inspecter le support et le châssis",
          "3": "Après un déplacement, attendre 24 h avant de déballer",
          "4": "Éviter les variations brusques de température et d’humidité",
          "5": "Surveiller les signes d’infestation",
          "6": "Maintenir une distance de sécurité avec les murs",
          "7": "Éviter vibrations et chocs",
          "8": "Contrôler régulièrement le vernis de protection",
          "9": "Documenter photographiquement tout changement d’état"
        }
      },
      "sculpture": {
        "light": "Maximum 200 lux, protection UV recommandée",
        "placement": "Surface stable, loin des zones de passage",
        "rotation": "Inspection recommandée tous les 6 mois",
        "recommendations": {
          "0": "Adapter les conditions aux matériaux spécifiques",
          "1": "Vérifier la stabilité de la base et des fixations",
          "2": "Utiliser des gants adaptés au matériau",
          "3": "Contrôler corrosion, fissures ou détérioration",
          "4": "Utiliser un matériel de manutention adapté",
          "5": "Éviter les variations brusques de température et d’humidité",
          "6": "Surveiller les infestations des matériaux organiques",
          "7": "Maintenir un périmètre de sécurité autour de l’œuvre",
          "8": "Documenter l’état de surface et les altérations",
          "9": "Prévoir un socle adapté au poids et à la forme",
          "10": "Vérifier régulièrement l’équilibre et la stabilité"
        }
      },
      "art_interactif": {
        "light": "Selon les spécifications techniques de l’œuvre",
        "placement": "Zone électriquement stable, loin des champs magnétiques",
        "rotation": "Test de fonctionnement recommandé tous les 3 mois",
        "recommendations": {
          "0": "Documenter et archiver tous les composants techniques",
          "1": "Conserver une copie de sauvegarde des fichiers numériques",
          "2": "Vérifier la compatibilité des formats de fichiers",
          "3": "Tester périodiquement les éléments interactifs",
          "4": "Prévoir un plan de migration technologique",
          "5": "Conserver la documentation technique originale",
          "6": "Effectuer des sauvegardes sur plusieurs supports",
          "7": "Surveiller l’obsolescence technologique",
          "8": "Maintenir un inventaire détaillé des composants",
          "9": "Prévoir des pièces de rechange critiques"
        }
      },
      "generale": {
        "light": "Maximum 150 lux, sans exposition directe aux UV",
        "placement": "Éviter les murs extérieurs et les sources de chaleur",
        "rotation": "Rotation recommandée tous les 6 mois",
        "recommendations": {
          "0": "Vérifier régulièrement la poussière ou les décolorations",
          "1": "Utiliser des gants en coton lors de toute manipulation",
          "2": "Après un déplacement, attendre 24 h avant de déballer",
          "3": "Éviter les variations brusques de température et d’humidité"
        }
      }
    }
  },
  "partner": {
    "emptyState": {
      "title": "Votre espace partenaire est prêt.",
      "body": "Complétez votre profil partenaire pour apparaître dans l’annuaire ARTKIV et permettre aux collectionneurs et professionnels de comprendre immédiatement vos spécialités.",
      "completeProfile": "Compléter mon profil",
      "viewDirectory": "Voir l’annuaire",
      "nextTitle": "Préparez votre espace pendant que vous attendez votre première demande",
      "filtered": "Aucune demande correspondant à ce filtre."
    },
    "common": {
      "loading": "Chargement…",
      "refresh": "Rafraîchir",
      "back": "Retour",
      "noSession": "Session introuvable",
      "artwork": "Œuvre",
      "untitled": "Sans titre",
      "unknownArtist": "Artiste inconnu",
      "client": "Client",
      "email": "E-mail",
      "type": "Type",
      "value": "Valeur",
      "notes": "Notes",
      "created": "Créée le {{date}}",
      "urgent": "Urgent",
      "processing": "Traitement…",
      "sending": "Envoi…",
      "saving": "Enregistrement…",
      "yes": "Oui",
      "no": "Non"
    },
    "specialties": {
      "generic": "Espace Partenaire",
      "insurance": "Partenaire Assurance",
      "transport": "Partenaire Transport",
      "valuation": "Expert Estimation",
      "conservation": "Expert Conservation"
    },
    "sidebar": {
      "space": "Espace partenaire",
      "navigation": "Navigation partenaire",
      "requests": "Demandes",
      "completed": "Dossiers terminés",
      "profile": "Profil public",
      "directory": "Annuaire ARTKIV",
      "contract": "Mon contrat",
      "guide": "Bien utiliser ARTKIV",
      "support": "Contacter ARTKIV",
      "profileProgress": "Profil complété",
      "improveVisibility": "Améliorer ma visibilité",
      "contractStatus": "Partenariat ARTKIV",
      "activeUntil": "Actif jusqu’au {{date}}",
      "contractAvailable": "Retrouvez ici les informations de votre partenariat.",
      "viewContract": "Voir mon contrat"
    },
    "filters": {
      "all": "Toutes",
      "pending": "En attente",
      "seen": "Vues",
      "answered": "Répondues",
      "quoted": "Devis transmis",
      "accepted": "Acceptées",
      "rejected": "Refusées",
      "done": "Clôturées",
      "in_progress": "En cours",
      "completed": "Terminées",
      "cancelled": "Annulées"
    },
    "status": {
      "pending": "En attente",
      "seen": "Vue",
      "answered": "Répondue",
      "quoted": "Devis transmis",
      "accepted": "Acceptée",
      "rejected": "Refusée",
      "done": "Clôturée",
      "in_progress": "En cours",
      "completed": "Terminée",
      "cancelled": "Annulée"
    },
    "dashboard": {
      "eyebrow": "Portail professionnel ARTKIV",
      "howItWorks": "Fonctionnement",
      "title": "Espace Partenaire",
      "subtitle": "Vos demandes",
      "subtitleConservation": "Constats, recommandations, restauration et conservation",
      "intro": "Centralisez les demandes reçues via ARTKIV, consultez uniquement les informations partagées pour chaque mission et suivez les échanges jusqu’à la clôture du dossier.",
      "steps": {
        "receive": "Recevez une demande qualifiée",
        "review": "Consultez les éléments autorisés",
        "respond": "Répondez et suivez le dossier"
      },
      "partnershipTitle": "Mon partenariat ARTKIV",
      "partnershipStatus": "Statut",
      "accessMode": "Accès",
      "relationship": "Relation",
      "validUntil": "Validité",
      "noExpiry": "Sans échéance",
      "manageProfile": "Gérer mon profil",
      "noPartnershipRecord": "Votre fiche partenaire n’est pas encore reliée à ce compte. Contactez ARTKIV pour finaliser l’activation.",
      "partnerStatus": {
        "draft": "Brouillon",
        "invited": "Invité",
        "active": "Actif",
        "suspended": "Suspendu",
        "expired": "Expiré"
      },
      "accessModes": {
        "free": "Gracieux",
        "paid": "Payant",
        "custom": "Sur mesure",
        "none": "Aucun"
      },
      "relationships": {
        "marketplace_provider": "Prestataire marketplace",
        "operational_provider": "Prestataire opérationnel",
        "institutional_free": "Partenaire institutionnel",
        "directory_only": "Annuaire uniquement",
        "strategic": "Partenaire stratégique"
      },
      "metrics": {
        "total": "Toutes les demandes",
        "pending": "À traiter",
        "active": "En cours",
        "done": "Clôturées"
      },
      "loadingSpace": "Chargement de l’espace partenaire…",
      "configurationHint": "Vérifiez la fiche partenaire et le type renseigné dans l’administration.",
      "scope": "Les informations affichées correspondent uniquement aux données partagées dans le cadre de chaque demande.",
      "open": "Ouvrir la demande",
      "markSeen": "Marquer comme vue",
      "loadError": "Impossible de charger les demandes.",
      "seenError": "Impossible de marquer la demande comme vue."
    },
    "requests": {
      "request": "Demande",
      "insuredValue": "Valeur à assurer",
      "insuranceExpected": "Attendu : devis, attestation ou ajustement de couverture",
      "pickup": "Enlèvement",
      "delivery": "Livraison",
      "transportExpected": "Attendu : estimation du coût, créneau et contraintes d’emballage",
      "valuationExpected": "Attendu : fourchette, commentaires ou demande de documents",
      "conservationRequest": "Demande de conservation",
      "issue": "Problème",
      "conservationExpected": "Attendu : diagnostic, recommandations ou devis de restauration",
      "viewDetails": "Voir les détails",
      "detailTodo": "Le détail et les actions métier doivent être connectés à cette demande."
    },
    "insurance": {
      "title": "Espace Partenaire Assurance",
      "subtitle": "Gérez les demandes de devis, attestations et mises à jour de valeur",
      "requestTitle": "Demande d’assurance",
      "treatment": "Traitement partenaire",
      "intervention": "Cadre d’intervention",
      "interventionBody": "Ces informations ont été partagées par le collectionneur pour cette demande d’assurance. Elles ne donnent pas accès à l’ensemble de sa collection.",
      "context": "Contexte",
      "homePremium": "Assurance habitation haut de gamme",
      "fineArtPolicy": "Contrat spécifique œuvres d’art",
      "policyType": "Type de couverture",
      "nailToNail": "Clou à clou",
      "allRisks": "Tous risques",
      "transportRequired": "Transport requis",
      "event": "Événement : {{start}} → {{end}}",
      "analysisData": "Données fournies pour analyse assurantielle.",
      "requestedValue": "Valeur demandée",
      "clientMessage": "Message du client",
      "reply": "Répondre",
      "messageLabel": "Message au collectionneur",
      "messagePlaceholder": "Questions, précisions requises, conditions de couverture, délai…",
      "quoteAmount": "Montant du devis (EUR)",
      "sendMessage": "Envoyer le message",
      "sendQuote": "Envoyer le devis",
      "close": "Clôturer la demande",
      "locked": "Cette demande est au statut {{status}}. Le client a pris une décision ou le dossier est clôturé : aucune modification n’est possible.",
      "invalidQuote": "Montant de devis invalide.",
      "loadError": "Impossible de charger la demande.",
      "updateError": "Impossible de mettre à jour la demande.",
      "seenSuccess": "Demande marquée comme vue.",
      "answerSuccess": "Message envoyé au collectionneur.",
      "quoteSuccess": "Devis envoyé avec succès.",
      "closeSuccess": "Demande clôturée."
    },
    "transport": {
      "title": "Espace Partenaire Transport",
      "subtitle": "Gérez vos demandes de transport, de manutention et de devis",
      "defaultRequest": "Transport d’œuvre"
    },
    "valuation": {
      "title": "Espace Expert Estimation",
      "subtitle": "Gérez vos demandes d’estimation et accédez aux fiches œuvres partagées",
      "tipTitle": "Rassemblez les informations utiles",
      "tipBody": "Consultez les photos, dimensions, date, signature, caractéristiques techniques, provenance et état de conservation partagés par le collectionneur.",
      "requestTitle": "Demande d’estimation",
      "backToList": "Retour à mes demandes",
      "artworkImage": "Image de l’œuvre",
      "details": "Informations détaillées",
      "titleLabel": "Titre",
      "artist": "Artiste",
      "year": "Année de création",
      "medium": "Technique",
      "dimensions": "Dimensions",
      "support": "Support",
      "signature": "Signature",
      "certificate": "Certificat",
      "provenance": "Provenance",
      "condition": "État de conservation",
      "additionalNotes": "Notes additionnelles",
      "collector": "Collectionneur",
      "name": "Nom",
      "company": "Entreprise",
      "quickActions": "Actions rapides",
      "start": "Commencer l’estimation",
      "yourValuation": "Votre estimation",
      "estimatedValue": "Valeur estimée",
      "expertNotes": "Notes et justification",
      "notesPlaceholder": "Justification de l’estimation, comparables, état du marché…",
      "save": "Enregistrer l’estimation",
      "invalidValue": "Veuillez saisir une valeur estimée valide.",
      "loadError": "Impossible de charger la demande.",
      "updateError": "Impossible de mettre à jour le statut.",
      "saveError": "Impossible d’enregistrer l’estimation.",
      "saveSuccess": "Estimation enregistrée avec succès."
    },
    "contract": {
      "title": "Mon partenariat avec ARTKIV",
      "status": "Statut",
      "active": "Actif",
      "startsAt": "Date de début",
      "endsAt": "Échéance",
      "renewal": "Renouvellement",
      "renewalAutomatic": "Renouvellement automatique",
      "renewalManual": "Renouvellement manuel",
      "document": "Document contractuel",
      "download": "Télécharger le contrat",
      "contact": "Contacter ARTKIV au sujet du contrat",
      "noDocument": "Aucun document contractuel n’est disponible dans votre espace."
    },
    "guide": {
      "title": "Mieux profiter d’ARTKIV",
      "profileTitle": "Rendez votre profil visible",
      "profileBody": "Ajoutez vos spécialités, zones d’intervention, langues, références et coordonnées.",
      "responseTitle": "Répondez rapidement",
      "responseBody": "Une première réponse courte rassure le demandeur, même si le devis complet vient ensuite.",
      "statusTitle": "Tenez les statuts à jour",
      "statusBody": "Les statuts permettent au client et à ARTKIV de suivre le dossier sans relance inutile.",
      "privacyTitle": "Respectez le périmètre partagé",
      "privacyBody": "N’utilisez que les informations rendues accessibles pour la mission concernée."
    },
    "insuranceDashboard": {
      "eyebrow": "Pilotage des demandes d’assurance",
      "intro": "Analysez les besoins de couverture transmis via ARTKIV, échangez sur les informations manquantes, adressez un devis ou une attestation et suivez chaque dossier jusqu’à sa décision.",
      "workflowTitle": "Parcours métier assurance",
      "workflow": {
        "review": "Examiner l’œuvre, la valeur et le contexte partagés",
        "qualify": "Préciser le risque, la couverture et les pièces nécessaires",
        "quote": "Transmettre un devis, une attestation ou des conditions",
        "follow": "Suivre l’acceptation, le refus ou la clôture du dossier"
      },
      "partnershipTitle": "Cadre du partenariat",
      "commercialTerms": "Les conditions commerciales de l’assurance relèvent de votre accord individuel avec ARTKIV ; aucun partage 85/15 n’est appliqué automatiquement.",
      "privacyBody": "Vous accédez uniquement aux données autorisées pour la demande d’assurance, jamais à la collection complète.",
      "metrics": {
        "total": "Demandes reçues",
        "pending": "À examiner",
        "quoted": "Réponses ou devis",
        "accepted": "Acceptées ou clôturées"
      },
      "emptyTitle": "Aucune demande d’assurance à traiter",
      "emptyBody": "Les nouvelles sollicitations apparaîtront ici avec les informations expressément partagées par le demandeur."
    },
    "valuationDashboard": {
      "eyebrow": "Missions de valorisation",
      "intro": "Traitez les demandes d’estimation confiées via ARTKIV, analysez le dossier documentaire partagé, formalisez votre avis et restituez une valeur argumentée.",
      "workflowTitle": "Parcours métier valorisation",
      "workflow": {
        "review": "Vérifier la fiche œuvre et les pièces disponibles",
        "analyze": "Analyser l’état, la provenance, le marché et les comparables",
        "document": "Documenter la valeur et la méthodologie retenue",
        "deliver": "Restituer l’estimation et clôturer la mission"
      },
      "partnershipTitle": "Mandat et conditions",
      "commercialTerms": "Pour les missions marketplace éligibles, la rémunération suit les conditions convenues avec ARTKIV, notamment le partage 85/15 lorsqu’il est prévu au contrat.",
      "privacyBody": "Seules les informations partagées pour la mission sont accessibles.",
      "metrics": {
        "total": "Missions reçues",
        "pending": "À accepter",
        "in_progress": "En cours d’analyse",
        "completed": "Restituées"
      },
      "emptyTitle": "Aucune mission de valorisation à traiter",
      "emptyBody": "Les nouvelles missions qui vous sont attribuées apparaîtront ici avec leur dossier documentaire."
    }
  },
  "clientMissions": {
    "title": "Mes missions",
    "active": "{{count}} mission en cours avec votre conseiller — suivez son avancement.",
    "active_plural": "{{count}} missions en cours avec votre conseiller — suivez leur avancement.",
    "active_one": "{{count}} mission en cours avec votre conseiller — suivez son avancement.",
    "active_other": "{{count}} missions en cours avec votre conseiller — suivez leur avancement.",
    "view": "Voir"
  },
  "advisorHelp": {
    "button": "Besoin d’aide ?",
    "menuTitle": "Aide Art Advisor",
    "items": {
      "reports": "Générer un rapport professionnel",
      "understandValue": "Comprendre la valeur d’une œuvre",
      "valuation": "Estimer une œuvre",
      "insurance": "Préparer un dossier d’assurance",
      "salesDonations": "Ventes & donations",
      "clientCollections": "Gérer les collections de vos clients",
      "privacyAccess": "Confidentialité & accès clients"
    },
    "allGuides": "Toutes les fiches pratiques"
  },
  "billingIdentity": {
    "title": "Identité de facturation",
    "businessToggle": "Je facture au nom d’une entreprise",
    "description": "Requis pour la facturation électronique obligatoire (B2B). L’identifiant dépend du pays : <siren>SIREN</siren> en France, <vat>numéro de TVA intracommunautaire</vat> dans l’UE. Vos données restent privées et ne servent qu’à la facturation.",
    "countries": {
      "france": "France",
      "belgium": "Belgique",
      "luxembourg": "Luxembourg",
      "germany": "Allemagne",
      "italy": "Italie",
      "spain": "Espagne",
      "netherlands": "Pays-Bas",
      "portugal": "Portugal",
      "austria": "Autriche",
      "ireland": "Irlande",
      "greece": "Grèce",
      "switzerlandNonEu": "Suisse (hors UE)",
      "unitedKingdomNonEu": "Royaume-Uni (hors UE)",
      "unitedStatesNonEu": "États-Unis (hors UE)",
      "other": "Autre pays"
    },
    "validation": {
      "sirenLength": "Le SIREN doit comporter 9 chiffres.",
      "sirenInvalid": "SIREN invalide (clé de contrôle).",
      "sirenValid": "SIREN valide.",
      "siretLength": "Le SIRET doit comporter 14 chiffres.",
      "siretInvalid": "SIRET invalide (clé de contrôle).",
      "siretValid": "SIRET valide.",
      "vatFormat": "Format attendu : préfixe pays + numéro (ex. BE0123456789).",
      "vatPrefix": "Le n° de TVA devrait commencer par « {{expected}} » pour ce pays.",
      "vatValid": "Format TVA valide (validation VIES à confirmer)."
    },
    "errors": {
      "companyRequired": "La raison sociale est requise pour une facturation entreprise.",
      "sirenRequiredFrance": "En France, le SIREN (9 chiffres) est requis pour une facture professionnelle conforme.",
      "vatRequiredEu": "Dans l’UE, le numéro de TVA intracommunautaire est requis (identifiant B2B intra-UE)."
    },
    "fields": {
      "country": "Pays de facturation *",
      "companyName": "Raison sociale *",
      "siren": "SIREN * (9 chiffres)",
      "siret": "SIRET (14 chiffres, optionnel)",
      "vatOptional": "N° TVA intracommunautaire (optionnel)",
      "vatRequired": "N° TVA intracommunautaire *",
      "taxIdOptional": "Identifiant fiscal (optionnel)",
      "address": "Adresse de facturation",
      "postalCode": "Code postal",
      "city": "Ville",
      "billingEmail": "Email de facturation (optionnel)"
    },
    "placeholders": {
      "companyName": "Ex. Galerie Durand SARL",
      "taxId": "N° d’identification fiscale, le cas échéant",
      "address": "12 rue des Beaux-Arts",
      "city": "Paris",
      "billingEmail": "compta@…"
    },
    "saving": "Enregistrement…",
    "save": "Enregistrer",
    "saved": "Enregistré"
  },
  "register": {
    "title": "Créer votre compte Artkiv",
    "titleDelegated": "Rejoindre un accès délégué",
    "stepAccountTitle": "Créez votre compte",
    "stepPlanTitle": "Choisissez votre formule",
    "stepProgress": "Étape {{current}} sur {{total}}",
    "firstNameLabel": "Prénom",
    "firstNamePlaceholder": "Votre prénom",
    "continue": "Continuer",
    "back": "Retour",
    "showPw": "Afficher",
    "hidePw": "Masquer",
    "accountRecap": "Compte",
    "editAccount": "Modifier",
    "emailInvalid": "Adresse email invalide.",
    "passwordShort": "6 caractères minimum.",
    "heroEyebrow": "ARTKIV",
    "heroCopy": "Documentez, valorisez et transmettez votre collection en toute confiance.",
    "heroPoint1": "Inventaire et documents centralisés",
    "heroPoint2": "Estimation et valorisation par l’IA",
    "heroPoint3": "Transmission préparée sereinement",
    "errors": {
      "invalidInviteLink": "Lien d’invitation invalide ou expiré.",
      "inviteRevoked": "Cette invitation a été révoquée.",
      "inviteAlreadyUsed": "Cette invitation a déjà été utilisée.",
      "invalidInvite": "Invitation invalide.",
      "demoInviteIncompatible": "Invitation collaborateur incompatible avec un compte démo.",
      "userNotCreated": "Utilisateur non créé. Vérifiez Supabase (confirmation email requise ?)",
      "signup": "Erreur lors de l’inscription"
    },
    "invite": {
      "subtitle": "Vous avez été invité(e) à collaborer à une collection. Aucun abonnement n’est requis.",
      "emailLabel": "Email invité :",
      "emailMismatch": "Veuillez utiliser l’adresse invitée."
    },
    "demo": {
      "title": "Compte de démonstration",
      "body": "Vous utilisez un compte démo. Le changement de plan sera immédiat sans passer par le paiement.",
      "planUpdated": "Plan démo mis à jour avec succès !"
    },
    "launch": {
      "title": "Offre de lancement",
      "body": "Profitez de <trial>14 jours d’essai gratuit</trial> sur le plan Standard pour toute inscription avant le <date>15 février 2026</date>. Aucun prélèvement pendant la période d’essai."
    },
    "fields": {
      "email": "Adresse email",
      "password": "Mot de passe"
    },
    "placeholders": {
      "email": "votre@email.com",
      "password": "Minimum 6 caractères"
    },
    "sections": {
      "collectors": "Collectionneurs",
      "professionals": "Professionnels"
    },
    "plans": {
      "perMonth": "/mois",
      "standard": {
        "name": "Standard",
        "description": "Gestion de collection complète",
        "trial": "14 jours gratuits"
      },
      "premium": {
        "name": "Premium",
        "badge": "POPULAIRE",
        "description": "IA avancée & matching successoral"
      },
      "artAdvisor": {
        "name": "Art Advisor",
        "badge": "PRO",
        "description": "Jusqu’à 5 clients et 1 assistant"
      },
      "artAdvisorPremium": {
        "name": "AA Premium",
        "badge": "PRO+",
        "description": "Clients illimités et 3 assistants"
      },
      "fondation": {
        "name": "Fondation",
        "badge": "INSTITUTION",
        "description": "Fondations et dotations",
        "note": "Espace ouvert par notre équipe après un échange : nous vous contactons dès l'inscription."
      },
      "familyOffice": {
        "name": "Family Office",
        "badge": "ENTREPRISE",
        "price": "Sur devis",
        "description": "Solution sur mesure"
      }
    },
    "buttons": {
      "changing": "Changement en cours…",
      "creating": "Création en cours…",
      "createDelegated": "Créer mon accès délégué",
      "changePlan": "Changer de plan",
      "createAccount": "Créer mon compte"
    },
    "trialFootnote": "Aucun prélèvement pendant l’essai gratuit de 14 jours. Vous pouvez annuler à tout moment avant la fin de l’essai.",
    "professionalFollowup": "Après création de votre compte, vous serez redirigé pour nous contacter et planifier une démonstration personnalisée.",
    "legal": {
      "terms": "Conditions générales",
      "privacy": "Politique de confidentialité",
      "sentence": "En vous inscrivant, vous acceptez nos <terms>Conditions générales</terms> et notre <privacy>Politique de confidentialité</privacy>."
    },
    "login": {
      "prompt": "Déjà un compte ?",
      "link": "Se connecter"
    }
  },
  "mobileCapture": {
    "newArtwork": {
      "heading": "Photographier une œuvre"
    },
    "verb": {
      "scan": "Scanner",
      "photo": "Photographier"
    },
    "doc": {
      "invoice": "Facture",
      "certificate": "Certificat",
      "verso": "Verso",
      "signature": "Signature",
      "condition": "État / défaut",
      "detail": "Détail",
      "main": "Vue principale",
      "generic": "Document"
    },
    "auth": {
      "title": "Connectez-vous",
      "body": "Connectez ce téléphone au même compte Artkiv, puis rescannez le QR code.",
      "cta": "Se connecter"
    },
    "error": {
      "title": "Lien indisponible",
      "expired": "Ce QR code a expiré. Regénérez-en un depuis votre ordinateur.",
      "completed": "Cette capture a déjà été envoyée.",
      "generic": "Session introuvable. Regénérez le QR depuis votre ordinateur."
    },
    "takePhoto": "Prendre la photo",
    "hint": "La caméra s'ouvre directement.",
    "use": "Utiliser cette photo",
    "retake": "Reprendre",
    "sending": "Envoi…",
    "done": {
      "title": "Envoyé",
      "body": "Vous pouvez revenir à votre ordinateur : le document y apparaît déjà."
    }
  },
  "usePhone": {
    "title": "Utiliser mon téléphone",
    "subtitle": "Scannez ce QR code avec l'appareil photo de votre téléphone.",
    "qrAlt": "QR code de capture",
    "waiting": "En attente du téléphone…",
    "connected": "Téléphone connecté — prenez la photo",
    "error": "Impossible de générer le QR. Réessayez.",
    "cancel": "Annuler",
    "close": "Fermer",
    "chooseType": "Que voulez-vous capturer ?",
    "received": {
      "title": "Reçu depuis votre téléphone",
      "body": "L'élément a bien été rattaché à l'œuvre."
    }
  },
  "onboarding": {
    "welcome": {
      "eyebrow": "Bienvenue sur ARTKIV",
      "helloName": "Bienvenue {{name}}.",
      "helloNoName": "Bienvenue.",
      "intro": "Votre environnement est déjà configuré. Quelques questions rapides nous permettront de personnaliser votre expérience — rien à paramétrer.",
      "start": "Commencer",
      "space": {
        "collectionneurPlan": "Votre abonnement {{plan}} est activé.",
        "collectionneurGeneric": "Votre espace est prêt.",
        "advisor": "Votre accès Art Advisor est activé.",
        "family_office": "Votre espace Family Office est prêt.",
        "fondation": "Votre espace Fondation est prêt.",
        "notaire": "Votre espace Notaire est prêt.",
        "assureur": "Votre espace Assureur est prêt."
      }
    },
    "progress": "Question {{current}} / {{total}}",
    "back": "Retour",
    "skip": "Passer",
    "continue": "Continuer",
    "finish": "Terminer",
    "saving": "Enregistrement…",
    "yes": "Oui",
    "no": "Non",
    "saveError": "La sauvegarde a échoué. Vous pouvez réessayer ou continuer directement.",
    "done": {
      "eyebrow": "Tout est prêt",
      "title": "Votre espace est personnalisé.",
      "actionLabel": "Première action",
      "importExisting": "Reprendre mon inventaire existant"
    },
    "dashboard": {
      "title": "Pour bien démarrer",
      "hello": "Reprenons là où vous en êtes.",
      "helloName": "Reprenons, {{name}}.",
      "dismiss": "Masquer",
      "shortcutsLabel": "Raccourcis",
      "stage": {
        "collectionneur": "Vous avez {{count}} œuvre(s) dans votre collection.",
        "advisor": "Vous accompagnez {{count}} client(s).",
        "family_office": "Vous gérez {{count}} famille(s).",
        "fondation": "Vous gérez {{count}} collection(s).",
        "notaire": "{{count}} dossier(s) de succession.",
        "assureur": "{{count}} demande(s) reçue(s)."
      },
      "advice": {
        "support": "Un import assisté peut structurer votre collection rapidement — déposez vos documents pour recevoir une recommandation.",
        "centralize": "Commencez par centraliser vos documents : déposez-les et ARTKIV les analyse pour vous.",
        "transmission": "Préparez la transmission : renseignez vos bénéficiaires et documentez vos œuvres clés.",
        "insure": "Pour bien assurer, gardez des valeurs à jour et vos justificatifs à portée de main.",
        "market": "Suivez la cote de vos artistes pour saisir les bons moments.",
        "inventory": "Ajoutez vos œuvres une à une, ou déposez un fichier pour aller plus vite.",
        "generic": "Déposez votre existant : ARTKIV le structure et vous propose la suite."
      },
      "shortcuts": {
        "succession": "Planifier la transmission",
        "insure": "Assurer ma collection",
        "market": "Suivre le marché",
        "addWork": "Ajouter une œuvre",
        "deposit": "Déposer mes documents",
        "estimate": "Estimer une œuvre",
        "home": "Mon espace",
        "importExisting": "Reprendre l'existant"
      }
    },
    "questions": {
      "collectionneur": {
        "collection_size": {
          "label": "Taille approximative de votre collection ?",
          "opts": {
            "lt20": "Moins de 20 œuvres",
            "b20_100": "20 à 100 œuvres",
            "b100_500": "100 à 500 œuvres",
            "gt500": "Plus de 500 œuvres"
          }
        },
        "documents_location": {
          "label": "Où se trouvent vos documents aujourd'hui ?",
          "opts": {
            "paper": "Papier / classeurs",
            "computer": "Fichiers sur ordinateur",
            "cloud": "Cloud (Drive, Dropbox…)",
            "scattered": "Un peu partout"
          }
        },
        "main_goal": {
          "label": "Quel est votre objectif principal ?",
          "opts": {
            "inventory": "Inventorier ma collection",
            "transmission": "Préparer la transmission",
            "insure": "Assurer / valoriser",
            "market": "Suivre le marché"
          }
        },
        "wants_support": {
          "label": "Souhaitez-vous être accompagné pour démarrer ?"
        }
      },
      "advisor": {
        "already_clients": {
          "label": "Travaillez-vous déjà avec des collectionneurs ?"
        },
        "clients_count": {
          "label": "Combien de clients souhaitez-vous gérer ?",
          "opts": {
            "b1_5": "1 à 5",
            "b6_20": "6 à 20",
            "b21_50": "21 à 50",
            "gt50": "Plus de 50"
          }
        },
        "has_inventories": {
          "label": "Disposez-vous déjà d'inventaires, PDF ou fichiers Excel à reprendre ?"
        }
      },
      "family_office": {
        "families_count": {
          "label": "Combien de familles accompagnez-vous ?",
          "opts": {
            "b1_3": "1 à 3",
            "b4_10": "4 à 10",
            "gt10": "Plus de 10"
          }
        },
        "works_with_experts": {
          "label": "Travaillez-vous déjà avec des experts ?"
        },
        "create_first_family": {
          "label": "Souhaitez-vous créer votre première famille maintenant ?"
        }
      },
      "fondation": {
        "foundation_name": {
          "label": "Nom de la fondation ?",
          "placeholder": "Ex. Fondation…"
        },
        "collections_count": {
          "label": "Combien de collections gérez-vous ?",
          "opts": {
            "one": "1",
            "b2_5": "2 à 5",
            "gt5": "Plus de 5"
          }
        },
        "has_inventory": {
          "label": "Disposez-vous déjà d'un inventaire ?"
        },
        "collaborators_count": {
          "label": "Combien de collaborateurs utiliseront ARTKIV ?",
          "opts": {
            "solo": "Moi seul",
            "b2_5": "2 à 5",
            "gt5": "Plus de 5"
          }
        }
      },
      "notaire": {
        "handles_art_successions": {
          "label": "Traitez-vous déjà des successions comprenant des œuvres d'art ?"
        },
        "create_first_dossier": {
          "label": "Souhaitez-vous créer votre premier dossier maintenant ?"
        }
      },
      "assureur": {
        "collections_count": {
          "label": "Combien de collections gérez-vous ?",
          "opts": {
            "b1_5": "1 à 5",
            "b6_20": "6 à 20",
            "gt20": "Plus de 20"
          }
        },
        "has_portfolio": {
          "label": "Disposez-vous déjà d'un portefeuille existant à reprendre ?"
        }
      }
    },
    "actions": {
      "collectionneur": {
        "title": "Prêt à commencer votre collection ?",
        "cta": "Commencer"
      },
      "advisor": {
        "title": "Invitez votre premier client.",
        "cta": "Inviter un client"
      },
      "family_office": {
        "title": "Créez votre première famille.",
        "cta": "Créer une famille"
      },
      "fondation": {
        "title": "Créez votre première collection.",
        "cta": "Créer une collection"
      },
      "notaire": {
        "title": "Ouvrez votre premier dossier de succession.",
        "cta": "Ouvrir un dossier"
      },
      "assureur": {
        "title": "Accédez à votre espace assureur.",
        "cta": "Voir mes demandes"
      }
    },
    "deposit": {
      "eyebrow": "Première action",
      "title": "Déposez vos premiers documents.",
      "intro": "PDF, photos, certificats, factures, fichiers Excel… ARTKIV reprend votre existant et l'analyse pour vous. Rien n'est structuré à la main pour commencer.",
      "choose": "Choisir des fichiers",
      "filesPicked": "{{count}} fichier(s) — {{size}} Mo",
      "hint": "PDF · JPG/PNG · CSV/XLSX — jusqu'à {{max}} fichiers",
      "more": "+ {{count}} autres…",
      "uploading": "Dépôt en cours… {{done}}/{{total}}",
      "later": "Plus tard",
      "submit": "Déposer et analyser",
      "submitting": "Dépôt…",
      "error": "Une erreur est survenue pendant le dépôt.",
      "sources": {
        "upload": "Téléverser",
        "dropbox": "Dropbox",
        "drive": "Google Drive",
        "email": "Email"
      },
      "comingSoon": "La connexion {{source}} arrive bientôt. En attendant, vous pouvez téléverser vos fichiers directement.",
      "chooseUpload": "Téléverser des fichiers",
      "byMetier": {
        "advisor": {
          "title": "Importez votre portefeuille existant.",
          "intro": "Inventaires clients, PDF, fichiers Excel, exports… ARTKIV reprend vos dossiers et les structure pour vous."
        },
        "family_office": {
          "title": "Reprenez vos dossiers patrimoniaux.",
          "intro": "Familles, patrimoines, inventaires et documents… déposez l'existant, ARTKIV le structure."
        },
        "fondation": {
          "title": "Importez votre inventaire.",
          "intro": "Inventaires, collections, documents de gouvernance, certificats… ARTKIV reprend et structure votre fonds."
        },
        "notaire": {
          "title": "Déposez les pièces du dossier.",
          "intro": "Inventaires de succession, expertises, PDF… ARTKIV lit et classe les pièces pour vous."
        },
        "assureur": {
          "title": "Importez votre portefeuille assuré.",
          "intro": "Portefeuille, contrats, collections, documents… ARTKIV reprend et structure vos dossiers."
        }
      }
    },
    "reco": {
      "loading": "Chargement de votre analyse…",
      "consentRequired": "L'analyse IA n'a pas été effectuée car le consentement IA n'est pas activé. Activez-le dans votre profil pour obtenir la synthèse automatique. Vos fichiers sont bien enregistrés.",
      "analyzingEyebrow": "Analyse en cours",
      "analyzingTitle": "ARTKIV analyse vos documents…",
      "analyzingBody": "La lecture et le classement de vos fichiers prennent quelques instants. Vous pouvez patienter ici — la recommandation s'affichera automatiquement.",
      "analyzingProgress": "{{done}} / {{total}} documents analysés",
      "tooLong": "L'analyse prend plus de temps que prévu.",
      "continueAnyway": "Continuer sans attendre",
      "resultEyebrow": "Analyse — {{metier}}",
      "resultTitle": "Voici ce qu'ARTKIV a détecté.",
      "errorBody": "L'analyse a rencontré un problème, mais vos fichiers sont bien enregistrés.",
      "howContinue": "Comment souhaitez-vous continuer ?",
      "counts": {
        "documents": "documents",
        "oeuvres": "œuvres détectées",
        "certificats": "certificats",
        "factures": "factures",
        "aStructurer": "à structurer"
      },
      "reason": {
        "autonome": "Peu de documents ({{documents}}) et bien lisibles : vous pouvez structurer vous-même.",
        "express": "Volume modéré ({{documents}} documents) : un import assisté rapide suffit.",
        "premium": "Volume important ({{documents}} documents) ou {{aStructurer}} à structurer : un contrôle humain complet est recommandé."
      },
      "recommended": "Recommandé",
      "payRedirect": "Redirection vers le paiement…",
      "offers": {
        "autonomous": {
          "title": "Continuer seul",
          "price": "Gratuit",
          "desc": "Vous structurez votre collection à votre rythme."
        },
        "express": {
          "title": "Import Express",
          "price": "99 €",
          "desc": "Pour une collection simple. Import assisté rapide."
        },
        "premium": {
          "title": "Import Premium",
          "price": "399 €",
          "desc": "Import complet, contrôle humain, structuration documentaire."
        },
        "concierge": {
          "title": "Conciergerie / Migration",
          "price": "sur devis",
          "desc": "Vous nous confiez vos archives, ARTKIV construit votre collection."
        }
      },
      "offersByMetier": {
        "collectionneur": {
          "premiumDesc": "Import complet, contrôle humain, structuration documentaire.",
          "top": {
            "title": "Conciergerie Collection",
            "price": "1 490 €",
            "desc": "Vous nous envoyez vos archives, ARTKIV construit votre collection."
          }
        },
        "advisor": {
          "premiumDesc": "Reprise des clients, collections, œuvres et documents, structuration complète, contrôle humain.",
          "top": {
            "title": "Migration Cabinet",
            "price": "dès 2 500 €",
            "desc": "Migration complète de votre cabinet, sur devis."
          }
        },
        "family_office": {
          "premiumDesc": "Reprise des familles, collections, dossiers patrimoniaux et héritiers, contrôle humain.",
          "top": {
            "title": "Migration Family Office",
            "price": "dès 2 500 €",
            "desc": "Migration complète, sur devis."
          }
        },
        "fondation": {
          "premiumDesc": "Reprise d'inventaire, collections, documents et gouvernance documentaire, contrôle humain.",
          "top": {
            "title": "Migration Fondation",
            "price": "dès 2 500 €",
            "desc": "Grandes fondations, plusieurs sites, dizaines de milliers d'œuvres. Sur devis."
          }
        },
        "notaire": {
          "premiumDesc": "Reprise des inventaires, successions, PDF et expertises, contrôle humain.",
          "top": {
            "title": "Accompagnement dédié",
            "price": "sur devis",
            "desc": "Prise en charge complète de vos dossiers, sur devis."
          }
        },
        "assureur": {
          "premiumDesc": "Reprise du portefeuille, contrats, collections et documents, contrôle humain.",
          "top": {
            "title": "Migration portefeuille",
            "price": "dès 2 500 €",
            "desc": "Migration complète de votre portefeuille, sur devis."
          }
        }
      },
      "payError": "Le paiement n'a pas pu démarrer.",
      "metier": {
        "collectionneur": "Collectionneur",
        "advisor": "Art Advisor",
        "family_office": "Family Office",
        "fondation": "Fondation",
        "notaire": "Notaire",
        "assureur": "Assureur",
        "generic": "Votre espace"
      }
    }
  },
  "teamDashboard": {
    "accessDenied": {
      "title": "Accès non accordé",
      "description": "L’espace « Partenaires & assurance » ne vous a pas été attribué. Demandez son activation à un administrateur.",
      "back": "Retour à mon espace"
    },
    "actions": {
      "refresh": "Actualiser",
      "search": "Recherche",
      "importClient": "Importer pour un client",
      "importClientTitle": "Importer des œuvres pour un client (CSV/XLSX)",
      "manageAuctionHouses": "Gérer les maisons de vente",
      "open": "Ouvrir",
      "details": "Détails",
      "viewInTool": "Voir dans l’outil",
      "close": "Fermer",
      "cancel": "Annuler",
      "saving": "Enregistrement…"
    },
    "common": {
      "loading": "Chargement…",
      "none": "Aucun",
      "active": "Actif",
      "inactive": "Inactif",
      "notAvailable": "n/d"
    },
    "header": {
      "mySpace": "Mon espace",
      "partnersTitle": "Partenaires & assurance",
      "hubTitle": "Tableau de bord — Équipe",
      "partnersSubtitle": "Contrats, événements facturables, demandes d’assurance et services curatoriaux.",
      "hubSubtitle": "Votre espace : accédez à vos environnements de travail."
    },
    "hub": {
      "spacesTitle": "Vos espaces",
      "spacesSubtitle": "Les environnements auxquels vous avez accès.",
      "manageTeamAccess": "Gérer l’équipe et les accès",
      "noSpaces": "Aucun espace ne vous a encore été attribué. Demandez à un administrateur de vous accorder un accès.",
      "comingSoon": "à venir"
    },
    "kpis": {
      "partnerRequests": "Demandes partenaires",
      "insurancePending": "Demandes d’assurance en attente",
      "pending": "En attente",
      "sent": "Envoyées",
      "urgent": "Urgentes"
    },
    "operations": {
      "eyebrow": "Opérations immédiates",
      "title": "Traitement & priorités"
    },
    "activity": {
      "title": "Activité récente",
      "subtitle": "Demandes partenaires, support et assurance en temps réel.",
      "supportTicket": "Ticket de support",
      "clientNumber": "Client n°{{id}}",
      "clientNamed": "Client : {{name}}",
      "channelNamed": "Canal : {{channel}}",
      "artworkNumber": "Œuvre n°{{id}}",
      "proposalNumber": "Proposition n°{{id}}",
      "insuranceTitle": "Assurance — {{context}}{{policyKind}}{{insuredValue}}",
      "createdAgo_one": "{{actor}} • Créée il y a {{count}} jour",
      "createdAgo_other": "{{actor}} • Créée il y a {{count}} jours",
      "empty": "Aucune activité pour ce filtre.",
      "filters": {
        "all": "Toutes",
        "pending": "En attente",
        "sent": "Envoyées",
        "urgent": "Urgentes"
      },
      "badges": {
        "sent": "Envoyée",
        "urgent": "Urgent",
        "toProcess": "À traiter",
        "pending": "En attente",
        "new": "Nouveau"
      },
      "demo": {
        "basquiat": "Dossier Basquiat – envoi à une institution",
        "soulages": "Soulages – proposition à Christie’s",
        "insuranceQuestion": "Question assurance AXA – attestation"
      }
    },
    "insurance": {
      "title": "Demandes d’assurance",
      "subtitle": "Triage, assignation manuelle, puis suivi par le partenaire.",
      "loading": "Chargement des demandes d’assurance…",
      "empty": "Aucune demande d’assurance pour le moment.",
      "unassigned": "— Non assigné —",
      "assignmentError": "Erreur lors de l’assignation du partenaire.",
      "table": {
        "date": "Date",
        "client": "Client",
        "context": "Contexte",
        "value": "Valeur",
        "artwork": "Œuvre",
        "status": "Statut",
        "partner": "Partenaire",
        "action": "Action"
      }
    },
    "workflows": {
      "eyebrow": "Workflows métier",
      "title": "Partenaires, contenus & orchestration"
    },
    "curatorial": {
      "title": "Services curatoriaux",
      "subtitle": "Gestion des demandes d’accompagnement curatoriel"
    },
    "valuationExpert": {
      "title": "Demandes d’estimation par un expert",
      "subtitle": "Demandes de valorisation d’une œuvre adressées à un expert partenaire nommé"
    },
    "partners": {
      "title": "Partenaires",
      "subtitle": "Contrats actifs et événements facturables.",
      "searchPlaceholder": "Rechercher un partenaire par email…",
      "count_one": "{{count}} partenaire",
      "count_other": "{{count}} partenaires",
      "empty": "Aucun partenaire avec le rôle « partner » n’a été trouvé.",
      "table": {
        "email": "Email",
        "specialty": "Spécialité",
        "activeContract": "Contrat actif",
        "pendingFiles": "Dossiers en attente",
        "actions": "Actions"
      }
    },
    "resources": {
      "eyebrow": "Ressources",
      "title": "Espace personnel & données partagées"
    },
    "personal": {
      "title": "Espace personnel",
      "profile": "Mon profil",
      "shortcuts": "Raccourcis",
      "allRequests": "Toutes les demandes",
      "help": "Aide",
      "systemStatus": "Statut du système",
      "database": "Base de données",
      "operational": "Opérationnel"
    },
    "shared": {
      "title": "Collections & œuvres partagées",
      "subtitle": "Cette section liste automatiquement tout ce que les clients Artkiv ont partagé avec votre compte."
    },
    "drawer": {
      "partner": "Partenaire",
      "newContract": "Nouveau contrat",
      "newEvent": "Nouvel événement",
      "contracts": "Contrats",
      "noContracts": "Aucun contrat pour ce partenaire.",
      "commissionRate": "Taux de commission : {{value}}",
      "fixedAmount": "Montant fixe : {{value}}",
      "contractDocument": "Document du contrat",
      "billableEvents": "Événements facturables (25 derniers)",
      "noEvents": "Aucun événement.",
      "occurredAt": "Date de l’événement",
      "base": "Base",
      "linkedContract": "Contrat lié"
    },
    "contractModal": {
      "title": "Nouveau contrat partenaire",
      "create": "Créer le contrat",
      "createError": "Création du contrat impossible : {{message}}",
      "commissionPlaceholder": "Ex. 10,00",
      "amountPlaceholder": "Ex. 1 200,00"
    },
    "eventModal": {
      "title": "Nouvel événement facturable",
      "selectContract": "— Sélectionner —",
      "noContract": "Aucun contrat disponible pour ce partenaire.",
      "create": "Créer l’événement",
      "createError": "Création de l’événement impossible : {{message}}",
      "amountPlaceholder": "Ex. 2 500"
    },
    "fields": {
      "partnerId": "Identifiant du partenaire",
      "partnerType": "Type de partenaire",
      "contractType": "Type de contrat",
      "startDate": "Date de début",
      "endDateOptional": "Date de fin (optionnel)",
      "currency": "Devise",
      "active": "Contrat actif",
      "commissionRate": "Taux de commission",
      "fixedAmount": "Montant fixe",
      "contractDocumentOptional": "URL du contrat (optionnel)",
      "internalNotesOptional": "Notes internes (optionnel)",
      "contractId": "Identifiant du contrat",
      "eventType": "Type d’événement",
      "referenceAmount": "Montant de référence",
      "occurredAt": "Date et heure de l’événement",
      "artworkIdOptional": "Identifiant de l’œuvre (optionnel)",
      "collectionIdOptional": "Identifiant de la collection (optionnel)",
      "clientIdOptional": "Identifiant du client (optionnel)"
    },
    "validation": {
      "partnerRequired": "L’identifiant du partenaire est requis.",
      "startDateRequired": "La date de début est requise.",
      "contractRequired": "L’identifiant du contrat est requis.",
      "occurredAtRequired": "La date de l’événement est requise."
    },
    "enums": {
      "statuses": {
        "pending": "En attente",
        "sent": "Envoyé",
        "assigned": "Assigné",
        "open": "Ouvert",
        "in_progress": "En cours",
        "answered": "Répondu",
        "closed": "Clôturé",
        "done": "Terminé",
        "completed": "Terminé",
        "cancelled": "Annulé",
        "active": "Actif",
        "inactive": "Inactif",
        "paid": "Payé",
        "overdue": "En retard",
        "invoice_sent": "Facture envoyée",
        "partially_paid": "Partiellement payé",
        "draft": "Brouillon"
      },
      "partnerTypes": {
        "insurance": "Assurance",
        "transport": "Transport",
        "valuation_expert": "Expert en valorisation",
        "conservation_expert": "Expert en conservation"
      },
      "contractTypes": {
        "commission": "Commission",
        "reverse": "Rétrocommission",
        "forfait": "Forfait"
      },
      "eventTypes": {
        "expertise": "Expertise",
        "transport": "Transport",
        "insurance_policy": "Police d’assurance",
        "restoration": "Restauration"
      },
      "insuranceContexts": {
        "insurance": "Assurance",
        "permanent_collection": "Collection permanente",
        "exhibition": "Exposition",
        "transport": "Transport",
        "loan": "Prêt",
        "storage": "Stockage",
        "event": "Événement",
        "temporary": "Couverture temporaire"
      },
      "policyKinds": {
        "all_risks": "Tous risques",
        "named_perils": "Risques désignés",
        "wall_to_wall": "Clou à clou",
        "transit": "Transport",
        "exhibition": "Exposition",
        "storage": "Stockage"
      },
      "requestTypes": {
        "general": "Demande générale",
        "museum": "Musée",
        "auction": "Vente aux enchères",
        "sale": "Vente",
        "loan": "Prêt",
        "exhibition": "Exposition",
        "insurance": "Assurance",
        "transport": "Transport",
        "expertise": "Expertise"
      }
    },
    "coins": {
      "partenaires": {
        "title": "Partenaires & assurance",
        "description": "Contrats, demandes d’assurance et événements facturables."
      },
      "support": {
        "title": "Support",
        "description": "Tickets et demandes d’assistance."
      },
      "newsletters": {
        "title": "Newsletters",
        "description": "Préparation et suivi des communications."
      },
      "galeries": {
        "title": "Galeries",
        "description": "Gestion des galeries et maisons de vente."
      },
      "curatorial": {
        "title": "Services curatoriaux",
        "description": "Demandes et accompagnements curatoriaux."
      },
      "curatoriaux": {
        "title": "Services curatoriaux",
        "description": "Demandes et accompagnements curatoriaux."
      },
      "import": {
        "title": "Import",
        "description": "Imports de collections et d’œuvres clients."
      },
      "imports": {
        "title": "Imports",
        "description": "Imports de collections et d’œuvres clients."
      },
      "recherche": {
        "title": "Recherche",
        "description": "Recherche transversale dans les données Artkiv."
      },
      "search": {
        "title": "Recherche",
        "description": "Recherche transversale dans les données Artkiv."
      },
      "administration": {
        "title": "Administration",
        "description": "Outils d’administration de la plateforme."
      },
      "collections": {
        "title": "Collections",
        "description": "Collections et œuvres partagées."
      }
    }
  },
  "advisorMissions": {
    "focus": {
      "active": "Missions en cours",
      "ready_to_deliver": "Livrables à envoyer",
      "to_invoice": "Missions à facturer",
      "follow_up": "Clients à relancer",
      "filtered": "Filtré",
      "clear": "Retirer le filtre"
    },
    "common": {
      "client": "Client",
      "loading": "Chargement…"
    },
    "disabled": {
      "title": "Module Missions non activé",
      "description": "Ce module est en cours de déploiement. Revenez bientôt."
    },
    "header": {
      "eyebrow": "Art Advisor",
      "title": "Missions",
      "description": "ARTKIV organise la mission. Vous gardez vos clients, vos honoraires et votre comptabilité."
    },
    "actions": {
      "close": "Fermer",
      "newMission": "+ Nouvelle mission",
      "creating": "Création…",
      "create": "Créer la mission"
    },
    "form": {
      "titleLabel": "Titre *",
      "titlePlaceholder": "Ex. Inventaire de la collection X",
      "typeLabel": "Type de mission",
      "clientLabel": "Client",
      "noClientOption": "— Aucun / contact externe —",
      "collectionLabel": "Collection",
      "noCollectionOption": "— Aucune —",
      "clientEntityLabel": "Dossier client",
      "noClientEntityOption": "— Aucun dossier —",
      "dueDateLabel": "Échéance",
      "priorityLabel": "Priorité",
      "billingModeLabel": "Mode de facturation",
      "scopeLabel": "Périmètre (optionnel)",
      "scopePlaceholder": "Décrivez le périmètre, les livrables ou les contraintes de la mission."
    },
    "kpis": {
      "inProgress": "Missions en cours",
      "readyToInvoice": "Prêtes à facturer",
      "invoiced": "Facturé (déclaré)",
      "received": "Encaissé (déclaré)",
      "overdue": "En retard (déclaré)",
      "disclaimer": "Données de suivi. Votre comptabilité et vos déclarations restent sous votre responsabilité et celle de votre outil comptable."
    },
    "table": {
      "mission": "Mission",
      "client": "Client",
      "progress": "Avancement",
      "dueDate": "Échéance",
      "billing": "Facturation",
      "lastActivity": "Dernière activité",
      "empty": "Aucune mission. Créez-en une pour commencer."
    },
    "errors": {
      "create": "Erreur : {{message}}"
    },
    "enums": {
      "missionTypes": {
        "inventory": "Inventaire",
        "valuation": "Valorisation",
        "appraisal": "Expertise",
        "expertise": "Expertise",
        "conservation": "Conservation",
        "condition_report": "Constat d’état",
        "insurance": "Assurance",
        "transport": "Transport",
        "sale": "Vente",
        "acquisition": "Acquisition",
        "succession": "Succession",
        "donation": "Donation",
        "loan": "Prêt",
        "exhibition": "Exposition",
        "curatorial": "Accompagnement curatorial",
        "documentation": "Documentation",
        "other": "Autre"
      },
      "statuses": {
        "draft": "Brouillon",
        "planned": "Planifiée",
        "in_progress": "En cours",
        "waiting_client": "En attente du client",
        "waiting_partner": "En attente d’un partenaire",
        "ready_to_deliver": "Prête à livrer",
        "delivered": "Livrée",
        "closed": "Clôturée",
        "cancelled": "Annulée"
      },
      "priorities": {
        "low": "Faible",
        "normal": "Normale",
        "high": "Haute",
        "urgent": "Urgente"
      },
      "billingModes": {
        "external": "Facturation directe par l’Advisor",
        "artkiv": "Facturation via ARTKIV",
        "artkiv_invoice": "Facturation via ARTKIV",
        "platform": "Facturation via la plateforme",
        "included": "Inclus dans les honoraires",
        "free": "Sans facturation"
      }
    }
  },
  "advisorBillingIdentity": {
    "title": "Identité de facturation",
    "description": {
      "before": "Votre entité morale et votre régime de TVA. Ces informations servent à vos documents et à ",
      "emphasis": "déterminer la TVA appliquée sur vos missions",
      "after": ". Vous restez responsable de leur exactitude."
    },
    "validation": {
      "sirenLength": "Le SIREN doit comporter 9 chiffres.",
      "sirenInvalid": "SIREN invalide (clé de contrôle).",
      "sirenValid": "SIREN valide."
    },
    "fields": {
      "legalName": "Raison sociale / entité morale",
      "tradeName": "Nom commercial (optionnel)",
      "legalForm": "Forme juridique",
      "siren": "SIREN (9 chiffres)",
      "siret": "SIRET (14 chiffres, optionnel)",
      "vatNumber": "N° de TVA intracommunautaire",
      "vatRegime": "Régime de TVA",
      "defaultVatRate": "Taux de TVA par défaut (%)",
      "exemptionMention": "Mention de franchise (apparaît sur la facture)",
      "billingEmail": "Email de facturation",
      "address": "Adresse du siège",
      "postalCode": "Code postal",
      "city": "Ville"
    },
    "placeholders": {
      "legalName": "Ex. Delorme Conseil SARL",
      "legalForm": "SARL, SAS, EI, micro-entreprise…"
    },
    "vatRegimes": {
      "standard": "Assujetti (TVA standard)",
      "franchiseBase": "Franchise en base (non assujetti)",
      "custom": "Personnalisé"
    },
    "actions": {
      "saving": "Enregistrement…",
      "save": "Enregistrer l’identité de facturation",
      "saved": "Enregistré"
    }
  },
  "expertIdentity": {
    "title": "Identité professionnelle",
    "subtitle": "Ces éléments apparaissent sur vos rapports clients et, si vous activez votre profil public, dans l’annuaire Artkiv.",
    "fields": {
      "professionalTitle": "Titre professionnel"
    },
    "placeholders": {
      "professionalTitle": "Ex. Expert en art moderne et contemporain, Paris"
    },
    "hints": {
      "professionalTitle": "Apparaît sous votre nom dans les rapports PDF et l’annuaire."
    },
    "pdfLogo": {
      "title": "Logo des rapports clients",
      "description": "Apparaît uniquement dans vos PDF privés. Vos clients voient votre marque, pas l’annuaire public.",
      "name": "Logo PDF",
      "preview": "Aperçu du logo PDF"
    },
    "publicLogo": {
      "title": "Logo de l’annuaire public",
      "description": "Visible dans l’annuaire Artkiv uniquement si vous activez votre profil public.",
      "name": "Logo de l’annuaire",
      "preview": "Aperçu du logo de l’annuaire"
    },
    "acceptedFormats": "Formats acceptés : PNG, JPG, SVG — 2 Mo maximum. Fond transparent recommandé (PNG ou SVG).",
    "validation": {
      "imageOnly": "Veuillez sélectionner une image (PNG, JPG, SVG).",
      "maxSize": "Le logo ne doit pas dépasser 2 Mo."
    },
    "actions": {
      "uploading": "Téléversement en cours…",
      "changeLogo": "Changer le logo",
      "remove": "Supprimer",
      "saving": "Sauvegarde…",
      "save": "Sauvegarder l’identité"
    },
    "toasts": {
      "logoUpdated": "{{label}} mis à jour.",
      "saved": "Identité professionnelle sauvegardée."
    },
    "errors": {
      "urlNotGenerated": "URL non générée",
      "upload": "Erreur lors du téléversement : {{message}}",
      "save": "Erreur : {{message}}"
    }
  },
  "expertProfile": {
    "welcome": {
      "title": "Bienvenue chez Artkiv !",
      "description": "Pour rejoindre notre réseau d’experts certifiés et être référencé dans notre annuaire, complétez votre profil professionnel ci-dessous. Une fois validé, vous pourrez inviter vos clients Artkiv à attester de votre expertise.",
      "stepsTitle": "Les 4 étapes vers la certification :",
      "steps": {
        "completeProfileTitle": "Remplir votre profil",
        "completeProfileDetail": "(nom, spécialité, bio, localisation, photo)",
        "activatePresenceTitle": "Activer votre présence",
        "activatePresenceDetail": "dans l’annuaire Artkiv",
        "inviteClientsTitle": "Inviter au moins 3 clients Artkiv",
        "inviteClientsDetail": "à valider votre expertise",
        "getBadge": "Obtenir le badge « Expert certifié »"
      }
    },
    "incomplete": {
      "title": "Profil incomplet",
      "before": "Complétez les champs essentiels (",
      "fields": "nom, spécialité, bio, localisation",
      "after": ") pour pouvoir activer votre présence dans l’annuaire."
    },
    "ready": {
      "title": "Profil prêt à être publié !",
      "description": "Votre profil est complet. Activez votre présence publique Artkiv ci-dessous pour apparaître dans notre annuaire et commencer à recevoir des demandes de clients.",
      "hint": "Une fois votre profil public, vous pourrez inviter vos clients à valider votre expertise afin d’obtenir le badge « Expert certifié »."
    },
    "directory": {
      "title": "Présence dans l’annuaire Artkiv",
      "publicStatus": "Votre profil est visible dans l’annuaire public",
      "privateStatus": "Votre profil est actuellement privé",
      "completeFirst": "Complétez d’abord votre profil (nom, spécialité, bio, localisation) pour activer cette fonctionnalité.",
      "visibleOn": "Votre profil est visible sur",
      "aboutTitle": "À propos de la présence dans l’annuaire :",
      "aboutText": "Un expert Artkiv peut gérer ses clients, être invité par d’autres et, s’il le souhaite, activer une vitrine professionnelle. Son profil est normalisé dans notre annuaire afin de garantir la transparence et la qualité du service.",
      "criteriaTitle": "Critères de présence dans l’annuaire :",
      "criteria": {
        "experience": "Exercer en tant que professionnel de l’art depuis au moins 5 ans",
        "education": "Justifier d’une formation et d’une expérience avancées en histoire de l’art",
        "noStock": "Ne pas détenir de stock ni accepter d’œuvres en dépôt-vente",
        "clientPaid": "Être rémunéré uniquement par ses clients",
        "transparency": "Garantir la transparence de la structure de rémunération",
        "clientInterest": "Placer les intérêts des clients en priorité"
      }
    },
    "photo": {
      "alt": "Expert",
      "uploading": "Téléversement en cours…",
      "change": "Changer la photo"
    },
    "cv": {
      "analyzing": "Analyse du CV…",
      "upload": "Téléverser un CV (PDF)"
    },
    "certified": "Certifié",
    "fields": {
      "fullName": "Nom complet",
      "specialty": "Spécialité",
      "organization": "Organisation",
      "location": "Localisation",
      "contactEmail": "Email de contact",
      "phone": "Téléphone",
      "experience": "Expérience",
      "languages": "Langues",
      "bio": "Biographie professionnelle",
      "specializations": "Spécialisations",
      "credentials": "Certifications et qualifications"
    },
    "placeholders": {
      "fullName": "Ex. Marie Dupont",
      "specialty": "Ex. Art moderne",
      "organization": "Ex. Maison de ventes XYZ",
      "location": "Ex. Paris, France",
      "contactEmail": "Ex. expert@example.com",
      "phone": "Ex. +33 6…",
      "experience": "Ex. Plus de 25 ans, expert depuis 2000",
      "languages": "Ex. FR, EN, ES",
      "bio": "Résumé de votre parcours et de votre expertise (400 à 700 caractères recommandés)",
      "specializations": "Ex. Impressionnisme, Art déco",
      "credentials": "Ex. ILAB, SFEP"
    },
    "actions": {
      "saving": "Enregistrement…",
      "save": "Enregistrer le profil",
      "refresh": "Actualiser"
    },
    "certification": {
      "title": "Certification expert",
      "subtitle": "Invitez vos clients Artkiv à valider votre expertise pour obtenir le badge « Expert certifié ».",
      "howToTitle": "Comment obtenir des validations ?",
      "steps": {
        "shareTitle": "Partagez votre profil",
        "shareDetail": "avec vos clients existants",
        "inviteTitle": "Invitez-les à rejoindre Artkiv",
        "inviteDetail": "s’ils ne sont pas encore membres",
        "validateBefore": "Une fois connectés, ils pourront",
        "validateStrong": "valider votre expertise",
        "validateAfter": "depuis votre profil.",
        "badgeBefore": "Après",
        "badgeStrong": "3 validations",
        "badgeAfter": ", vous obtenez automatiquement le badge « Expert certifié »."
      },
      "importantTitle": "Important :",
      "importantText": "Seuls les membres Artkiv peuvent valider un expert. Vos clients doivent d’abord créer un compte sur Artkiv.",
      "privateMessage": "Activez votre présence publique pour accéder à la certification."
    }
  },
  "expertBillingManager": {
    "common": {
      "loading": "Chargement…",
      "signInRequired": "Veuillez vous connecter",
      "notAvailable": "N/D"
    },
    "toasts": {
      "loadError": "Erreur lors du chargement des données.",
      "feesSaved": "Tarifs mis à jour avec succès.",
      "feesSaveError": "Erreur lors de la sauvegarde des tarifs."
    },
    "serviceTypes": {
      "validation": "Validation d’estimation",
      "expertiseCnes": "Expertise CNES",
      "placementInstitution": "Placement en institution",
      "placementAuction": "Placement aux enchères",
      "custom": "Service personnalisé"
    },
    "statuses": {
      "pending": "En attente",
      "inProgress": "En cours",
      "completed": "Complété",
      "cancelled": "Annulé"
    },
    "header": {
      "title": "Facturation et honoraires",
      "before": "Suivez vos revenus, configurez vos tarifs et gérez vos versements en toute transparence. Chaque service complété génère automatiquement un versement programmé 7 jours plus tard.",
      "modelLabel": "Nouveau modèle 2026 :",
      "after": "Vous recevez 90 % du prix des services que vous facturez via la plateforme (Artkiv prend 10 %) ; le client paie le prix affiché, sans frais supplémentaires. Aucune commission sur vos ventes ni vos honoraires en direct. Ce modèle inclut la facturation électronique conforme en 2026, les paiements sécurisés et le support fiscal dédié."
    },
    "navigation": {
      "overview": "Vue d’ensemble",
      "services": "Services",
      "fees": "Tarifs",
      "payouts": "Versements"
    },
    "overview": {
      "totalGrossRevenue": "Revenu brut total",
      "completedServices": "{{count}} service complété",
      "completedServices_one": "{{count}} service complété",
      "completedServices_other": "{{count}} services complétés",
      "completedServices_plural": "{{count}} services complétés",
      "netRevenue": "Revenu net",
      "afterCommission": "Après commission Artkiv",
      "pending": "En attente",
      "servicesInProgress": "Services en cours",
      "averageTicket": "Ticket moyen",
      "perService": "Par service",
      "revenueBreakdown": "Répartition des revenus",
      "yourNetShare": "Votre part nette",
      "artkivCommission": "Commission Artkiv",
      "totalGross": "Total brut",
      "latestServices": "Derniers services"
    },
    "actions": {
      "viewAll": "Voir tout",
      "saving": "Enregistrement…",
      "saveFees": "Enregistrer les tarifs",
      "reset": "Réinitialiser"
    },
    "empty": {
      "noServices": "Aucun service pour le moment",
      "noPayouts": "Aucun versement pour le moment"
    },
    "services": {
      "historyTitle": "Historique des services",
      "columns": {
        "service": "Service",
        "artwork": "Œuvre",
        "date": "Date",
        "status": "Statut",
        "amountInclTax": "Montant TTC",
        "commission": "Commission",
        "yourShare": "Votre part"
      }
    },
    "fees": {
      "title": "Configuration des tarifs",
      "subtitle": "Définissez vos honoraires pour chaque type de service. La commission Artkiv sera calculée automatiquement.",
      "youReceive": "Vous recevez (90 %)",
      "commissionHint": "Artkiv : 10 % • Client : aucun frais en plus",
      "validation": {
        "title": "Validation d’estimation",
        "subtitle": "Service standard sous 48 h",
        "priceLabel": "Prix TTC (recommandé : 49 €)"
      },
      "cnes": {
        "restrictedInfo": "Les expertises certifiées CNES sont réservées aux experts accrédités. Votre forfait s’applique automatiquement aux missions compatibles avec votre statut.",
        "certifiedTitle": "Expertise certifiée (CNES)",
        "deepOpinionTitle": "Avis d’expert approfondi",
        "certifiedSubtitle": "Expertise physique certifiée CNES",
        "deepOpinionSubtitle": "Analyse experte non certifiée (hors CNES)",
        "baseRateLabel": "Tarif de base (recommandé : 300 €)"
      },
      "hourly": {
        "title": "Taux horaire",
        "subtitle": "Pour les services additionnels",
        "priceLabel": "Prix HT par heure (recommandé : 80 €)"
      },
      "placement": {
        "title": "Placement en institution ou aux enchères",
        "subtitle": "Frais fixes et commission variable",
        "priceLabel": "Frais fixes HT (recommandé : 500 €)",
        "noteTitle": "Note :",
        "noteText": "commission variable sur le prix de vente final selon les CGV (généralement 2 à 5 %)."
      }
    },
    "commissionModel": {
      "title": "Nouveau modèle de commission (2026)",
      "youReceiveLabel": "Vous recevez :",
      "artkivTakesLabel": "Artkiv prend :",
      "clientPaysLabel": "Le client paie :",
      "youPayLabel": "Vous payez :",
      "exampleLabel": "Exemple :",
      "fees": "de frais",
      "total": "au total",
      "paidServices": {
        "title": "Services payants (estimations, expertises, etc.)",
        "youReceive": "90 % du prix du service",
        "artkivTakes": "10 % (prélevés sur votre part)",
        "clientPays": "le prix du service, sans frais supplémentaires",
        "exampleTitle": "Estimation à 149 €",
        "exampleYouReceive": "Vous recevez : 134,10 € (90 %)",
        "exampleClientPays": "Le client paie : 149 € HT",
        "exampleArtkivTakes": "Artkiv prend : 14,90 € (10 %)"
      },
      "introduction": {
        "title": "Mise en relation « Conseiller personnel »",
        "clientPays": "0 € (gratuit, inclus dans son abonnement)",
        "youPay": "49 € HT (58,80 € TTC) si vous acceptez",
        "artkivTakes": "49 € (accès à un client qualifié)"
      },
      "why": {
        "title": "Pourquoi ce modèle ?",
        "intro": "Ces commissions permettent à Artkiv de :",
        "platform": "maintenir la plateforme et la facturation électronique conforme en 2026",
        "payments": "gérer les paiements sécurisés (garantie sous 48 h)",
        "support": "fournir un support client et fiscal dédié",
        "savings": "vous faire économiser environ 1 560 € par an (logiciel et comptable)"
      }
    },
    "payouts": {
      "title": "Historique des versements",
      "paidOn": "Versé le {{date}}",
      "scheduledOn": "Prévu le {{date}}",
      "statuses": {
        "paid": "Payé",
        "scheduled": "Programmé"
      }
    }
  },
  "collaborators": {
    "title": "Collaborateurs",
    "subtitle": "Accès aux collections (équipe, assistants, experts)",
    "common": {
      "loading": "Chargement…"
    },
    "stats": {
      "total": "{{count}} au total",
      "total_one": "{{count}} au total",
      "total_other": "{{count}} au total",
      "active": "{{count}} actif",
      "active_one": "{{count}} actif",
      "active_other": "{{count}} actifs",
      "active_plural": "{{count}} actifs",
      "pending": "{{count}} en attente",
      "pending_one": "{{count}} en attente",
      "pending_other": "{{count}} en attente"
    },
    "actions": {
      "invite": "Inviter",
      "assistantAccess": "Accès assistant",
      "hide": "Masquer",
      "details": "Détails",
      "cancel": "Annuler",
      "update": "Mettre à jour",
      "sendInvitation": "Envoyer l’invitation",
      "copy": "Copier",
      "close": "Fermer"
    },
    "empty": {
      "title": "Aucun collaborateur",
      "text": "Invitez un assistant ou un expert pour compléter la collection."
    },
    "roles": {
      "labels": {
        "teamReadonly": "Membre d’équipe (lecture seule)",
        "teamMember": "Membre d’équipe",
        "expert": "Expert",
        "collectorClient": "Client collectionneur",
        "assistant": "Assistant",
        "familyOfficeUser": "Utilisateur Family Office",
        "artAdvisor": "Art Advisor",
        "familyOffice": "Family Office"
      },
      "descriptions": {
        "teamReadonly": "1 membre en lecture seule",
        "teamMember": "Jusqu’à 5 membres avec permissions",
        "expert": "Experts invités ponctuellement",
        "collectorClientLimited": "5 clients maximum",
        "collectorClientUnlimited": "Clients illimités",
        "assistant": "Jusqu’à 3 assistants",
        "assistantOne": "1 assistant maximum",
        "familyOfficeUser": "Utilisateurs illimités",
        "artAdvisor": "Conseil artistique et suivi curatorial",
        "familyOffice": "Gestion patrimoniale et dimension financière"
      }
    },
    "statuses": {
      "pending": "En attente",
      "active": "Actif",
      "suspended": "Suspendu",
      "revoked": "Révoqué"
    },
    "tooltips": {
      "activate": "Activer manuellement (l’utilisateur s’est enregistré)",
      "resend": "Renvoyer l’invitation",
      "copyLink": "Copier le lien d’accès",
      "edit": "Modifier",
      "suspend": "Suspendre",
      "reactivate": "Réactiver",
      "revoke": "Révoquer"
    },
    "permissions": {
      "label": "Permissions",
      "none": "aucune",
      "view": "Voir les œuvres",
      "edit": "Éditer les fiches",
      "add": "Ajouter des œuvres",
      "delete": "Supprimer des œuvres",
      "export": "Exporter les données",
      "reports": "Générer des rapports",
      "ai": "Accéder aux outils IA",
      "short": {
        "view": "voir",
        "edit": "éditer",
        "add": "ajouter",
        "delete": "supprimer",
        "export": "export",
        "reports": "rapports",
        "ai": "IA"
      }
    },
    "collections": {
      "label": "Collections",
      "noneDefined": "aucune collection définie"
    },
    "modal": {
      "editTitle": "Modifier un collaborateur",
      "inviteTitle": "Inviter un collaborateur"
    },
    "form": {
      "role": "Rôle",
      "email": "Email",
      "firstName": "Prénom",
      "lastName": "Nom",
      "phone": "Téléphone",
      "accessibleCollections": "Collections accessibles",
      "collectionsHint": "Le collaborateur verra uniquement les collections cochées.",
      "noCollectionsLoaded": "Aucune collection chargée. L’accès restera lié à la collection courante si elle existe.",
      "notes": "Notes",
      "notesPlaceholder": "Notes internes sur ce collaborateur…"
    },
    "presets": {
      "readonly": "Lecture seule",
      "assistant": "Assistant",
      "expert": "Expert"
    },
    "linkModal": {
      "title": "Lien d’invitation du collaborateur",
      "description": "Envoyez ce lien à votre collaborateur. Il peut créer un compte ou se connecter pour accepter."
    },
    "fallbacks": {
      "unknownClient": "Client inconnu",
      "untitledCollection": "Collection sans nom",
      "collectionWithId": "Collection {{id}}"
    },
    "confirm": {
      "revoke": "Êtes-vous sûr de vouloir révoquer ce collaborateur ?",
      "activate": "Activer manuellement cet accès collaborateur ? L’utilisateur pourra se connecter immédiatement."
    },
    "toasts": {
      "inviteReady": "Invitation du collaborateur prête ✍️",
      "invitationResent": "Invitation renvoyée par email ✅",
      "linkCopied": "Lien d’invitation copié ✅",
      "activating": "Activation en cours…",
      "activated": "Collaborateur activé ✅"
    },
    "errors": {
      "load": "Erreur lors du chargement des collaborateurs : {{message}}",
      "unknownPlan": "Plan non reconnu",
      "roleLimit": "Limite atteinte pour ce rôle ({{current}}/{{limit}}). Passez au plan supérieur ou révoquez un accès.",
      "selectCollection": "Choisissez au moins une collection accessible.",
      "generic": "Erreur : {{message}}",
      "resend": "Erreur lors du renvoi : {{message}}",
      "unknown": "inconnue",
      "noToken": "Aucun jeton disponible. Cliquez d’abord sur « Renvoyer l’invitation ».",
      "copyLink": "Impossible de copier le lien.",
      "copyManually": "Sélectionnez le lien et copiez-le manuellement.",
      "activateImpossible": "Impossible d’activer ce collaborateur.",
      "activate": "Erreur lors de l’activation : {{message}}"
    },
    "audit": {
      "revokeReason": "Révoqué depuis le tableau de bord"
    }
  },
  "artworksForSale": {
    "loading": "Chargement des œuvres en vente…",
    "empty": "Aucune œuvre en vente pour le moment.",
    "untitledArtwork": "Œuvre sans titre",
    "unknownTechnique": "Technique inconnue",
    "undefined": "Non défini",
    "sections": {
      "mine": "Vos œuvres en vente",
      "others": "Œuvres en vente par d’autres collectionneurs"
    },
    "labels": {
      "estimate": "Estimation",
      "purchasePrice": "Prix d’achat",
      "salePrice": "Prix de vente",
      "proposedPrice": "Prix proposé"
    },
    "actions": {
      "view": "Voir la fiche",
      "remove": "Retirer",
      "makeOffer": "Proposer une offre"
    },
    "confirmRemove": "Voulez-vous vraiment retirer cette œuvre de la vente ?",
    "errors": {
      "loadingUnknown": "Erreur inconnue lors du chargement.",
      "remove": "Erreur lors du retrait de la vente : {{message}}",
      "unknown": "erreur inconnue"
    }
  },
  "estimationPage": {
    "title": "Estimations des œuvres",
    "form": {
      "title": "Ajouter une nouvelle estimation",
      "methodIntro": "Le type d’estimation détermine la méthode utilisée pour évaluer la valeur de l’œuvre :"
    },
    "methods": {
      "ai": {
        "label": "Estimation IA",
        "description": "Générée automatiquement par nos algorithmes internes à partir d’œuvres similaires, du médium, des dimensions, de l’artiste et des tendances du marché."
      },
      "physical": {
        "label": "Estimation physique",
        "description": "Réalisée par un expert après inspection directe ou sur pièce, en galerie, en dépôt ou dans un autre lieu."
      },
      "comparables": {
        "label": "Estimation par œuvres semblables",
        "description": "Fondée sur la comparaison directe avec des œuvres similaires déjà évaluées ou vendues, à partir de données internes ou de sources externes."
      },
      "insurance": {
        "label": "Estimation assurance",
        "description": "Fournie par un assureur ou un intermédiaire agréé afin de déterminer une valeur de couverture contractuelle."
      },
      "succession": {
        "label": "Estimation succession",
        "description": "Destinée à une déclaration patrimoniale ou à une transmission, conformément aux exigences fiscales et notariales."
      }
    },
    "fields": {
      "artwork": "Œuvre",
      "artist": "Artiste",
      "appraiser": "Estimateur",
      "date": "Date",
      "estimatedValue": "Valeur estimée (€)",
      "estimatedValueShort": "Valeur estimée",
      "method": "Type d’estimation",
      "notes": "Notes",
      "document": "Document (PDF ou image)",
      "documentShort": "Document"
    },
    "placeholders": {
      "selectArtwork": "Sélectionnez une œuvre",
      "selectExpert": "Choisir un expert",
      "searchArtwork": "🔍 Rechercher une œuvre…"
    },
    "actions": {
      "newEstimation": "Nouvelle estimation",
      "comparableEstimation": "Estimation par œuvres semblables",
      "pointsEstimation": "Estimation par points",
      "cancel": "Annuler",
      "addExpert": "Ajouter",
      "save": "Enregistrer",
      "download": "Télécharger"
    },
    "history": {
      "title": "Historique des estimations",
      "empty": "Aucune estimation ne correspond à votre recherche."
    },
    "fallbacks": {
      "unknownArtwork": "Œuvre inconnue",
      "unknownArtist": "Artiste inconnu"
    },
    "alerts": {
      "required": "Veuillez renseigner au moins l’œuvre et la valeur estimée.",
      "uploadError": "Erreur lors de l’envoi du document.",
      "saveError": "Erreur lors de l’enregistrement : {{message}}",
      "saved": "Estimation enregistrée avec succès !"
    }
  },
  "depositsPage": {
    "title": "Dépôts & Prêts",
    "subtitle": "Collections confiées à des tiers et œuvres en prêt individuel",
    "museumSidebar": {
      "title": "Proposer à un musée",
      "text": "Constituez un dossier de proposition pour une institution à partir de vos œuvres.",
      "cta": "Créer un dossier musée"
    },
    "tabs": {
      "deposits": "Collections en dépôt",
      "loans": "Œuvres en prêt",
      "risks": "À clarifier"
    },
    "ownerTypes": {
      "a_clarifier": "À clarifier",
      "private_collector": "Collectionneur privé",
      "institution": "Institution",
      "family_succession": "Famille / succession"
    },
    "contract": {
      "noEndDate": "⚠ Pas de date de fin",
      "expiredAgo": "EXPIRÉ il y a {{count}} jour",
      "expiredAgo_plural": "EXPIRÉ il y a {{count}} jours",
      "expiredAgo_one": "EXPIRÉ il y a {{count}} jour",
      "expiredAgo_other": "EXPIRÉ il y a {{count}} jours",
      "expiresIn": "⚠ Expire dans {{count}} jour",
      "expiresIn_plural": "⚠ Expire dans {{count}} jours",
      "expiresIn_one": "⚠ Expire dans {{count}} jour",
      "expiresIn_other": "⚠ Expire dans {{count}} jours",
      "validUntil": "Valide jusqu’au {{date}}",
      "urgentSummary": "{{count}} contrat expiré ou à renouveler sous 60 jours",
      "urgentSummary_plural": "{{count}} contrats expirés ou à renouveler sous 60 jours",
      "urgentSummary_one": "{{count}} contrat expiré ou à renouveler sous 60 jours",
      "urgentSummary_other": "{{count}} contrats expirés ou à renouveler sous 60 jours"
    },
    "toast": {
      "depositSaved": "Fiche dépôt enregistrée",
      "loanMarked": "Œuvre marquée en prêt",
      "loanRemoved": "Statut de prêt retiré",
      "error": "Erreur : {{message}}"
    },
    "depositModal": {
      "title": "Fiche dépôt",
      "ownerType": "Type de propriétaire",
      "ownerName": "Nom du propriétaire",
      "ownerNamePlaceholder": "Nom ou raison sociale",
      "contact": "Contact",
      "contactPlaceholder": "Email, téléphone…",
      "contractStart": "Début du contrat",
      "contractEnd": "Fin du contrat",
      "insuranceRequired": "Assurance requise",
      "insuranceHolderPlaceholder": "Qui porte l’assurance ? (déposant, dépositaire…)",
      "specialConditions": "Conditions particulières",
      "specialConditionsPlaceholder": "Clauses, restrictions, obligations…"
    },
    "loanModal": {
      "removeTitle": "Retirer du prêt",
      "markTitle": "Marquer en prêt",
      "destination": "Destination / bénéficiaire du prêt",
      "destinationPlaceholder": "Ex. Musée d’Art Moderne, Paris",
      "confirmReturn": "Confirmer le retour",
      "confirmLoan": "Confirmer le prêt"
    },
    "empty": {
      "depositsTitle": "Aucune collection en dépôt",
      "depositsText": "Créez une collection avec le type « Dépôt » depuis Ma Collection pour la gérer ici.",
      "loansTitle": "Aucune œuvre en prêt",
      "loansText": "Marquez des œuvres comme « en prêt » depuis leurs fiches individuelles ou depuis cette page.",
      "viewCollections": "Voir mes collections",
      "viewCollection": "Voir ma collection"
    },
    "risks": {
      "allLocated": "Toutes vos œuvres sont localisées",
      "loanLocatedHint": "Les œuvres en prêt sont considérées localisées chez l’institution emprunteuse.",
      "unknownLocationTitle": "Localisation inconnue —",
      "unknownLocationText": "Ces œuvres n’ont ni lieu de stockage ni prêt renseigné. En cas de sinistre, leur position ne pourra pas être prouvée à l’assureur.",
      "collectionLabel": "Collection : {{collection}}"
    },
    "actions": {
      "complete": "Renseigner",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "edit": "Modifier",
      "view": "Voir"
    },
    "depositCard": {
      "badge": "Dépôt",
      "artworkCount_one": "{{count}} œuvre",
      "artworkCount_other": "{{count}} œuvres",
      "insurance": "Assurance : {{holder}}",
      "toDefine": "à définir",
      "missingRecord": "⚠ Aucune fiche dépôt renseignée — contrat, propriétaire et assurance inconnus"
    },
    "loanCard": {
      "estimatedValue": "Valeur estimée : {{value}}",
      "return": "Retour",
      "record": "Fiche"
    }
  },
  "locationManager": {
    "page": {
      "title": "Mes emplacements",
      "subtitle": "Quelques informations suffisent pour prendre soin de chaque œuvre, là où elle vit — chez vous comme dans un lieu spécialisé."
    },
    "status": {
      "suitable": "Adapté",
      "improve": "À améliorer",
      "monitor": "À surveiller"
    },
    "microcopy": {
      "headerTitle": "Prenez soin de vos œuvres, là où elles vivent",
      "headerSub": "Quelques informations suffisent pour recevoir des conseils adaptés à chaque œuvre — chez vous comme dans un lieu spécialisé.",
      "homeTitle": "Conservée chez vous ? C'est souvent parfaitement adapté.",
      "homeText": "ARTKIV vous aide simplement à vérifier la lumière, l'humidité, la chaleur et la sécurité de l'accrochage.",
      "unknownTitle": "Vous n'avez pas toutes les réponses ? Aucun problème.",
      "unknownText": "Indiquez ce que vous savez aujourd'hui. Vous pourrez compléter plus tard.",
      "proTitle": "Besoin d'un environnement plus technique ?",
      "proText": "Pour certaines œuvres sensibles, volumineuses ou fréquemment déplacées, un stockage spécialisé peut apporter des services supplémentaires.",
      "privacyTitle": "Votre adresse et vos photos restent privées.",
      "privacyText": "Vous choisissez précisément qui peut consulter les informations du lieu."
    },
    "actions": {
      "newLocation": "Nouvel emplacement",
      "cancel": "Annuler",
      "edit": "Modifier",
      "delete": "Supprimer",
      "transfer": "Transférer",
      "confirm": "Confirmer",
      "save": "Enregistrer"
    },
    "fields": {
      "type": "Type",
      "address": "Adresse",
      "notes": "Notes",
      "status": "Statut"
    },
    "types": {
      "primaryResidence": "Résidence principale",
      "secondaryResidence": "Résidence secondaire",
      "office": "Bureau / locaux professionnels",
      "personalReserve": "Réserve personnelle",
      "selfStorage": "Garde-meuble / self-stockage",
      "artWarehouse": "Entrepôt d'art spécialisé",
      "professionalDeposit": "Galerie / atelier / dépôt pro",
      "museum": "Musée / institution",
      "transit": "Transport / transit",
      "freeport": "Entrepôt sous douane / port franc",
      "storage": "Stockage",
      "loan": "Prêt",
      "exhibition": "Exposition",
      "other": "Autre"
    },
    "security": {
      "intrusionAlarm": "Alarme intrusion",
      "videoSurveillance": "Vidéosurveillance",
      "restrictedAccess": "Accès restreint",
      "specificInsurance": "Assurance spécifique"
    },
    "risks": {
      "low": "Faible",
      "medium": "Moyen",
      "high": "Élevé"
    },
    "conditions": {
      "temperature": "Température",
      "humidity": "Humidité",
      "light": "Lumière",
      "ventilation": "Ventilation",
      "humidityRelative": "Humidité relative",
      "lightUv": "Lumière / UV",
      "packagingVentilation": "Emballage / Ventilation",
      "temperaturePlaceholder": "Ex. : 18-20 °C, stable, climatisé",
      "humidityPlaceholder": "Ex. : 50-55 % HR, contrôlée",
      "lightPlaceholder": "Ex. : obscurité totale, UV filtrés, stores",
      "ventilationPlaceholder": "Ex. : rouleaux sans acide, caisses bois, espace aéré"
    },
    "form": {
      "sections": {
        "general": "Informations générales",
        "conservation": "Conditions de conservation",
        "security": "Mesures de sécurité",
        "risk": "Niveau de risque global",
        "observationsPhotos": "Observations & photos"
      },
      "name": "Nom de l’emplacement",
      "generalObservations": "Observations générales",
      "observationsPlaceholder": "Risques observés, travaux à prévoir, accès, gardiennage…"
    },
    "photos": {
      "title": "Photos de l’espace",
      "uploadingShort": "Import…",
      "uploading": "Import en cours…",
      "add": "+ Ajouter",
      "addPhotos": "+ Ajouter des photos",
      "addSpacePhotos": "Ajouter des photos de l’espace",
      "addMore": "Ajouter d’autres photos"
    },
    "artworks": {
      "atLocation": "Œuvres à cet emplacement :"
    },
    "transfer": {
      "selectDestination": "Sélectionner une destination",
      "confirmTitle": "Confirmer le transfert",
      "destination": "Destination"
    },
    "delete": {
      "confirmTitle": "Supprimer cet emplacement ?",
      "containsArtworks": "Cet emplacement contient {{count}} œuvre. Transférez-la avant de supprimer.",
      "containsArtworks_plural": "Cet emplacement contient {{count}} œuvres. Transférez-les avant de supprimer.",
      "containsArtworks_one": "Cet emplacement contient {{count}} œuvre. Transférez-la avant de supprimer.",
      "containsArtworks_other": "Cet emplacement contient {{count}} œuvres. Transférez-les avant de supprimer.",
      "irreversible": "Cette action est irréversible."
    },
    "fallback": {
      "untitled": "Sans titre",
      "unknownArtist": "artiste inconnu"
    },
    "notifications": {
      "uploadError": "Erreur d’import : {{message}}",
      "selectTransfer": "Veuillez sélectionner une destination et des œuvres à transférer.",
      "transferSuccess": "Œuvres transférées avec succès !",
      "transferError": "Erreur lors du transfert.",
      "updateSuccess": "Emplacement mis à jour !",
      "updateError": "Erreur lors de la mise à jour.",
      "createSuccess": "Nouvel emplacement ajouté.",
      "createError": "Erreur lors de la création.",
      "deleteBlocked": "Impossible de supprimer : {{count}} œuvre se trouve dans cet emplacement. Transférez-la d’abord.",
      "deleteBlocked_plural": "Impossible de supprimer : {{count}} œuvres se trouvent dans cet emplacement. Transférez-les d’abord.",
      "deleteBlocked_one": "Impossible de supprimer : {{count}} œuvre se trouve dans cet emplacement. Transférez-la d’abord.",
      "deleteBlocked_other": "Impossible de supprimer : {{count}} œuvres se trouvent dans cet emplacement. Transférez-les d’abord.",
      "deleteSuccess": "Emplacement supprimé.",
      "deleteError": "Erreur lors de la suppression."
    }
  },
  "estimationValidation": {
    "cancelled": {
      "ui": {
        "paiementAnnule": "Paiement annulé",
        "vousAvezAnnuleLeProcessusDePaiementAucunMontant": "Vous avez annulé le processus de paiement. Aucun montant n'a été débité. Votre demande de validation n'a pas été créée.",
        "retourAuxEstimations": "Retour aux estimations"
      }
    },
    "success": {
      "ui": {
        "verificationDuPaiement": "Vérification du paiement...",
        "paiementConfirme": "Paiement confirmé !",
        "votreDemandeDeValidationAEteTransmiseANotre": "Votre demande de validation a été transmise à notre équipe d'experts. Vous recevrez l'estimation validée par email sous",
        "4872hOuvres": "48-72h ouvrés",
        "prochainesEtapes": "Prochaines étapes",
        "vousRecevrezUnEmailDeConfirmationImmediatement": "Vous recevrez un email de confirmation immédiatement",
        "notreEquipeAnalyseraVotreEstimationDansLes4872h": "Notre équipe analysera votre estimation dans les 48-72h",
        "vousRecevrezLeRapportDetailleParEmail": "Vous recevrez le rapport détaillé par email",
        "retourAuxEstimations": "Retour aux estimations",
        "monCompte": "Mon compte"
      }
    },
    "request": {
      "ui": {
        "aucuneDonneeDEstimationTrouveeVeuillezDAbordEffectuer": "Aucune donnée d'estimation trouvée. Veuillez d'abord effectuer le calcul.",
        "votreDemandeDeValidationAEteEnvoyeeAL": "✅ Votre demande de validation a été envoyée à l'équipe Artkiv. Vous recevrez une notification par email dans les 48-72h.",
        "calculDEstimationRequis": "Calcul d'estimation requis",
        "vousDevezDAbordEffectuerLeCalculDEstimation": "Vous devez d'abord effectuer le calcul d'estimation (méthode par points ou comparables) avant de pouvoir demander une validation.",
        "retourAuxEstimations": "Retour aux estimations",
        "demandeDeValidationDEstimation": "Demande de validation d'estimation",
        "serviceExpertArtkivValidationSous4872h": "Service expert Artkiv - Validation sous 48-72h",
        "recapitulatifDeVotreEstimation": "Récapitulatif de votre estimation",
        "sansTitre": "Sans titre",
        "methodeUtilisee": "Méthode utilisée",
        "methodeParPoints": "Méthode par points",
        "uvresComparables": "Œuvres comparables",
        "valeurEstimee": "Valeur estimée",
        "indiceDeConfiance": "Indice de confiance",
        "estimationProvisoireBaseDeComparablesInsuffisantePourValidationC": "Estimation provisoire — base de comparables insuffisante pour validation CUP complète.",
        "validationGratuiteIncluse": "Validation gratuite incluse",
        "servicePayant": "Service payant",
        "votreAbonnement": "Votre abonnement",
        "validationsGratuitesParMois": "validations gratuites par mois.",
        "validationsUtiliseesCeMois": "Validations utilisées ce mois",
        "validationsGratuitesRestantes": "Validations gratuites restantes",
        "coutDeCetteValidation": "Coût de cette validation",
        "passezALAbonnementPremiumPourObtenir50Validations": ": Passez à l'abonnement Premium pour obtenir 50 validations gratuites/mois",
        "commentCaMarche": "Comment ça marche ?",
        "envoiDeVotreDemande": "Envoi de votre demande",
        "votreCalculDEstimationEstTransmisALEquipe": "Votre calcul d'estimation est transmis à l'équipe Artkiv",
        "verificationExperte": "Vérification experte",
        "nosExpertsAnalysentVosDonneesVerifientLesSourcesEt": "Nos experts analysent vos données, vérifient les sources et affinent l'estimation",
        "receptionSous4872h": "Réception sous 48-72h",
        "vousRecevezLEstimationValideeParEmailAvecUn": "Vous recevez l'estimation validée par email avec un rapport détaillé",
        "envoiEnCours": "Envoi en cours...",
        "envoyerPourValidation": "Envoyer pour validation",
        "gratuit": "(Gratuit)",
        "noteImportante": "Note importante :",
        "cetteValidationNEstPasUneExpertiseOfficielleCnes": "Cette validation n'est pas une expertise officielle CNES. Pour les œuvres de valeur importante (> 80 000 €) ou pour un usage légal (succession, assurance), une expertise physique par un expert agréé peut être requise.",
        "enSavoirPlus": "En savoir plus",
        "loading": "Chargement…",
        "submitError": "❌ Erreur lors de l'envoi de la demande : {{message}}",
        "planIncludes": "Votre abonnement {{plan}} inclut {{count}} validations gratuites par mois.",
        "tip": "Astuce",
        "range": "Fourchette"
      }
    },
    "info": {
      "ui": {
        "serviceDeValidationDEstimation": "Service de validation d'estimation",
        "commentFaireValiderVotreEstimationParUnExpertArtkiv": "Comment faire valider votre estimation par un expert Artkiv",
        "leProcessusEn3Etapes": "Le processus en 3 étapes",
        "effectuezVotreEstimation": "Effectuez votre estimation",
        "utilisezLUneDeNosDeuxMethodesPourCalculer": "Utilisez l'une de nos deux méthodes pour calculer la valeur de votre œuvre :",
        "methodeParPoints": "Méthode par points",
        "calculBaseSurLesDimensionsEtLaCoteDe": ": calcul basé sur les dimensions et la cote de l'artiste",
        "uvresComparables": "Œuvres comparables",
        "analyseDeVentesSimilairesRecentes": ": analyse de ventes similaires récentes",
        "demandezLaValidation": "Demandez la validation",
        "uneFoisVotreCalculTermineCliquezSurDemanderUne": "Une fois votre calcul terminé, cliquez sur \"Demander une validation experte\". Vous verrez immédiatement si cette validation est gratuite (selon votre quota mensuel) ou payante (150 €).",
        "recevezLEstimationValidee": "Recevez l'estimation validée",
        "nosExpertsVerifientVosDonneesConsolidentLesSourcesEt": "Nos experts vérifient vos données, consolident les sources et affinent l'estimation. Vous recevez un rapport détaillé par email sous",
        "4872hOuvres": "48-72h ouvrés",
        "tarificationTransparente": "Tarification transparente",
        "lesValidationsNeSontPasAutomatiquementInclusesDansVotre": "Les validations ne sont PAS automatiquement incluses dans votre abonnement",
        "abonnementStandard": "Abonnement Standard",
        "validationsGratuites": "Validations gratuites",
        "10Mois": "10 / mois",
        "auDelaDuQuota": "Au-delà du quota",
        "150Validation": "150 € / validation",
        "abonnementPremium": "Abonnement Premium",
        "recommande": "Recommandé",
        "50Mois": "50 / mois",
        "ceQuiEstInclusDansLaValidation": "Ce qui est inclus dans la validation",
        "verificationDesDonnees": "Vérification des données",
        "controleDeCoherenceDesInformationsSaisies": "Contrôle de cohérence des informations saisies",
        "consolidationDesSources": "Consolidation des sources",
        "verificationEtEnrichissementDesComparables": "Vérification et enrichissement des comparables",
        "affinementDeLEstimation": "Affinement de l'estimation",
        "ajustementsBasesSurLExpertiseDuMarche": "Ajustements basés sur l'expertise du marché",
        "rapportDetaille": "Rapport détaillé",
        "documentPdfProfessionnelAvecMethodologie": "Document PDF professionnel avec méthodologie",
        "notreEngagementTransparence": "💎 Notre engagement transparence",
        "artkivNeModifieJamaisVosCalculs": "Artkiv ne modifie jamais vos calculs.",
        "notreValidationEnrichitVotreAnalyseAvecDesVentesComplementaires": "Notre validation enrichit votre analyse avec des ventes complémentaires que nous avons identifiées dans nos bases de données professionnelles (Artprice, Artnet, archives maisons de ventes).",
        "chaqueAjoutEstJustifie": "Chaque ajout est justifié",
        "etTraceDansLeRapportFinal": "et tracé dans le rapport final.",
        "vousVerrezExactement": "Vous verrez exactement :",
        "votreCalculInitial": "Votre calcul initial",
        "reproduitTelQuelInchange": "(reproduit tel quel, inchangé)",
        "lesVentesAjouteesParArtkiv": "Les ventes ajoutées par Artkiv",
        "avecSourcesExactesMaisonDeVentesDateLotEt": "avec sources exactes (maison de ventes, date, lot) et raisons de leur inclusion",
        "lesVentesEcartees": "Les ventes écartées",
        "siNecessaireAvecJustificationDetaillee": "(si nécessaire) avec justification détaillée",
        "lEcartEntreVotreEstimationEtLaNotre": "L'écart entre votre estimation et la nôtre",
        "avecExplicationMethodologique": "avec explication méthodologique",
        "notreSeuleMission": "Notre seule mission :",
        "vousDonnerLEstimationLaPlusJustePossibleBasee": "vous donner l'estimation la plus juste possible, basée sur le marché réel. Nous ne touchons aucune commission sur les ventes ou assurances ultérieures. Notre revenu provient uniquement des frais de validation.",
        "importantValidationVsExpertiseCnes": "⚠️ Important : Validation vs Expertise CNES",
        "laValidationDEstimationArtkiv": "La validation d'estimation Artkiv",
        "nEstPas": "n'est pas",
        "uneExpertiseOfficielleParUnExpertAgreeCnesElle": "une expertise officielle par un expert agréé CNES. Elle convient pour :",
        "assurancePourDesUvres80000": "• Assurance pour des œuvres < 80 000 €",
        "gestionDeCollectionPersonnelle": "• Gestion de collection personnelle",
        "premiereEvaluationAvantVente": "• Première évaluation avant vente",
        "pourLesUvresDeHauteValeur80000Ou": "Pour les œuvres de haute valeur (> 80 000 €) ou pour un usage légal (succession, donation, contentieux), une",
        "expertiseCnes": "expertise CNES",
        "estRecommandeeOuObligatoire": "est recommandée ou obligatoire.",
        "enSavoirPlus": "En savoir plus",
        "questionsFrequentes": "Questions fréquentes",
        "commentPuisJeEtreSurEQuArtkivN": "💎 Comment puis-je être sûr(e) qu'Artkiv n'invente pas des ventes pour justifier un prix plus élevé ?",
        "excellenteQuestionEtNousLaComprenonsParfaitement": "Excellente question, et nous la comprenons parfaitement.",
        "laTransparenceEstAuCUrDeNotreService": "La transparence est au cœur de notre service de validation. Voici nos 4 garanties :",
        "votreCalculResteIntact": "Votre calcul reste intact",
        "nousReproduisonsExactementVotreEstimationInitialeDansLeRapport": "Nous reproduisons EXACTEMENT votre estimation initiale dans le rapport (Section 1), sans aucune modification. Vous pourrez comparer côte à côte.",
        "sourcesVerifiables": "Sources vérifiables",
        "chaqueVenteAjouteeInclutMaisonDeVentesDateExacte": "Chaque vente ajoutée inclut : maison de ventes, date exacte, numéro de lot, et lien vers les archives publiques quand disponibles. Vous pouvez tout vérifier.",
        "justificationSystematique": "Justification systématique",
        "pourChaqueVenteAjouteeNousExpliquonsPourquoiElleEst": "Pour chaque vente ajoutée, nous expliquons POURQUOI elle est pertinente (dimensions similaires, période identique, maison prestigieuse, etc.).",
        "aucunConflitDInteret": "Aucun conflit d'intérêt",
        "nousNeTouchonsAucuneCommissionSurVosVentesOu": "Nous ne touchons AUCUNE commission sur vos ventes ou assurances futures. Notre seul revenu : les 150 € de validation (ou inclus dans votre abonnement).",
        "notreReputationDependDeNotreHonneteteUnClientInsatisfait": "Notre réputation dépend de notre honnêteté. Un client insatisfait peut partager notre rapport avec d'autres experts pour vérification. Nous n'avons aucun intérêt à manipuler les données.",
        "quellesSourcesDeDonneesUtilisezVousPourEnrichirMon": "Quelles sources de données utilisez-vous pour enrichir mon estimation ?",
        "notreValidationReposeSurUnAccesProfessionnelAPlusieurs": "Notre validation repose sur un accès professionnel à plusieurs bases de données de référence du marché de l'art :",
        "basesDeDonneesMondiales": "📊 Bases de données mondiales",
        "30mResultatsDeVentes": ": 30M+ résultats de ventes",
        "ventesInternationalesDepuis1985": ": Ventes internationales depuis 1985",
        "theArtMarket": "The Art Market",
        "analysesSectorielles": ": Analyses sectorielles",
        "archivesMaisonsDeVentes": "🏛️ Archives maisons de ventes",
        "christieSSothebySBonhams": "• Christie's, Sotheby's, Bonhams",
        "artcurialTajanPiasaMillon": "• Artcurial, Tajan, Piasa, Millon",
        "cataloguesSpecialisesParArtiste": "• Catalogues spécialisés par artiste",
        "sourcesAcademiques": "📚 Sources académiques",
        "cataloguesRaisonnesSiDisponibles": "• Catalogues raisonnés (si disponibles)",
        "publicationsDExpertsSpecialises": "• Publications d'experts spécialisés",
        "archivesGaleriesHistoriques": "• Archives galeries historiques",
        "expertiseInterne": "👥 Expertise interne",
        "expertsDiplomesHistoireDeLArt": "• Experts diplômés histoire de l'art",
        "specialisationsParPeriode": "• Spécialisations par période",
        "veilleContinueDuMarche": "• Veille continue du marché",
        "notreValeurAjoutee": "Notre valeur ajoutée :",
        "nousCroisonsCesSourcesProfessionnellesSouventPayantesOuA": "Nous croisons ces sources professionnelles (souvent payantes ou à accès restreint) pour identifier les ventes les plus pertinentes que vous n'auriez pas trouvées seul(e).",
        "toutesLesVentesAjouteesDansVotreRapportInclurontLa": "Toutes les ventes ajoutées dans votre rapport incluront la source exacte pour que vous puissiez vérifier leur authenticité.",
        "commentFonctionneLeQuotaMensuelDeValidationsGratuites": "Comment fonctionne le quota mensuel de validations gratuites ?",
        "chaqueAbonnementInclutUnCertainNombreDeValidationsGratuites": "Chaque abonnement inclut un certain nombre de validations gratuites par mois :",
        "standard29Mois": "Standard (29 €/mois) :",
        "10ValidationsGratuites": "10 validations gratuites",
        "premium199Mois": "Premium (199 €/mois) :",
        "50ValidationsGratuites": "50 validations gratuites",
        "important": "📅 Important :",
        "leQuotaSeRenouvelleAutomatiquementLe1erDeChaque": "Le quota se renouvelle automatiquement le 1er de chaque mois. Les validations non utilisées ne sont pas reportées au mois suivant.",
        "auDelaDuQuotae1b639": "Au-delà du quota :",
        "chaqueValidationSupplementaireCoute150QuelQueSoitVotre": "Chaque validation supplémentaire coûte 150 €, quel que soit votre abonnement.",
        "astuce": "💡 Astuce :",
        "siVousFaitesRegulierementPlusDe2ValidationsPayantes": "Si vous faites régulièrement plus de 2 validations payantes par mois, passer à Premium devient rentable (199 € pour 50 validations = 3,98 €/validation en valeur d'abonnement).",
        "puisJeAvoirUneValidationEnMoinsDe48h": "Puis-je avoir une validation en moins de 48h si c'est urgent ?",
        "leDelaiStandardEstDe": "Le délai standard est de",
        "4872HeuresOuvrees": "48-72 heures ouvrées",
        "lundiVendrediHorsJoursFeries": "(lundi-vendredi, hors jours fériés).",
        "pourUne": "Pour une",
        "validationExpress24h": "validation express (24h)",
        "nousPouvonsEtudierVotreDemandeAuCasParCas": ", nous pouvons étudier votre demande au cas par cas :",
        "contactezNousA": "Contactez-nous à",
        "expertsArtkivCom": "experts@artkiv.com",
        "avantDeFaireLaDemande": "AVANT de faire la demande",
        "supplementDe75Total225OuQuota75": "Supplément de 75 € (total : 225 € ou quota + 75 €)",
        "selonDisponibiliteDeNosExpertsPasGaranti": "Selon disponibilité de nos experts (pas garanti)",
        "attention": "⚠️ Attention :",
        "memeEnExpressNousMaintenonsLaMemeQualiteD": "Même en express, nous maintenons la même qualité d'analyse. Si la complexité nécessite plus de temps, nous vous préviendrons.",
        "queFaireAvecLeRapportDeValidationUneFois": "Que faire avec le rapport de validation une fois reçu ?",
        "leRapportDeValidationArtkivPeutEtreUtilisePour": "Le rapport de validation Artkiv peut être utilisé pour :",
        "usagesRecommandes": "✅ Usages recommandés",
        "assuranceUvres80000": "• Assurance œuvres < 80 000 €",
        "gestionCollectionPersonnelle": "• Gestion collection personnelle",
        "partageAvecConseillerPatrimoine": "• Partage avec conseiller patrimoine",
        "discussionAvecGaleriste": "• Discussion avec galeriste",
        "valorisationPatrimoniale": "• Valorisation patrimoniale",
        "necessiteExpertiseCnes": "❌ Nécessite expertise CNES",
        "successionDeclarationFiscale": "• Succession (déclaration fiscale)",
        "donationActeNotarie": "• Donation (acte notarié)",
        "contentieuxJuridique": "• Contentieux juridique",
        "assuranceUvres800004aa7fe": "• Assurance œuvres > 80 000 €",
        "venteMaisonInternationale": "• Vente maison internationale",
        "litigeAuthenticite": "• Litige authenticité",
        "pourAllerPlusLoin": "💼 Pour aller plus loin :",
        "siVotreSituationNecessiteUneExpertiseCnesOfficielleContactez": "Si votre situation nécessite une expertise CNES officielle, contactez-nous à experts@artkiv.com. Le rapport Artkiv servira de base solide pour l'expertise physique.",
        "queSePasseTIlSiJeNeSuis": "Que se passe-t-il si je ne suis pas satisfait(e) du rapport ?",
        "votreSatisfactionEstNotrePrioriteSiVousAvezDes": "Votre satisfaction est notre priorité. Si vous avez des questions ou contestations :",
        "contactezNousSous7Jours": "Contactez-nous sous 7 jours",
        "emailExpertsArtkivComAvecVotreReferenceDeValidation": "Email : experts@artkiv.com avec votre référence de validation",
        "echangeAvecLExpertValidateur": "Échange avec l'expert validateur",
        "nousOrganisonsUnAppelPourClarifierLesPointsContestes": "Nous organisons un appel pour clarifier les points contestés",
        "correctionSiErreurDeNotrePart": "Correction si erreur de notre part",
        "siNousAvonsFaitUneErreurFactuelleNousCorrigeons": "Si nous avons fait une erreur factuelle, nous corrigeons gratuitement sous 48h",
        "important7cb751": "⚠️ Important :",
        "unSimpleDesaccordMethodologiqueNeConstituePasUneErreur": "Un simple désaccord méthodologique ne constitue pas une erreur. Toutes nos estimations reposent sur des ventes réelles vérifiables. Nous vous expliquerons notre raisonnement en détail.",
        "mesDonneesEtImagesDUvresSontEllesConfidentielles": "Mes données et images d'œuvres sont-elles confidentielles ?",
        "laConfidentialiteEstGarantieA100": "La confidentialité est garantie à 100% :",
        "aucunPartageAvecDesTiers": "Aucun partage avec des tiers",
        "vosImagesEtInformationsNeSortentJamaisDArtkiv": "- Vos images et informations ne sortent jamais d'Artkiv sans votre consentement explicite",
        "conformiteRgpd": "Conformité RGPD",
        "toutesVosDonneesSontProtegeesSelonLeReglementEuropeen": "- Toutes vos données sont protégées selon le règlement européen sur la protection des données",
        "hebergementSecuriseEurope": "Hébergement sécurisé Europe",
        "serveursHetznerEnAllemagneChiffrementSauvegardesQuotidiennes": "- Serveurs Hetzner en Allemagne, chiffrement, sauvegardes quotidiennes",
        "accesRestreint": "Accès restreint",
        "seulLExpertAssigneAVotreValidationAccedeA": "- Seul l'expert assigné à votre validation accède à vos données pendant le traitement",
        "suppressionALaDemande": "Suppression à la demande",
        "vousPouvezDemanderLaSuppressionDeVosDonneesA": "- Vous pouvez demander la suppression de vos données à tout moment (droit à l'oubli)",
        "pourPlusDInformations": "Pour plus d'informations :",
        "politiqueDeConfidentialite": "Politique de confidentialité",
        "pretAEstimerVotreUvre": "Prêt à estimer votre œuvre ?",
        "commencezParChoisirVotreMethodeDEstimation": "Commencez par choisir votre méthode d'estimation",
        "commencerLEstimation": "Commencer l'estimation",
        "absolument": "Absolument."
      }
    }
  },
  "estimationSuccession": {
    "ui": {
      "dansQuelPaysSeSitueLaSuccession": "Dans quel pays se situe la succession ?",
      "lesReglesDEvaluationDesUvresDArtVarient": "Les règles d'évaluation des œuvres d'art varient selon la législation locale.",
      "changerDePays": "Changer de pays",
      "successionEnBelgique": "🇧🇪 Succession en Belgique",
      "valeurVenaleAuJourDuDecesPossibiliteDeDation": "Valeur vénale au jour du décès. Possibilité de dation en paiement d'œuvres d'art (évaluation à 120% en Flandre depuis 2023).",
      "selectionnezLaRegionDuDefunt": "Sélectionnez la région du défunt",
      "lesDroitsDeSuccessionVarientSelonLaRegionDe": "Les droits de succession varient selon la région de domicile du défunt.",
      "evaluationDeLUvreDArt": "Évaluation de l'œuvre d'art",
      "valeurVenaleDeLUvreAuJourDuDeces": "Valeur vénale de l'œuvre au jour du décès",
      "ex50000": "Ex: 50000",
      "estimationParCommissairePriseurOuExpertRecommandee": "Estimation par commissaire-priseur ou expert recommandée",
      "valeurTotaleDeLaSuccession": "Valeur totale de la succession",
      "ex500000": "Ex: 500000",
      "lienDeParenteAvecLeDefunt": "Lien de parenté avec le défunt",
      "selectionner": "Sélectionner",
      "conjointCohabitantLegal": "Conjoint / Cohabitant légal",
      "ligneDirecteEnfantsParents": "Ligne directe (enfants, parents)",
      "freresSUrsOnclesTantes": "Frères, sœurs, oncles, tantes",
      "autresHeritiers": "Autres héritiers",
      "optionDationEnPaiement": "💡 Option : Dation en paiement",
      "vousPouvezPayerLesDroitsDeSuccessionEnCedant": "Vous pouvez payer les droits de succession en cédant des œuvres d'art appartenant au patrimoine culturel belge.",
      "avantageFlandreReforme2023": "🇧🇪 Avantage Flandre (réforme 2023)",
      "evaluationA": "• Évaluation à",
      "120DeLaValeurVenale": "120% de la valeur vénale",
      "elargissementAuxBiensCulturelsBijouxManuscritsObjetsArcheologiqu": "• Élargissement aux \"biens culturels\" (bijoux, manuscrits, objets archéologiques)",
      "remboursementDuSurplusSiValeurDroitsDus": "• Remboursement du surplus si valeur > droits dus",
      "envisagerLaDationEnPaiement": "Envisager la dation en paiement",
      "necessiteAccordDeLEtatEtExpertiseFraisA": "Nécessite accord de l'État et expertise (frais à prévoir)",
      "pointsClesBelgique": "📋 Points clés - Belgique",
      "valeurVenale": "Valeur vénale",
      "auJourDuDecesMarcheDesBiensDOccasion": "au jour du décès (marché des biens d'occasion)",
      "expertiseRecommandee": "Expertise recommandée",
      "parCommissairePriseurPourUvresImportantes": "par commissaire-priseur pour œuvres importantes",
      "tauxVariables": "Taux variables",
      "selonRegionDegreDeParenteEtMontant": "selon région, degré de parenté et montant",
      "dationPossible": "Dation possible",
      "cessionDUvresAuLieuDuPaiementEnNumeraire": ": cession d'œuvres au lieu du paiement en numéraire",
      "controleFiscal": "Contrôle fiscal",
      "lAdministrationPeutDemanderUneExpertiseDeControle": ": l'administration peut demander une expertise de contrôle",
      "retour": "← Retour",
      "demanderUneExpertise": "Demander une expertise",
      "successionEnSuisse": "🇨🇭 Succession en Suisse",
      "26RegimesCantonauxDifferentsValeurVenaleAuJourDu": "26 régimes cantonaux différents. Valeur vénale au jour du décès. Schwyz et Obwald : aucun impôt. Dation possible dans certains cantons (Genève, Vaud...).",
      "selectionnezLeCantonDuDernierDomicileDuDefunt": "Sélectionnez le canton du dernier domicile du défunt",
      "lImpotSurLesSuccessionsEstPreleveParLe": "L'impôt sur les successions est prélevé par le canton de résidence du défunt.",
      "cantonDe": "Canton de",
      "aucunImpotSurLesSuccessionsDansCeCanton": "✓ Aucun impôt sur les successions dans ce canton",
      "informationsSurLUvre": "Informations sur l'œuvre",
      "valeurVenaleDeLUvreChf": "Valeur vénale de l'œuvre (CHF)",
      "evaluationALaValeurDuMarcheAuJourDu": "Évaluation à la valeur du marché au jour du décès",
      "lienAvecLeDefunt": "Lien avec le défunt",
      "conjointPartenaireEnregistre": "Conjoint / Partenaire enregistré",
      "enfantsPetitsEnfants": "Enfants / Petits-enfants",
      "freresEtSUrs": "Frères et sœurs",
      "dationEnPaiementDisponible": "💡 Dation en paiement disponible",
      "leCantonDe": "Le canton de",
      "permetDePayerLImpotSurLesSuccessionsEn": "permet de payer l'impôt sur les successions en remettant une œuvre de haute valeur culturelle à l'État.",
      "cantonDeVaudLdpi2005": "Canton de Vaud (LDPI 2005)",
      "serviceDesAffairesCulturellesSeracEvalueLInteret": "• Service des affaires culturelles (SERAC) évalue l'intérêt",
      "enrichissementDesCollectionsDuMuseeCantonal": "• Enrichissement des collections du Musée cantonal",
      "procedureDAgrementRequise": "• Procédure d'agrément requise",
      "envisagerLaDationEnPaiementPourCetteUvre": "Envisager la dation en paiement pour cette œuvre",
      "specificitesDuCanton": "📋 Spécificités du canton",
      "26SystemesDifferents0A50": ": 26 systèmes différents (0% à 50%)",
      "impotCommunal": "Impôt communal",
      "peutSAjouterALImpotCantonal": ": peut s'ajouter à l'impôt cantonal",
      "delaiDePaiement": "Délai de paiement",
      "generalement30JoursApresNotification": ": généralement 30 jours après notification",
      "evaluationAuJourDuDecesMarcheSecondaire": ": évaluation au jour du décès (marché secondaire)",
      "pasDImpotFederal": "Pas d'impôt fédéral",
      "seulsLesCantonsPreleventLImpot": ": seuls les cantons prélèvent l'impôt",
      "changerDeCanton": "← Changer de canton",
      "faireEtablirUnInventaireParUnCommissairePriseurOu": "Faire établir un inventaire par un commissaire-priseur ou expert",
      "montantForfaitaireFaibleEtSimple": "Montant forfaitaire faible et simple",
      "utiliserLeForfaitMobilierStandard": "Utiliser le forfait mobilier standard",
      "comparerInventaireVsForfaitSelonValeurReelle": "Comparer inventaire vs forfait selon valeur réelle",
      "consulterUnNotaireOuExpertComptable": "Consulter un notaire ou expert-comptable",
      "successionEnFranceArticle764Cgi": "🇫🇷 Succession en France - Article 764 CGI",
      "hierarchieLegale1VentePublique2Ans2Inventaire": "Hiérarchie légale : 1) Vente publique (2 ans) → 2) Inventaire (5 ans) → 3) Assurance (-10 ans) → 4) Forfait 5% ou déclaration estimative",
      "informationsSurLaSuccession": "Informations sur la succession",
      "valeurTotaleDeLaSuccessionAvantDeductionDesDettes": "Valeur totale de la succession (avant déduction des dettes)",
      "inclutImmobilierPlacementsAutresBiensMobiliers": "Inclut : immobilier, placements, autres biens mobiliers",
      "forfaitMobilier5": "Forfait mobilier 5% =",
      "siVousUtilisezLeForfaitLesMeublesUvresSeront": "Si vous utilisez le forfait, les meubles/œuvres seront évalués à ce montant minimum",
      "concernantLUvreAEstimer": "Concernant l'œuvre à estimer :",
      "ventePubliqueDansLes2Ans": "Vente publique dans les 2 ans",
      "prixDeVenteObligatoireSiVenteAuxEncheresApres": "Prix de vente obligatoire si vente aux enchères après décès",
      "dateDeLaVente": "Date de la vente",
      "prixDeVente": "Prix de vente (€)",
      "inventaireDansLes5Ans": "Inventaire dans les 5 ans",
      "parNotaireCommissairePriseurOuExpert": "Par notaire, commissaire-priseur ou expert",
      "dateDeLInventaire": "Date de l'inventaire",
      "valeurEstimee": "Valeur estimée (€)",
      "contratDAssuranceDeMoinsDe10Ans": "Contrat d'assurance de moins de 10 ans",
      "volIncendieOuDommage": "Vol, incendie ou dommage",
      "dateDuContrat": "Date du contrat",
      "valeurAssuree": "Valeur assurée (€)",
      "voirLaRecommandation": "Voir la recommandation",
      "recapitulatif": "Récapitulatif",
      "valeurTotaleSuccession": "Valeur totale succession",
      "forfaitMobilier547ea06": "Forfait mobilier 5%",
      "valeurInventaire": "Valeur inventaire",
      "recommandation": "Recommandation :",
      "pointsDAttention": "⚠️ Points d'attention",
      "lAdministrationFiscalePeutContesterEtDemanderUnePreuve": "L'administration fiscale peut contester et demander une preuve contraire",
      "distinctionEntreMeublesMeublantsTableauxDOrnementEtObjets": "Distinction entre \"meubles meublants\" (tableaux d'ornement) et \"objets d'art/collection\" (galerie privée)",
      "delaisVentePublique2AnsInventaire5AnsAssurance": "Délais : vente publique (2 ans), inventaire (5 ans), assurance (10 ans)",
      "conserverTousLesJustificatifsFacturesExpertisesContrats": "Conserver tous les justificatifs : factures, expertises, contrats",
      "besoinDUnAccompagnementProfessionnel": "Besoin d'un accompagnement professionnel ?",
      "unExpertComptableSpecialiseEnFiscaliteDesSuccessionsOu": "Un expert-comptable spécialisé en fiscalité des successions ou un commissaire-priseur peut vous aider à optimiser l'évaluation et éviter les erreurs coûteuses.",
      "modifierLesDonnees": "Modifier les données",
      "estimationPourSuccession": "Estimation pour succession",
      "outilDAideALaDeclarationFiscaleSelonVotre": "Outil d'aide à la déclaration fiscale selon votre juridiction",
      "leModuleDEstimationSuccessionPourCePaysEst": "Le module d'estimation succession pour ce pays est en cours de développement.",
      "choisirUnAutrePays": "Choisir un autre pays",
      "ressourcesUtiles": "Ressources utiles",
      "article764DuCodeGeneralDesImpotsFrance": "→ Article 764 du Code Général des Impôts (France)",
      "bofipEvaluationDesBiensMeublesFrance": "→ BOFiP - Évaluation des biens meubles (France)",
      "fichePratiqueSuccessionArtkiv": "→ Fiche pratique succession Artkiv"
    },
    "data": {
      "country": {
        "FR": {
          "name": "France",
          "regulations": "Article 764 CGI - Forfait 5% ou inventaire"
        },
        "BE": {
          "name": "Belgique",
          "regulations": "Valeur vénale au jour du décès"
        },
        "CH": {
          "name": "Suisse",
          "regulations": "Règles cantonales variables"
        },
        "US": {
          "name": "États-Unis",
          "regulations": "Fair Market Value - IRS"
        },
        "UK": {
          "name": "Royaume-Uni",
          "regulations": "Probate valuation - HMRC"
        }
      },
      "region": {
        "WAL": {
          "name": "Wallonie",
          "info": "Code des droits de succession wallon"
        },
        "BXL": {
          "name": "Bruxelles-Capitale",
          "info": "Région de Bruxelles-Capitale"
        },
        "FLA": {
          "name": "Flandre",
          "info": "Erfbelasting - Réforme 2023 avec dation élargie"
        }
      },
      "canton": {
        "GE": {
          "name": "Genève",
          "exemption": "Ligne directe et conjoint exonérés"
        },
        "VD": {
          "name": "Vaud",
          "exemption": "Enfants : 250k CHF exonérés"
        },
        "ZH": {
          "name": "Zurich",
          "exemption": "Ligne directe exonérée"
        },
        "BE": {
          "name": "Berne",
          "exemption": "Ligne directe et conjoint exonérés"
        },
        "VS": {
          "name": "Valais",
          "exemption": "Selon barème cantonal"
        },
        "TI": {
          "name": "Tessin",
          "exemption": "Selon barème cantonal"
        },
        "SZ": {
          "name": "Schwyz",
          "exemption": "Aucun impôt successoral"
        },
        "OW": {
          "name": "Obwald",
          "exemption": "Aucun impôt successoral"
        }
      }
    },
    "recommendation": {
      "inventory": "Inventaire",
      "flatRate": "Forfait 5%",
      "toEvaluate": "À évaluer",
      "savings": "Économie de {{amount}} sur les droits de succession"
    }
  },
  "estimationAssurance": {
    "ui": {
      "factureDAchat": "Facture d'achat",
      "expertiseAgreee": "Expertise agréée",
      "certificatDAuthenticite": "Certificat d'authenticité",
      "historiqueProvenance": "Historique provenance",
      "uvresComparables": "Œuvres comparables",
      "etatExcellent": "État excellent",
      "estimationPourAssurance": "Estimation pour assurance",
      "constituezUnDossierSolidePourJustifierVotreValeurDeclaree": "Constituez un dossier solide pour justifier votre valeur déclarée",
      "valeurDeclareeVsValeurAgreee": "💡 Valeur déclarée vs Valeur agréée",
      "valeurDeclaree": "Valeur déclarée",
      "vousEstimezVousMemeLaValeurAvecJustificatifsPlus": ": Vous estimez vous-même la valeur (avec justificatifs). Plus simple et rapide. Recommandé jusqu'à 80 000 €.",
      "valeurAgreee": "Valeur agréée",
      "expertiseParUnProfessionnelAgreeCnesObligatoireAuDela": ": Expertise par un professionnel agréé CNES. Obligatoire au-delà de 80 000 € et recommandé pour les œuvres importantes.",
      "quelleMethodeDEvaluationChoisir": "Quelle méthode d'évaluation choisir ?",
      "vousEstimezVousMemeAvecDesJustificatifsFactureComparables": "Vous estimez vous-même avec des justificatifs (facture, comparables, photos, provenance). Artkiv vous aide à constituer le dossier en vous listant les éléments manquants.",
      "rapideEtSimple": "✓ Rapide et simple",
      "recommandeJusquA80000": "✓ Recommandé jusqu'à 80 000 €",
      "coutGratuitDansVotreAbonnement": "✓ Coût : gratuit (dans votre abonnement)",
      "expertRequis": "Expert requis",
      "expertiseParUnProfessionnelAgreeCnesChambreNationaleDes": "Expertise par un professionnel agréé CNES (Chambre Nationale des Experts). Garantie maximale pour l'assureur.",
      "obligatoire80000": "✓ Obligatoire > 80 000 €",
      "reconnueParTousLesAssureurs": "✓ Reconnue par tous les assureurs",
      "cout150500SelonUvre": "✓ Coût : 150-500 € selon œuvre",
      "votreUvreActuelle": "📊 Votre œuvre actuelle",
      "valeurActuelleDansArtkiv": "Valeur actuelle dans Artkiv",
      "expertiseRecommandee": "Expertise recommandée",
      "valeurDeclareeSuffisante": "Valeur déclarée suffisante",
      "changerDeMethode": "Changer de méthode",
      "constituerVotreDossierDeJustification": "Constituer votre dossier de justification",
      "valeurDeclareePourLAssurance": "Valeur déclarée pour l'assurance (€)",
      "ex15000": "Ex: 15000",
      "valeurDeRemplacementPrixDAchatInflationMarge10": "Valeur de remplacement (prix d'achat + inflation + marge 10-20%)",
      "prixDAchatInitial": "Prix d'achat initial",
      "ex12000": "Ex: 12000",
      "dateDAchat": "Date d'achat",
      "suggestionBaseeSurInflationMargeRemplacement": "💡 Suggestion basée sur inflation + marge remplacement",
      "utiliserCetteValeur": "Utiliser cette valeur",
      "documentsJustificatifs": "📎 Documents justificatifs",
      "factureDAchatRecuFortementRecommande": "Facture d'achat / Reçu (fortement recommandé)",
      "sourcesComparablesOptionnel": "Sources comparables (optionnel)",
      "exArtpriceChristieSSothebyS": "Ex: Artprice, Christie's, Sotheby's...",
      "etatDeConservation": "État de conservation",
      "tresBon": "Très bon",
      "necessiteRestauration": "Nécessite restauration",
      "analyserLeDossier": "Analyser le dossier →",
      "demanderUneExpertiseAgreee": "Demander une expertise agréée",
      "unExpertAgreeCnesPartenaireDArtkivVaEvaluer": "Un expert agréé CNES partenaire d'Artkiv va évaluer votre œuvre en tenant compte de :",
      "authenticiteCertificatsProvenanceSignature": "Authenticité (certificats, provenance, signature)",
      "etatDeConservationRestaurationsAlterations": "État de conservation (restaurations, altérations)",
      "rareteEtDemandeDuMarcheActuel": "Rareté et demande du marché actuel",
      "historiqueDeLUvreEtDeLArtiste": "Historique de l'œuvre et de l'artiste",
      "comparablesRecentsVentesAuxEncheresGaleries": "Comparables récents (ventes aux enchères, galeries)",
      "tarifsIndicatifs": "💰 Tarifs indicatifs",
      "uvre10000": "Œuvre < 10 000 €",
      "uvre10k100k": "Œuvre 10k - 100k €",
      "uvre100000": "Œuvre > 100 000 €",
      "surDevis": "Sur devis",
      "valeurEstimeeOptionnel": "Valeur estimée (optionnel)",
      "ex150000": "Ex: 150000",
      "pourOrienterLExpertNonContractuel": "Pour orienter l'expert (non contractuel)",
      "messagePourLExpert": "Message pour l'expert",
      "informationsComplementairesUrgencePreferences": "Informations complémentaires, urgence, préférences...",
      "demandeEnvoyeeAuxExpertsArtkiv": "Demande envoyée aux experts Artkiv !",
      "demanderUnDevisExpert": "Demander un devis expert",
      "contacterDirectement": "Contacter directement",
      "modifierLeDossier": "Modifier le dossier",
      "analyseDeVotreDossier": "Analyse de votre dossier",
      "forceDeJustification": "Force de justification",
      "scoreBaseSur": "Score basé sur",
      "criteres": "critères",
      "typeDAssuranceRecommande": "Type d'assurance recommandé",
      "assuranceSpecialiseeObjetDArt": "Assurance spécialisée objet d'art",
      "extensionAssuranceHabitation": "Extension assurance habitation",
      "primeEstimee": "Prime estimée : ~",
      "an": "€/an",
      "dossierSolide": "✅ Dossier solide",
      "dossierARenforcer": "⚠️ Dossier à renforcer",
      "dossierInsuffisant": "❌ Dossier insuffisant",
      "ajoutezUneFactureDAchat": "Ajoutez une facture d'achat",
      "cEstLeJustificatifLePlusImportant": ": c'est le justificatif le plus important",
      "expertiseObligatoire": "Expertise obligatoire",
      "votreUvreDepasse80000": ": votre œuvre dépasse 80 000 €",
      "ajoutezDes": "Ajoutez des",
      "sourcesDeComparables": "sources de comparables",
      "artpriceMaisonsDeVentes": "(Artprice, maisons de ventes)",
      "completezL": "Complétez l'",
      "historiqueDeProvenance": "historique de provenance",
      "dansLaFicheUvre": "dans la fiche œuvre",
      "etatMoyenEnvisagezUne": "État moyen : envisagez une",
      "avantAssurance": "avant assurance",
      "prochainesEtapes": "Prochaines étapes",
      "dossierEnregistreDansLUvre": "Dossier enregistré dans l'œuvre !",
      "enregistrerDansLUvre": "Enregistrer dans l'œuvre",
      "retourALaFiche": "Retour à la fiche",
      "contacterUnCourtierPartenaire": "Contacter un courtier partenaire",
      "aSavoirSurLAssurance": "📋 À savoir sur l'assurance",
      "renouvellementExpertise": "Renouvellement expertise",
      "tousLes10AnsArtAncienOu2Ans": ": tous les 10 ans (art ancien) ou 2 ans (art contemporain)",
      "couvertureClouAClou": "Couverture \"clou à clou\"",
      "protegeDurantTransportEtExpositionTemporaire": ": protège durant transport et exposition temporaire",
      "verifiezLeMontantSouvent510DeLaValeur": ": vérifiez le montant (souvent 5-10% de la valeur)",
      "securite": "Sécurité",
      "certainsAssureursExigentAlarmeCoffreOuSurveillance": ": certains assureurs exigent alarme, coffre ou surveillance",
      "declarationModification": "Déclaration modification",
      "informezVotreAssureurDeTouteRestaurationOuChangementD": ": informez votre assureur de toute restauration ou changement d'état",
      "ressourcesUtiles": "Ressources utiles",
      "expertsPartenairesArtkiv": "Experts partenaires Artkiv",
      "demanderUneMiseEnRelation": "→ Demander une mise en relation",
      "annuaireCnesExpertsAgrees": "→ Annuaire CNES (experts agréés)",
      "courtiersSpecialises": "Courtiers spécialisés",
      "nosCourtiersPartenaires": "→ Nos courtiers partenaires",
      "guideAssuranceUvresDArt": "→ Guide assurance œuvres d'art",
      "pourLesFamilyOffices": "Pour les family offices :",
      "artkivProposeUnServiceDedieDeGestionPatrimonialeIncluant": "Artkiv propose un service dédié de gestion patrimoniale incluant expertise, assurance globale et optimisation fiscale.",
      "contactezNotreEquipe": "Contactez notre équipe",
      "conditionExcellent": "Excellent",
      "conditionGood": "Bon",
      "conditionFair": "Moyen",
      "franchise": "Franchise",
      "restoration": "restauration"
    }
  },
  "auth": {
    "required": {
      "title": "Connexion requise",
      "text": "Connectez-vous pour accéder à votre profil."
    },
    "login": "Se connecter"
  },
  "sharedDashboard": {
    "common": {
      "untitled": "Sans titre",
      "client": "Client",
      "clientNumber": "Client #{{id}}",
      "ownCollection": "Ma collection"
    },
    "report": {
      "defaultTitle": "Rapport — {{collection}}",
      "noArtworks": "Aucune œuvre dans cette collection.",
      "generateError": "Erreur lors de la génération du rapport.",
      "title": "Générer un rapport",
      "loadingArtworks": "Chargement des œuvres…",
      "artworkCount": "{{count}} œuvre dans cette collection",
      "artworkCount_plural": "{{count}} œuvres dans cette collection",
      "artworkCount_one": "{{count}} œuvre dans cette collection",
      "artworkCount_other": "{{count}} œuvres dans cette collection",
      "titleLabel": "Titre du rapport",
      "includedContent": "Contenu inclus",
      "options": {
        "title": "Titre de l’œuvre",
        "artist": "Artiste",
        "medium": "Médium",
        "dimensions": "Dimensions",
        "price": "Estimation / Prix",
        "location": "Localisation",
        "thumbnail": "Miniatures",
        "date": "Date du rapport"
      },
      "coBrandingPrefix": "Le rapport sera co-marqué avec votre logo si vous l’avez renseigné dans",
      "profileIdentity": "Profil → Identité professionnelle",
      "cancel": "Annuler",
      "generating": "Génération…",
      "downloadPdf": "Télécharger le PDF"
    },
    "tabs": {
      "collections": "Collections ({{count}})",
      "artworks": "Œuvres ({{count}})"
    },
    "searchPlaceholder": "Rechercher…",
    "allClients": "Tous les clients",
    "sort": {
      "recentlyUpdated": "Récemment modifiées",
      "recentlyCreated": "Récemment créées",
      "name": "Nom (A-Z)",
      "ascending": "Croissant",
      "descending": "Décroissant"
    },
    "reload": "Recharger",
    "errors": {
      "load": "Impossible de charger les données partagées."
    },
    "loading": "Chargement des données…",
    "empty": {
      "collection": "Aucune collection partagée",
      "artwork": "Aucune œuvre partagée"
    },
    "badges": {
      "shared": "PARTAGÉ",
      "edit": "MODIFICATION",
      "view": "LECTURE"
    },
    "labels": {
      "client": "Client :",
      "modifiedOn": "Modifiée le {{date}}"
    },
    "actions": {
      "viewCollection": "Voir la collection →",
      "viewArtwork": "Voir l’œuvre →",
      "reportPdf": "↓ Rapport PDF",
      "present": "▶ Présenter"
    }
  },
  "sharedPresentation": {
    "errors": {
      "expired": "Ce lien de présentation a expiré.",
      "invalid": "Ce lien de présentation n’est plus valide.",
      "generic": "Impossible d’accéder à cette présentation."
    },
    "loading": "Chargement de la présentation…",
    "accessDenied": "Accès refusé",
    "backToArtkiv": "Retour à Artkiv"
  },
  "sharePresentationModal": {
    "title": "Partager la présentation",
    "close": "Fermer",
    "description": "Créez un lien temporaire pour partager cette collection avec votre client. Il pourra consulter la présentation sur n’importe quel appareil, sans connexion.",
    "expiryLabel": "Expiration du lien :",
    "duration": {
      "hour_one": "{{count}} heure",
      "hour_other": "{{count}} heures",
      "day_one": "{{count}} jour",
      "day_other": "{{count}} jours"
    },
    "generating": "Génération…",
    "generate": "Générer le lien",
    "scanMobile": "Scannez pour ouvrir sur mobile",
    "copied": "✓ Copié",
    "copy": "Copier",
    "expiresOn": "Expire le :",
    "directAccess": "Ce lien permet un accès direct à la présentation, sans authentification.",
    "revoke": "Révoquer le lien",
    "errors": {
      "create": "Erreur lors de la génération du lien.",
      "revoke": "Erreur lors de la révocation du lien.",
      "empty": "Échec de création du lien de partage."
    }
  },
  "sharingSettings": {
    "title": "Experts partagés",
    "empty": "Aucun expert partagé pour le moment"
  },
  "sharedAccessManager": {
    "title": "Accès partagés",
    "stats": "{{experts}} expert(s) • {{users}} utilisateur(s)",
    "loading": "Chargement…",
    "empty": "Aucun accès partagé pour le moment",
    "errors": {
      "load": "Impossible de charger les accès partagés.",
      "revoke": "Erreur lors du retrait de l’accès.",
      "update": "Erreur lors de la mise à jour des droits de lecture ou d’édition."
    },
    "sections": {
      "experts": "Experts ({{count}})",
      "users": "Autres utilisateurs ({{count}})"
    },
    "fallback": {
      "collection": "Collection sans nom",
      "allCollections": "Toutes les collections",
      "user": "Utilisateur",
      "expert": "Expert"
    },
    "certified": "Certifié",
    "sharedCollections": "Collections partagées ({{count}})",
    "sharedOn": "Partagé le {{date}}",
    "permission": {
      "edit": "Édition",
      "view": "Lecture",
      "switchConfirm": "Basculer les droits de {{name}} pour « {{collection}} » ?",
      "toView": "Passer en lecture seule",
      "toEdit": "Activer l’édition"
    },
    "revoke": {
      "collectionConfirm": "Retirer l’accès de {{name}} à « {{collection}} » ?",
      "collectionTitle": "Retirer cette collection",
      "allConfirm": "Retirer tous les accès de {{name}} ?",
      "allTitle": "Retirer tous les accès",
      "button": "Retirer"
    },
    "roles": {
      "user": "Utilisateur",
      "familyOffice": "Family Office",
      "expert": "Expert",
      "team": "Équipe"
    },
    "plan": "Plan : {{plan}}"
  },
  "sharedCollectionsList": {
    "loading": "Chargement…",
    "empty": "Aucune collection partagée.",
    "fallbackTitle": "Collection",
    "view": "Voir la collection"
  },
  "artistQuoteTools": {
    "common": {
      "artistPlaceholder": "Nom de l’artiste"
    },
    "mediums": {
      "huile": "Huile sur toile",
      "huile_sur_toile": "Huile sur toile",
      "aquarelle": "Aquarelle",
      "dessin": "Dessin",
      "sculpture": "Sculpture"
    },
    "mediumBreakdown": {
      "title": "Répartition par technique",
      "averagePrice": "Prix moyen : {{value}}",
      "analyzed": "{{count}} œuvre analysée",
      "analyzed_one": "{{count}} œuvre analysée",
      "analyzed_other": "{{count}} œuvres analysées"
    },
    "formatAnalysis": {
      "title": "Analyse par format",
      "formatLabel": "Format {{format}}",
      "formats": {
        "petit": "petit",
        "moyen": "moyen",
        "grand": "grand"
      },
      "averagePrice": "Prix moyen : {{value}} ({{count}} œuvre)",
      "averagePrice_one": "Prix moyen : {{value}} ({{count}} œuvre)",
      "averagePrice_other": "Prix moyen : {{value}} ({{count}} œuvres)",
      "noData": "Aucune donnée"
    },
    "trendAlerts": {
      "positive": "🚀 Forte hausse : +{{value}} % sur les 6 derniers mois.",
      "negative": "📉 Forte baisse : −{{value}} % sur les 6 derniers mois."
    },
    "engine": {
      "title": "Estimation de la cote d’artiste",
      "widthPlaceholder": "Largeur (cm)",
      "heightPlaceholder": "Hauteur (cm)",
      "mediumLabel": "Technique",
      "periodLabel": "Période artistique",
      "periods": {
        "major": "Période majeure",
        "minor": "Période mineure",
        "neutral": "Période neutre"
      },
      "pricePerSqM": "Prix moyen au m² (€)",
      "estimate": "Estimation : {{value}}"
    },
    "iaAlert": {
      "title": "Créer une alerte IA",
      "types": {
        "vente_recommandee": "Vente recommandée",
        "hausse_cote": "Hausse de cote",
        "baisse_cote": "Baisse de cote"
      },
      "messagePlaceholder": "Message de l’alerte",
      "save": "Enregistrer l’alerte",
      "saved": "Alerte enregistrée.",
      "error": "Impossible d’enregistrer l’alerte : {{message}}"
    },
    "quoteForm": {
      "title": "Ajouter une cote artiste",
      "averageValue": "Valeur moyenne (€)",
      "pricePerSqM": "Prix moyen au m² (€)",
      "notesPlaceholder": "Source ou commentaire (ex. : Artprice, ventes 2024…)",
      "save": "Enregistrer",
      "success": "Cote enregistrée avec succès !",
      "error": "Erreur : {{message}}"
    },
    "chart": {
      "noData": "Aucune donnée trouvée pour cet artiste et cette technique.",
      "title": "Évolution de la cote",
      "averageValue": "Valeur moyenne"
    },
    "dashboard": {
      "title": "Tableau de bord : {{artist}}"
    }
  },
  "museumProposalPayment": {
    "loading": "Chargement du paiement",
    "errors": {
      "createPayment": "Erreur lors de la création du paiement.",
      "payment": "Le paiement n’a pas pu être finalisé."
    },
    "checkout": {
      "processing": "Traitement en cours…",
      "pay": "Payer {{amount}} HT"
    },
    "title": {
      "auction": "Service de mise aux enchères",
      "institution": "Service de placement d’œuvre"
    },
    "summary": {
      "title": "Récapitulatif de votre demande",
      "artwork": "Œuvre",
      "target": {
        "auction": "Maison de vente ciblée",
        "institution": "Institution ciblée"
      },
      "service": "Service",
      "serviceName": {
        "auction": "Placement en vente aux enchères",
        "institution": "Placement en institution"
      },
      "initialAmount": "Montant initial",
      "amountExVat": "{{amount}} HT"
    },
    "partner": {
      "team": "Équipe Artkiv"
    },
    "service": {
      "title": "Prestation de service",
      "partner": "Notre partenaire : {{name}}",
      "partnerDescription": {
        "auction": "Équipe spécialisée dans les ventes aux enchères et l’expertise d’œuvres d’art",
        "institution": "Experte en placement d’œuvres auprès des institutions culturelles"
      },
      "includesTitle": "La prestation comprend",
      "includes": {
        "auction": {
          "1": "Évaluation de l’œuvre et estimation de sa valeur sur le marché des enchères",
          "2": "Recommandations sur les ventes spécialisées les plus adaptées",
          "3": "Mise en relation avec les commissaires-priseurs spécialisés",
          "4": "Négociation des conditions de vente (frais, réserve, etc.)",
          "5": "Suivi du processus jusqu’à la vente finale"
        },
        "institution": {
          "1": "Analyse de l’œuvre et de son potentiel pour l’institution ciblée",
          "2": "Rédaction professionnelle d’une lettre de présentation personnalisée",
          "3": "Contacts directs avec les conservateurs et responsables d’acquisition",
          "4": "Suivi de la proposition pendant 6 mois",
          "5": "Rapport mensuel sur l’avancement des démarches"
        }
      }
    },
    "pricing": {
      "title": "Tarification",
      "fixed": "Frais fixes : {{amount}} HT (payables maintenant)",
      "hourly": "Honoraires pour les démarches supplémentaires : 80 € HT/heure",
      "commission": {
        "auction": "Commission en cas de vente aux enchères : variable selon la valeur de l’œuvre (détaillée dans les conditions générales)",
        "institution": "Commission en cas de vente : variable selon la valeur de l’œuvre (détaillée dans les conditions générales)"
      }
    },
    "paymentTitle": "Paiement",
    "legal": {
      "acceptance": "En procédant au paiement, vous acceptez nos <terms>conditions générales de service</terms>.",
      "additionalInvoices": "Toute facture supplémentaire pour des heures additionnelles vous sera présentée pour approbation avant facturation."
    }
  },
  "proposalCancelled": {
    "fallbackArtwork": "votre œuvre",
    "title": "Demande annulée",
    "subtitle": "La demande de service pour {{artwork}} a bien été annulée.",
    "noCharge": "Votre demande a été annulée avec succès. Aucun frais ne vous sera facturé.",
    "help": "Pour effectuer une nouvelle demande ultérieurement ou poser une question, contactez notre équipe.",
    "back": "Retour à mon tableau de bord"
  },
  "upcomingAuctions": {
    "loading": "Chargement des ventes à venir…",
    "error": "Erreur : {{message}}",
    "empty": {
      "title": "Aucune vente à venir",
      "description": "Les ventes aux enchères apparaîtront ici prochainement.",
      "text": "Les prochaines ventes aux enchères apparaîtront ici."
    },
    "title": "Ventes aux enchères à venir",
    "subtitle": "Maisons de vente internationales · Top 10 mondial",
    "filters": {
      "allHouses": "Toutes les maisons",
      "ariaLabel": "Filtrer par maison de vente"
    },
    "saleCount": "{{count}} vente(s)",
    "saleCount_one": "{{count}} vente",
    "saleCount_other": "{{count}} ventes",
    "saleCount_plural": "{{count}} ventes",
    "topRank": "Top {{rank}}",
    "openWebsite": "Ouvrir le site de {{house}}",
    "footer": "{{count}} vente(s) à venir · Mises à jour quotidiennes",
    "footer_one": "{{count}} vente à venir · Mise à jour quotidienne",
    "footer_other": "{{count}} ventes à venir · Mises à jour quotidiennes",
    "footer_plural": "{{count}} ventes à venir · Mises à jour quotidiennes",
    "allHouses": "Toutes les maisons",
    "salesCount": "{{count}} ventes"
  },
  "requireStaff": {
    "checkingAccess": "Vérification de vos droits d’accès…"
  },
  "refPricingAdmin": {
    "title": "Références de prix (ref_pricing)",
    "newRule": "+ Nouvelle règle",
    "searchPlaceholder": "Recherche (mouvement, médium, artiste, source)",
    "refresh": "↻ Rafraîchir",
    "loading": "Chargement…",
    "empty": "Aucune règle",
    "page": "Page {{page}}",
    "previous": "Précédent",
    "next": "Suivant",
    "edit": "Éditer",
    "delete": "Supprimer",
    "confirmDelete": "Supprimer cette règle ?",
    "deleteError": "Impossible de supprimer la règle : {{message}}",
    "loadError": "Impossible de charger les règles : {{message}}",
    "sort": {
      "newest": "Plus récentes",
      "oldest": "Plus anciennes",
      "priceDesc": "€/m² ↓",
      "priceAsc": "€/m² ↑",
      "confidenceDesc": "Confiance ↓",
      "confidenceAsc": "Confiance ↑"
    },
    "table": {
      "movement": "Mouvement",
      "artist": "Artiste",
      "medium": "Médium",
      "minCm2": "cm² min",
      "maxCm2": "cm² max",
      "pricePerM2": "€/m²",
      "lowPct": "− %",
      "highPct": "+ %",
      "recency": "Fraîcheur",
      "confidence": "Confiance",
      "created": "Créée",
      "actions": "Actions"
    },
    "fields": {
      "artistOptional": "Artiste (optionnel)",
      "movement": "Mouvement",
      "medium": "Médium",
      "minCm2": "cm² min",
      "maxCm2": "cm² max",
      "pricePerM2": "€/m²",
      "lowPct": "− % (basse)",
      "highPct": "+ % (haute)",
      "recencyMonths": "Fraîcheur (mois)",
      "sourceNote": "Source / Note",
      "confidence": "Confiance (0–100)"
    },
    "editor": {
      "editTitle": "Éditer la règle",
      "newTitle": "Nouvelle règle",
      "close": "Fermer",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "saved": "✅ Enregistré",
      "saveError": "❌ {{message}}"
    }
  },
  "adminInvite": {
    "title": "Inviter un membre de l’équipe",
    "email": "Email",
    "submit": "Inviter",
    "sending": "Envoi…",
    "success": "Invitation envoyée ✅",
    "errorFallback": "Invitation échouée",
    "error": "Erreur : {{message}}",
    "role": {
      "label": "Rôle",
      "expert": "Expert",
      "team": "Équipe",
      "admin": "Administrateur"
    },
    "plan": {
      "label": "Plan",
      "standard": "Standard",
      "premium": "Premium"
    },
    "description": "L’invitation crée l’utilisateur à partir de son email, initialise son profil avec le rôle et le plan choisis, puis marque le profil comme approuvé."
  },
  "estimationComparableForm": {
    "title": "Ajouter une vente comparable",
    "success": "✅ Vente enregistrée avec succès dans realized_sales",
    "saving": "Enregistrement…",
    "cancel": "Annuler",
    "add": "Ajouter",
    "errors": {
      "missingArtwork": "Aucune œuvre n’est associée à cette vente comparable.",
      "insert": "Impossible d’enregistrer la vente comparable : {{message}}"
    },
    "fields": {
      "sourceType": {
        "label": "Source (site, presse, etc.)",
        "placeholder": "Sotheby’s, Le Monde, etc."
      },
      "title": "Titre de l’œuvre",
      "artist": "Artiste",
      "estimatedValue": "Valeur estimée (€)",
      "exactSource": "Source exacte (lien, citation…)",
      "medium": "Technique / support",
      "dimensions": {
        "label": "Dimensions (en cm)",
        "height": "Hauteur",
        "width": "Largeur",
        "depth": "Profondeur"
      },
      "comment": "Commentaire (facultatif)"
    }
  },
  "pendingProfiles": {
    "loading": "Chargement des profils en attente…",
    "title": "🛂 Profils à approuver",
    "empty": "Aucun nouveau profil en attente.",
    "approve": "✅ Approuver",
    "approving": "Approbation…",
    "notProvided": "Non renseigné",
    "contact": "📧 {{email}} | 📞 {{phone}}",
    "createdAt": "Créé le : {{date}}",
    "errors": {
      "load": "Impossible de charger les profils : {{message}}",
      "approve": "Impossible d’approuver ce profil : {{message}}"
    }
  },
  "myValidationRequests": {
    "loading": "Chargement de vos demandes…",
    "title": "Mes demandes de validation",
    "count": "{{count}} demande(s)",
    "count_one": "{{count}} demande",
    "count_other": "{{count}} demandes",
    "count_plural": "{{count}} demandes",
    "empty": "Vous n’avez pas encore de demande de validation.",
    "createEstimate": "Créer une estimation",
    "untitledArtwork": "Œuvre sans titre",
    "requestedAt": "Demandé le {{date}}",
    "status": {
      "pending": "En attente",
      "in_progress": "En cours",
      "completed": "Validée",
      "rejected": "Rejetée"
    },
    "method": {
      "label": "Méthode :",
      "points": "Par points",
      "comparables": "Comparables"
    },
    "cost": {
      "label": "Coût :",
      "free": "Gratuit"
    },
    "expertNotes": "Notes de l’expert :",
    "rejectionReason": "Motif du rejet :",
    "downloadReport": "Télécharger le rapport",
    "processingDelay": "⏱️ Votre demande est en cours de traitement. Délai estimé : 48 à 72 heures ouvrées.",
    "errors": {
      "load": "Impossible de charger vos demandes : {{message}}"
    }
  },
  "icmsSubscription": {
    "title": "Estimation par œuvres semblables — ICMS",
    "intro": "⚠️ L’estimation reste <strong>validée par un expert humain</strong>. L’IA et les calculs ICMS servent de fondation explicable et traçable.",
    "common": {
      "untitled": "Sans titre",
      "unknownArtwork": "Œuvre inconnue"
    },
    "errors": {
      "load": "Impossible de charger les données : {{message}}"
    },
    "alerts": {
      "maxExternal": "Vous pouvez ajouter jusqu’à cinq comparables externes maximum.",
      "selectArtwork": "Sélectionnez une œuvre.",
      "staffFallbackRequired": "Moins de trois comparables : renseignez le fallback (dimensions + €/m²).",
      "clientVerificationRequired": "Moins de trois comparables : demandez une vérification Artkiv pour un calcul par format.",
      "humanValidationRequired": "Validation humaine requise : cochez la case de confirmation.",
      "notLoggedIn": "Utilisateur non connecté.",
      "reportUploadError": "Erreur lors de l’envoi du rapport.",
      "requestError": "Impossible d’enregistrer la demande de vérification : {{message}}",
      "saveError": "Erreur lors de l’enregistrement : {{message}}",
      "saved": "Estimation ICMS enregistrée et rapport généré."
    },
    "artwork": {
      "label": "Œuvre à estimer",
      "placeholder": "Sélectionnez une œuvre"
    },
    "internalComparables": {
      "title": "Sélectionnez des œuvres comparables internes",
      "noValue": "Pas de valeur estimée",
      "valuePlaceholder": "Valeur €",
      "missingValue": "Valeur manquante : demander une vérification Artkiv"
    },
    "externalComparables": {
      "title": "Ajoutez des comparables externes (jusqu’à 5)",
      "add": "Ajouter une œuvre comparable externe",
      "remove": "Supprimer",
      "fields": {
        "title": "Titre",
        "artist": "Artiste",
        "source": "Source (site, presse)",
        "medium": "Technique",
        "dimensions": "Dimensions",
        "value": "Valeur estimée (€)",
        "date": "Date de vente ou de publication",
        "comment": "Commentaire"
      }
    },
    "subscription": {
      "standard": "⚠️ Votre abonnement est <strong>Standard</strong> : une intervention de l’équipe Artkiv peut être nécessaire pour valider cette estimation.",
      "premium": "✅ Votre abonnement est <strong>Premium</strong> : une vérification mensuelle par l’équipe Artkiv est incluse.",
      "requestVerification": "Demander la vérification Artkiv",
      "requesting": "Demande en cours…",
      "requestSaved": "✅ Demande enregistrée",
      "lastVerification": "Dernière vérification : {{date}}",
      "nextDue": "— Prochaine échéance : {{date}}"
    },
    "fallback": {
      "title": "Fallback « prix par format »",
      "active": "Actif (moins de trois comparables)",
      "inactive": "Inactif",
      "staffDescription": "Réservé à l’équipe : saisissez les dimensions et le tarif au m² pratiqué par la galerie. Cette valeur sert uniquement à ce calcul et reste soumise à validation humaine.",
      "height": "Hauteur (cm)",
      "width": "Largeur (cm)",
      "basePrice": "Prix de base (€/m²)",
      "surface": "Surface : {{area}} m²",
      "autoSwitch": "Dès que trois comparables ou plus sont disponibles, l’ICMS prévaut automatiquement.",
      "clientDescription": "Avec moins de trois comparables, le calcul par format doit être confirmé par l’équipe Artkiv. Utilisez le bouton de demande de vérification ci-dessus."
    },
    "values": {
      "title": "Valeurs calculées",
      "icmsBase": "ICMS (base) :",
      "fmv": "FMV (après ajustements) :",
      "retailReplacement": "Valeur de remplacement (assurance) :",
      "succession": "Valeur successorale :"
    },
    "confidence": {
      "title": "Score de confiance",
      "volume": "Volume de comparables : {{score}}/35",
      "dispersion": "Dispersion des prix : {{score}}/35",
      "diversity": "Diversité des sources : {{score}}/10",
      "recency": "Fraîcheur (≤ 24 mois) : {{score}}/20"
    },
    "explain": {
      "title": "IA explicable — pondération des sources",
      "description": "Ces pourcentages montrent quelles sources influencent concrètement l’estimation et renforcent la transparence du calcul.",
      "factors": {
        "sameArtistNamed": "Ventes récentes du même artiste ({{artist}})",
        "sameArtist": "Ventes récentes du même artiste",
        "movementNamed": "Ventes récentes du mouvement {{movement}}",
        "similarContemporary": "Ventes récentes d’artistes contemporains similaires",
        "internalComparables": "Comparables internes (collection client)",
        "otherExternalSales": "Autres ventes externes",
        "aiTrendAdjustment": "Ajustement IA (tendance)",
        "expertAdjustment": "Ajustement expert",
        "recentExternalSales": "Ventes externes récentes",
        "aiExpertAdjustment": "Ajustement IA / expert"
      }
    },
    "movements": {
      "impressionism": "impressionnisme",
      "streetArt": "street art",
      "contemporaryAbstraction": "abstraction contemporaine",
      "contemporaryFigurative": "figuration contemporaine",
      "digitalNft": "art numérique / NFT",
      "other": "mouvement similaire"
    },
    "advanced": {
      "show": "Afficher les paramètres avancés",
      "hide": "Masquer les paramètres avancés",
      "title": "Pondérations et ajustements",
      "internalWeight": "Poids des comparables internes (%)",
      "externalWeight": "Poids des comparables externes (%)",
      "aiTrend": "Ajustement de tendance IA (%)",
      "expertAdjustment": "Ajustement expert (%)",
      "insuranceMarkup": "Prime assurance (%)",
      "successionDiscount": "Décote successorale (%)",
      "hint": "Gardez la somme des poids proche de 100 % (interne + externe). Elle est renormalisée automatiquement lorsqu’une famille de comparables est vide."
    },
    "validation": {
      "label": "Je confirme avoir <strong>revu et validé</strong> cette estimation en tant qu’expert ou galeriste."
    },
    "actions": {
      "save": "Enregistrer l’estimation et générer le PDF",
      "cancel": "Annuler"
    },
    "pdf": {
      "title": "Rapport d’estimation — Méthode des œuvres semblables (ICMS)",
      "date": "Date : {{date}}",
      "artwork": "Œuvre estimée : {{title}}",
      "calculatedValues": "Valeurs calculées :",
      "icmsBase": "• ICMS (base) : {{value}}",
      "fmv": "• Fair Market Value (après ajustements) : {{value}}",
      "retailReplacement": "• Valeur de remplacement (assurance) : {{value}}",
      "successionValue": "• Valeur successorale : {{value}}",
      "fallbackMode": "Mode fallback « prix par format » activé — {{area}} m² × {{price}} €/m²",
      "icmsDetails": "Détails ICMS :",
      "internalMean": "• Moyenne interne robuste : {{value}} — poids {{weight}} %",
      "externalMean": "• Moyenne externe robuste : {{value}} — poids {{weight}} %",
      "adjustments": "• Ajustement tendance IA : {{ai}} % — Ajustement expert : {{expert}} %",
      "markups": "• Prime assurance : +{{insurance}} % — Décote successorale : −{{succession}} %",
      "confidenceBreakdown": "Score de confiance — décomposition :",
      "volume": "• Volume de comparables : {{score}}/35",
      "dispersion": "• Dispersion des prix : {{score}}/35",
      "diversity": "• Diversité des sources : {{score}}/10",
      "recency": "• Fraîcheur (≤ 24 mois) : {{score}}/20",
      "explainability": "Explication IA :",
      "factorLine": "• {{weight}} % — {{label}}",
      "internalComparables": "Comparables internes :",
      "externalComparables": "Comparables externes :",
      "comparableLine": "• {{title}} — {{artist}} {{date}} — {{value}} — {{source}}"
    }
  },
  "artworkImages": {
    "alt": {
      "main": "Image principale de l’œuvre",
      "primary": "Image principale",
      "thumbnail": "Miniature {{id}}",
      "view": "Vue {{id}}"
    },
    "selected": "Sélectionnée",
    "primary": "Principale",
    "addImage": "Ajouter une image",
    "deleteConfirm": "Supprimer cette image ?",
    "deleteTitle": "Supprimer cette image",
    "formats": "Formats supportés : JPEG, PNG, WEBP",
    "limit": "Limite : 10 images (30 Mo maximum par image)"
  },
  "artworkImageManager": {
    "quotaReached": "Vous avez atteint le nombre maximal d’images autorisées pour votre plan.",
    "onlyRemaining": "Seules {{count}} image(s) supplémentaire(s) peuvent être ajoutées avec votre plan.",
    "uploadPrompt": "Déposez vos images ici ou cliquez pour en ajouter",
    "uploadDisabled": "Ajout d’images désactivé",
    "formats": "Formats supportés : JPEG, PNG, WEBP",
    "usage": "Images utilisées : {{count}} / {{max}}",
    "unlimited": "illimité",
    "familyOfficeNote": "Avec le plan Family Office, seuls vos clients peuvent ajouter ou modifier les images. Vous disposez d’une vue consolidée.",
    "artworkAlt": "Œuvre",
    "primary": "Principale",
    "setCover": "Mettre en une",
    "deletePrimaryConfirm": "Supprimer l’image principale ? Une autre image deviendra automatiquement principale.",
    "deleteConfirm": "Supprimer cette image ?"
  },
  "artworkNft": {
    "title": "NFT & blockchain",
    "subtitle": "Enregistrez les informations blockchain d’une œuvre déjà tokenisée",
    "info": {
      "title": "La blockchain chez ARTKIV",
      "body": "Cet onglet enregistre les informations d’une œuvre déjà tokenisée (NFT ou certificat on-chain). ARTKIV horodate par ailleurs une empreinte SHA-256 de la fiche ; l’ancrage public (ex. Tezos) et la tokenisation via un partenaire ne sont pas encore actifs.",
      "fingerprintCta": "Voir l’empreinte numérique ARTKIV"
    },
    "smartstamp": {
      "title": "Certification blockchain",
      "body": "Vous n’avez pas encore certifié cette œuvre. Vous pouvez utiliser notre partenaire SmartStamp pour créer une certification blockchain sécurisée.",
      "cta": "Découvrir SmartStamp"
    },
    "certificationType": "Type de certification",
    "types": {
      "digital": {
        "label": "Œuvre numérique",
        "description": "Création artistique numérique authentifiée"
      },
      "certificate": {
        "label": "Certificat d’authenticité",
        "description": "Certification blockchain d’une œuvre physique"
      },
      "hybrid": {
        "label": "Œuvre hybride",
        "description": "Fusion entre art physique et numérique"
      }
    },
    "blockchainOther": "Autre blockchain",
    "contractAddress": "Adresse du contrat",
    "tokenId": "Token ID",
    "tokenPlaceholder": "Identifiant du token",
    "provider": "Fournisseur",
    "providerSelect": "Sélectionnez un fournisseur",
    "providerOther": "Autre",
    "mintDate": "Date de création",
    "explorerLink": "Lien vers l’explorateur",
    "linkedPhysicalTitle": "Associée à une œuvre physique",
    "linkedPhysicalDescription": "Cette certification correspond à une œuvre physique",
    "certificateTitle": "Certificat blockchain"
  },
  "artworkLocationTab": {
    "lossTypes": {
      "vol": "Vol",
      "perte": "Perte",
      "destruction": "Destruction",
      "incendie": "Incendie",
      "inondation": "Inondation",
      "autre": "Autre"
    },
    "locationTypes": {
      "museum": "Musée",
      "gallery": "Galerie",
      "home": "Domicile",
      "residence": "Résidence",
      "warehouse": "Entrepôt",
      "storage": "Stockage",
      "loan": "Prêt",
      "exhibition": "Exposition",
      "other": "Autre"
    },
    "lossModal": {
      "badge": "Déclaration",
      "title": "Perte · Vol · Destruction",
      "untitled": "Œuvre sans titre",
      "successTitle": "Déclaration enregistrée",
      "successBody": "Consultez le module Pertes & Vols pour accéder au rapport complet.",
      "eventType": "Type d’événement",
      "eventDate": "Date de l’événement",
      "declaredValue": "Valeur déclarée (€)",
      "estimatedValue": "Valeur estimée",
      "location": "Lieu au moment de l’événement",
      "locationPlaceholder": "Ex. : résidence principale, galerie XY…",
      "policeReport": "Plainte déposée",
      "policeRef": "N° de procès-verbal",
      "insuranceClaim": "Déclaration à l’assurance",
      "insuranceRef": "Référence du sinistre",
      "indemnity": "Indemnité reçue (€)",
      "notes": "Notes complémentaires",
      "notesPlaceholder": "Circonstances, témoins, documents joints…",
      "fiscalNote": "Note fiscale — En France, les pertes et vols d’œuvres d’art peuvent être déductibles sous conditions. Un procès-verbal est généralement requis. Consultez votre notaire ou expert-comptable.",
      "error": "Erreur lors de l’enregistrement.",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "save": "Enregistrer la déclaration"
    },
    "lossStatus": {
      "incident": "Incident",
      "declared": "Œuvre déclarée : {{type}}",
      "police": "PV déclaré"
    },
    "loan": {
      "outgoing": "En prêt sortant",
      "contact": "Contact : {{value}}",
      "from": "Du {{date}}",
      "to": "au {{date}}",
      "agreementRef": "Réf. convention : {{value}}",
      "borrowerLocation": "L’emplacement actuel de l’œuvre est l’institution emprunteuse. Définissez un lieu de stockage habituel une fois le prêt terminé."
    },
    "currentLocation": "Emplacement actuel",
    "hiddenLocation": "Cette œuvre est associée à un lieu défini par votre client. Vos autorisations actuelles ne permettent pas d’en consulter ou modifier les détails.",
    "noLocation": "Aucun emplacement défini pour cette œuvre.",
    "defineLocation": "Définir un emplacement",
    "declareLoss": "Déclarer une perte · vol · destruction",
    "change": "Changer",
    "fields": {
      "address": "Adresse",
      "city": "Ville",
      "country": "Pays",
      "contact": "Contact",
      "email": "E-mail",
      "phone": "Téléphone",
      "notes": "Notes"
    },
    "history": "Historique des emplacements",
    "available": "Autres emplacements disponibles",
    "viewAll": "Voir tous les emplacements ({{count}})",
    "manage": "Gérer mes emplacements"
  },
  "artworkComparables": {
    "methods": {
      "cup_alleges": "Méthode comparative allégée (synthétique)",
      "cup_complet": "Méthode CUP complète (comparable documenté)",
      "cup_ifrs": "CUP — IFRS 13 / BOFiP"
    },
    "saveError": "Erreur de sauvegarde : {{message}}",
    "unknownError": "Erreur inconnue",
    "title": "Expertise CUP",
    "subtitle": "Méthode Comparable Uncontrolled Price — conforme IFRS 13 / BOFiP",
    "saved": "Sauvegardé",
    "save": "Sauvegarder l’expertise",
    "expertValueSection": "Valeur vénale à dire d’expert",
    "estimatedValue": "Valeur estimée (€ HT)",
    "estimatedPlaceholder": "Ex. : 4500",
    "method": "Méthode",
    "select": "Sélectionner…",
    "expertDate": "Date d’expertise",
    "range": "Fourchette ±10 % :",
    "comparablesAverage": "Moyenne des comparables :",
    "gapWarning": "Écart supérieur à 30 % avec les comparables",
    "comparablesTitle": "Ventes comparables ({{count}}/3 minimum)",
    "addComparable": "Ajouter un comparable",
    "empty": "Aucun comparable saisi. Ajoutez au moins 3 ventes de référence.",
    "firstComparable": "Premier comparable",
    "comparable": "Comparable {{number}}",
    "auctionHouse": "Maison de vente",
    "auctionHousePlaceholder": "Ex. : Christie’s, Artcurial, Millon…",
    "saleDate": "Date de vente",
    "soldArtwork": "Titre / description de l’œuvre vendue",
    "soldArtworkPlaceholder": "Ex. : lithographie signée, 45 × 60 cm, tirage à 20 exemplaires",
    "hammerPrice": "Prix adjugé (€)",
    "hammerPricePlaceholder": "Ex. : 3800",
    "adjustment": "Ajustement (%)",
    "adjustmentPlaceholder": "Ex. : -10 ou +5",
    "adjustedValue": "Valeur ajustée",
    "adjustmentNote": "Note / justification de l’ajustement",
    "adjustmentNotePlaceholder": "Ex. : format plus petit, état passable, marché en baisse",
    "expertNote": "Note d’expert (incluse dans le rapport)",
    "expertNotePlaceholder": "Observations sur l’état, la rareté, le marché et la provenance… Cette note sera intégrée dans la fiche CUP du rapport.",
    "complete": "Fiche CUP complète, prête pour le rapport.",
    "missingValue": "valeur vénale manquante",
    "missingComparables": "{{count}} comparable(s) manquant(s)",
    "incomplete": "Fiche incomplète : {{reason}}."
  },
  "artworkProvenance": {
    "title": "Provenance",
    "add": "Ajouter un élément",
    "empty": "Aucun élément de provenance enregistré.",
    "edit": "Modifier",
    "delete": "Supprimer",
    "types": {
      "direct_artiste": "Direct artiste",
      "echange_production": "Échange / production",
      "galerie": "Galerie",
      "vente_privee": "Vente privée",
      "encheres": "Vente aux enchères",
      "succession": "Succession / héritage",
      "don": "Don",
      "collection_privee": "Collection privée",
      "autre": "Autre"
    }
  },
  "artworkSpecifications": {
    "sections": {
      "dimensions": "Dimensions de l’œuvre",
      "framed": "Dimensions encadrées",
      "paper": "Dimensions du papier",
      "duration": "Durée"
    },
    "hints": {
      "dimensions": "L’œuvre seule, sans cadre ni marges (la « vue »).",
      "framed": "Hors-tout, cadre compris — dimensions utiles pour l’accrochage, le transport et l’assurance.",
      "paper": "Œuvres sur papier : dimensions de la feuille entière, souvent plus grandes que l’image."
    },
    "fields": {
      "height": "Hauteur",
      "width": "Largeur",
      "depth": "Profondeur",
      "unit": "Unité",
      "framedHeight": "Hauteur encadrée",
      "framedWidth": "Largeur encadrée",
      "framedDepth": "Profondeur encadrée",
      "frameUnit": "Unité du cadre",
      "paperHeight": "Hauteur du papier",
      "paperWidth": "Largeur du papier",
      "paperUnit": "Unité du papier"
    },
    "swapTitle": "Permuter la hauteur et la largeur",
    "swap": "Permuter H/L",
    "units": {
      "inches": "pouces"
    },
    "durationPlaceholder": "Ex. : 12 min 30 s, boucle vidéo, performance temporaire…"
  },
  "artworkDocumentsTab": {
    "view": "Voir",
    "loading": "Chargement…",
    "openError": "Impossible d’ouvrir ce document. Veuillez réessayer.",
    "title": "Documents",
    "deleteConfirm": "Supprimer ce document ?",
    "types": {
      "certificate": "Certificat d’authenticité",
      "invoice": "Facture",
      "condition_report": "Rapport de conservation",
      "exhibition": "Documents d’exposition",
      "photo": "Photographie HD",
      "other": "Autre"
    },
    "loan": {
      "title": "Convention de prêt sortant",
      "noReference": "Sans référence",
      "institution": "Institution",
      "location": "Lieu",
      "contact": "Contact",
      "start": "Début",
      "end": "Fin prévue",
      "conditions": "Conditions",
      "empty": "Œuvre en prêt. Renseignez l’institution et les dates depuis la fiche Modifier."
    },
    "lot": {
      "title": "Documents du lot — {{title}}",
      "add": "Ajouter au lot",
      "referenceAlt": "Référence du lot",
      "referenceTitle": "Photo de référence (lot)",
      "referenceSubtitle": "Image commune à tous les exemplaires",
      "empty": "Aucun document commun pour ce lot.",
      "remove": "Retirer du lot"
    },
    "aiScore": "Score IA :",
    "certificate": {
      "missingTitle": "Certificat d’authenticité manquant",
      "missingBody": "Ajoutez un certificat pour augmenter la valeur et la traçabilité de votre œuvre.",
      "classicTitle": "Certificat classique détecté",
      "classicBody": "Renforcez sa protection avec une preuve d’authenticité datée et infalsifiable.",
      "blockchainTitle": "Preuve d’authenticité validée",
      "blockchainBody": "Votre œuvre bénéficie d’une preuve d’authenticité infalsifiable{{blockchain}}."
    },
    "empty": "Aucun document associé à cette œuvre",
    "addedOn": "Ajouté le {{date}}",
    "reclassify": "Changer la catégorie",
    "add": "Ajouter un document"
  },
  "ocrEnrich": {
    "fields": {
      "year": "Année",
      "dimensions": "Dimensions",
      "medium": "Médium / technique",
      "mediumCategory": "Catégorie",
      "acquisitionPrice": "Prix d’acquisition",
      "acquisitionType": "Type d’acquisition",
      "acquisitionDate": "Date d’acquisition",
      "seller": "Donateur / vendeur",
      "buyer": "Bénéficiaire / acquéreur",
      "title": "Titre",
      "artist": "Artiste",
      "signature": "Signature",
      "authentication": "Certificat / authentification",
      "signatureNotes": "Notes de signature",
      "auctionHouse": "Maison de vente",
      "auctionSaleName": "Nom de la vente",
      "auctionSaleDate": "Date de la vente",
      "auctionLotNumber": "Numéro de lot",
      "auctionHammerPrice": "Prix adjugé (€)",
      "auctionFees": "Frais de vente TTC"
    },
    "mediumCategory": {
      "painting": "Peinture",
      "photography": "Photographie",
      "sculpture": "Sculpture",
      "print": "Estampe",
      "drawing": "Dessin",
      "work_on_paper": "Œuvre sur papier",
      "mixed_media": "Technique mixte",
      "installation": "Installation",
      "film_video": "Film / Vidéo",
      "digital": "Art numérique",
      "ceramics": "Céramique",
      "textile": "Textile",
      "design": "Design",
      "other": "Autre"
    },
    "button": {
      "title": "Extraire les métadonnées depuis les documents PDF de la fiche",
      "analyzing": "Analyse en cours…",
      "enrich": "Enrichir via OCR"
    },
    "documentTypes": {
      "invoice": "Facture / Bordereau / Acte de donation ou d’échange",
      "certificate": "Certificat d’authenticité",
      "condition_report": "Constat d’état",
      "exhibition": "Document d’exposition",
      "other": "Autre"
    },
    "modal": {
      "title": "Champs extraits par l’OCR",
      "subtitle": "Sélectionnez les champs à appliquer à la fiche"
    },
    "sections": {
      "documentsAnalyzed": "Documents analysés",
      "auction": "Vente aux enchères"
    },
    "documents": {
      "changeCategory": "Changer la catégorie",
      "rerun": "↺ Relancer l’analyse avec les types corrigés",
      "untitled": "Document"
    },
    "confidence": {
      "title": "Score de confiance OCR",
      "description": "Le score combine la qualité des sources trouvées, le rapprochement entre la facture et l’œuvre, ainsi que les éventuelles incohérences détectées.",
      "level": {
        "veryHigh": "Très élevé",
        "high": "Élevé",
        "medium": "Moyen",
        "careful": "Prudent"
      }
    },
    "dimensions": {
      "warningTitle": "Écart de dimensions détecté",
      "record": "Fiche :",
      "document": "Facture :",
      "differenceEachSide": "Différence de {{diff}} cm de chaque côté —",
      "recordLikelyFramed": "La fiche inclut probablement le cadre (mesure hors-tout).",
      "documentLikelyFramed": "La facture inclut probablement le cadre.",
      "mismatch": "Les dimensions ne correspondent pas — à vérifier avant d’appliquer.",
      "applyQuestion": "Appliquer les dimensions de la facture à la fiche ?",
      "yesApply": "Oui — appliquer {{dimensions}}",
      "noKeep": "Non — garder {{dimensions}}",
      "confirmed": "Les dimensions de la facture seront appliquées",
      "rejected": "Dimensions inchangées — à vérifier manuellement",
      "confirmationRequired": "⚠ confirmation requise ci-dessus",
      "onlyWarning": "Aucun autre champ à mettre à jour — vérifiez l’écart de dimensions ci-dessus."
    },
    "titleTechnicalWarning": "⚠ description technique détectée",
    "actions": {
      "saving": "Sauvegarde…",
      "applied": "Appliqué",
      "applyCount": "Appliquer {{count}} champ{{plural}}"
    },
    "alerts": {
      "noNewInfo": "L’OCR n’a trouvé aucune nouvelle information dans ces documents.",
      "ocrError": "Erreur OCR : {{message}}",
      "noFieldSelected": "Aucun champ sélectionné.",
      "noPatch": "Aucune donnée exploitable après normalisation.",
      "saveError": "Erreur de sauvegarde : {{message}}"
    },
    "errors": {
      "urlInaccessible": "Document inaccessible : {{name}}",
      "readFailed": "Lecture du document impossible ({{status}})",
      "emptyDocument": "Document vide ou illisible."
    }
  },
  "servicesCuratorialPage": {
    "back": "← Retour",
    "title": "Accompagnement curatoriel",
    "intro": "Donnez à votre collection un <strong>point de vue curatoriel</strong> : axes thématiques, titres cohérents, <strong>mots-clés</strong> pertinents et cadrage éditorial. Cet apport structure vos fiches-œuvres et <strong>outille la valorisation</strong> à long terme.",
    "pricing": {
      "title": "Service payant sur devis",
      "description": "Nos experts partenaires vous proposeront un <strong>devis personnalisé</strong> selon la portée de l’intervention. Vous restez libre de l’accepter ou de le refuser après réception."
    },
    "scope": {
      "label": "Portée",
      "collection": "Toute la collection"
    },
    "goals": {
      "label": "Objectif principal",
      "options": {
        "structure": "Structurer ma collection (thématiques, titres, mots-clés)",
        "presentation": "Préparer une présentation / un accrochage",
        "narrative": "Créer un récit narratif et éditorial",
        "audit": "Audit curatorial complet",
        "other": "Autre, à préciser ci-dessous"
      }
    },
    "details": {
      "label": "Détails / contexte",
      "placeholder": "Ex. : focus sur la photographie contemporaine, ligne directrice par décennie, indexation par thèmes…",
      "startingPoint": "Point de départ : œuvre {{id}}"
    },
    "expert": {
      "label": "Sélection de l’expert",
      "auto": {
        "title": "Artkiv sélectionne pour moi",
        "description": "Nous vous proposons l’expert le plus adapté à votre collection."
      },
      "choose": {
        "title": "Je choisis mon expert",
        "description": "Parcourez notre annuaire d’experts certifiés."
      },
      "loading": "Chargement des experts…",
      "empty": "Aucun expert disponible pour le moment.",
      "generic": "Expert",
      "directory": "Voir l’annuaire complet des experts"
    },
    "contact": {
      "email": "Email de contact",
      "preference": "Préférence de contact",
      "methods": {
        "email": "Email",
        "phone": "Téléphone",
        "video": "Visio"
      }
    },
    "submit": {
      "send": "Envoyer la demande",
      "sending": "Envoi…"
    },
    "error": {
      "generic": "Une erreur est survenue. Merci de réessayer."
    },
    "success": {
      "title": "Demande envoyée ✓",
      "artwork": "Merci ! Notre équipe <strong>curatoriale partenaire</strong> va analyser votre besoin et revenir vers vous sous <strong>48 h</strong> avec un <strong>devis personnalisé</strong> pour cette œuvre.",
      "collection": "Merci ! Notre équipe <strong>curatoriale partenaire</strong> va analyser votre besoin et revenir vers vous sous <strong>48 h</strong> avec un <strong>devis personnalisé</strong> pour l’ensemble de votre collection.",
      "backCollection": "Retourner à ma collection"
    },
    "note": "Note : cet accompagnement est réalisé par des <strong>experts partenaires</strong> sélectionnés. Vous recevrez un devis personnalisé sous 48 h et resterez libre de l’accepter ou non."
  },
  "servicesValuationPage": {
    "back": "← Retour",
    "title": "Demander une estimation à un expert",
    "intro": "Envoyez cette œuvre à un <strong>expert partenaire</strong> — celui que vous choisissez, ou celui qu’Artkiv vous propose — pour obtenir une <strong>estimation argumentée</strong>, distincte de nos outils d’auto-estimation.",
    "pricing": {
      "title": "Service payant sur devis",
      "description": "L’expert partenaire vous proposera un <strong>devis personnalisé</strong> selon la portée de la mission. Vous restez libre de l’accepter ou de le refuser après réception."
    },
    "artwork": {
      "label": "Œuvre concernée",
      "unknown": "Œuvre sélectionnée"
    },
    "purpose": {
      "label": "Objectif de l’estimation",
      "options": {
        "sale": "Préparer une vente",
        "insurance": "Assurance",
        "succession": "Succession / transmission",
        "donation": "Donation",
        "other": "Autre, à préciser ci-dessous"
      }
    },
    "details": {
      "label": "Détails / contexte",
      "placeholder": "Ex. : historique, provenance connue, urgence, éléments déjà en votre possession…"
    },
    "expert": {
      "label": "Sélection de l’expert",
      "auto": {
        "title": "Artkiv sélectionne pour moi",
        "description": "Nous vous proposons l’expert le plus adapté à cette œuvre."
      },
      "choose": {
        "title": "Je choisis mon expert",
        "description": "Parcourez notre annuaire d’experts partenaires."
      },
      "loading": "Chargement des experts…",
      "empty": "Aucun expert disponible pour le moment.",
      "generic": "Expert",
      "noAccountHint": "Expert référencé sans compte Artkiv — l’équipe Artkiv le contactera manuellement.",
      "directory": "Voir l’annuaire complet des experts"
    },
    "contact": {
      "email": "Email de contact",
      "preference": "Préférence de contact",
      "methods": {
        "email": "Email",
        "phone": "Téléphone",
        "video": "Visio"
      }
    },
    "submit": {
      "send": "Envoyer la demande",
      "sending": "Envoi…"
    },
    "error": {
      "generic": "Une erreur est survenue. Merci de réessayer."
    },
    "success": {
      "title": "Demande envoyée ✓",
      "body": "Merci ! Votre demande a été transmise à l’<strong>expert partenaire</strong> (ou à notre équipe s’il n’a pas encore de compte Artkiv). Vous recevrez un <strong>devis personnalisé</strong> sous 48 h.",
      "backArtwork": "Retourner à la fiche œuvre",
      "backCollection": "Retourner à ma collection"
    },
    "note": "Note : cette estimation est réalisée par un <strong>expert partenaire</strong> distinct de l’équipe Artkiv. Vous recevrez un devis personnalisé sous 48 h et resterez libre de l’accepter ou non."
  },
  "teamAuctionHouses": {
    "title": "Maisons de vente",
    "searchPlaceholder": "Rechercher par nom, ville, pays ou site",
    "refresh": "Rafraîchir",
    "creating": "Création…",
    "add": "Ajouter",
    "loading": "Chargement…",
    "saving": "Sauvegarde…",
    "save": "Sauvegarder",
    "empty": "Aucun résultat",
    "fields": {
      "name": "Nom",
      "nameRequired": "Nom *",
      "city": "Ville",
      "country": "Pays",
      "website": "Site",
      "websitePlaceholder": "Site (https://…)",
      "topTen": "Top 10",
      "rank": "Rang",
      "active": "Active",
      "action": "Action"
    }
  },
  "proposeMuseum": {
    "common": {
      "loading": "Chargement…",
      "untitled": "Sans titre"
    },
    "auth": {
      "title": "Connexion requise",
      "description": "Veuillez vous connecter pour proposer une œuvre.",
      "login": "Se connecter"
    },
    "title": "Proposer une œuvre",
    "subtitle": "Soumettez votre œuvre à une institution ou à une maison de vente.",
    "type": {
      "title": "Quel est votre objectif ?",
      "auctionNote": "La vente suit un parcours distinct : estimation, réserve, frais et calendrier. Les champs muséaux ne sont pas demandés.",
      "institution_gift": { "title": "Don ou legs", "description": "Proposer une entrée en collection permanente." },
      "institution_loan": { "title": "Prêt pour exposition", "description": "Répondre à un projet curatorial temporaire." },
      "auction_sale": { "title": "Vente aux enchères", "description": "Demander étude, estimation et mise en vente." },
      "museum": {
        "title": "Musée / Institution",
        "description": "Exposition temporaire ou permanente pour valoriser votre œuvre."
      },
      "auction": {
        "title": "Maison de vente",
        "description": "Vente aux enchères pour une valorisation optimale."
      }
    },
    "institutionType": {
      "label": "Type d'institution",
      "options": { "museum": "Musée", "foundation": "Fondation", "frac": "FRAC / centre d'art", "university": "Université", "public": "Hôpital / organisme public", "other": "Autre" }
    },
    "contact": {
      "name": "Contact identifié",
      "namePlaceholder": "Nom (facultatif)",
      "role": "Fonction",
      "rolePlaceholder": "Conservation, acquisitions…"
    },
    "missionFit": {
      "label": "Adéquation avec la mission et les collections",
      "placeholder": "Quel manque, axe scientifique ou projet curatorial cette œuvre vient-elle réellement servir ?"
    },
    "provenance": {
      "label": "Provenance et titre de propriété",
      "placeholder": "Historique de propriété, facture, certificat, éléments restant à vérifier…",
      "ownership": "Je confirme être propriétaire ou mandaté pour proposer cette œuvre."
    },
    "documents": {
      "label": "Pièces déjà disponibles",
      "items": { "images": "Images haute définition", "invoice": "Facture / preuve de propriété", "provenance": "Provenance documentée", "condition": "Constat d'état", "authenticity": "Certificat / avis d'authenticité", "valuation": "Valorisation indépendante" }
    },
    "restrictions": {
      "label": "Conditions envisagées",
      "hint": "Les institutions privilégient généralement les dons sans restriction excessive.",
      "options": { "none": "Sans restriction particulière", "credit_line": "Ligne de crédit souhaitée", "display_request": "Souhait de présentation (non garanti)", "other": "Autres conditions à discuter" }
    },
    "artwork": {
      "label": "Votre œuvre",
      "loading": "Chargement des œuvres…",
      "empty": "Aucune œuvre disponible. Ajoutez d’abord des œuvres à votre collection.",
      "select": "Sélectionner une œuvre"
    },
    "institution": {
      "auctionLabel": "Maison de vente",
      "museumLabel": "Institution visée",
      "auctionPlaceholder": "Ex. : Christie’s, Sotheby’s…",
      "museumPlaceholder": "Ex. : Centre Pompidou, MoMA…"
    },
    "message": {
      "label": "Message de présentation",
      "auctionPlaceholder": "Informations sur l’œuvre, sa provenance et son état…",
      "museumPlaceholder": "Pourquoi cette œuvre mérite-t-elle d’être exposée ?"
    },
    "museum": {
      "artistBio": "Biographie de l’artiste",
      "artistBioPlaceholder": "Parcours, expositions, éléments biographiques…",
      "artworkDescription": "Description de l’œuvre",
      "artworkDescriptionPlaceholder": "Technique, dimensions, contexte de création…",
      "relevance": "Pertinence artistique / curatoriale",
      "relevancePlaceholder": "Pourquoi cette œuvre aurait-elle sa place dans l’institution visée ?"
    },
    "exhibitions": {
      "title": "Historique d’expositions",
      "close": "Fermer",
      "add": "Ajouter une exposition",
      "delete": "Supprimer",
      "save": "Enregistrer l’exposition",
      "fields": {
        "title": "Titre de l’exposition",
        "venue": "Lieu / institution",
        "location": "Ville / pays",
        "description": "Description"
      }
    },
    "auction": {
      "estimateLabel": "Estimation souhaitée",
      "estimatePlaceholder": "Ex. : 12 000",
      "reserveLabel": "Prix de réserve",
      "reservePlaceholder": "Ex. : 9 000",
      "reserveHint": "Prix minimum en dessous duquel l'œuvre n'est pas vendue (facultatif)."
    },
    "services": {
      "title": "Service de l’expert",
      "service": "Service",
      "clientRate": "Tarif client HT",
      "expertCost": "Coût expert HT",
      "expertService": "Service expert",
      "selectedExpert": "Expert sélectionné",
      "defaultDescription": "Placement institutionnel, forfait 500 € HT"
    },
    "expert": {
      "label": "Expert partenaire",
      "select": "Sélectionner un expert…",
      "directory": "Voir l’annuaire"
    },
    "sendMethod": {
      "title": "Méthode d’envoi",
      "professional": {
        "title": "Service professionnel, 500 € HT",
        "auctionDescription": "Notre expert négocie pour vous et assure le suivi pendant six mois.",
        "museumDescription": "Notre expert soumet votre œuvre et assure le suivi pendant six mois."
      },
      "self": {
        "title": "Je gère moi-même, gratuit",
        "description": "Recevez la proposition formatée par email et gérez vous-même les contacts."
      },
      "emailLabel": "Votre email",
      "emailPlaceholder": "email@exemple.com"
    },
    "submit": {
      "toPayment": "Continuer vers le paiement",
      "send": "Envoyer la proposition"
    },
    "alerts": {
      "exhibitionRequired": "Renseignez au minimum le titre et le lieu de l’exposition.",
      "selectArtwork": "Veuillez sélectionner une œuvre.",
      "selectExpert": "Choisissez un expert avant de continuer.",
      "createFailed": "Impossible de créer la proposition.",
      "submitError": "Erreur lors de la soumission : {{message}}",
      "unknownError": "Erreur inconnue"
    },
    "payment": {
      "title": "Paiement sécurisé",
      "description": "Finalisez la mission pour lancer la proposition institutionnelle.",
      "amountExclTax": "Montant HT",
      "vat": "TVA 20 %",
      "totalInclTax": "Total TTC",
      "processing": "Traitement en cours…",
      "pay": "Payer {{amount}} HT",
      "createError": "Erreur lors de la création du paiement.",
      "genericError": "Erreur de paiement."
    },
    "history": {
      "title": "Historique de vos propositions",
      "museum": "Institution",
      "auction": "Enchères",
      "type": { "institution_gift": "Don / legs", "institution_loan": "Prêt d'exposition", "auction_sale": "Vente aux enchères", "museum": "Institution", "auction": "Enchères", "other": "Proposition" },
      "status": {
        "pending": "En attente",
        "paid": "Payé",
        "awaitingPayment": "Paiement requis"
      }
    }
  },
  "supportImportCancel": {
    "title": "Paiement annulé",
    "description": "Vous pouvez réessayer à tout moment depuis la page d’import assisté.",
    "back": "Revenir à l’import assisté"
  },
  "supportImportSuccess": {
    "title": "Merci !",
    "description": "Votre paiement a été confirmé. Un expert Artkiv va vous contacter.",
    "dashboard": "Retour au tableau de bord"
  },
  "stripeSuccess": {
    "title": "Paiement réussi !",
    "description": "Votre abonnement ARTKIV est maintenant actif.",
    "redirect": "Redirection vers votre espace personnel…"
  },
  "newsletterUnsubscribe": {
    "loading": "Traitement en cours…",
    "successTitle": "Désinscription réussie",
    "successDescription": "Vous avez été désinscrit de notre newsletter.",
    "errorTitle": "Erreur",
    "errorDescription": "Une erreur est survenue lors de la désinscription."
  },
  "pendingApproval": {
    "title": "En attente de validation",
    "thanks": "Merci pour votre inscription sur Artkiv.",
    "reviewing": "Votre compte est en cours de validation par notre équipe.",
    "delayWarning": "⚡ Si vous n’avez pas de nouvelles sous 48 heures,",
    "contact": "merci de nous contacter à {{email}}.",
    "emailNotice": "Vous recevrez un email dès que votre compte sera activé."
  },
  "authCallback": {
    "verifyingEmail": "Vérification de votre email…",
    "invalidSession": "Session invalide, redirection…",
    "emailConfirmed": "Email confirmé ! Vérification de l’abonnement…",
    "subscriptionFound": "Abonnement trouvé, redirection…",
    "redirectPayment": "Redirection vers le paiement…",
    "error": "Erreur : {{message}}",
    "pleaseWait": "Veuillez patienter…"
  },
  "updatePassword": {
    "title": "Nouveau mot de passe",
    "newPassword": "Nouveau mot de passe",
    "newPasswordPlaceholder": "Minimum {{count}} caractères",
    "confirmPassword": "Confirmer le mot de passe",
    "confirmPasswordPlaceholder": "Confirmez votre mot de passe",
    "updating": "Mise à jour…",
    "submit": "Mettre à jour le mot de passe",
    "success": "✅ Mot de passe mis à jour avec succès !",
    "errors": {
      "mismatch": "Les mots de passe ne correspondent pas.",
      "tooShort": "Le mot de passe doit contenir au moins {{count}} caractères.",
      "generic": "Erreur lors de la mise à jour du mot de passe."
    }
  },
  "emailConfirmationWaiting": {
    "defaultEmail": "votre adresse",
    "title": "Confirmez votre adresse email",
    "sentTo": "Nous avons envoyé un lien de confirmation à",
    "stepInboxTitle": "Étape 1 : Vérifiez votre boîte de réception",
    "stepInboxDescription": "Consultez vos emails et cliquez sur le lien de confirmation que nous vous avons envoyé.",
    "spamTitle": "Vérifiez vos spams",
    "spamDescription": "Si vous ne voyez pas notre email, pensez à vérifier votre dossier spam ou courrier indésirable.",
    "stepPaymentTitle": "Étape 2 : Finalisez votre paiement",
    "stepPaymentDescription": "Après confirmation de votre email, vous serez automatiquement redirigé vers Stripe pour finaliser votre abonnement.",
    "notReceived": "Vous n’avez pas reçu l’email ?",
    "sending": "Envoi en cours…",
    "retryIn": "Réessayer dans {{seconds}} s",
    "resend": "Renvoyer l’email de confirmation",
    "success": "✓ Email renvoyé avec succès !",
    "error": "✗ Erreur lors de l’envoi. Veuillez réessayer.",
    "importantLabel": "Important :",
    "importantDescription": "Vous ne pourrez pas accéder à votre espace personnel tant que votre email n’aura pas été confirmé et votre abonnement finalisé.",
    "needHelp": "Besoin d’aide ?",
    "contactSupport": "Contactez notre support",
    "backToLogin": "Retour à la connexion"
  },
  "supportTicketDetail": {
    "back": "Retour",
    "notFound": "Ticket introuvable.",
    "dashboard": "Tableau de bord",
    "priority": "Priorité : {{value}}",
    "channel": "Canal : {{value}}",
    "mode": "Mode : {{value}}",
    "createdAgo": "Créé il y a {{count}} jour(s)",
    "createdAgo_one": "Créé il y a {{count}} jour",
    "createdAgo_other": "Créé il y a {{count}} jours",
    "client": "Client : #{{id}}",
    "markResolved": "Marquer résolu",
    "message": "Message",
    "metadata": "Métadonnées",
    "status": {
      "open": "Ouvert",
      "pending": "En attente",
      "sent": "Envoyé",
      "resolved": "Résolu",
      "closed": "Fermé",
      "canceled": "Annulé"
    }
  },
  "supportImportPage": {
    "title": "Import assisté par un expert",
    "introStandard": "Confiez-nous l’import de vos œuvres depuis un tableur ou un document. {{price}} pour l’import standard.",
    "introExtended": "Pour les volumes importants : {{hourlyPrice}} par heure.",
    "requesterEmail": "Votre email (facturation / contact)",
    "collectorEmail": "Email du collectionneur",
    "importType": "Type d’import",
    "scope": {
      "standard": "Standard — {{price}}",
      "extended": "Étendu — {{hourlyPrice}}/h"
    },
    "estimatedHours": "Nombre d’heures estimées",
    "fileLabel": "Fichier (CSV/XLSX/DOCX/PDF) — optionnel",
    "fileHelp": "Vous pourrez aussi nous l’envoyer ensuite si le fichier est volumineux.",
    "notesLabel": "Précisions utiles (nombre d’entrées, particularités…)",
    "estimatedAmount": "Montant estimé :",
    "amountInclTax": "{{amount}} TTC",
    "redirecting": "Redirection…",
    "pay": "Procéder au paiement",
    "details": {
      "standardTitle": "Standard ({{price}}) :",
      "standardDescription": "fichier structuré (CSV/XLSX) ou liste simple Doc/PDF, dans un volume raisonnable.",
      "extendedTitle": "Étendu ({{hourlyPrice}}/h) :",
      "extendedDescription": "listes volumineuses non structurées, sources multiples ou nettoyage important."
    },
    "afterPayment": "Après paiement, un expert Artkiv prend en charge votre import, vous envoie un aperçu de contrôle et finalise l’intégration.",
    "errors": {
      "emailsRequired": "Les emails du demandeur et du collectionneur sont requis.",
      "hoursRequired": "Indiquez un nombre d’heures supérieur ou égal à 1.",
      "checkoutNotCreated": "La session de paiement n’a pas été créée.",
      "generic": "Une erreur est survenue."
    }
  },
  "intergenerationalMatchingPage": {
    "title": "Test de matching intergénérationnel",
    "matchAlert": "✅ Transmettre « {{artwork}} » à {{heir}}",
    "rejectLog": "❌ Rejet de « {{artwork}} » pour {{heir}}",
    "heirs": {
      "sarah": {
        "preferences": {
          "landArt": "Land Art",
          "sustainableArt": "Art écoresponsable"
        },
        "values": {
          "sustainability": "Durabilité",
          "transmission": "Transmission"
        }
      },
      "james": {
        "preferences": {
          "classical": "Classique",
          "renaissance": "Renaissance"
        },
        "values": {
          "investment": "Investissement"
        }
      }
    },
    "artworks": {
      "suspendedForests": {
        "title": "Forêts suspendues",
        "medium": "Acrylique sur toile"
      },
      "emeraldCascade": {
        "title": "Cascade Émeraude",
        "medium": "Photographie"
      }
    }
  },
  "warehouseVisit": {
    "title": "Visite entrepôt",
    "common": {
      "loading": "Chargement…",
      "untitled": "Sans titre"
    },
    "conditions": {
      "excellent": "Excellent",
      "very_good": "Très bon",
      "good": "Bon",
      "fair": "Moyen",
      "poor": "Mauvais",
      "partially_restorable": "Partiellement restaurable",
      "heavily_damaged": "Très endommagé",
      "irreparable": "Irréparable"
    },
    "risks": {
      "faible": "Risque faible",
      "moyen": "Risque moyen",
      "eleve": "Risque élevé",
      "urgent": "URGENT"
    },
    "fields": {
      "condition": "État de conservation",
      "riskLevel": "Niveau de risque",
      "visitNotes": "Notes de visite",
      "notesPlaceholder": "Dommages constatés, urgences, observations…",
      "randomNotesPlaceholder": "Observations, dommages constatés…",
      "medium": "Technique",
      "dimensions": "Dimensions",
      "estimatedValue": "Valeur estimée"
    },
    "actions": {
      "saved": "Enregistré",
      "save": "Enregistrer",
      "record": "Fiche",
      "next": "Suivante",
      "inspect": "Inspecter",
      "back": "Retour",
      "exportPdf": "Exporter rapport PDF",
      "finish": "Terminer la visite · voir le résumé"
    },
    "client": {
      "title": "Choisir un client",
      "description": "Sélectionnez le collectionneur à inspecter",
      "empty": "Aucun client accessible"
    },
    "location": {
      "title": "Choisir un emplacement",
      "description": "Sélectionnez le lieu à inspecter aujourd’hui",
      "loading": "Chargement des emplacements…",
      "empty": "Aucun emplacement enregistré",
      "lastVisit": "Dernière visite"
    },
    "risk": {
      "zone": "Zone à risque {{risk}}",
      "zoneArtwork": "Zone de stockage à risque {{risk}} — cette œuvre peut être affectée",
      "unsuitable": "Les conditions de conservation sont inadaptées"
    },
    "random": {
      "title": "Œuvre aléatoire"
    },
    "summary": {
      "completed": "Visite terminée",
      "title": "Résumé de visite",
      "priority": "À traiter en priorité ({{count}})",
      "noUrgency": "Aucune urgence constatée",
      "allGood": "Toutes les œuvres inspectées sont en bon état"
    },
    "stats": {
      "present": "Œuvres présentes",
      "evaluated": "Évaluées",
      "damaged": "En mauvais état",
      "highRisk": "Risque élevé / urgent",
      "total": "Total",
      "notEvaluated": "Non éval.",
      "damagedShort": "Abîmées",
      "evaluatedProgress": "{{evaluated}}/{{total}} évaluées"
    },
    "inspection": {
      "title": "Inspection",
      "search": "Titre, artiste, n° inventaire…",
      "loading": "Chargement des œuvres…",
      "empty": "Aucune œuvre enregistrée pour cet emplacement",
      "noResults": "Aucun résultat",
      "resultCount": "{{count}} œuvre",
      "resultCount_other": "{{count}} œuvres",
      "sortedByCondition": "triées par état"
    },
    "filters": {
      "all": "Tout ({{count}})",
      "damaged": "Abîmées ({{count}})",
      "random": "Aléatoire"
    },
    "pdf": {
      "title": "Rapport de visite entrepôt",
      "location": "Emplacement",
      "visitDate": "Visite du",
      "riskZone": "Zone classée à risque {{risk}}",
      "unsuitable": "Les conditions de conservation de ce lieu sont inadaptées à la préservation des œuvres.",
      "evaluatedVisit": "Évaluées lors de cette visite",
      "intervention": "Œuvres nécessitant une intervention",
      "noUrgency": "Aucune urgence constatée lors de cette visite",
      "artwork": "Œuvre",
      "artist": "Artiste",
      "inventoryNumber": "N° inventaire",
      "fullInventory": "Inventaire complet de la visite",
      "generatedOn": "Rapport généré le {{date}}",
      "confidential": "Confidentiel"
    }
  },
  "collectionReports": {
    "title": "Créer un rapport",
    "error": "Erreur",
    "types": {
      "inventory": "Rapport d’inventaire",
      "artist": "Rapport par artiste",
      "location": "Rapport par localisation",
      "valuation": "Rapport d’évaluation",
      "insurance": "Rapport pour assurance",
      "exhibition": "Catalogue d’exposition",
      "acquisition": "Historique d’acquisition",
      "condition": "Rapport d’état des œuvres",
      "completude": "Rapport de complétude — Données manquantes"
    },
    "actions": {
      "viewExisting": "Voir les rapports existants",
      "generating": "Génération en cours…",
      "generatePdf": "Générer le PDF"
    },
    "fields": {
      "reportType": "Type de rapport",
      "reportName": "Nom du rapport"
    },
    "common": {
      "notProvided": "Non renseigné"
    },
    "selection": {
      "advisorTitle": "Sélection du collectionneur et de la collection",
      "collectionTitle": "Sélection de la collection",
      "collector": "Collectionneur",
      "allCollectors": "Tous les collectionneurs",
      "sharedCollectors": "{{count}} collectionneur avec accès partagé",
      "sharedCollectors_other": "{{count}} collectionneurs avec accès partagé",
      "collection": "Collection",
      "allCollections": "Toutes les collections",
      "untitledCollection": "Collection sans titre",
      "loadedInCollection": "{{count}} œuvre chargée dans cette collection",
      "loadedInCollection_other": "{{count}} œuvres chargées dans cette collection",
      "loadedTotal": "{{count}} œuvre chargée au total",
      "loadedTotal_other": "{{count}} œuvres chargées au total"
    },
    "largeCollection": {
      "title": "Votre sélection contient {{count}} œuvres.",
      "description": "Pour les collections importantes, nous recommandons de générer le rapport par collection ou par artiste plutôt que sur l’ensemble : le résultat sera plus lisible et plus rapide à produire.",
      "thumbnails": "Les miniatures seront limitées aux 50 premières œuvres pour garantir la génération du PDF."
    },
    "completeness": {
      "title": "Champs à vérifier",
      "description": "Cochez les informations dont vous voulez détecter les lacunes.",
      "essential": "essentiel",
      "note": "Les champs marqués « essentiel » sont nécessaires pour une estimation ou valorisation opposable."
    },
    "options": {
      "title": "Options du rapport",
      "includeDate": "Inclure la date d’aujourd’hui",
      "includeThumbnails": "Inclure les miniatures (images des œuvres)",
      "valueTotals": "Totaux de valeur des œuvres",
      "purchaseTotal": "Valeur d’achat totale"
    },
    "data": {
      "title": "Données à inclure",
      "image": "Image principale",
      "artist": "Nom de l’artiste",
      "dimensions": "Dimensions",
      "medium": "Technique / médium",
      "mediumShort": "Médium",
      "creationYear": "Année de création",
      "estimatedValue": "Valeur estimée",
      "invoiceCertificate": "Facture ou certificat",
      "inventoryRef": "Référence inventaire",
      "description": "Description",
      "acquisitionPrice": "Prix d’acquisition",
      "location": "Localisation",
      "priceEstimated": "Prix / Valeur estimée",
      "valueSource": "Citer la source des valeurs"
    },
    "whiteLabel": {
      "title": "Rapport personnalisé",
      "description": "Générez un rapport avec votre identité professionnelle",
      "enable": "Activer",
      "company": "Nom de votre entreprise ou cabinet",
      "current": "Actuellement",
      "editProfile": "Modifier dans mon profil",
      "logo": "Votre logo",
      "changeLogo": "Changer le logo",
      "noLogo": "Aucun logo importé. Ajoutez votre logo dans votre profil pour personnaliser vos rapports.",
      "addLogo": "Ajouter un logo",
      "note": "Vos rapports seront générés avec votre identité professionnelle au lieu de la marque Artkiv. Idéal pour les présenter à vos clients."
    },
    "layout": {
      "title": "Mise en page",
      "groupBy": "Grouper par",
      "none": "Aucun groupement",
      "artist": "Artiste",
      "location": "Localisation",
      "medium": "Médium",
      "year": "Année",
      "sortBy": "Trier par",
      "titleSort": "Titre",
      "value": "Valeur",
      "acquisitionDate": "Date d’acquisition"
    }
  },
  "valuationPdf": {
    "reportTitle": "Rapport de valorisation",
    "preparedFor": "Document préparé pour validation et accompagnement par l’Art Advisor",
    "purpose": "Finalité",
    "preparedBy": "Établi par",
    "date": "Date",
    "client": "Client",
    "executiveSummary": "Synthèse exécutive",
    "artworksValued": "Œuvres évaluées",
    "lowRange": "Fourchette basse",
    "highRange": "Fourchette haute",
    "retainedValue": "Valeur retenue",
    "averageConfidence": "Indice moyen de confiance",
    "confidenceNote": "Ce score mesure la robustesse documentaire de la valorisation, pas une garantie de réalisation du prix.",
    "artworkDetail": "Détail de valorisation par œuvre",
    "marketToDocument": "Marché à documenter",
    "expertValidationRequired": "Validation expert requise",
    "untitled": "Sans titre",
    "artistMissing": "Artiste non renseigné",
    "confidence": "Confiance",
    "liquidity": "Liquidité",
    "risk": "Risque",
    "trend": "Tendance",
    "marketReading": "Lecture marché",
    "method": "Méthode",
    "sources": "Sources",
    "notProvidedF": "Non renseignée",
    "notProvidedPlural": "non renseignées",
    "sourcesWeighting": "Sources / comparables et pondération",
    "recommendation": "Recommandation Art Advisor",
    "generalNotes": "Notes générales de l’Art Advisor",
    "methodologyTitle": "Méthodologie",
    "methodologyDescription": "La valorisation applique les règles ARTKIV par groupe : Groupe A en CUP directe ; Groupe B en analogie avec au moins 5 références ; Groupe C par formule (H + L) × valeur du point. Les résultats de plus de 5 ans sont exclus sauf absence totale d’alternative. Les prix galerie servent uniquement de borne haute.",
    "disclaimer": "Ce rapport de valorisation est un document d’aide à la décision établi par un Art Advisor à partir des informations disponibles à la date d’émission. Il ne constitue pas une expertise judiciaire, fiscale ou patrimoniale. Les valeurs indiquées restent indicatives et doivent être confirmées par un expert agréé.",
    "defaultFinality": "Valorisation de marché",
    "defaultBadge": "Document de travail expert",
    "buttonTitle": "Exporter {{count}} œuvre(s), valeur retenue {{value}}",
    "noArtwork": "Aucune œuvre à exporter",
    "generating": "Génération du PDF…",
    "export": "Exporter le rapport PDF",
    "methodology": {
      "direct_cup": "Groupe A — CUP directe : résultats récents du même artiste pondérés ; résultats de plus de 5 ans exclus. Le prix galerie sert uniquement de borne haute.",
      "analogy_cup": "Groupe B — CUP par analogie : comparables récents pondérés et abattement de prudence en l’absence de résultats propres.",
      "point_method": "Groupe C — Méthode à points : formule (H + L) × valeur du point."
    }
  },
  "artpriceImport": {
    "messages": {
      "loginRequired": "Vous devez être connecté pour importer un PDF.",
      "importError": "Erreur d’import",
      "processing": "PDF importé. Analyse en cours ({{id}}…)",
      "processed": "PDF importé et analysé. {{count}} traitement terminé.",
      "queued": "PDF importé. Analyse en file d’attente.",
      "houseAdded": "Maison de ventes ajoutée.",
      "returnToCup": "Revenez au CUP pour charger les comparables."
    },
    "context": {
      "title": "Contexte d’import",
      "description": "Chaque comparable importé sera rattaché à son propriétaire : client, expert ou équipe Artkiv.",
      "importedBy": "Importé par",
      "visibility": "Visibilité calculée",
      "client": "Client concerné",
      "selectClient": "Sélectionner un client",
      "clientUuid": "UUID du client",
      "clientWarning": "Sans client, un expert ne doit pas importer dans un espace non attribué."
    },
    "house": {
      "optional": "Maison de ventes (optionnel)",
      "search": "Rechercher…",
      "addTitle": "Ajouter une maison de ventes",
      "name": "Nom",
      "city": "Ville",
      "country": "Pays",
      "website": "Site web",
      "aliases": "Alias (séparés par des virgules)"
    },
    "actions": {
      "add": "Ajouter",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "import": "Importer",
      "importing": "Import…",
      "backToCup": "Retour à l’assistant CUP"
    },
    "table": {
      "artist": "Artiste",
      "title": "Titre",
      "estimate": "Estimation",
      "hammer": "Marteau",
      "sale": "Vente",
      "owner": "Propriétaire"
    }
  },
  "valuationReport": {
    "loading": "Chargement du module de valorisation…",
    "kicker": "Rapport · Art Advisor Premium",
    "title": "Rapport de Valorisation",
    "description": "Sélectionnez les œuvres, classez les artistes en Groupe A/B/C, définissez les fourchettes par artiste/médium/format, appliquez-les aux fiches œuvres, ajustez les exceptions puis sauvegardez.",
    "inflation": {
      "title": "Rapport inflation (IPC INSEE) disponible",
      "description": "revalorisation du prix d’achat, sans estimation CUP requise"
    },
    "steps": {
      "purpose": "Finalité",
      "artworks": "Œuvres",
      "artists": "Artistes A/B/C",
      "records": "Fiches œuvres"
    },
    "actions": {
      "open": "Ouvrir",
      "chooseArtworks": "Choisir les œuvres",
      "back": "Retour",
      "defineRanges": "Définir les fourchettes",
      "saving": "Sauvegarde…",
      "saveQuotes": "Sauvegarder mes cotations personnelles artiste/médium",
      "applyAll": "Appliquer toutes les fourchettes aux fiches",
      "backToArtists": "Retour au classement artistes",
      "saveArtworks": "Sauvegarder dans artworks",
      "exportPdf": "Exporter PDF",
      "exportWord": "Exporter Word"
    },
    "fields": {
      "clientName": "Nom du client",
      "clientPlaceholder": "Client / dossier",
      "artist": "Artiste"
    },
    "common": {
      "untitled": "Sans titre",
      "date": "date",
      "artworkCount": "{{count}} œuvre",
      "artworkCount_other": "{{count}} œuvres"
    },
    "purpose": {
      "title": "Finalité du rapport",
      "options": {
        "assurance": {
          "label": "Assurance",
          "description": "Valeur documentée pour couverture ou renouvellement d’assurance."
        },
        "succession": {
          "label": "Succession / transmission",
          "description": "Valorisation prudente, explicable et traçable pour partage patrimonial."
        },
        "marche": {
          "label": "Marché / arbitrage",
          "description": "Fourchette de marché exploitable pour décision de vente, conservation ou acquisition."
        },
        "pret": {
          "label": "Nantissement / prêt",
          "description": "Lecture prudente intégrant liquidité, documentation et risque."
        }
      }
    },
    "selection": {
      "title": "Choix des œuvres",
      "description": "Référence inventaire affichée pour éviter les confusions dans les lots importants.",
      "selected": "{{count}} sélectionnée",
      "selected_other": "{{count}} sélectionnées",
      "phaseTitle": "Phase 0 — cotations personnelles expert",
      "phaseDescription": "Après sélection, ARTKIV vérifie si vous avez déjà sauvegardé une cote pour les artistes et médiums présents. Si oui, les groupes A/B/C et les fourchettes sont préremplis. Sinon, vous les renseignez puis vous les sauvegardez seulement si vous le souhaitez.",
      "allCollections": "Toutes les collections",
      "search": "Rechercher artiste, titre, inventaire…",
      "toggleAll": "Tout sélectionner / désélectionner ({{count}})",
      "savedQuote": "Cotation enregistrée",
      "noRange": "Pas de fourchette",
      "loadingQuotes": "Recherche des cotations…",
      "classify": "Classer les artistes ({{count}})"
    },
    "classification": {
      "title": "Classement des artistes en Groupe A/B/C",
      "description": "On fixe d’abord la méthode par artiste. Ensuite les fourchettes se travaillent par artiste, médium et format.",
      "prefilled": "{{count}} cotation personnelle préchargée. Les champs restent modifiables.",
      "prefilled_other": "{{count}} cotations personnelles préchargées. Les champs restent modifiables.",
      "none": "Aucune cotation personnelle préexistante n’a été trouvée pour cette sélection. Remplissez les groupes maintenant, puis sauvegardez vos cotations si vous voulez les réutiliser.",
      "comparableArtists": "Artistes comparables : artiste A, artiste B…",
      "analogyReason": "Même galerie, génération, exposition commune…",
      "expertNote": "Note expert sur la cote de l’artiste, liquidité, prudence, tendance…",
      "otherArtworks": "{{count}} autre œuvre",
      "otherArtworks_other": "{{count}} autres œuvres"
    },
    "confidence": {
      "low": "Confiance basse",
      "medium": "Confiance moyenne",
      "high": "Confiance haute"
    },
    "ranges": {
      "title": "Fourchettes par artiste + médium + format",
      "description": "Sauvegardez les cotations personnelles expert seulement si vous voulez enrichir votre bibliothèque privée. Appliquez ensuite les fourchettes aux fiches œuvres, puis ajustez les exceptions une par une.",
      "prefilled": "Cotation personnelle préremplie",
      "artworkPrefilled": "Estimation déjà saisie sur les fiches — fourchettes et pondération préchargées",
      "applyToRecords": "Appliquer aux {{count}} fiches",
      "pointLow": "Point bas",
      "pointHigh": "Point haut",
      "low": "Fourchette basse €",
      "high": "Fourchette haute €",
      "average": "Valeur moyenne €",
      "weightingTitle": "Méthodologie de pondération",
      "weightingDescription": "Les résultats de plus de 5 ans sont exclus. Le prix galerie actuel sert uniquement de borne haute, jamais de moyenne.",
      "savedNote": "Note de cotation sauvegardée pour cet artiste/médium/format",
      "ownRecentCount": "Nb propres < 3 ans",
      "ownRecentMedian": "Médiane propres < 3 ans €",
      "ownOldCount": "Nb propres 3-5 ans",
      "ownOldMedian": "Médiane propres 3-5 ans €",
      "compRecentCount": "Nb comparables < 3 ans",
      "compRecentMedian": "Médiane comparables < 3 ans €",
      "compOldCount": "Nb comparables 3-5 ans",
      "compOldMedian": "Médiane comparables 3-5 ans €",
      "galleryCap": "Prix galerie actuel, borne haute uniquement €",
      "prudenceDiscount": "Abattement prudence si 0 résultat propre %",
      "sourcesDetail": "Sources détaillées et justification des comparables"
    },
    "adjustments": {
      "title": "Ajustements manuels / exceptions par œuvre",
      "description": "L’expert peut corriger une œuvre historique, muséale ou atypique après l’application en masse.",
      "finalValue": "Valeur finale",
      "certificate": "Certificat +5%",
      "provenance": "Provenance artiste +2%",
      "followUp": "Suivi impeccable +5%",
      "expertOverride": "Ajustement expert exceptionnel",
      "sources": "Sources consultées",
      "justification": "Justification client par œuvre…",
      "low": "Basse €",
      "high": "Haute €",
      "retained": "Valeur retenue €",
      "forcedValue": "Valeur finale forcée €",
      "overrideReason": "Motif : œuvre historique, exposition majeure…"
    },
    "losses": {
      "title": "Œuvres sorties du total actif",
      "description": "Les œuvres irréparables sont affichées en pertes et ne sont pas intégrées dans le total actif."
    },
    "totalAdjusted": "Total actif ajusté",
    "generalNotes": "Notes générales du rapport"
  },
  "artistQuotes": {
    "loading": "Chargement des cotations artistes…",
    "backToTools": "Retour aux outils",
    "kicker": "Bibliothèque privée expert",
    "title": "Cotations artistes",
    "description": "Sauvegardez vos groupes A/B/C, fourchettes, analogies et paramètres décisionnels. En Groupe A, les ventes du même artiste sont aussi pondérées par dimensions, technique, proximité de format et fraîcheur. En Groupe B, chaque artiste comparable porte sa propre décote expert.",
    "messages": {
      "required": "Artiste et médium sont obligatoires.",
      "saved": "Cotation artiste sauvegardée dans votre bibliothèque privée.",
      "confirmDelete": "Supprimer cette cotation personnelle ?",
      "deleted": "Cotation supprimée."
    },
    "methods": {
      "directCup": "Groupe A — CUP directe",
      "directCupPrudent": "C+ — CUP directe prudente / série",
      "analogyCup": "Groupe B — CUP par analogie",
      "analogyCupRatio": "C+ — Analogie / ratio pivot",
      "hybridPointsCup": "C+ — Points + comparables partiels",
      "pointMethod": "Groupe C — Méthode à points"
    },
    "confidence": {
      "label": "Confiance",
      "low": "Basse",
      "medium": "Moyenne",
      "high": "Haute"
    },
    "microSegment": {
      "kicker": "Œil expert · micro-segment",
      "title": "Créer une ligne spéciale quand une série devient plus fiable que le médium général",
      "description": "Exemple : ne pas mélanger toute la photographie de Yuki Onodera si l’expert a isolé plusieurs résultats cohérents de la série Transvest. Dans ce cas, la cotation devient une ligne dédiée artiste + série / format / technique, classée en C+ ou CUP directe prudente : le marché reste fin, mais il est observable.",
      "item1": "Même artiste, mais aussi même série ou corpus identifiable.",
      "item2": "Formats proches, technique comparable, éditions lisibles.",
      "item3": "Plusieurs résultats ou estimations homogènes, même si la liquidité reste faible.",
      "item4": "La ligne spéciale évite de diluer le signal dans un médium trop large.",
      "prefill": "Préremplir l’exemple Yuki Onodera · Transvest"
    },
    "form": {
      "editTitle": "Modifier une cotation",
      "newTitle": "Nouvelle cotation",
      "artist": "Artiste",
      "medium": "Médium / format ex : Sculpture fer · grand format",
      "priceLow": "Fourchette basse €",
      "priceHigh": "Fourchette haute €",
      "averageValue": "Valeur moyenne €",
      "recentWeight": "Poids <3 ans %",
      "oldWeight": "Poids 3-5 ans %",
      "galleryCap": "Borne galerie €",
      "minReferences": "Min. références",
      "dimension": "Dim %",
      "technique": "Tech %",
      "proximity": "Prox %",
      "freshness": "Fraîcheur %",
      "pointLow": "Point bas €",
      "pointHigh": "Point haut €",
      "comparableArtist": "Artiste comparable",
      "logic": "Logique : même génération, matériau…",
      "source": "Source",
      "careerDiscount": "Décote carrière %",
      "maxPriceWeight": "Poids max prix %",
      "observedLow": "Bas €",
      "observedHigh": "Haut €",
      "discount": "Décote %",
      "weight": "Poids %",
      "notes": "Notes expert, sources, prudence, marché, tendance…"
    },
    "groupA": {
      "title": "Paramètres Groupe A — comparaison améliorée",
      "description": "Même artiste ne veut pas dire comparable automatique : ARTKIV pondère aussi les dimensions, la technique, la proximité de format et la fraîcheur des ventes. Les ventes de plus de 5 ans sont exclues du calcul, sauf reprise manuelle par l’expert."
    },
    "groupB": {
      "title": "Comparables Groupe B",
      "description": "Renseignez au moins 3 artistes comparables. La décote reste une décision de l’expert ; les coefficients qualifient dimensions, technique, proximité et fraîcheur.",
      "comparable": "Comparable #{{number}}",
      "expertOverride": "Décision experte personnelle : conserver cet analogue malgré une différence de marché.",
      "adjustedResult": "Résultat ajusté :",
      "calculatedRange": "Fourchette Groupe B calculée :",
      "average": "moyenne"
    },
    "marketRoles": {
      "trendOnly": "Analogue de tendance",
      "context": "Contexte uniquement",
      "priceComparable": "Comparable prix faible"
    },
    "marketTiers": {
      "inferior": "Marché inférieur",
      "equivalent": "Marché équivalent",
      "superior": "Marché supérieur",
      "different": "Marché différent"
    },
    "actions": {
      "add": "Ajouter",
      "delete": "Supprimer",
      "edit": "Modifier",
      "saving": "Sauvegarde…",
      "update": "Mettre à jour",
      "save": "Sauvegarder",
      "cancel": "Annuler"
    },
    "list": {
      "title": "Mes cotations personnelles",
      "search": "Rechercher artiste, médium…",
      "empty": "Aucune cotation trouvée.",
      "groupARecorded": "Groupe A : pondération dimensions / technique / proximité / fraîcheur enregistrée.",
      "groupB": "Groupe B :",
      "marketRules": "Règles marché personnalisées : {{count}} artiste(s)",
      "average": "Moyenne :"
    }
  },
  "artistQuotePage": {
    "title": "🎨 Recherche de cote d’artiste",
    "artistName": "Nom de l’artiste",
    "artistPlaceholder": "Ex. : Bernar Venet",
    "medium": "Technique",
    "mediums": {
      "oil": "Huile sur toile",
      "watercolor": "Aquarelle",
      "drawing": "Dessin",
      "sculpture": "Sculpture"
    },
    "submit": "Afficher le tableau de bord"
  },
  "accountPage": {
    "loading": "Chargement de votre abonnement…",
    "title": "Mon abonnement",
    "plan": "Plan :",
    "status": "Statut :",
    "trialActive": "⏳ Essai actif — il vous reste {{count}} jour(s) pour décider.",
    "trialActive_one": "⏳ Essai actif — il vous reste {{count}} jour pour décider.",
    "trialActive_other": "⏳ Essai actif — il vous reste {{count}} jours pour décider.",
    "active": "✓ Abonnement actif",
    "pastDue": "Paiement en retard — mettez à jour votre moyen de paiement.",
    "frozen": "🔒 Votre profil est temporairement gelé. Souscrivez à un plan pour retrouver toutes les fonctionnalités.",
    "manage": "Gérer mon abonnement",
    "invoices": "Mes factures",
    "noSubscription": "Aucun abonnement actif.",
    "choosePlan": "Choisir un plan",
    "plans": {
      "standard": "Standard",
      "premium": "Premium",
      "family_office": "Family Office",
      "art_advisor": "Art Advisor",
      "art_advisor_premium": "Art Advisor Premium",
      "expert": "Expert"
    },
    "statuses": {
      "active": "Actif",
      "trialing": "Essai en cours",
      "past_due": "Paiement en retard",
      "canceled": "Annulé",
      "unpaid": "Impayé",
      "incomplete": "Incomplet",
      "paused": "Suspendu"
    }
  },
  "conservationTrackingPage": {
    "title": "Suivi de conservation",
    "values": {
      "notProvidedMasculine": "Non renseigné",
      "notProvidedFeminine": "Non renseignée",
      "assessmentPending": "Évaluation en attente",
      "toCalculate": "À calculer",
      "toSchedule": "À planifier",
      "sampleRecommendation": "Œuvre en état impeccable, y compris les coins et la surface. Prochaine inspection visuelle dans 1 an, rapport complet dans 5 ans. Maintenir la température entre 18 et 20 °C et l’humidité entre 45 et 55 %. Éviter toute exposition directe aux UV."
    }
  },
  "messaging": {
    "back": "Retour",
    "title": "Messagerie",
    "conversations": "Conversations",
    "loading": "Chargement…",
    "emptyConversations": "Aucune conversation pour le moment.",
    "conversation": "Conversation",
    "selectConversation": "Sélectionnez une conversation",
    "chooseConversation": "Choisissez une conversation dans la liste.",
    "emptyMessages": "Aucun message. Lancez la discussion 🙂",
    "placeholder": "Écrire un message…",
    "send": "Envoyer",
    "user": "Utilisateur",
    "userWithId": "Utilisateur ({{id}}…)",
    "errors": {
      "loadConversations": "Impossible de charger les conversations.",
      "loadMessages": "Impossible de charger les messages.",
      "send": "Envoi impossible.",
      "introFeeRequired": "Acceptez d'abord la mise en relation (onglet Clients) pour répondre à ce collectionneur."
    },
    "rlsNote": "Sécurité RLS : accès limité aux conversations et messages autorisés."
  },
  "insuranceRequest": {
    "header": {
      "title": "Demande d’assurance",
      "subtitle": "Lancez une demande de devis et contrôlez précisément les informations partagées avec le courtier."
    },
    "dataControl": {
      "title": "Contrôle des données partagées",
      "description": "Vous choisissez exactement les informations de la fiche œuvre transmises au courtier. Par défaut, les données techniques nécessaires sont partagées et les informations sensibles sont protégées, notamment la provenance détaillée, le prix d’acquisition et la localisation exacte.",
      "sharedCountSuffix": "/{{total}} champs partagés",
      "hide": "Masquer",
      "customize": "Personnaliser",
      "controlLabel": "le contrôle des données",
      "shareAll": "✓ Tout partager",
      "minimum": "🔐 Minimum vital"
    },
    "sections": {
      "identity": "🎨 Identité de l’œuvre",
      "technical": "🔬 Caractéristiques techniques",
      "condition": "⚙️ État et conservation",
      "authenticity": "✅ Authenticité",
      "values": "💰 Valeurs",
      "acquisitionWarning": "Informations d’acquisition, partage déconseillé",
      "other": "Autres données"
    },
    "labels": {
      "recommended": "(recommandées)",
      "premiumImpact": "(impact sur la prime)",
      "sensitive": "(sensible)",
      "verySensitive": "(très sensible)"
    },
    "fields": {
      "title": "Titre",
      "artist": "Artiste",
      "year": "Année",
      "typeOfArt": "Type d’art",
      "medium": "Médium / technique",
      "dimensions": "Dimensions",
      "condition": "État",
      "conditionNotes": "Notes d’état",
      "provenance": "Provenance",
      "certificate_auth": "Certificat d’authenticité",
      "signature": "Signature",
      "signature_desc": "Description de la signature",
      "editionInfo": "Informations d’édition",
      "acquisition_date": "Date d’acquisition",
      "acquisition_source": "Source d’acquisition",
      "acquisition_price": "Prix d’acquisition",
      "acquisition_type": "Type d’acquisition",
      "estimated_value": "Valeur estimée",
      "valuation_estimated_value": "Valorisation estimée",
      "last_estimation_date": "Dernière date d’estimation",
      "location_id": "Localisation exacte",
      "image_url": "Image",
      "description": "Description",
      "documents": "Documents",
      "specifications": "Spécifications",
      "subjectMatter": "Sujet / thème",
      "styles": "Styles"
    },
    "anonymization": {
      "active": "Anonymisations actives :"
    },
    "anonymized": {
      "workByArtist": "Œuvre de {{artist}}",
      "longProvenance": "Historique documenté sur plusieurs décennies",
      "establishedProvenance": "Provenance établie et documentée",
      "specializedGallery": "Galerie européenne spécialisée",
      "publicAuction": "Vente aux enchères publique",
      "professionalSource": "Source professionnelle établie",
      "secureLocation": "Lieu sécurisé, identifiant masqué"
    },
    "artwork": {
      "fallbackTitle": "Œuvre",
      "year": "Année",
      "medium": "Médium",
      "dimensions": "Dimensions",
      "condition": "État",
      "certificate": "Certificat d’authenticité",
      "currentEstimate": "Estimation actuelle",
      "sharedSummary": "{{shared}} champs seront transmis au courtier sur {{total}} disponibles.",
      "tipTitle": "Conseil :",
      "tipBody": "Déclenchez la demande depuis la fiche œuvre afin que le courtier reçoive automatiquement les informations nécessaires, sans échanges inutiles."
    },
    "coverage": {
      "question": "Quelle est votre situation ?",
      "homePremium": {
        "title": "Assurance habitation haut de gamme",
        "body": "Vérifier la couverture de mes œuvres, identifier les limites et demander un complément."
      },
      "fineArt": {
        "title": "Contrat spécifique œuvres d’art",
        "body": "Police dédiée et protection sur mesure adaptée à la valeur réelle des pièces."
      }
    },
    "policy": {
      "label": "Type de contrat souhaité",
      "select": "— Sélectionner —",
      "nailToNail": "🧷 Clou à clou, événement, transport ou exposition",
      "allRisks": "🛡️ Tous risques, couverture complète",
      "transportRequired": "Transport requis"
    },
    "event": {
      "start": "Début de l’événement, optionnel",
      "end": "Fin de l’événement, optionnel"
    },
    "form": {
      "storageLocation": "Lieu de conservation",
      "storagePlaceholder": "Domicile, garde-meuble, galerie, freeport…",
      "insuredValue": "Valeur à assurer (EUR)",
      "prefilled": "(préremplie depuis votre fiche)",
      "valuePlaceholder": "Ex. 12000",
      "context": "Contexte ou message complémentaire, optionnel",
      "contextPlaceholder": "Précisions sur vos attentes, délais ou conditions particulières…",
      "name": "Votre nom, optionnel",
      "email": "Votre email, optionnel"
    },
    "consent": {
      "title": "Cadre du service d’orientation assurantielle",
      "description": "En soumettant cette demande, vous reconnaissez qu’Artkiv agit uniquement comme plateforme de mise en relation et ne vend aucun produit d’assurance. Les courtiers partenaires interviennent de manière indépendante. Aucune souscription n’est engagée via Artkiv.",
      "checkbox": "J’ai pris connaissance du cadre du service et je souhaite transmettre cette demande.",
      "link": "Consulter les conditions complètes"
    },
    "actions": {
      "sending": "Envoi en cours…",
      "submit": "✨ Envoyer la demande",
      "cancel": "Annuler"
    },
    "errors": {
      "acceptTerms": "Veuillez accepter le cadre du service avant d’envoyer la demande.",
      "noSession": "Aucune session active.",
      "invalidInsuredValue": "La valeur assurée est invalide.",
      "selectPolicy": "Veuillez sélectionner le type de contrat, clou à clou ou tous risques.",
      "submit": "Erreur lors de l’envoi de la demande."
    },
    "footer": {
      "title": "Pourquoi partager toutes ces informations ?",
      "body": "Un courtier spécialisé évalue les risques selon la technique, l’état de conservation, la provenance et la valeur récente. Un dossier complet lui permet de proposer une solution adaptée dès le premier échange.",
      "note": "⚡ Gain de temps et communication améliorée"
    }
  },
  "insuranceRequestDetail": {
    "loading": "Chargement de votre demande…",
    "notFound": "Demande introuvable.",
    "artworkFallback": "Œuvre",
    "errors": {
      "load": "Erreur lors du chargement de la demande.",
      "updateStatus": "Impossible de mettre à jour le statut."
    },
    "header": {
      "title": "Détail de la demande",
      "subtitle": "Suivi de votre demande d’assurance",
      "createdAt": "Créée le {{date}}"
    },
    "actions": {
      "back": "← Retour",
      "backToRequests": "← Retour à mes demandes",
      "refresh": "🔄 Rafraîchir",
      "accept": "✓ Accepter la proposition",
      "reject": "✗ Refuser"
    },
    "status": {
      "pending": "En attente",
      "seen": "Consultée",
      "answered": "Réponse reçue",
      "quoted": "Devis reçu",
      "accepted": "Acceptée",
      "rejected": "Refusée",
      "done": "Clôturée",
      "unknown": "Statut inconnu"
    },
    "statusExplanation": {
      "pending": "Votre courtier partenaire a reçu la demande et l’analysera sous 48 h.",
      "seen": "Votre courtier a ouvert la demande et prépare sa recommandation.",
      "answered": "Vous avez reçu une réponse. Prenez le temps de la lire avant de décider.",
      "quoted": "Vous avez reçu une proposition. Prenez le temps de la lire avant de décider.",
      "accepted": "Vous avez accepté la proposition. Le courtier vous contactera pour finaliser.",
      "rejected": "Vous avez décliné la proposition. Vous pouvez relancer une demande si nécessaire.",
      "done": "Cette demande est clôturée.",
      "unknown": "Le statut de cette demande est en cours de mise à jour."
    },
    "analysis": {
      "title": "Comment le courtier analyse-t-il votre demande ?",
      "body": "Grâce aux informations de la fiche œuvre, notamment la provenance, le certificat et l’état de conservation, le courtier peut évaluer précisément les risques et proposer une couverture adaptée sans réclamer de nombreux documents par email.",
      "note": "⚡ Gain de temps et recommandation plus juste pour votre collection."
    },
    "details": {
      "requestType": "Type de demande",
      "insuredValue": "Valeur assurée",
      "context": "Contexte"
    },
    "requestType": {
      "insurance_quote": "Demande de devis d’assurance"
    },
    "coverage": {
      "home_premium": "Assurance habitation haut de gamme",
      "fine_art_policy": "Contrat spécifique œuvres d’art"
    },
    "policy": {
      "nail_to_nail": "Clou à clou",
      "all_risks": "Tous risques"
    },
    "coverageDetails": {
      "title": "📋 Détails de la couverture demandée",
      "policyType": "Type de contrat",
      "storageLocation": "Lieu de conservation",
      "transportRequired": "Transport requis pour cette œuvre",
      "eventPeriod": "Période événementielle"
    },
    "sharedInfo": {
      "title": "📄 Informations transmises au courtier",
      "description": "Ces éléments ont été volontairement partagés dans le cadre de cette demande. Ils permettent au courtier de mieux comprendre votre besoin sans multiplier les échanges."
    },
    "partner": {
      "title": "Recommandation du courtier partenaire",
      "noticeTitle": "Ce qu’il faut savoir",
      "noticeBody": "La proposition ci-dessous est indicative. Prenez le temps de la lire, posez vos questions et décidez librement.",
      "message": "Message du courtier",
      "quoteAmount": "Montant de la prime proposée",
      "percentage": "Soit environ {{percentage}} % de la valeur assurée. Un coût raisonnable pour protéger votre patrimoine.",
      "importantTitle": "Important :",
      "importantBody": "En cas d’acceptation, la contractualisation se fait directement avec le courtier partenaire, en dehors de la plateforme Artkiv. Vous serez recontacté sous 48 h pour finaliser les modalités."
    },
    "pending": {
      "title": "Analyse en cours",
      "body": "Votre courtier partenaire a reçu la demande et analyse les éléments fournis. Vous recevrez une recommandation sous 48 h en moyenne.",
      "note": "L’étude attentive de votre dossier permet de proposer la solution la plus adaptée."
    },
    "footer": {
      "title": "Pourquoi le coût d’une assurance reste-t-il raisonnable ?",
      "body": "Une prime d’assurance pour œuvres d’art représente en moyenne 0,1 % à 0,3 % de la valeur par an. Pour une pièce de 20 000 €, cela équivaut à 20 à 60 € par mois. Face au risque financier et émotionnel d’une perte totale, c’est un investissement protecteur.",
      "note": "✨ Certains contrats incluent expertise, restauration d’urgence et accompagnement juridique."
    }
  },
  "insuranceRequests": {
    "hero": {
      "title": "Mes demandes d’assurance",
      "subtitle": "Suivez l’avancement de vos demandes de devis, attestations et mises à jour de valeur."
    },
    "actions": {
      "newRequest": "✨ Nouvelle demande",
      "refresh": "🔄 Rafraîchir",
      "viewDetails": "Voir les détails"
    },
    "errors": {
      "noSession": "Aucune session active.",
      "load": "Erreur lors du chargement des demandes."
    },
    "loading": "Chargement de vos demandes…",
    "artworkFallback": "Œuvre",
    "education": {
      "whyInsure": {
        "title": "Pourquoi assurer une collection d’art ?",
        "protection": "Protéger ce qui compte. Même dans un lieu sécurisé, les risques existent : dégât des eaux, incendie, vol ou dommage accidentel pendant un déplacement.",
        "affordable": "Une prime accessible. Assurer une œuvre coûte généralement entre 0,1 % et 0,3 % de sa valeur par an. Pour une pièce de 10 000 €, cela représente environ 10 à 30 € par mois.",
        "note": "💬 Nos courtiers partenaires analysent la fiche œuvre afin de proposer une solution sur mesure."
      },
      "sharing": {
        "title": "Pourquoi partager les informations de ma fiche œuvre ?",
        "body": "Chaque demande permet au courtier partenaire d’accéder uniquement aux éléments que vous choisissez, comme la provenance, le certificat, le rapport d’état ou la dernière estimation.",
        "result": "Résultat : une analyse rapide, une recommandation précise et moins d’échanges par email.",
        "note": "🔒 Le partenaire n’accède qu’à cette demande, jamais au reste de votre collection."
      }
    },
    "privacy": {
      "title": "Contrôle et confidentialité",
      "body": "Artkiv ne vend aucun produit d’assurance. La plateforme facilite le contact avec un courtier spécialisé en œuvres d’art, sélectionné pour son expertise.",
      "scope": "Les informations transmises sont strictement limitées au périmètre nécessaire à l’analyse. Le courtier ne voit rien d’autre."
    },
    "empty": {
      "title": "Aucune demande pour le moment.",
      "body": "Lancez votre première demande pour recevoir une recommandation d’assurance adaptée à votre collection. La démarche est rapide, confidentielle et sans engagement.",
      "cta": "Créer ma première demande"
    },
    "coverage": {
      "home_premium": "Habitation haut de gamme",
      "fine_art_policy": "Contrat œuvres d’art"
    },
    "policy": {
      "nail_to_nail": "Clou à clou",
      "all_risks": "Tous risques"
    },
    "labels": {
      "transport": "Transport",
      "type": "Type",
      "insuredValue": "Valeur assurée"
    },
    "requestType": {
      "insurance_quote": "Demande de devis d’assurance"
    },
    "status": {
      "pending": "En attente",
      "seen": "Consultée",
      "answered": "Réponse reçue",
      "quoted": "Devis reçu",
      "accepted": "Acceptée",
      "rejected": "Refusée",
      "done": "Clôturée"
    },
    "footer": {
      "title": "Bien plus qu’une simple assurance",
      "body": "Chaque demande vous met en relation avec un expert qui comprend la valeur patrimoniale et affective de votre collection. Vous bénéficiez d’une analyse sur mesure, sans formulaire générique ni couverture inadaptée.",
      "note": "💬 Une question sur votre couverture actuelle ? Nos courtiers partenaires répondent sous 48 h en moyenne."
    }
  },
  "partners": {
    "back": "Retour",
    "loading": "Chargement…",
    "close": "Fermer",
    "title": "Nos partenaires de services",
    "subtitle": "Des professionnels qualifiés et de confiance pour accompagner la gestion de votre collection.",
    "search": "Rechercher…",
    "service": "Service",
    "categories": {
      "labels": {
        "all": "Tous",
        "insurance": "Courtiers d’assurance",
        "transport": "Transporteurs",
        "conservation": "Conservateurs",
        "other": "Autres services"
      },
      "descriptions": {
        "all": "Tous les partenaires",
        "insurance": "Protection de vos œuvres d’art",
        "transport": "Transport spécialisé d’œuvres d’art",
        "conservation": "Restauration et conservation",
        "other": "Services complémentaires"
      }
    },
    "contact": "Contacter",
    "addToContacts": "Ajouter à mes contacts",
    "alert": {
      "loginRequired": "Veuillez vous connecter pour ajouter ce partenaire à vos contacts.",
      "addedToContacts": "Partenaire ajouté à vos contacts.",
      "comingSoon": "Cette fonctionnalité sera bientôt disponible pour ce type de partenaire.",
      "error": "Erreur lors de l’ajout du partenaire."
    },
    "errors": {
      "load": "Erreur lors du chargement des partenaires."
    },
    "modal": {
      "title": "Contacter le partenaire",
      "desc": "Utilisez les coordonnées ci-dessous pour contacter ce partenaire :",
      "company": "Entreprise",
      "email": "Email",
      "phone": "Téléphone",
      "address": "Adresse"
    },
    "empty": {
      "title": "Aucun partenaire trouvé",
      "search": "Essayez une autre recherche",
      "filter": "Sélectionnez une autre catégorie"
    }
  },
  "eventLanding": {
    "ribbon": {
      "onSite": "Sur place :",
      "followStories": "Suivez nos stories →"
    },
    "events": {
      "when": {
        "thisWeek": "cette semaine",
        "nextWeek": "la semaine prochaine",
        "december": "en décembre"
      }
    },
    "hero": {
      "title": "Rencontrons-nous au salon.",
      "subtitle": "Artkiv associe intelligence artificielle, blockchain et expertise humaine pour documenter, estimer et protéger vos œuvres. L’art ne se collectionne pas seulement, il se transmet.",
      "freeTrial": "🎁 Essai gratuit de 14 jours",
      "requestMeeting": "📅 Demander un rendez-vous au salon"
    },
    "audiences": {
      "collectors": {
        "title": "Collectionneuses et collectionneurs",
        "body": "Carnet de vie des œuvres, provenance et documents, estimations pédagogiques et transmission familiale simplifiée."
      },
      "families": {
        "title": "Familles et héritiers",
        "body": "Vous héritez d’œuvres ? Nous clarifions ce que vous possédez, sa valeur et les erreurs juridiques ou fiscales à éviter."
      },
      "professionals": {
        "title": "Family offices et assureurs",
        "body": "Dossier d’actif culturel exploitable, traçabilité et preuves pour réduire les risques et fluidifier la couverture."
      }
    },
    "meeting": {
      "title": "On se parle 15 minutes sur place ?",
      "body": "Venez avec une œuvre précise, une photo, une facture ou un certificat, ou simplement une question sur la succession ou l’assurance. Nous réservons un créneau discret pendant la foire.",
      "emailSubject": "Rendez-vous foire",
      "emailCta": "✉️ Envoyer ma demande",
      "instagramCta": "Message Instagram @artkiv_official"
    },
    "footer": {
      "tagline": "Outil de confiance pour les collections privées : valeur, traçabilité et protection."
    }
  },
  "sharedPage": {
    "title": "Collections partagées avec moi"
  },
  "artworkCharts": {
    "title": "Statistiques de collection",
    "collection": "Collection",
    "allCollections": "Toutes",
    "noCollection": "Sans collection",
    "untitled": "Sans titre",
    "unknown": "Inconnue",
    "notProvided": "Non renseigné",
    "notLocated": "Non localisé",
    "loadError": "Impossible de charger les œuvres.",
    "charts": {
      "valueByLocation": "Valeur totale par lieu",
      "artworksByArtist": "Nombre d’œuvres par artiste",
      "byMedium": "Répartition par médium",
      "byType": "Répartition par type d’art",
      "byPeriod": "Répartition par période",
      "byTotalValue": "Répartition par valeur totale"
    },
    "datasets": {
      "totalValue": "Valeur totale",
      "artworks": "Œuvres"
    },
    "periodHelp": "Les œuvres sans année sont classées dans la catégorie « Inconnue ».",
    "noValueData": "Aucune donnée de valeur disponible",
    "tooltipCount": "{{value}} ({{percent}} %)"
  },
  "artworkCosts": {
    "title": "Suivi des coûts – {{artwork}}",
    "artworkFallback": "Œuvre n°{{id}}",
    "back": "Retour à l’œuvre",
    "addTitle": "Ajouter un coût",
    "selectType": "Sélectionner un type",
    "amountPlaceholder": "Montant (€)",
    "description": "Description",
    "provider": "Nom du prestataire",
    "automaticCategory": "Catégorie automatique :",
    "saving": "Enregistrement…",
    "add": "Ajouter",
    "history": "Historique des coûts",
    "columns": {
      "date": "Date",
      "type": "Type",
      "amount": "Montant",
      "lot": "Lot",
      "description": "Description",
      "provider": "Prestataire"
    },
    "total": "Total",
    "saveError": "Erreur lors de l’enregistrement.",
    "loadError": "Impossible de charger les coûts.",
    "empty": "Aucun coût enregistré.",
    "lots": {
      "lot1": "Lot 1",
      "lot2": "Lot 2"
    },
    "types": {
      "fabrication": "Fabrication",
      "framing": "Encadrement",
      "otherTechnical": "Autre (technique)",
      "exhibition": "Exposition",
      "documentation": "Documentation",
      "legalFees": "Frais juridiques",
      "otherEnhancement": "Autre (mise en valeur)"
    }
  },
  "smartDashboardRedirect": {
    "loadingDashboard": "Chargement du tableau de bord…",
    "loadingPartner": "Chargement de l’espace partenaire…"
  },
  "marketInsights": {
    "loading": "Chargement des données Art Basel 2025…",
    "loadError": "Erreur lors du chargement des données Art Basel",
    "title": "Art Basel 2025 Insights",
    "subtitle": "Données et analyses du marché de l’art contemporain",
    "nav": {
      "overview": "Vue d’ensemble",
      "sectors": "Secteurs",
      "prices": "Prix",
      "recommendations": "Recommandations"
    },
    "overview": {
      "title": "Vue d’ensemble du marché 2025",
      "globalSales": "Ventes globales",
      "billionUsd": "Milliards USD",
      "onlineShare": "Part e-commerce",
      "vs2024": "+2 % vs 2024",
      "volumeGrowth": "Croissance du volume",
      "transactions": "Transactions",
      "averageValue": "Valeur moyenne",
      "perTransaction": "Par transaction",
      "topMarkets": "Principaux marchés"
    },
    "sectors": {
      "title": "Performance par secteur",
      "performance": "Performance :",
      "volume": "Volume :"
    },
    "prices": {
      "title": "Segments de prix",
      "volumeShare": "Part du volume :",
      "valueShare": "Part de la valeur :",
      "growth": "Croissance :"
    },
    "recommendations": {
      "title": "Recommandations IA",
      "collectorInsights": "Insights collectionneurs",
      "artAllocation": "Allocation art moyenne",
      "onlinePreference": "Préfèrent l’achat en ligne",
      "millennials": "Participation des millennials"
    },
    "footer": {
      "source": "Sources : rapport Art Basel & UBS 2025 • Algorithme version {{version}}",
      "updated": "Dernière mise à jour : {{date}}"
    },
    "countries": {
      "United States": "États-Unis",
      "United Kingdom": "Royaume-Uni",
      "China": "Chine",
      "France": "France",
      "Switzerland": "Suisse",
      "Hong Kong": "Hong Kong"
    },
    "sectorNames": {
      "Contemporary Art": "Art contemporain",
      "Modern Art": "Art moderne",
      "Post-War Art": "Art d’après-guerre",
      "Impressionist and Post-Impressionist": "Impressionnisme et postimpressionnisme",
      "Old Masters": "Maîtres anciens"
    }
  },
  "expertsDirectory": {
    "badge": "Expert Artkiv",
    "requestLabel": "Demande",
    "defaultIntro": "Bonjour, je souhaite vous ajouter comme Art Advisor personnel.",
    "conversationError": "Conversation non créée",
    "loginRequired": "Veuillez vous connecter.",
    "artkivOnly": "Réservé aux experts Artkiv.",
    "notAuthenticated": "Utilisateur non authentifié",
    "alreadyRequested": "Une demande est déjà en cours ou acceptée.",
    "requestDescription": "Demande de conseiller personnel",
    "success": "Invitation envoyée. En attente de réponse de l’expert.",
    "sendError": "Erreur lors de l’envoi.",
    "title": "Experts Artkiv",
    "search": "Rechercher un expert…",
    "allSpecialties": "Toutes les spécialités",
    "becomeAdvisor": "Devenir mon conseiller personnel",
    "messagePlaceholder": "Message pour l’expert (optionnel)",
    "sending": "Envoi…",
    "send": "Envoyer la demande"
  },
  "addArtwork": {
    "title": "Ajouter une œuvre",
    "tabs": {
      "details": "Détails",
      "specifications": "Spécifications",
      "provenance": "Provenance",
      "documents": "Documents",
      "location": "Emplacement",
      "nft": "NFT"
    },
    "collection": {
      "label": "Sélectionner une collection",
      "auto": "Créer automatiquement une collection (par défaut)",
      "unnamed": "Collection sans nom ({{id}})",
      "create": "+ Créer une nouvelle collection",
      "prompt": "Nom de la nouvelle collection :",
      "created": "Collection créée.",
      "createError": "Erreur lors de la création de la collection."
    },
    "uploadError": "Erreur lors de l’envoi de l’image.",
    "success": "Œuvre ajoutée avec succès.",
    "saveError": "Erreur : {{message}}",
    "saving": "Ajout en cours…",
    "submit": "Ajouter l’œuvre"
  },
  "acceptCollectionTransfer": {
    "errors": {
      "invalid": "Lien invalide.",
      "notFound": "Lien introuvable ou expiré.",
      "expired": "Ce lien a expiré (validité de 7 jours).",
      "cancelled": "Ce transfert a été annulé par l’Art Advisor.",
      "network": "Erreur réseau. Réessayez.",
      "generic": "Erreur"
    },
    "loading": "Vérification du lien…",
    "invalidTitle": "Lien invalide",
    "home": "Retour à l’accueil",
    "wrongUserTitle": "Compte incorrect",
    "wrongUserBody": "Ce lien est destiné à {{expected}}. Vous êtes connecté avec {{current}}.",
    "wrongUserHelp": "Déconnectez-vous puis reconnectez-vous avec le bon compte.",
    "switchAccount": "Se déconnecter et changer de compte",
    "doneTitle": "Collections transférées",
    "doneBody": "Les collections sont maintenant dans votre espace Artkiv.",
    "viewCollections": "Voir mes collections",
    "accepting": "Transfert en cours…",
    "eyebrow": "INVITATION DE TRANSFERT",
    "title": "Votre Art Advisor vous transfère des collections",
    "included": "Collections incluses",
    "notice": "En acceptant, ces collections apparaîtront dans votre espace et votre Art Advisor conservera un accès limité pour vous assister.",
    "accept": "Accepter le transfert",
    "loginHelp": "Connectez-vous ou créez un compte avec {{email}} pour accepter.",
    "login": "Se connecter",
    "register": "Créer un compte"
  },
  "transportPreforum": {
    "documentTitle": "Transport d’œuvres – Demande de devis | ARTKIV",
    "authRequired": "Vous devez être connecté pour envoyer une demande de transport.",
    "sendError": "Échec de l’envoi de la demande. Merci de réessayer.",
    "title": "Transport d’œuvres – Demande de devis",
    "subtitle": "Collecte des informations pour un devis auprès d’un partenaire transport.",
    "steps": {
      "one": "Étape 1 – Lieux et œuvres",
      "two": "Étape 2 – Options et assurances",
      "three": "Étape 3 – Récapitulatif et envoi"
    },
    "prefill": "Préremplissage de l’adresse en cours…",
    "fields": {
      "carrier": "Transporteur",
      "salutation": "Civilité",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "pickupAddress": "Adresse d’enlèvement",
      "deliveryAddress": "Adresse de livraison",
      "city": "Ville",
      "country": "Pays",
      "desiredDate": "Date souhaitée",
      "distance": "Distance estimée (km)",
      "floor": "Étage (si ascenseur indisponible)",
      "pieces": "Nombre de pièces",
      "category": "Catégorie",
      "length": "L (cm)",
      "width": "l (cm)",
      "height": "H (cm)",
      "weight": "Poids (kg)",
      "packing": "Emballage",
      "crate": "Caisse de protection",
      "volume": "Volumétrie",
      "handling": "Manutention",
      "international": "Transport international",
      "temperature": "Contrôle de température",
      "declaredValue": "Valeur déclarée (€) pour l’assurance",
      "customs": "Formalités douanières",
      "attachments": "Ajouter des photos ou documents"
    },
    "hintApprox": "approx.",
    "pickupPlaceholder": "Ex. : 55 Storage Road, Boston, MA 02215, États-Unis",
    "salutations": {
      "mrs": "Mme",
      "mr": "M.",
      "other": "Autre"
    },
    "categories": {
      "painting": "Peinture",
      "sculpture": "Sculpture",
      "paper": "Dessin / Papier",
      "photography": "Photographie",
      "object": "Mobilier / Objet"
    },
    "packing": {
      "bubble": "Film bulles / mousse",
      "foam": "Mousse haute densité",
      "crate": "Caisse dédiée"
    },
    "crate": {
      "none": "Aucune",
      "cardboard": "Carton renforcé",
      "museum": "Bois (qualité musée)"
    },
    "volume": {
      "small": "Petite",
      "medium": "Moyenne",
      "large": "Grande"
    },
    "handling": {
      "simple": "Simple",
      "medium": "Moyenne",
      "complex": "Complexe (accrochage / gréage)"
    },
    "yes": "Oui",
    "no": "Non",
    "toPlan": "À prévoir",
    "import": "Importer",
    "filesAdded": "{{count}} fichier ajouté",
    "filesAdded_plural": "{{count}} fichiers ajoutés",
    "quickEstimate": "Estimation rapide",
    "quote": {
      "subtotal": "Sous-total logistique",
      "insurance": "Assurance (prévision)",
      "vat": "TVA 20 %",
      "estimatedTotal": "Total TTC estimé",
      "partnerEstimate": "Estimation partenaire ARTKIV (indicative)"
    },
    "cancel": "Annuler",
    "back": "Retour",
    "continue": "Continuer",
    "indicative": "estimation indicative",
    "readyTitle": "Prêt à transmettre au partenaire logistique",
    "readyBody": "Nous enregistrons votre demande. Un partenaire transport actif vous contacte pour confirmer le planning, les accès, l’équipe et le devis.",
    "summaryRequest": "Récapitulatif de la demande",
    "copy": "Copier",
    "sending": "Envoi…",
    "send": "Envoyer",
    "submittedTitle": "Demande enregistrée",
    "submittedBody": "Votre demande de transport a bien été enregistrée{{reference}}. Un partenaire transport vous recontactera par e-mail ou téléphone.",
    "reference": " (référence {{id}})",
    "backArtwork": "Retour à l’œuvre",
    "summary": "Résumé",
    "partner": "Partenaire :",
    "route": "Trajet",
    "floorLabel": "Étage :",
    "artworks": "Œuvre(s)",
    "selectedOptions": "Options choisies",
    "packingLabel": "Emballage :",
    "crateLabel": "Caisse :",
    "volumeLabel": "Volumétrie :",
    "handlingLabel": "Manutention :",
    "temperatureLabel": "Température :",
    "internationalLabel": "International :",
    "customsLabel": "Douane : Oui – Incoterm {{incoterm}}",
    "activeControl": "Contrôle actif",
    "other": "Autre",
    "artkiv": "ARTKIV"
  },
  "delegatedAccess": {
    "roles": {
      "team_member": "Membre de l’équipe",
      "team_readonly": "Accès en lecture seule",
      "expert": "Expert invité",
      "assistant": "Assistant",
      "client": "Client",
      "collaborator": "Collaborateur"
    },
    "tabs": {
      "collections": "Collections",
      "artworks": "Œuvres",
      "locations": "Emplacements",
      "reports": "Rapports",
      "vision": "Vision IA"
    },
    "edit": "Éditer",
    "untitled": "Sans titre",
    "untitledCollection": "Collection sans titre",
    "noSharedCollections": "Aucune collection partagée",
    "artworkCount": "{{count}} œuvre",
    "artworkCount_plural": "{{count}} œuvres",
    "editable": "MODIFIABLE",
    "search": "Titre, artiste…",
    "loading": "Chargement…",
    "noArtwork": "Aucune œuvre.",
    "page": "Page {{current}} / {{total}}",
    "allArtworksLoading": "Chargement de toutes les œuvres…",
    "allArtists": "Tous les artistes",
    "allMediums": "Tous les médiums",
    "clear": "Effacer",
    "results": "{{count}} résultat",
    "results_plural": "{{count}} résultats",
    "previous": "Préc.",
    "next": "Suiv.",
    "unknownLocation": "Emplacement non renseigné",
    "reportsPermissionTitle": "Permission non accordée",
    "reportsPermissionBody": "La génération de rapports n’est pas incluse dans votre accès collaborateur.",
    "reportsIntro": "Accédez aux rapports d’inventaire et de valorisation des collections partagées.",
    "reportInventory": "Rapport d’inventaire PDF",
    "reportInventoryDesc": "Générer un inventaire complet de la collection",
    "reportValuation": "Rapport de valorisation",
    "reportValuationDesc": "Rapport d’estimation et de valorisation",
    "visionPermissionBody": "L’accès aux outils Vision IA n’est pas inclus dans votre accès collaborateur.",
    "visionIntro": "Accédez aux outils d’analyse visuelle et d’enrichissement des fiches.",
    "openVision": "Ouvrir Vision Artkiv",
    "noAccess": "Aucun accès collaborateur actif.",
    "genericError": "Erreur.",
    "ownerFallback": "votre expert",
    "loadingPage": "Chargement…",
    "accessUnavailable": "Accès indisponible",
    "logout": "Se déconnecter",
    "logoutShort": "Déconnexion",
    "access": "Accès :",
    "permissions": {
      "view": "Voir",
      "edit": "Éditer",
      "add": "Ajouter",
      "delete": "Supprimer",
      "export": "Exporter",
      "reports": "Rapports",
      "ai": "IA"
    },
    "footer": "Votre accès est géré par {{owner}} et peut être modifié ou révoqué à tout moment. Toutes vos actions sont tracées. Cet espace ne requiert aucun abonnement de votre part."
  },
  "inflationReport": {
    "back": "Retour",
    "title": "Valeur actualisée à l’inflation",
    "subtitle": "Revalorisation du prix d’achat – Indice IPC INSEE base 100 (2015)",
    "ipc": {
      "live": "IPC en direct – {{date}}",
      "embedded": "IPC embarqué – {{date}}",
      "loading": "Chargement de l’IPC…",
      "unavailable": "IPC indisponible"
    },
    "collection": "Collection",
    "select": "Sélectionner…",
    "clientName": "Nom du client (pour le rapport)",
    "clientPlaceholder": "Ex. : Galerie RX",
    "loadingArtworks": "Chargement des œuvres…",
    "stats": {
      "total": "Œuvres totales",
      "withPrice": "Avec prix d’achat",
      "computable": "Calculables",
      "missing": "Données manquantes"
    },
    "financial": {
      "purchaseTotal": "Valeur totale d’achat",
      "updatedTotal": "Valeur actualisée totale",
      "globalVariation": "Variation globale"
    },
    "missing": {
      "summary": "{{count}} œuvre sans prix d’achat ou date d’acquisition – exclue du calcul.",
      "summary_plural": "{{count}} œuvres sans prix d’achat ou date d’acquisition – exclues du calcul.",
      "excelNotice": "Un onglet « Données manquantes » sera inclus dans l’export Excel.",
      "hide": "Masquer dans l’aperçu",
      "show": "Afficher dans l’aperçu",
      "hidden": "({{count}} sans données masquées)",
      "noPrice": "Prix d’achat manquant",
      "noDate": "Date d’acquisition manquante",
      "ipc": "IPC indisponible pour cette période",
      "ipcBefore": "IPC indisponible pour une acquisition antérieure à 2010"
    },
    "preview": "Aperçu des calculs",
    "columns": {
      "inventory": "N° inv.",
      "artwork": "Œuvre",
      "date": "Date d’acquisition",
      "purchasePrice": "Prix d’achat",
      "coefficient": "Coeff.",
      "updatedValue": "Valeur actualisée",
      "variation": "+/−"
    },
    "untitled": "Sans titre",
    "formatTitle": "Format du rapport",
    "formats": {
      "pdf": "Mise en page professionnelle",
      "word": "Fichier .docx éditable",
      "excel": "3 onglets : calculs, données manquantes et synthèse"
    },
    "alerts": {
      "chooseFormat": "Sélectionnez au moins un format.",
      "noIpc": "Données IPC non disponibles.",
      "generation": "Erreur de génération : {{message}}"
    },
    "generating": "Génération en cours…",
    "downloadMultiple": "Télécharger {{formats}}",
    "downloadOne": "Télécharger {{format}}",
    "selectFormat": "Sélectionner un format",
    "noComputable": "Aucune œuvre avec prix d’achat et date d’acquisition disponibles.",
    "legal": "Ce rapport actualise le prix d’achat selon l’évolution du coût de la vie (IPC INSEE). Il ne reflète ni la cote de marché de l’artiste ni la valeur vénale de l’œuvre. Il peut servir de référence plancher en matière de succession (art. 761 CGI) ou d’assurance.",
    "referenceIndex": "Indice de référence : {{value}} – {{date}}.",
    "empty": "Aucune œuvre dans cette collection.",
    "export": {
      "untitled": "Sans titre",
      "sheetRevaluation": "Revalorisation",
      "sheetMissing": "Données manquantes",
      "sheetSummary": "Synthèse",
      "headers": {
        "inventory": "N° inventaire",
        "title": "Titre",
        "artist": "Artiste",
        "acquisitionDate": "Date acquisition",
        "purchasePrice": "Prix achat (EUR)",
        "acquisitionIpc": "IPC acquisition",
        "referenceIpc": "IPC référence",
        "coefficient": "Coefficient",
        "updatedValue": "Valeur actualisée (EUR)",
        "variation": "Variation (%)",
        "missing": "Donnée manquante",
        "parameter": "Paramètre",
        "value": "Valeur"
      },
      "summary": {
        "collection": "Collection",
        "client": "Client",
        "reportDate": "Date du rapport",
        "referenceIpc": "IPC de référence",
        "totalArtworks": "Œuvres totales",
        "computedArtworks": "Œuvres calculées",
        "missingData": "Données manquantes",
        "totalPurchase": "Total prix d’achat (EUR)",
        "totalUpdated": "Total actualisé (EUR)",
        "globalVariation": "Variation globale (%)",
        "indexSource": "Source indice",
        "legalReference": "Référence légale",
        "indexSourceValue": "INSEE IPC ensemble France hors tabac, base 100 (2015)",
        "legalValue": "Art. 761 CGI – succession / assurance"
      },
      "coverTitle": "VALEUR D’ACQUISITION ACTUALISÉE",
      "coverSubtitle": "Revalorisation au coût de la vie – Indice IPC INSEE base 100 (2015)",
      "coverMethod": "Méthode conforme à l’art. 761 CGI – Référence plancher succession et assurance",
      "collection": "Collection : {{name}}",
      "client": "Client : {{name}}",
      "reportDate": "Date du rapport : {{date}}",
      "referenceIpc": "Indice IPC de référence : {{value}} ({{date}})",
      "worksWithPrice": "ŒUVRES AVEC PRIX D’ACHAT",
      "totalUpdated": "VALEUR TOTALE ACTUALISÉE",
      "averageCoefficient": "COEFFICIENT MOYEN",
      "tableTitle": "TABLEAU DE REVALORISATION",
      "computedCount": "{{count}} œuvre calculée – IPC {{date}}",
      "computedCount_plural": "{{count}} œuvres calculées – IPC {{date}}",
      "tableHeaders": {
        "inventory": "N° inv.",
        "titleArtist": "Titre / Artiste",
        "acquisition": "Acq.",
        "purchase": "Prix achat",
        "coefficient": "Coeff.",
        "updated": "Val. actualisée",
        "variation": "+/−"
      },
      "total": "TOTAL",
      "missingTitle": "DONNÉES MANQUANTES POUR LE CALCUL INFLATION",
      "missingIntro": "Ces œuvres ne figurent pas dans la valorisation faute de prix d’achat ou de date d’acquisition.",
      "exclusionReason": "Motif d’exclusion",
      "methodologyTitle": "NOTE MÉTHODOLOGIQUE",
      "methodology": {
        "objectTitle": "OBJET DU RAPPORT",
        "object1": "Ce rapport présente la valeur d’acquisition de chaque œuvre actualisée selon l’évolution du coût de la vie en France.",
        "object2": "Il ne constitue ni une estimation de la valeur de marché de l’œuvre ni un certificat d’expertise.",
        "indexTitle": "INDICE UTILISÉ",
        "index1": "Indice des prix à la consommation (IPC) – ensemble France hors tabac, base 100 en 2015.",
        "index2": "Source : INSEE, série 001641683. Données CVS. Couverture : 2000 à ce jour.",
        "formulaTitle": "FORMULE",
        "formula1": "Valeur actualisée = Prix d’acquisition × (IPC date du rapport / IPC mois d’acquisition)",
        "formula2": "Le coefficient est calculé avec 3 décimales. La valeur actualisée est arrondie à l’euro.",
        "currenciesTitle": "DEVISES ÉTRANGÈRES",
        "currencies1": "Pour les œuvres acquises dans une devise autre que l’EUR, le calcul utilise le champ acquisition_price_eur lorsqu’il est disponible.",
        "currencies2": "À défaut, l’œuvre est exclue du total et la conversion est signalée comme indisponible.",
        "useTitle": "UTILISATION",
        "use1": "Cette valeur peut servir de référence plancher pour une succession, une assurance ou un bilan patrimonial indicatif.",
        "use2": "Elle ne se substitue pas à une expertise de valeur vénale à dire d’expert.",
        "privacyTitle": "CONFIDENTIALITÉ",
        "privacy1": "Ce document est strictement confidentiel et établi à la seule demande du client nommé.",
        "privacy2": "Il ne peut être communiqué à des tiers sans accord écrit de QUANG & CO.",
        "legalUseTitle": "UTILISATION LÉGALE",
        "legalUse1": "Référence plancher pour déclaration de succession (art. 761 CGI) et contrats d’assurance.",
        "legalUse2": "Ne remplace pas une expertise de valeur vénale."
      },
      "established": "Établi le {{date}}",
      "worksWithAcquisition": "{{count}} œuvre avec prix d’acquisition renseigné",
      "worksWithAcquisition_plural": "{{count}} œuvres avec prix d’acquisition renseigné",
      "referenceShort": "IPC de référence : {{value}} – {{date}}",
      "priceMissing": "Prix manquant",
      "dateMissing": "Date manquante",
      "ipcMissing": "IPC indisponible",
      "confidential": "Les estimations sont établies à titre indicatif. QUANG & CO – Confidentiel.",
      "excludedCount": "{{count}} œuvre exclue du calcul",
      "excludedCount_plural": "{{count}} œuvres exclues du calcul",
      "companyExpert": "QUANG & CO – Expert indépendant en évaluation d'œuvres d'art",
      "companyArtAdvisory": "QUANG & CO – Conseil en art"
    }
  },
  "expertReport": {
    "back": "Ma Collection",
    "title": "Rapport d'expertise",
    "subtitle": "Générez le rapport CUP et le tableau Excel — QUANG & CO",
    "collection": "Collection",
    "select": "Sélectionner…",
    "clientName": "Nom du client (pour le rapport)",
    "clientPlaceholder": "Ex. : Galerie RX",
    "loading": "Chargement des œuvres…",
    "stats": {
      "total": "Œuvres totales",
      "valued": "Valorisées",
      "cupComplete": "Fiches CUP complètes",
      "totalValue": "Valeur totale estimée"
    },
    "detected": {
      "title": "Option détectée :",
      "basedOn": "Basé sur {{count}} fiche CUP complète",
      "basedOn_plural": "Basé sur {{count}} fiches CUP complètes"
    },
    "options": {
      "synthese": {
        "label": "Option 1 — Synthétique",
        "short": "Option 1",
        "description": "Synthèse globale",
        "price": "2 000 € HT"
      },
      "cup_60": {
        "label": "Option 2 — 60 fiches CUP",
        "short": "Option 2",
        "description": "60 fiches CUP max",
        "price": "3 500 € HT"
      },
      "cup_200": {
        "label": "Option 3 — 200 fiches CUP",
        "short": "Option 3",
        "description": "Toutes les fiches CUP",
        "price": "7 800 € HT"
      }
    },
    "incomplete": "{{count}} fiche sans comparables complets. Le rapport PDF inclura uniquement les fiches CUP complètes. Le tableau Excel inclura toutes les œuvres.",
    "incomplete_plural": "{{count}} fiches sans comparables complets. Le rapport PDF inclura uniquement les fiches CUP complètes. Le tableau Excel inclura toutes les œuvres.",
    "reportMode": "Mode du rapport PDF",
    "formatTitle": "Format du rapport",
    "formats": {
      "pdf": "Mise en page professionnelle",
      "word": "Fichier .docx éditable"
    },
    "alerts": {
      "selectFormat": "Sélectionnez au moins un format (PDF ou Word).",
      "generation": "Erreur de génération : {{message}}",
      "excel": "Erreur Excel : {{message}}"
    },
    "actions": {
      "generating": "Génération en cours…",
      "downloadBoth": "Télécharger PDF + Word",
      "downloadWord": "Télécharger Word (.docx)",
      "downloadPdf": "Télécharger le rapport PDF",
      "excelGenerating": "Génération Excel…",
      "downloadExcel": "Télécharger le tableau Excel"
    },
    "common": {
      "untitled": "Sans titre",
      "unattributed": "Non attribué",
      "yes": "Oui",
      "no": "Non",
      "unknown": "Inconnu",
      "notProvided": "Non renseigné"
    },
    "methods": {
      "direct": "CUP directe — ventes aux enchères de l’artiste",
      "analogy": "CUP par analogie — artistes de profil similaire",
      "points": "Méthode par points — marché primaire encadré"
    },
    "risks": {
      "low": "Risque faible",
      "medium": "Risque moyen",
      "high": "Risque élevé"
    },
    "conditions": {
      "excellent": "Excellent",
      "very_good": "Très bon",
      "good": "Bon",
      "fair": "Moyen",
      "very_poor": "Très moyen",
      "poor": "Mauvais",
      "damaged": "Endommagé",
      "heavily_damaged": "Très abîmé (restaurable)",
      "partially_restorable": "Partiellement restaurable",
      "to_restore": "À restaurer",
      "irreparable": "Irrécupérable"
    },
    "documents": {
      "invoice": "facture",
      "certificate": "certificat",
      "condition": "constat / conservation",
      "count": "{{count}} document",
      "count_plural": "{{count}} documents"
    },
    "export": {
      "filePrefix": "Rapport_Expertise",
      "sheets": {
        "recap": "Récapitulatif",
        "comparables": "Comparables CUP",
        "artists": "Synthèse artistes"
      },
      "excel": {
        "inventory": "N° inventaire",
        "title": "Titre",
        "artist": "Artiste",
        "year": "Année",
        "medium": "Technique",
        "dimensions": "Dimensions",
        "estimated": "Valeur estimée (€)",
        "low": "Fourchette basse",
        "high": "Fourchette haute",
        "method": "Méthode",
        "expertDate": "Date expertise",
        "complete": "Fiche CUP complète",
        "artworkTitle": "Titre œuvre",
        "comparableNo": "Comparable n°",
        "auctionHouse": "Maison de vente",
        "saleDate": "Date vente",
        "soldArtwork": "Œuvre vendue",
        "hammer": "Prix adjugé (€)",
        "adjustment": "Ajustement (%)",
        "note": "Note",
        "count": "Nb œuvres",
        "total": "Valeur totale (€)",
        "average": "Valeur moy. (€)"
      },
      "coverTitle": "RAPPORT D’EXPERTISE",
      "coverSubtitle": "Valorisation d’une collection d’œuvres d’art",
      "coverMethod": "Méthode CUP — Conforme IFRS 13 / BOFiP",
      "company": "QUANG & CO — Conseil en art",
      "summaryByArtist": "Synthèse par artiste",
      "stats": {
        "evaluated": "ŒUVRES ÉVALUÉES",
        "totalValue": "VALEUR TOTALE ESTIMÉE",
        "estimatedSheets": "FICHES ESTIMÉES"
      },
      "methodologyTitle": "MÉTHODOLOGIE DE VALORISATION",
      "methodologyBase": "Base : IFRS 13 / BOFiP",
      "sections": {
        "method": "MÉTHODE RETENUE",
        "ranges": "FOURCHETTES RETENUES",
        "artistSales": "VENTES AUX ENCHÈRES DE L’ARTISTE",
        "referenceSales": "VENTES AUX ENCHÈRES RETENUES COMME RÉFÉRENCE",
        "expertNote": "NOTE DE L’EXPERT",
        "marketValue": "VALEUR VÉNALE À DIRE D’EXPERT",
        "unknownCondition": "ÉTAT DE CONSERVATION : INCONNU (à préciser à dire d’expert)",
        "documentation": "DOCUMENTATION",
        "analogArtists": "ARTISTES ANALOGUES",
        "storage": "LOCALISATION & CONDITIONS DE STOCKAGE",
        "signature": "SIGNATURE & AUTHENTICITÉ",
        "reference": "VENTES DE RÉFÉRENCE",
        "writeoff": "ŒUVRES IRRÉPARABLES — VALEUR NULLE (WRITE-OFF)",
        "losses": "PERTES / VOLS / DESTRUCTIONS / IRRÉPARABLES — VALEUR 0",
        "sold": "ŒUVRES VENDUES / CÉDÉES — HORS COLLECTION",
        "pending": "ŒUVRES EN ATTENTE D’ESTIMATION"
      },
      "table": {
        "artworkArtist": "Œuvre / Artiste",
        "source": "Source",
        "hammer": "Marteau",
        "artwork": "Œuvre",
        "detail": "Détail",
        "inventory": "Inventaire",
        "artist": "Artiste",
        "titleYear": "Titre / Année",
        "medium": "Technique",
        "dimensions": "Dim.",
        "theoretical": "Val. théorique",
        "condition": "État",
        "auctionDate": "Maison / Date",
        "price": "PRIX",
        "count": "Nb",
        "totalValue": "Valeur totale",
        "averageValue": "Valeur moyenne"
      },
      "disclaimer": "Les estimations sont établies à dire d’expert. Elles n’ont pas valeur de certificat d’authenticité. QUANG & CO — Confidentiel.",
      "pendingDisclaimer": "Ces œuvres feront l’objet d’une estimation complémentaire. QUANG & CO — Confidentiel.",
      "soldDisclaimer": "Ces œuvres ont quitté la collection et ne sont pas incluses dans la valorisation. QUANG & CO — Confidentiel.",
      "lossDisclaimer": "Ces œuvres sont comptabilisées pour mémoire avec une valeur nulle. QUANG & CO — Confidentiel.",
      "methodologyIntro": "La valeur retenue dans ce rapport est la valeur vénale (juste valeur IFRS 13) : le prix auquel un bien pourrait être échangé entre parties informées et indépendantes dans des conditions normales de marché. Trois méthodes sont appliquées selon la profondeur du marché secondaire de chaque artiste.",
      "groups": {
        "aTitle": "GROUPE A — CUP DIRECTE (Comparable Uncontrolled Price)",
        "a1": "Applicable lorsque l’artiste dispose d’un marché secondaire documenté avec des résultats récents (moins de 5 ans).",
        "a2": "Principe : la valeur est calculée à partir des ventes aux enchères publiques de l’artiste lui-même.",
        "a3": "Source : résultats Artprice, pondérés selon leur ancienneté.",
        "a4": "Fiabilité : élevée lorsque le volume est suffisant.",
        "bTitle": "GROUPE B — CUP PAR ANALOGIE",
        "b1": "Applicable lorsque le marché secondaire de l’artiste est insuffisant ou trop ancien.",
        "b2": "Principe : comparaison avec des artistes de profil similaire.",
        "b3": "Source : ventes d’artistes analogues sélectionnés par l’expert, avec décote prudentielle si nécessaire.",
        "b4": "Fiabilité : modérée, la sélection des analogues relevant du jugement expert.",
        "cTitle": "GROUPE C — MÉTHODE PAR POINTS (marché primaire)",
        "c1": "Applicable lorsque l’artiste ne dispose pas d’un marché secondaire constitué.",
        "c2": "Principe : grille multicritères selon les dimensions et le médium.",
        "c3": "Complément : reconnaissance institutionnelle, expositions, publications et présence en galerie.",
        "c4": "Fiabilité : indicative, reflétant le marché primaire."
      },
      "adjustmentsTitle": "GRILLE D’AJUSTEMENT (applicable à toutes les méthodes)",
      "adjustmentHeaders": {
        "criterion": "Critère",
        "impact": "Impact",
        "description": "Description"
      },
      "adjustments": {
        "excellent": "Excellent / Très bon / Bon",
        "none": "Aucun abattement",
        "fair": "Moyen",
        "fairDesc": "Usures ou rayures non structurelles",
        "veryPoor": "Très moyen",
        "veryPoorDesc": "Dégradation notable, restauration conseillée",
        "restorable": "Très abîmé restaurable",
        "restorableDesc": "Restauration obligatoire",
        "irreparable": "Irréparable",
        "zero": "Valeur 0",
        "totalLoss": "Dépréciation totale",
        "certificate": "Certificat d’authenticité",
        "artistProvenance": "Provenance directe artiste",
        "documentBonus": "Bonification documentaire"
      },
      "fairValueDisclaimer": "Les estimations constituent une juste valeur à date. Elles ne garantissent pas un prix de cession.",
      "confidentialShort": "QUANG & CO — Confidentiel.",
      "present": "Présent",
      "absent": "Absent",
      "writeoffSummary": "{{count}} œuvre | Valeur retenue : 0 EUR",
      "writeoffSummary_plural": "{{count}} œuvres | Valeur retenue : 0 EUR",
      "writeoffIntro": "Ces œuvres ont fait l’objet d’un examen de conservation concluant à un dommage irréparable. Leur valeur marchande actuelle est retenue à 0 EUR. La valeur théorique hors sinistre est indiquée à titre informatif uniquement et ne peut être mobilisée sans restauration certifiée.",
      "irreparable": "Irréparable",
      "theoreticalDisclaimer": "La valeur théorique hors sinistre est estimée sur la base du marché au moment de l’expertise et ne constitue pas une valeur d’assurance. QUANG & CO — Confidentiel.",
      "zeroValueCount": "{{count}} œuvre — valeur 0",
      "zeroValueCount_plural": "{{count}} œuvres — valeur 0",
      "event": "Événement",
      "coverDescription": "Valorisation d'une collection d'œuvres d'art",
      "analogues": "Analogues : {{names}}",
      "lossTypes": {
        "vol": "Vol",
        "loss": "Perte",
        "destruction": "Destruction",
        "fire": "Incendie",
        "flood": "Inondation",
        "other": "Autre événement"
      }
    },
    "narrative": {
      "method": "Méthode retenue : {{method}}.",
      "pointsRange": "Valeur estimée par points (segment {{segment}}) : {{low}} - {{high}}.",
      "retainedRange": "Fourchette retenue : {{low}} - {{high}}.",
      "retainedValue": "Valeur vénale retenue : {{value}}.",
      "groupC": "Groupe C — marché primaire encadré. Aucune vente aux enchères retenue.",
      "referenceRange": "Fourchette de référence : {{low}} - {{high}} par œuvre.",
      "directSales": "Ventes directes de l’artiste retenues : {{count}} résultat(s) aux enchères.",
      "selectedSales": "Ventes retenues : {{direct}} directe(s), {{extrapolations}} extrapolation(s), {{analogies}} analogie(s).",
      "references": "Références retenues par l’expert :",
      "row": "{{index}}. {{kind}} : {{artist}}, « {{title}} », {{source}}, retenue à {{price}}{{weight}}.",
      "weight": ", poids {{weight}}",
      "pendingSales": "Ventes de l’artiste : en cours d’enregistrement dans la mémoire expert.",
      "kinds": {
        "direct": "vente directe",
        "extrapolation": "extrapolation",
        "analogy": "analogie"
      },
      "artistMissing": "Artiste non renseigné",
      "sourceMissing": "source non renseignée",
      "priceMissing": "prix non renseigné"
    }
  },
  "suiviIAPage": {
    "backToArtwork": "Retour à l’œuvre"
  },
  "exportDossiers": {
    "loading": "Chargement…",
    "authRequired": {
      "title": "Connexion requise",
      "text": "Connectez-vous pour générer vos dossiers professionnels.",
      "login": "Se connecter"
    },
    "title": "Générer un dossier professionnel",
    "subtitle": "Créez des dossiers PDF de qualité musée pour vos œuvres.",
    "defaults": {
      "collector": "Collectionneur",
      "collectionName": "Ma Collection",
      "collectionType": "Art contemporain",
      "collectionFocus": "Collection privée",
      "collectionHistory": "Collection constituée avec passion.",
      "themeContemporary": "Art contemporain",
      "themePainting": "Peinture",
      "themeSculpture": "Sculpture"
    },
    "formats": {
      "donation": {
        "title": "Dossier Donation",
        "pages": "20 à 30 pages",
        "description": "Don définitif à un musée"
      },
      "loan": {
        "title": "Dossier Prêt",
        "pages": "12 à 15 pages",
        "description": "Prêt temporaire pour exposition"
      },
      "book": {
        "title": "Book Collection",
        "pages": "40 à 60 pages",
        "description": "Format prestige et catalogue"
      }
    },
    "descriptions": {
      "donation": {
        "title": "Dossier de Donation",
        "text": "Pour proposer un don définitif à un musée. Inclut l’historique complet, les conditions fiscales et le calendrier de donation.",
        "features": {
          "history": "Historique de la collection",
          "tax": "Conditions fiscales",
          "schedule": "Calendrier proposé",
          "appendices": "Annexes documentaires"
        }
      },
      "loan": {
        "title": "Dossier de Prêt",
        "text": "Format condensé pour un prêt temporaire ou une exposition. Accent sur l’assurance, le transport et les conditions de conservation.",
        "features": {
          "insurance": "Conditions d’assurance",
          "transport": "Transport spécialisé",
          "conservation": "Conservation détaillée",
          "facility": "Facility report"
        }
      },
      "book": {
        "title": "Book de Collection",
        "text": "Format prestige pour une exposition personnelle, un catalogue ou un livre d’art. Inclut un essai critique optionnel et une organisation flexible.",
        "features": {
          "essay": "Essai critique",
          "organisation": "4 modes d’organisation",
          "index": "Index détaillé",
          "colophon": "Colophon professionnel"
        }
      }
    },
    "actions": {
      "selectAll": "Tout sélectionner",
      "deselectAll": "✓ Tout désélectionner"
    },
    "selection": {
      "count": "{{selected}} / {{total}} œuvres sélectionnées"
    },
    "artworks": {
      "loading": "Chargement de vos œuvres…",
      "empty": "Aucune œuvre dans votre collection",
      "add": "Ajouter des œuvres",
      "fallbackArtwork": "Œuvre",
      "noImage": "Pas d’image",
      "unknownArtist": "Artiste inconnu",
      "untitled": "Sans titre",
      "mediumUnknown": "Médium non spécifié"
    }
  },
  "resetPasswordPage": {
    "errors": {
      "send": "Erreur lors de l’envoi de l’email"
    },
    "success": {
      "title": "Email envoyé ✅",
      "messageBefore": "Un lien de réinitialisation a été envoyé à",
      "messageAfter": "Pensez à vérifier vos courriers indésirables si vous ne le voyez pas.",
      "portalNote": "Family Office, expert et partenaire utilisent le même portail de connexion."
    },
    "actions": {
      "backToLogin": "Retour à la connexion",
      "explorePlatform": "Explorer la plateforme",
      "explore": "Explorer",
      "exploreFirst": "Je veux d’abord explorer la plateforme"
    },
    "imageAlt": "Arrière-plan Artkiv",
    "hero": {
      "line1": "Mot de passe oublié ? Cela arrive.",
      "line2": "Nous vous envoyons un lien sécurisé pour repartir."
    },
    "mobileIntro": "Nous vous envoyons un lien de réinitialisation.",
    "form": {
      "title": "Réinitialiser le mot de passe",
      "descriptionLine1": "Saisissez votre adresse email pour recevoir un lien sécurisé.",
      "descriptionLine2": "Aucun changement n’est effectué sans utiliser ce lien.",
      "emailLabel": "Email",
      "emailPlaceholder": "votre@email.com",
      "emailHint": "Utilisez l’adresse email associée à votre compte Artkiv, qu’il soit client, expert, Family Office ou partenaire.",
      "sending": "Envoi en cours…",
      "submit": "Envoyer le lien"
    },
    "footerHelp": "Vous ne recevez rien ? Vérifiez vos courriers indésirables, puis réessayez."
  },
  "ficheDetailPage": {
    "backToGuides": "Retour aux fiches pratiques",
    "notFoundTitle": "Fiche non trouvée",
    "steps": "Étapes à suivre",
    "usefulLinks": "Liens utiles",
    "otherGuides": "Autres fiches utiles",
    "comingSoon": "bientôt disponible"
  },
  "authRedirect": {
    "redirecting": "Redirection…"
  },
  "paymentSuccessPage": {
    "serverError": "Erreur serveur"
  },
  "artBaselService": {
    "countries": {
      "us": "États-Unis",
      "uk": "Royaume-Uni",
      "china": "Chine",
      "france": "France"
    },
    "sectors": {
      "postWarContemporary": "Après-guerre et contemporain",
      "modernArt": "Art moderne",
      "impressionist": "Impressionnisme",
      "oldMasters": "Maîtres anciens"
    },
    "sectorInsights": {
      "postWarContemporary": "Baisse de la valeur, mais hausse du volume et démocratisation du marché.",
      "modernArt": "Opportunités sur le segment intermédiaire, avec une activité plus faible sur le très haut de gamme.",
      "impressionist": "Offre plus rare et augmentation du nombre de transactions.",
      "oldMasters": "Niveau le plus bas depuis quinze ans et peu de lots au-dessus de 10 M$."
    },
    "priceInsights": {
      "under50k": "Seul segment en croissance en valeur.",
      "between50k1m": "Le marché intermédiaire reste sous pression.",
      "over1m": "Forte contraction du segment premium.",
      "over10m": "Baisse marquée du nombre de lots exceptionnels."
    },
    "adminRecommendations": {
      "accessible": "Privilégier le segment inférieur à 50 000 $ pour les nouveaux collectionneurs.",
      "midMarket": "Signaler les opportunités du marché intermédiaire, entre 50 000 $ et 1 M$, avec un potentiel de décote.",
      "premiumCaution": "Rester prudent sur les estimations supérieures à 1 M$, le marché étant très sélectif.",
      "accessibleContemporary": "Favoriser l’art contemporain accessible plutôt que le très haut de gamme établi.",
      "democratization": "Intégrer un facteur de démocratisation dans le score de compatibilité."
    },
    "profile": {
      "emergingWorks": "Œuvres émergentes recommandées",
      "diversification": "Diversification suggérée"
    },
    "market": {
      "trendContemporary": "Tendance de l’art contemporain en 2025",
      "digitalGrowth": "Marché numérique en croissance",
      "investmentRecommended": "Investissement recommandé"
    },
    "matching": {
      "styleCompatibility": "Compatibilité stylistique",
      "budgetAligned": "Budget aligné",
      "suggestion1": "Suggestion 1",
      "suggestion2": "Suggestion 2"
    },
    "context": {
      "internationalFairs": "Présence dans les foires internationales",
      "establishedGallery": "Représentation par une galerie établie",
      "collectorInterest": "Intérêt croissant des collectionneurs",
      "artBaselTrend": "Tendance du marché Art Basel 2025"
    },
    "gallery": {
      "international": "Galerie internationale",
      "artBasel": "Représentation à Art Basel"
    },
    "personalized": {
      "emergingCreative": "Œuvres d’artistes émergents à fort potentiel créatif",
      "classicProvenance": "Pièces classiques avec provenance établie",
      "boldContemporary": "Investissements audacieux dans l’art contemporain",
      "safeValues": "Valeurs sûres du marché artistique",
      "buyBeforeRise": "Opportunité d’acquisition avant la hausse prévue",
      "entryPoint": "Point d’entrée idéal pour commencer votre collection"
    },
    "longTerm": {
      "diversification": "Diversification progressive de la collection",
      "trendMonitoring": "Suivi des tendances Art Basel",
      "sectorExpertise": "Développement de l’expertise sectorielle"
    },
    "marketTiming": {
      "favorable": "Moment favorable pour l’acquisition",
      "observation": "Période d’observation et de sélection"
    },
    "trends": {
      "digitalArtists": "Artistes numériques émergents",
      "sculpturalPractices": "Nouvelles pratiques sculpturales",
      "conceptualArt": "Art conceptuel contemporain"
    },
    "heirFactors": {
      "styleAligned": "Style artistique aligné",
      "historicalInterest": "Période historique d’intérêt",
      "budgetCompatible": "Budget compatible",
      "displaySpace": "Espace d’exposition adapté"
    },
    "heirRecommendations": {
      "recommended": "Œuvre recommandée pour ce profil",
      "appreciation": "Excellent potentiel d’appréciation",
      "tasteAlignment": "Alignement avec les goûts exprimés"
    }
  },
  "conservationReport": {
    "loading": "Chargement…",
    "analyzing": "Analyse IA en cours…",
    "confirmDeleteImage": "Supprimer cette image ?",
    "fields": {
      "lastFullReport": "Dernier rapport complet",
      "lastInspection": "Dernière inspection visuelle",
      "lastTransport": "Dernier transport",
      "riskLevel": "Niveau de risque",
      "nextInspection": "Prochaine inspection",
      "nextFullReport": "Prochain rapport complet",
      "photographedZone": "Zone photographiée",
      "addHdPhotos": "Ajouter des photos HD",
      "recommendation": "Recommandation IA / expert"
    },
    "risks": {
      "low": "Faible",
      "moderate": "Modéré",
      "high": "Élevé"
    },
    "zones": {
      "surface": "Surface",
      "topLeft": "Coin supérieur gauche",
      "topRight": "Coin supérieur droit",
      "bottomLeft": "Coin inférieur gauche",
      "bottomRight": "Coin inférieur droit",
      "reverse": "Verso",
      "frame": "Encadrement",
      "other": "Autre",
      "unknown": "Zone inconnue"
    },
    "images": {
      "previewAlt": "Aperçu {{number}}",
      "existingAlt": "Vue {{number}}",
      "clickToDelete": "Cliquer pour supprimer"
    },
    "actions": {
      "back": "Retour à la fiche",
      "saving": "Sauvegarde…",
      "update": "Mettre à jour",
      "create": "Créer"
    },
    "alerts": {
      "saved": "Rapport sauvegardé avec succès.",
      "saveError": "Erreur lors de la sauvegarde."
    }
  },
  "philanthropyAdvisor": {
    "title": "Philanthropie & mécénat",
    "subtitle": "Assistant de stratégie pour Family Office, appliqué au client actif",
    "noActiveClient": "Aucun client actif n’est sélectionné pour ce Family Office.",
    "regimes": {
      "frFlatTax": "France — Taxe forfaitaire de 6,5 % au-delà de 5 000 € par cession",
      "frCapitalGain": "France — Plus-value à 19 % + 17,2 %, avec abattement de 5 % par an après deux ans",
      "ukCgt": "Royaume-Uni — CGT simplifiée à 20 % (indicatif)",
      "dePrivate": "Allemagne — Exonération indicative après plus d’un an de détention privée",
      "none": "Non sélectionné"
    },
    "levers": {
      "loan": {
        "title": "Prêt d’œuvres à des institutions",
        "detail1": "Dépôt temporaire ou convention de longue durée",
        "detail2Fr": "Frais de conservation, d’assurance ou de restauration potentiellement déductibles, à confirmer",
        "detail2Other": "Frais potentiellement déductibles selon le pays",
        "detail3": "Visibilité et légitimation de la collection"
      },
      "dation": {
        "title": "Dation en paiement en France",
        "detail1": "Règlement des droits de succession en œuvres d’art",
        "detail2": "Évaluation à la valeur de marché, sans taxation de la plus-value dans ce cadre",
        "detail3": "Acceptation réservée aux œuvres exceptionnelles par les autorités compétentes"
      },
      "foundation": {
        "title": "Fondation d’entreprise ou fondation abritée",
        "detail1": "Structure pérenne pour gérer la collection",
        "detail2": "Déduction fiscale des apports selon la juridiction",
        "detail3": "Organisation d’expositions et de prêts aux musées"
      },
      "usufruct": {
        "title": "Don avec usufruit ou nue-propriété en France",
        "detail1": "Conservation de la jouissance de l’œuvre",
        "detail2": "Réduction fiscale immédiate calculée sur la valeur de la nue-propriété",
        "detail3": "Transmission progressive pouvant limiter la fiscalité successorale"
      }
    },
    "alerts": {
      "createdNotStored": "Plan créé, mais non historisé car la table est indisponible.",
      "createdStored": "Plan créé et historisé.",
      "pdfError": "Impossible de générer le PDF."
    },
    "actions": {
      "exportPdfTitle": "Exporter le plan en PDF",
      "exportPdfShort": "Export PDF",
      "exportPdf": "Exporter le PDF",
      "saving": "Enregistrement…",
      "createPlan": "Créer le plan"
    },
    "clientCard": {
      "client": "Client",
      "taxRegime": "Régime fiscal",
      "taxCountry": "Pays fiscal : {{country}}"
    },
    "plan": {
      "title": "Plan de mécénat — Synthèse",
      "estimatedBenefit": "Gain fiscal estimé, à titre indicatif"
    },
    "eligibility": {
      "eligible": "Éligible",
      "notApplicable": "Non applicable"
    },
    "beyondTax": {
      "title": "Intérêts au-delà de la fiscalité",
      "legitimacy": {
        "title": "Légitimation & expertise",
        "point1": "Collaborations avec des conservateurs et des experts",
        "point2": "Documentation académique et provenance renforcée"
      },
      "network": {
        "title": "Accès & réseau",
        "point1": "Invitations privées et comités d’acquisition",
        "point2": "Réseau de directeurs, commissaires et collectionneurs"
      },
      "value": {
        "title": "Valorisation patrimoniale",
        "point1": "La visibilité publique peut soutenir la valeur lors d’une revente",
        "point2": "Catalogues et historique d’exposition"
      },
      "transmission": {
        "title": "Transmission & protection",
        "point1": "Clarté des droits et assurance renforcée",
        "point2": "Traçabilité et documentation AML/KYC"
      }
    },
    "note": {
      "label": "Note du Family Office",
      "placeholder": "Points d’attention, partenaires pressentis, institutions cibles…"
    },
    "disclaimer": {
      "title": "Avertissement.",
      "text": "Estimations indicatives fondées sur les informations disponibles dans Artkiv. Vérifiez les règles applicables avec un conseil fiscal ou un avocat. Les politiques et seuils varient selon la juridiction."
    }
  },
  "expertNews": {
    "empty": "Aucune collection partagée détectée",
    "artistCount": "{{count}} artistes présents dans les collections de vos clients",
    "more": "{{count}} artistes supplémentaires"
  },
  "notFound": {
    "title": "Page introuvable",
    "message": "La ressource demandée n’existe pas ou n’est pas accessible."
  },
  "blockchainShowcase": {
    "current": {
      "title": "Empreinte numérique ARTKIV",
      "subtitle": "Une preuve d’intégrité des données enregistrées sur une fiche œuvre.",
      "available": "Disponible",
      "coming": "À venir",
      "fingerprint": {
        "title": "Empreinte SHA-256",
        "description": "ARTKIV crée un hash unique à partir d’un snapshot des informations de l’œuvre."
      },
      "timestamp": {
        "title": "Horodatage",
        "description": "La date de création de l’empreinte est conservée avec le snapshot."
      },
      "verify": {
        "title": "Vérification d’intégrité",
        "description": "Une empreinte identique confirme que les données correspondent à l’enregistrement ARTKIV."
      },
      "tezos": {
        "title": "Ancrage public Tezos",
        "description": "Étape future : publier uniquement le hash sur Tezos, sans exposer les données privées de l’œuvre."
      },
      "scope": {
        "title": "Ce que cela prouve",
        "text": "L’empreinte documente l’intégrité d’un état de données. Elle ne détermine pas l’authenticité artistique d’une œuvre."
      },
      "privacy": {
        "title": "Données privées",
        "text": "Les informations de l’œuvre restent dans ARTKIV. Un futur ancrage public ne porterait que sur le hash."
      }
    },
    "title": "Blockchain & sécurité",
    "subtitle": "Protégez et tracez vos œuvres d’art avec la technologie blockchain",
    "partnership": {
      "technology": "Technologie blockchain",
      "europe": "Europe"
    },
    "roles": {
      "standard": "Standard",
      "premium": "Premium",
      "artAdvisor": "Art Advisor",
      "artAdvisorPremium": "Art Advisor Premium",
      "familyOffice": "Family Office"
    },
    "features": {
      "certificate": {
        "title": "Certificat blockchain",
        "description": "Chaque œuvre reçoit un certificat blockchain unique et infalsifiable, reconnu internationalement."
      },
      "history": {
        "title": "Historique traçable infalsifiable",
        "description": "Les mouvements et transactions pourront être enregistrés de façon permanente et transparente. Fonction bientôt disponible."
      },
      "smartContracts": {
        "title": "Smart contracts de prêt et de location",
        "description": "Automatisez les contrats de prêt et de location avec la sécurité de la blockchain."
      },
      "explorer": {
        "title": "Export vers l’explorateur blockchain",
        "description": "Exportez et consultez vos données directement dans l’explorateur blockchain."
      },
      "auditTrail": {
        "title": "Piste d’audit complète",
        "description": "Piste d’audit de toutes les modifications et de tous les accès aux collections. Fonction bientôt disponible."
      },
      "kyc": {
        "title": "Conformité AML-KYC automatisée",
        "description": "Vérification automatisée de la conformité pour les transactions importantes. Fonction bientôt disponible."
      }
    },
    "status": {
      "available": "Disponible",
      "viewOnly": "Consultation uniquement",
      "upgrade": "Passer au forfait supérieur"
    },
    "info": {
      "why": {
        "title": "Pourquoi Tezos ?",
        "text": "Tezos est une blockchain de nouvelle génération utilisée par des acteurs du marché de l’art européen. Son mécanisme de consensus limite fortement la consommation énergétique et les coûts de transaction. Elle permet d’enregistrer des preuves d’authenticité et de traçabilité avec une empreinte environnementale réduite."
      },
      "security": {
        "title": "Sécurité & souveraineté européenne",
        "text": "Artkiv s’appuie sur une infrastructure européenne afin de soutenir la conformité RGPD et la maîtrise des données. Les certificats sont horodatés et vérifiables, tandis que les informations sensibles restent dans la base sécurisée d’Artkiv. Seule la preuve d’authenticité est inscrite sur la blockchain."
      },
      "how": {
        "title": "Comment cela fonctionne-t-il ?",
        "text": "Lorsqu’une œuvre est certifiée, Artkiv crée une empreinte numérique unique, ou hash SHA-256, de son certificat. Cette empreinte est inscrite de manière permanente sur la blockchain Tezos. Elle permet de vérifier l’authenticité du certificat sans révéler les informations confidentielles concernant l’œuvre ou son propriétaire."
      }
    },
    "upgrade": {
      "title": "Débloquez toutes les fonctionnalités blockchain",
      "text": "Passez à Family Office pour accéder à l’ensemble des outils de sécurité blockchain.",
      "button": "Découvrir Family Office"
    }
  },
  "blockchainDemo": {
    "selectorLabel": "Découvrez les fonctionnalités blockchain disponibles selon votre plan :",
    "monthlyPrice": "{{price}} / mois",
    "roles": {
      "standard": "Standard",
      "premium": "Premium",
      "artAdvisor": "Art Advisor",
      "artAdvisorPremium": "Art Advisor Premium",
      "familyOffice": "Family Office"
    },
    "footer": {
      "title": "Prêt à sécuriser votre collection avec la blockchain ?",
      "text": "Rejoignez les collectionneurs et Art Advisors qui utilisent Artkiv pour protéger et valoriser leurs œuvres grâce à une certification blockchain européenne.",
      "startTrial": "Commencer l’essai gratuit",
      "scheduleDemo": "Planifier une démonstration"
    }
  },
  "validationRequests": {
    "loading": "Chargement de vos demandes…",
    "title": "Mes demandes de validation",
    "count": "{{count}} demandes",
    "empty": "Vous n’avez pas encore de demande de validation.",
    "createEstimation": "Créer une estimation",
    "status": {
      "pending": "En attente",
      "inProgress": "En cours",
      "completed": "Validée",
      "rejected": "Rejetée"
    },
    "requestedOn": "Demandée le",
    "method": {
      "label": "Méthode",
      "points": "Par points",
      "comparables": "Comparables"
    },
    "cost": "Coût",
    "free": "Gratuit",
    "expertNotes": "Notes de l’expert",
    "rejectionReason": "Motif du rejet",
    "downloadReport": "Télécharger le rapport",
    "processingDelay": "Votre demande est en cours de traitement. Délai estimé : 48 à 72 heures ouvrées."
  },
  "artistAuctions": {
    "dateUnavailable": "Date non disponible",
    "emptyArtists": {
      "title": "Aucun artiste dans votre collection ou votre liste de suivi",
      "text": "Ajoutez des œuvres ou suivez des artistes pour afficher les ventes qui les concernent."
    },
    "followingCount": "{{count}} artistes suivis",
    "noUpcoming": "Aucune vente à venir concernant vos artistes ce mois-ci.",
    "title": "Ventes concernant vos artistes",
    "summary": "{{artists}} artistes suivis · {{auctions}} ventes à venir",
    "collectionArtists": "Artistes de votre collection"
  },
  "artworkAccessHistory": {
    "title": "Historique des consultations et modifications de la fiche œuvre par votre expert",
    "tabs": {
      "all": "Tout",
      "views": "Consultations",
      "edits": "Modifications"
    },
    "error": "Erreur : {{message}}",
    "empty": "Aucun événement dans cet onglet.",
    "actions": {
      "edit": "Modification",
      "view": "Consultation"
    },
    "user": "Utilisateur",
    "note": "Note : {{note}}",
    "source": "Source : {{source}}"
  },
  "successionEstimation": {
    "title": "Planification successorale",
    "subtitle": "Simulez l’impact fiscal d’une transmission patrimoniale et anticipez les stratégies d’optimisation. Cet outil aide le Family Office et le notaire à préparer la succession conformément à l’article 764 du Code général des impôts.",
    "reportTitle": "Simulation de planification successorale",
    "common": {
      "toDetermine": "À déterminer"
    },
    "methods": {
      "publicAuction": "Vente aux enchères publique, article 764 du CGI",
      "insuranceUnder10Years": "Contrat d’assurance de moins de dix ans, article 764 du CGI",
      "furnitureFlatRate": "Forfait des meubles meublants à 5 % de la succession, article 764 du CGI",
      "marketValue": "Valeur vénale au jour du décès, selon l’estimation d’un expert"
    },
    "alerts": {
      "selectArtwork": "Veuillez sélectionner une œuvre.",
      "notConnected": "Utilisateur non connecté.",
      "reportError": "Erreur lors de la génération du rapport.",
      "saveError": "Erreur lors de l’enregistrement.",
      "success": "Simulation enregistrée et rapport généré avec succès."
    },
    "artworkSection": {
      "title": "Œuvre concernée",
      "selectLabel": "Sélectionnez l’œuvre à analyser",
      "selectPlaceholder": "Choisir une œuvre",
      "artist": "Artiste",
      "medium": "Technique",
      "currentValue": "Valeur estimée actuelle",
      "lastEstimation": "Date de la dernière estimation"
    },
    "parameters": {
      "title": "Paramètres de simulation",
      "noteTitle": "Note :",
      "noteText": "La date de simulation est fixée par défaut au 31 décembre de l’année précédente afin de faciliter les calculs prospectifs sans implication personnelle.",
      "simulationDate": "Date de simulation",
      "artworkStatus": "Statut de l’œuvre",
      "furnitureHelp": "Un tableau accroché dans un logement peut être qualifié de meuble meublant et relever du forfait de 5 %.",
      "totalEstateValue": "Valeur totale de la succession",
      "totalEstatePlaceholder": "500000",
      "flatRateHelp": "L’œuvre sera évaluée à 5 % de cette valeur totale selon la méthode forfaitaire."
    },
    "status": {
      "identifiedCollection": "Collection identifiée",
      "furniture": "Meuble meublant, décoration"
    },
    "valuationMethods": {
      "title": "Méthodes d’évaluation fiscale, article 764 du CGI",
      "auction": "Vente aux enchères publique dans les cinq ans",
      "hammerPrice": "Prix d’adjudication",
      "hammerPricePlaceholder": "25000",
      "saleDate": "Date de la vente",
      "insurance": "Contrat d’assurance de moins de dix ans",
      "insuredValue": "Valeur assurée",
      "insuredValuePlaceholder": "30000",
      "contractDate": "Date du contrat",
      "expert": "Expert consulté, facultatif",
      "expertPlaceholder": "Nom du commissaire-priseur ou de l’expert"
    },
    "notes": {
      "label": "Notes particulières",
      "placeholder": "Contexte, provenance, particularités…"
    },
    "results": {
      "title": "Résultats de la simulation",
      "fiscalValue": "Valeur fiscale estimée",
      "inheritanceTax": "Droits de succession",
      "averageRate": "Estimation moyenne à 25 %",
      "dation": "Dation en paiement",
      "recommended": "Recommandée",
      "notNecessary": "Non nécessaire",
      "aboveThreshold": "Valeur supérieure à 150 000 €",
      "belowThreshold": "Valeur inférieure à 150 000 €",
      "method": "Méthode d’évaluation retenue",
      "dationRecommendation": "Recommandation : la valeur élevée de cette œuvre justifie l’étude d’une dation en paiement, sous réserve de l’agrément ministériel et de l’analyse des professionnels compétents."
    },
    "actions": {
      "back": "Retour aux estimations",
      "saveAndGenerate": "Enregistrer la simulation et générer le rapport"
    },
    "legal": {
      "title": "Avertissement :",
      "text": "Ce document constitue une simulation indicative de planification patrimoniale. Il ne remplace pas une consultation juridique et fiscale approfondie auprès d’un notaire, d’un avocat fiscaliste ou d’un commissaire-priseur. Les barèmes, abattements et règles applicables peuvent évoluer."
    },
    "pdf": {
      "title": "SIMULATION DE PLANIFICATION SUCCESSORALE",
      "confidential": "Rapport confidentiel — Document de travail",
      "generatedOn": "Généré le : {{date}}",
      "sections": {
        "artwork": "1. ŒUVRE CONCERNÉE",
        "assumptions": "2. HYPOTHÈSES DE SIMULATION",
        "fiscalValuation": "3. ÉVALUATION FISCALE, ARTICLE 764 DU CGI",
        "inheritanceTax": "4. ESTIMATION DES DROITS DE SUCCESSION",
        "recommendations": "5. RECOMMANDATIONS"
      },
      "fields": {
        "title": "Titre : {{value}}",
        "artist": "Artiste : {{value}}",
        "medium": "Technique : {{value}}",
        "dimensions": "Dimensions : {{value}}",
        "simulationDate": "Date de simulation : {{date}}",
        "artworkStatus": "Statut de l’œuvre : {{value}}",
        "method": "Méthode retenue : {{value}}",
        "fiscalValue": "Valeur fiscale estimée : {{value}}",
        "estimatedTax": "Droits estimés, selon un taux moyen : {{value}}"
      },
      "taxNoteLine1": "Le montant réel dépend du lien de parenté, des abattements applicables et",
      "taxNoteLine2": "du barème progressif en vigueur au moment de la succession.",
      "dation": {
        "title": "Dation en paiement recommandée",
        "line1": "La valeur de l’œuvre justifie l’étude d’une dation en paiement des droits.",
        "line2": "Cette procédure permet, sous conditions, de remettre l’œuvre à l’État en règlement",
        "line3": "des droits de succession, après agrément des autorités compétentes."
      },
      "recommendations": {
        "expertise": "• Faire expertiser l’œuvre par un commissaire-priseur ou un expert agréé",
        "documents": "• Constituer un dossier complet : provenance, certificats et état de conservation",
        "donation": "• Étudier une donation du vivant avec réserve d’usufruit",
        "notary": "• Consulter un notaire spécialisé en droit de l’art"
      },
      "disclaimerLine1": "Cette simulation est fournie à titre indicatif et ne peut se substituer",
      "disclaimerLine2": "à une consultation juridique et fiscale approfondie auprès de professionnels.",
      "footer": "Document confidentiel — Usage strictement interne",
      "page": "Page {{current}}/{{total}}"
    }
  },
  "round36": {
    "actualitesModule": {
      "dateUnavailable": "Date non disponible",
      "exhibitions": {
        "emptyDescription": "Les expositions concernant vos artistes apparaîtront ici.",
        "emptyTitle": "Aucune exposition à venir",
        "loadError": "Impossible de charger les expositions.",
        "technicalError": "Erreur technique lors du chargement des expositions."
      },
      "saleFallback": "Vente",
      "view": "Voir"
    },
    "artistMarketRatio": {
      "actions": {
        "addToEstimation": "Ajouter à l’estimation",
        "calculating": "Calcul…",
        "loadSales": "Charger les ventes",
        "saveRatio": "Enregistrer le ratio"
      },
      "description": "Pour les cas pauvres en comparables directs : choisissez un artiste pivot parmi les analogues validés, puis deux paniers de ventes comparables.",
      "enoughData": "Échantillons suffisants pour calculer le ratio.",
      "errors": {
        "selectArtists": "Choisissez un artiste pivot et un artiste cible avant de charger les ventes.",
        "supabase": "Erreur lors du chargement des données de marché."
      },
      "extrapolationComment": "Extrapolation ARTKIV : {{price}} × ratio {{ratio}} × prudence {{caution}}. ID du ratio : {{ratioId}}.",
      "fields": {
        "analogSource": "Analogues proposés à partir de la fiche de cote artiste.",
        "caution": "Coefficient de prudence",
        "chooseValidatedAnalog": "Choisir un analogue validé",
        "format": "Format",
        "mediumBucket": "Famille de médium",
        "noAnalogPlaceholder": "Aucun analogue validé",
        "otherArtist": "Autre artiste…",
        "periodEnd": "Fin de période",
        "periodStart": "Début de période",
        "pivotArtist": "Artiste pivot",
        "pivotPlaceholder": "Nom de l’artiste pivot",
        "referencePlaceholder": "Prix de la vente de référence",
        "referenceSale": "Prix de référence pivot",
        "targetArtist": "Artiste cible"
      },
      "match": "correspondance {{score}}/100",
      "medium": {
        "other": "Autre",
        "painting": "Peinture",
        "print": "Estampe / édition",
        "sculptureObject": "Sculpture / objet",
        "workOnPaper": "Œuvre sur papier"
      },
      "notEnoughData": "Sélectionnez au moins deux ventes dans chaque panier.",
      "notSaved": "non enregistré",
      "pendingEstimation": "Calculez le ratio pour obtenir une valeur extrapolée.",
      "pivotMedian": "Médiane pivot : {{value}}",
      "ratioCaution": "Ratio marché : {{ratio}} · prudence : {{caution}}",
      "result": "Valeur extrapolée",
      "savedComment": "Ratio généré depuis {{pivot}} ventes pivot et {{target}} ventes cible. Invendus exclus.",
      "size": {
        "all": "Tous formats",
        "large": "Grand format",
        "medium": "Format moyen",
        "small": "Petit format"
      },
      "targetMedian": "Médiane cible : {{value}}",
      "title": "Extrapolation par ratio d’artiste",
      "unknownDate": "date inconnue",
      "unknownDimensions": "dimensions inconnues",
      "unknownHouse": "Maison non renseignée",
      "unknownMedium": "technique inconnue",
      "untitled": "Sans titre"
    },
    "clientManagement": {
      "actions": {
        "cancel": "Annuler",
        "corporateReports": "Rapports corporate",
        "report": "Rapport",
        "requestAccess": "Demander l’accès à un client",
        "view": "Voir"
      },
      "cards": {
        "activeClients": "Clients actifs",
        "notYetOnArtkiv": "dont {{count}} pas encore sur Artkiv",
        "pending": "En attente",
        "trackedArtworks": "Œuvres suivies"
      },
      "columns": {
        "actions": "Actions",
        "artworks": "Œuvres",
        "client": "Client",
        "collections": "Collections",
        "status": "Statut",
        "type": "Type"
      },
      "confirm": {
        "cancelRequest": "Annuler cette demande ?"
      },
      "description": "Gérez vos demandes d’accès et suivez vos clients.",
      "duplicate": {
        "accepted": "Vous avez déjà accès à ce client.",
        "pending": "Une demande est déjà en attente pour ce client."
      },
      "empty": "Aucune demande envoyée.",
      "errors": {
        "cancel": "Erreur lors de l’annulation",
        "invalidEmail": "Email invalide",
        "send": "Erreur lors de l’envoi",
        "updateClientType": "Erreur lors de la mise à jour du type client"
      },
      "form": {
        "clientType": "Type de client *",
        "corporateDescription": "Entreprise, fondation, hôtel ou cabinet, avec rapport d’audit",
        "description": "Si le client est déjà sur Artkiv, il recevra une notification immédiate. Sinon, il sera notifié lorsqu’il créera son compte.",
        "email": "Email du client *",
        "emailPlaceholder": "client@exemple.com",
        "message": "Message (optionnel)",
        "messagePlaceholder": "Bonjour, j’aimerais accéder à vos collections…",
        "privateDescription": "Collectionneur privé, accès à sa collection",
        "send": "Envoyer la demande",
        "sending": "Envoi…",
        "title": "Demander l’accès à un client"
      },
      "health": {
        "noPhoto": "{{count}} sans photo",
        "noValue": "{{count}} sans valeur"
      },
      "loading": "Chargement…",
      "notOnArtkiv": "Pas encore sur Artkiv",
      "note": {
        "add": "Ajouter une note",
        "editTitle": "Cliquer pour modifier",
        "placeholder": "Note sur ce client…",
        "saveError": "Erreur lors de l’enregistrement",
        "saved": "Note enregistrée"
      },
      "sections": {
        "corporate": "Clients Corporate",
        "counts": "{{active}} actif(s) · {{pending}} en attente",
        "none": "Aucun client {{type}}.",
        "private": "Clients particuliers"
      },
      "status": {
        "accepted": "Accepté",
        "cancelled": "Annulé",
        "declined": "Refusé",
        "expired": "Expiré",
        "pending": "En attente"
      },
      "success": {
        "cancelled": "Demande annulée",
        "sentFuture": "Demande envoyée à {{email}}. Le client sera notifié lorsqu’il rejoindra Artkiv.",
        "sentKnown": "Demande envoyée à {{name}}."
      },
      "title": "Mes clients",
      "types": {
        "corporate": "Corporate",
        "corporateLower": "corporate",
        "private": "Particulier",
        "privateLower": "particulier"
      }
    },
    "collectionBreakdown": {
      "allCollections": "Toutes les collections",
      "artworkCount": "{{count}} œuvre(s)",
      "byArtworkCount": "Répartition par nombre d’œuvres",
      "charts": {
        "medium": "Répartition par médium",
        "period": "Répartition par période",
        "top10Artists": "Top 10 des artistes",
        "top5Artists": "Top 5 des artistes",
        "type": "Répartition par type d’art",
        "valueByCollection": "Valeur par collection",
        "valueByLocation": "Valeur par emplacement",
        "valueByMedium": "Valeur par médium"
      },
      "collectionLabel": "Collection",
      "loadError": "Erreur lors du chargement des œuvres.",
      "loading": "Chargement des analyses…",
      "modeAria": "Choisir le mode de répartition",
      "modes": {
        "collections": "Collections",
        "locations": "Emplacements"
      },
      "noArtworkAvailable": "Aucune œuvre disponible.",
      "noArtworkSelection": "Aucune œuvre pour cette sélection.",
      "numberOfArtworks": "Nombre d’œuvres",
      "periodUnknownNote": "{{count}} œuvre(s) sans année de création renseignée (non affichées ci-dessus).",
      "periodUnknownLotNote": "Dont {{count}} en lot : renseignez l’année du lot pour les dater.",
      "summary": "{{count}} œuvre(s) · valeur totale {{value}}",
      "totalValue": "Valeur totale",
      "unclassified": "À classer",
      "unknownArtist": "Artiste inconnu",
      "unlocated": "Non localisé",
      "untitled": "Sans titre"
    },
    "collectionDetail": {
      "actions": {
        "delete": "Supprimer",
        "edit": "Modifier",
        "editTitle": "Modifier la collection",
        "expert": "Expert",
        "expertise": "Demander une expertise",
        "exportComplete": "Export complet (ZIP + images)",
        "lot": "Créer un lot",
        "ocr": "Enrichir par OCR",
        "present": "Partager une présentation",
        "report": "Créer un rapport",
        "share": "Partager"
      },
      "share": {
        "access": "Accès (droits)",
        "presentation": "Présentation"
      },
      "sidebar": {
        "artworks": "Œuvres",
        "exports": "Exports & dossiers",
        "manage": "Gestion",
        "share": "Partage & présentation",
        "viewPresentation": "Voir la présentation"
      },
      "authRequired": {
        "button": "Se connecter",
        "description": "Connectez-vous pour consulter cette collection.",
        "title": "Connexion requise"
      },
      "banners": {
        "deposit": {
          "complete": "Compléter les informations du dépôt",
          "description": "Ces œuvres appartiennent à un tiers et sont exclues de votre patrimoine artistique.",
          "title": "Collection en dépôt"
        },
        "donation": {
          "clarify": "Préciser le statut juridique",
          "description": "Ces œuvres ont été reçues par donation ou legs. Leur statut juridique doit être documenté.",
          "title": "Donation ou legs"
        },
        "foundationDeposit": {
          "complete": "Compléter la convention de dépôt",
          "description": "La fondation conserve ces œuvres pour le compte d’un tiers institutionnel.",
          "title": "Dépôt institutionnel"
        },
        "foundationOwned": {
          "description": "Ces œuvres appartiennent à la fondation et sont incluses dans sa valorisation patrimoniale.",
          "title": "Propriété de la fondation"
        },
        "founderLoan": {
          "complete": "Compléter les informations du prêteur",
          "description": "Ces œuvres sont mises à disposition par le fondateur sans transfert de propriété.",
          "title": "Prêt du fondateur"
        },
        "inalienable": {
          "clarify": "Préciser le régime juridique",
          "description": "La valeur est indicative et les cessions sont soumises au régime juridique applicable.",
          "title": "Collection inaliénable"
        }
      },
      "convention": "Convention : {{value}}",
      "legalStatus": {
        "a_clarifier": "À clarifier",
        "autre": "Autre régime",
        "dation": "Dation en paiement",
        "don_avec_reserve_usufruit": "Don avec réserve d’usufruit",
        "don_legs_inalienable": "Don / legs avec clause d’inaliénabilité",
        "etat_musees_de_france": "État, Musées de France",
        "fondation_abritee": "Fondation abritée",
        "pret_artiste_vivant": "Prêt d’un artiste vivant",
        "pret_institution": "Prêt d’une institution",
        "tresor_national": "Trésor national classé"
      },
      "lenderLabel": "Prêteur",
      "loading": "Chargement…",
      "loadingCollection": "Chargement de la collection…",
      "loanValidUntil": "Prêt valable jusqu’au {{date}}",
      "notFound": {
        "back": "Retour aux collections",
        "description": "Cette collection n’existe pas ou vous n’y avez pas accès.",
        "title": "Collection introuvable"
      },
      "ownerLabel": "Propriétaire",
      "reference": "Référence : {{value}}",
      "sharedWithYou": "Collection partagée avec vous",
      "stats": {
        "artworks": "Œuvres",
        "estimatedValue": "Valeur estimée"
      },
      "translationUnavailable": "Traduction indisponible",
      "unnamedCollection": "Collection sans titre",
      "validUntil": "Valable jusqu’au {{date}}"
    },
    "collectionEdit": {
      "imagePreviewAlt": "Aperçu de la collection",
      "importCsvXlsx": "Importer un fichier CSV / XLSX",
      "inventoryMissing": "Référence d’inventaire non renseignée",
      "inventoryNumber": "Référence d’inventaire : {{number}}"
    },
    "collectionTypeBadge": {
      "types": {
        "deposit": "Dépôt",
        "foundation_deposit": "Dépôt institution",
        "foundation_donation": "Donation / legs",
        "foundation_founder": "Prêt fondateur",
        "foundation_owned": "Propriété propre",
        "inalienable": "Inaliénable",
        "private": "Privée"
      }
    },
    "collectionTypeSelector": {
      "fields": {
        "conditions": "Conditions particulières (optionnel)",
        "contractEnd": "Fin du contrat",
        "contractReference": "Référence du contrat (optionnel)",
        "contractStart": "Début du contrat",
        "conventionReference": "Référence de la convention (optionnel)",
        "insuredBy": "Assurance prise en charge par",
        "legalReference": "Référence du dossier / numéro de classement (optionnel)",
        "legalStatus": "Statut juridique",
        "ownerName": "Nom du propriétaire",
        "ownerType": "Type de propriétaire",
        "partyEnd": "Fin de mise à disposition",
        "partyName": "Nom du tiers",
        "partyStart": "Début de mise à disposition",
        "partyType": "Type de tiers"
      },
      "hints": {
        "deposit": "Les œuvres en dépôt sont exclues du calcul de votre patrimoine artistique.",
        "foundation": "Ces informations permettent de distinguer les œuvres appartenant à la fondation de celles détenues pour le compte de tiers.",
        "foundationDeposit": "Ces œuvres restent la propriété du tiers indiqué et ne sont pas incluses dans la valeur patrimoniale de la fondation.",
        "foundationDonation": "Documentez les clauses de donation ou de legs afin de sécuriser la gestion et les éventuelles restrictions.",
        "inalienable": "Ces œuvres apparaîtront avec la mention « valeur indicative, non réalisable sur le marché »."
      },
      "insuredBy": {
        "foundation": "La fondation",
        "owner": "Le propriétaire",
        "shared": "Partagé",
        "unspecified": "À préciser"
      },
      "label": "Type de collection",
      "legalStatuses": {
        "a_clarifier": "À clarifier",
        "autre": "Autre régime",
        "dation": "Dation en paiement",
        "don_avec_reserve_usufruit": "Don avec réserve d’usufruit",
        "don_legs_inalienable": "Don / legs avec clause d’inaliénabilité",
        "etat_musees_de_france": "État, Musées de France",
        "fondation_abritee": "Fondation abritée",
        "pret_artiste_vivant": "Prêt d’un artiste vivant",
        "pret_institution": "Prêt d’une institution",
        "tresor_national": "Trésor national classé"
      },
      "ownerTypes": {
        "a_clarifier": "À clarifier",
        "family_succession": "Famille / succession",
        "institution": "Institution (musée, fondation)",
        "private_collector": "Collectionneur privé"
      },
      "panels": {
        "depositTitle": "Informations sur le dépôt",
        "foundationLegalTitle": "Statut juridique de la fondation",
        "founderLender": "Informations sur le prêteur",
        "inalienableTitle": "Précisions sur le régime juridique",
        "realOwner": "Propriétaire réel / déposant"
      },
      "partyTypes": {
        "a_clarifier": "À clarifier",
        "artiste": "Artiste",
        "autre": "Autre",
        "donateur_prive": "Donateur / famille",
        "etat": "État français",
        "fondation": "Autre fondation",
        "institution": "Institution privée",
        "musee": "Musée public"
      },
      "placeholders": {
        "conditions": "Assurance, restrictions, autres clauses…",
        "contractReference": "Ex. : Contrat de prêt du 15/03/2026",
        "conventionReference": "Ex. : Convention n°2026-04",
        "legalReference": "Ex. : Dossier MCC n°2018-345",
        "ownerName": "Nom ou raison sociale",
        "partyName": "Nom de l’État, du musée, de l’institution ou du donateur"
      },
      "types": {
        "deposit": {
          "description": "Œuvres prêtées par un tiers. Hors patrimoine, sous contrat.",
          "title": "Dépôt"
        },
        "foundation_deposit": {
          "description": "Œuvres dont la fondation a la garde. Propriétaire : État, musée ou institution.",
          "title": "Dépôt institution"
        },
        "foundation_donation": {
          "description": "Œuvres reçues par donation ou legs. Peuvent être redistribuées vers des institutions.",
          "title": "Donation / legs"
        },
        "foundation_founder": {
          "description": "Collection personnelle du fondateur mise à disposition de la fondation.",
          "title": "Prêt du fondateur"
        },
        "foundation_owned": {
          "description": "Œuvres acquises par la fondation. Valorisation active, gestion pleine.",
          "title": "Propriété propre"
        },
        "inalienable": {
          "description": "Régime patrimonial protégé. Valorisation indicative, cession soumise à autorisation.",
          "title": "Œuvres inaliénables"
        },
        "private": {
          "description": "Propriété pleine. Gestion libre, valorisation et cession autorisées.",
          "title": "Collection privée"
        }
      }
    },
    "collectionsList": {
      "tabs": {
        "all": "Toutes",
        "own": "Mes collections",
        "shared": "Collections clients"
      },
      "transfer": {
        "button": "Transférer des collections",
        "title": "Transférer mes collections"
      }
    },
    "diagnosticImport": {
      "actions": {
        "analyzing": "Analyse en cours…",
        "fix": "Corriger automatiquement",
        "fixing": "Correction en cours…",
        "run": "Lancer le diagnostic",
        "technicalDetails": "Voir les détails techniques"
      },
      "alerts": {
        "fixError": "Erreur lors de la correction : {{error}}",
        "fixSuccess": "Correction réussie. {{count}} œuvre(s) corrigée(s). Actualisez la page pour voir les œuvres.",
        "selectCollection": "Veuillez d’abord sélectionner une collection."
      },
      "checks": {
        "allArtworks": {
          "found": "{{count}} œuvre(s) trouvée(s) au total",
          "name": "Œuvres sans filtre client_id"
        },
        "clientId": {
          "name": "Analyse client_id",
          "ok": "Tous les client_id correspondent.",
          "problem": "Problème détecté : {{count}} œuvre(s) avec un mauvais client_id."
        },
        "collection": {
          "found": "Collection trouvée. Propriétaire : {{owner}}",
          "name": "Collection",
          "notFound": "Collection introuvable : {{error}}"
        },
        "generalError": "Erreur générale",
        "visibleArtworks": {
          "found": "{{count}} œuvre(s) visible(s) pour votre compte",
          "name": "Œuvres avec filtre client_id"
        }
      },
      "common": {
        "errorWithMessage": "Erreur : {{error}}",
        "none": "aucun"
      },
      "confirm": {
        "fixClientIds": "ATTENTION\n\nCette action va modifier le client_id de toutes les œuvres de cette collection.\n\nVoulez-vous continuer ?"
      },
      "description": "Ce diagnostic vérifie pourquoi les œuvres importées ne s’affichent pas et peut les corriger automatiquement.",
      "labels": {
        "collectionId": "ID de la collection",
        "count": "Nombre : {{count}}",
        "userId": "Votre ID"
      },
      "recommendations": {
        "allGood": "Tout fonctionne correctement. Les {{count}} œuvre(s) sont visibles.",
        "causeLabel": "Cause",
        "causeText": "Le client_id des œuvres importées ne correspond pas à votre identifiant utilisateur.",
        "foundIds": "ID trouvé(s)",
        "mixed": "Situation mixte. Consultez les détails ci-dessus.",
        "noArtwork": "Aucune œuvre n’a été importée dans cette collection.",
        "partial": "Situation partielle : {{visible}}/{{total}} œuvre(s) visible(s).",
        "partialCause": "Certaines œuvres ont probablement été importées avec un mauvais client_id.",
        "problemDetected": "Problème détecté : {{count}} œuvre(s) en base mais aucune visible.",
        "title": "Recommandations",
        "toFix": "Œuvres à corriger",
        "useFixButton": "Utilisez le bouton « Corriger automatiquement » ci-dessus pour résoudre ce problème.",
        "useFixButtonShort": "Utilisez « Corriger automatiquement » pour corriger toutes les œuvres."
      },
      "title": "Diagnostic d’import"
    },
    "estimationSemblables": {
      "actions": {
        "addExternal": "Ajouter un comparable manuel",
        "remove": "Supprimer",
        "save": "Enregistrer l’estimation"
      },
      "alerts": {
        "artworkUpdateError": "Le rapport a été créé, mais la fiche œuvre n’a pas pu être mise à jour.",
        "maxExternal": "Vous pouvez ajouter au maximum cinq comparables externes manuels.",
        "saveError": "Erreur lors de l’enregistrement de l’estimation.",
        "saved": "Estimation enregistrée avec succès.",
        "selectForVision": "Sélectionnez une œuvre et au moins trois comparables avant de lancer Vision.",
        "uploadError": "Erreur lors de la génération ou de l’envoi du rapport."
      },
      "averageLabel": "Moyenne estimée",
      "clientContext": "Client : {{client}} · rôle : {{role}} · plan : {{plan}}",
      "counts": "{{internal}} interne(s) · {{imported}} importé(s) · {{manual}} manuel(s)",
      "description": "Sélectionnez au moins trois comparables internes, importés ou manuels pour calculer une estimation.",
      "errors": {
        "notConnected": "Utilisateur non connecté",
        "vision": "Erreur Vision",
        "visionAnalysis": "Erreur lors de l’analyse Vision.",
        "visionNotConfigured": "API Vision non configurée."
      },
      "fields": {
        "artwork": "Œuvre à estimer",
        "selectArtwork": "Sélectionner une œuvre"
      },
      "global": "global",
      "importedHint": "Sélectionnez les résultats réellement comparables à l’œuvre étudiée.",
      "loadingImported": "Chargement des comparables importés…",
      "minimumComparables": "Au moins trois comparables sont nécessaires.",
      "noDetails": "Aucun détail",
      "noEstimatedValue": "Valeur non renseignée",
      "noImported": "Aucun comparable importé disponible.",
      "pdf": {
        "artwork": "Œuvre estimée : {{title}}",
        "date": "Date : {{date}}",
        "estimatedValue": "Valeur estimée : {{value}}",
        "externalComparables": "Comparables externes manuels :",
        "importedComparables": "Comparables importés :",
        "internalComparables": "Comparables internes :",
        "title": "Rapport d’estimation, œuvres semblables",
        "visionConfidence": "Indice de confiance Vision : {{value}}",
        "visionReading": "Lecture Vision :",
        "visionValue": "Affinage Vision : {{value}}"
      },
      "placeholders": {
        "artist": "Artiste",
        "comment": "Commentaire",
        "dimensions": "Dimensions",
        "medium": "Technique",
        "source": "Source / maison de vente",
        "title": "Titre",
        "value": "Valeur"
      },
      "sections": {
        "imported": "Comparables importés",
        "internal": "Comparables internes",
        "manual": "Comparables externes manuels"
      },
      "title": "Estimation par œuvres semblables",
      "unknownArtist": "Artiste inconnu",
      "unknownArtwork": "Œuvre inconnue",
      "unknownSource": "Source inconnue",
      "untitled": "Sans titre",
      "visibilityContext": "{{visibility}} · client {{client}}",
      "vision": {
        "action": "Lancer Vision",
        "confidence": "Confiance : {{value}}",
        "loading": "Analyse Vision…",
        "range": "Fourchette : {{low}} à {{high}}",
        "result": "Estimation Vision",
        "saveHint": "La valeur Vision sera retenue lors de l’enregistrement.",
        "title": "Affinage Vision"
      }
    },
    "expertClientAccessStatus": {
      "checking": "Vérification du partage…",
      "pending": "En attente du partage du client",
      "readError": "Erreur de lecture des permissions",
      "shared": "Partagé",
      "sharedOn": "Partagé le {{date}}"
    },
    "messagesButton": {
      "label": "Messages"
    },
    "museumLoanExport": {
      "actions": {
        "cancel": "Annuler",
        "generatePdf": "Générer le PDF",
        "generating": "Génération…"
      },
      "button": "Dossier de prêt ({{count}})",
      "errors": {
        "generation": "Impossible de générer le dossier de prêt."
      },
      "fields": {
        "curatorText": "Texte de présentation curatoriale",
        "endDate": "Fin de l’exposition",
        "exhibitionTheme": "Thème de l’exposition",
        "exhibitionTitle": "Titre de l’exposition",
        "installationDate": "Date d’installation",
        "museumName": "Musée / institution",
        "photographyAllowed": "Photographies autorisées",
        "restitutionDate": "Date de restitution",
        "startDate": "Début de l’exposition",
        "transportMethod": "Mode de transport"
      },
      "modal": {
        "title": "Configurer le dossier de prêt"
      },
      "pdf": {
        "acquiredFrom": "Acquis auprès de {{source}}",
        "acquisitionToComplete": "Informations d’acquisition à compléter",
        "annotationPlaceholder": "Annotations / zones identifiées / observations de conservation",
        "annotationZones": "ZONES D’ANNOTATION",
        "arrivalMuseum": "Arrivée au musée",
        "artist": "Artiste",
        "artworkConditionsSheet": "FICHE ŒUVRE {{current}}/{{total}}, CONDITIONS",
        "artworkCount": "• Nombre d’œuvres proposées : {{count}}",
        "artworkVisualSheet": "FICHE ŒUVRE {{current}}/{{total}}, VISUEL",
        "authorized": "autorisées",
        "collection": "Collection {{name}}",
        "conditionPlaceholder": "Excellent / Bon / Moyen",
        "conditionReport": "Constat d’état détaillé à établir avant le départ",
        "conditionSection": "ÉTAT DE CONSERVATION",
        "conditionToSpecify": "État à préciser",
        "contact": "Contact : {{value}}",
        "coverImagePlaceholder": "Image de couverture",
        "coverTitle": "PROPOSITION DE PRÊT",
        "credit": "Crédit",
        "currentPrivateCollection": "Collection privée actuelle",
        "deductibleBorrower": "Toute franchise reste à la charge de l’emprunteur",
        "defaultCredit": "Avec l’aimable autorisation de la Collection {{name}}",
        "defaultPresentation": "Dans le cadre de votre exposition « {{title}} », je souhaite proposer le prêt de {{count}} œuvre(s) de ma collection, en résonance avec votre propos curatorial sur {{theme}}. Cette sélection enrichirait le parcours et apporterait un éclairage complémentaire sur les thématiques abordées.",
        "departureCollection": "Départ de la collection",
        "exhibition": "Exposition : du {{start}} au {{end}}",
        "exhibitionPeriod": "• Période d’exposition : {{dates}}",
        "facilityReport": "FACILITY REPORT, PARTIE MUSÉE",
        "generalConditions": "CONDITIONS GÉNÉRALES DU PRÊT",
        "image": "Image",
        "imagePlaceholder": "Image non disponible",
        "installation": "Installation : {{date}}",
        "installationRestitution": "• Installation : {{installation}} | Restitution : {{restitution}}",
        "insuranceTotal": "• Valeur totale d’assurance : {{value}}",
        "keyInformation": "INFORMATIONS CLÉS",
        "lighting": "Éclairage adapté au médium",
        "loanConditionsReference": "Le prêt est soumis aux conditions détaillées ci-dessous et dans la convention jointe.",
        "loanDuration": "DURÉE DU PRÊT",
        "museum": "• Musée : {{name}}",
        "museumPacking": "Emballage et déballage par un personnel qualifié",
        "nailToNail": "Assurance clou à clou à la charge de l’emprunteur",
        "noArtworkSelected": "Aucune œuvre sélectionnée.",
        "noDirectSun": "Aucune exposition directe au soleil",
        "noThumbnails": "Aucune vignette disponible.",
        "notAuthorized": "non autorisées",
        "observations": "Observations :",
        "phonePlaceholder": "Téléphone :",
        "photographyCredit": "Crédit photographique : {{credit}}",
        "photographyPermission": "Photographies : {{status}}",
        "placeholders": {
          "contactDetails": "Nom, fonction, email, téléphone",
          "date": "[Date]",
          "dates": "[Dates]",
          "endDate": "[Date de fin]",
          "exhibitionDates": "[Dates d’exposition]",
          "exhibitionName": "[Nom de l’exposition]",
          "ifApplicable": "[le cas échéant]",
          "museumName": "[Nom du musée]",
          "name": "[Nom]",
          "startDate": "[Date de début]",
          "theme": "[thème]",
          "title": "[Titre]"
        },
        "presentation": "Présentation",
        "proposedArtworks": "Œuvres proposées",
        "proposedThumbnails": "Œuvres proposées, vignettes",
        "provenance": "PROVENANCE SYNTHÉTIQUE",
        "referGeneralConditions": "Se reporter aux conditions générales jointes.",
        "restitution": "Restitution : {{date}}",
        "roundTripConditionReport": "Constat d’état au départ et au retour",
        "secureDisplay": "Présentation et manipulation sécurisées",
        "summaryNotes": "Résumé / Notes",
        "temperature": "Température et hygrométrie stables",
        "toCompleteByConservation": "À compléter par le service de conservation",
        "toCompleteByMuseum": "À compléter et signer par l’institution emprunteuse.",
        "unknownArtist": "Artiste inconnu",
        "unspecifiedDimensions": "Dimensions non précisées",
        "unspecifiedMedium": "Technique non précisée",
        "untitled": "Sans titre",
        "visitAvailability": "Disponibilité pour une visite préalable : {{value}}",
        "visitAvailabilityPlaceholder": "Oui / Non / Dates"
      },
      "placeholders": {
        "curatorText": "Présentez la sélection et son intérêt pour l’exposition…",
        "exhibitionTheme": "Thème ou propos curatorial",
        "exhibitionTitle": "Titre de l’exposition",
        "museumName": "Nom du musée ou de l’institution",
        "photographyCredit": "Crédit photographique souhaité"
      },
      "transport": {
        "other": "À définir avec le musée",
        "self": "Transport organisé par le prêteur",
        "specialized": "Transporteur spécialisé"
      }
    },
    "museumProposal": {
      "actions": {
        "add": "Ajouter",
        "addExhibition": "Ajouter l’exposition",
        "cancel": "Annuler",
        "continuePayment": "Continuer vers le paiement",
        "delete": "Supprimer",
        "downloadCompletePdf": "Télécharger le dossier complet",
        "downloadPdf": "Télécharger le PDF",
        "generating": "Génération…",
        "generatingPdf": "Génération du PDF…",
        "preview": "Aperçu",
        "requestCancellation": "Demander l’annulation",
        "sendProposal": "Envoyer la proposition"
      },
      "cancellationPending": "Annulation demandée",
      "chooseArtwork": "Choisir une œuvre",
      "confirm": {
        "cancel": "Demander l’annulation ?",
        "delete": "Confirmer la suppression ?"
      },
      "defaults": {
        "artistBio": "{{artist}} est un artiste contemporain travaillant principalement avec {{medium}}.",
        "artisticRelevance": "Cette œuvre s’inscrit dans une démarche pertinente explorant des thèmes contemporains à travers {{medium}}.",
        "artworkDescription": "{{title}} {{year}} {{medium}} représente {{subject}} d’une manière singulière et captivante.",
        "subject": "un sujet",
        "thisArtwork": "Cette œuvre",
        "thisTechnique": "cette technique"
      },
      "emailHint": "Utilisé uniquement pour préparer votre envoi autonome.",
      "errors": {
        "cancel": "Erreur de demande d’annulation : {{error}}",
        "cancelGeneric": "Une erreur est survenue pendant la demande d’annulation.",
        "delete": "Erreur de suppression : {{error}}",
        "deleteGeneric": "Une erreur est survenue pendant la suppression.",
        "exhibitionRequired": "Renseignez au minimum le titre, le lieu et la date de début de l’exposition.",
        "pdf": "Erreur lors de la génération du dossier PDF.",
        "selectArtwork": "Veuillez sélectionner une œuvre.",
        "selectArtworkFirst": "Sélectionnez d’abord une œuvre.",
        "submit": "Erreur lors de l’envoi : {{error}}",
        "unknown": "Erreur inconnue"
      },
      "exhibition": {
        "fields": {
          "description": "Description",
          "endDate": "Date de fin",
          "location": "Ville / pays",
          "startDate": "Date de début",
          "title": "Titre",
          "venue": "Lieu / institution"
        },
        "title": "Ajouter une exposition"
      },
      "fields": {
        "artistBio": "Biographie de l’artiste",
        "artwork": "Sélectionnez votre œuvre",
        "artworkDescription": "Description de l’œuvre",
        "email": "Email de l’institution",
        "institution": "Institution cible",
        "presentationMessage": "Message de présentation",
        "previousExhibitions": "Expositions antérieures",
        "relevance": "Pertinence artistique et culturelle"
      },
      "loadingArtworks": "Chargement des œuvres…",
      "noArtwork": "Aucune œuvre disponible. Ajoutez d’abord des œuvres à votre collection.",
      "noExhibitions": "Aucune exposition renseignée.",
      "placeholders": {
        "artistBio": "Décrivez brièvement le parcours et la démarche de l’artiste…",
        "artworkDescription": "Décrivez l’œuvre, sa technique et son sujet…",
        "email": "contact@institution.org",
        "institution": "Ex. : Museum of Modern Art, Centre Pompidou…",
        "presentationMessage": "Présentez votre démarche et la raison de cette proposition…",
        "relevance": "Expliquez la pertinence de cette œuvre dans le contexte artistique et culturel actuel…"
      },
      "preview": {
        "artworkAlt": "Œuvre proposée",
        "exhibitionProposal": "Proposition d’exposition",
        "fields": {
          "artist": "Artiste",
          "medium": "Technique",
          "title": "Titre",
          "year": "Année"
        },
        "hint": "Cet aperçu présente les informations qui seront intégrées au dossier.",
        "noBiography": "Biographie non renseignée.",
        "noDescription": "Description non renseignée.",
        "noMessage": "Aucun message de présentation.",
        "noRelevance": "Pertinence non renseignée.",
        "notSpecified": "Non renseigné",
        "title": "Aperçu du dossier",
        "unknownArtist": "Artiste inconnu",
        "untitled": "Sans titre"
      },
      "sections": {
        "artistArtwork": "Informations sur l’artiste et l’œuvre",
        "details": "Détails de la proposition",
        "previousProposals": "Propositions précédentes",
        "submissionMethod": "Mode d’envoi"
      },
      "self": {
        "description": "Téléchargez le dossier et gérez directement l’envoi à l’institution.",
        "free": "Gratuit",
        "manage": "Vous gérez les échanges et relances",
        "ready": "Dossier prêt à envoyer",
        "title": "Envoi autonome"
      },
      "service": {
        "additionalFees": "Frais supplémentaires éventuels selon la mission",
        "description": "Artkiv prépare, vérifie et suit votre proposition.",
        "fixedFee": "Forfait de service",
        "followUp": "Suivi de la proposition",
        "monthlyReport": "Compte rendu mensuel",
        "title": "Service Artkiv"
      },
      "status": {
        "paid": "Payé",
        "pending": "En attente"
      },
      "title": "Proposer une œuvre à un musée ou une institution",
      "types": {
        "auction": "Vente aux enchères",
        "museum": "Musée / institution"
      },
      "untitledArtwork": "Œuvre sans titre"
    },
    "pendingExpertAccess": {
      "acceptedOn": "Accepté le {{date}}",
      "alerts": {
        "error": "Erreur : {{error}}",
        "shared": "Collections partagées avec l’expert."
      },
      "description": "Ces experts ont accepté votre invitation et attendent que vous partagiez vos collections.",
      "expertFallback": "Expert",
      "loading": "Chargement…",
      "message": "Message : {{message}}",
      "shareNow": "Partager maintenant",
      "sharing": "Partage…",
      "title": "{{count}} expert(s) en attente de partage"
    },
    "purchaseProposal": {
      "alerts": {
        "sent": "Votre proposition d’achat a bien été envoyée. Nous vous contacterons rapidement."
      },
      "errors": {
        "unavailable": "Œuvre non trouvée ou indisponible."
      },
      "fields": {
        "email": "Votre e-mail",
        "message": "Message / Offre",
        "name": "Votre nom",
        "placeholder": "Je souhaite faire une offre de…"
      },
      "loading": "Chargement…",
      "price": "Prix affiché : € {{price}} (hors taxes et frais)",
      "submit": "Envoyer ma proposition",
      "summary": "Artiste : {{artist}} | Année : {{year}} | Technique : {{medium}}",
      "title": "Faire une offre pour « {{title}} »",
      "undefined": "Non défini",
      "warning": "Attention :"
    },
    "saleModal": {
      "actions": {
        "cancel": "Annuler",
        "confirm": "Enregistrer la vente",
        "saving": "Enregistrement…"
      },
      "errors": {
        "priceRequired": "Renseignez un prix de vente valide.",
        "save": "Erreur lors de l’enregistrement de la vente."
      },
      "fields": {
        "buyer": "Acheteur",
        "buyerPlaceholder": "Nom de l’acheteur",
        "notes": "Notes",
        "notesPlaceholder": "Informations supplémentaires sur la vente",
        "saleDate": "Date de la vente",
        "salePrice": "Prix de vente (€)"
      },
      "success": "Vente enregistrée.",
      "title": "Enregistrer une vente"
    }
  },
  "partnerBilling": {
    "title": "Facturation partenaire — {{type}}",
    "partnerTypes": {
      "transport": "Transport",
      "insurance": "Assurance"
    },
    "description": "Ces factures concernent les commissions ou frais ARTKIV liés à vos interventions.",
    "invoiceFallback": "Facture",
    "issuedOn": "Émise le {{date}}",
    "dueOn": "Échéance le {{date}}",
    "noDueDate": "Sans échéance",
    "pay": "Payer",
    "empty": "Aucune facture à afficher.",
    "status": {
      "paid": "Payée",
      "pending": "En attente",
      "open": "Ouverte",
      "overdue": "En retard",
      "void": "Annulée",
      "draft": "Brouillon",
      "unknown": "Statut inconnu"
    }
  },
  "estimationPointMethod": {
    "loading": "Chargement…",
    "title": "Estimation par méthode du point",
    "formula": "Formule moderne : (Hauteur + Largeur) × Cote de l’artiste",
    "common": {
      "untitled": "Sans titre"
    },
    "errors": {
      "load": "Impossible de charger l’œuvre : {{message}}",
      "requiredFields": "Veuillez remplir tous les champs requis.",
      "depthRequired": "Veuillez indiquer la profondeur pour une sculpture."
    },
    "actions": {
      "backToEstimations": "Retour aux estimations",
      "backToArtwork": "Retour à la fiche œuvre",
      "calculate": "Calculer l’estimation",
      "requestValidation": "Demander une validation experte"
    },
    "missingDimensions": {
      "title": "Dimensions manquantes",
      "description": "Pour utiliser la méthode du point, la hauteur et la largeur de l’œuvre doivent être renseignées dans votre collection.",
      "add": "Ajouter les dimensions"
    },
    "parameters": {
      "title": "Paramètres",
      "artworkType": "Type d’œuvre",
      "type2d": "Peinture / Dessin (2D)",
      "type3d": "Sculpture (3D)",
      "dimensions": "Dimensions (en cm)",
      "prefilled": "✓ Préremplies depuis votre collection",
      "height": "Hauteur",
      "width": "Largeur",
      "depth": "Profondeur",
      "artistRating": "Cote de l’artiste"
    },
    "categories": {
      "young": {
        "label": "Jeunes talents et jeunes diplômés",
        "description": "Premières expositions, expérience du marché encore limitée"
      },
      "regional": {
        "label": "Artistes régionaux établis",
        "description": "Notoriété régionale, expositions régulières et représentation en galerie"
      },
      "national": {
        "label": "Artistes de renommée nationale",
        "description": "Présence nationale et ventes aux enchères occasionnelles"
      },
      "international": {
        "label": "Artistes internationaux établis",
        "description": "Présence dans des collections, musées et galeries reconnues"
      },
      "iconic": {
        "label": "Icônes de l’histoire de l’art",
        "description": "Importance historique et ventes de premier plan"
      }
    },
    "result": {
      "title": "Résultat",
      "empty": "Renseignez les paramètres puis cliquez sur « Calculer l’estimation ».",
      "calculation": "Calcul :",
      "indicativePrice": "Prix indicatif :",
      "range": "Fourchette (±20 %) :"
    },
    "validation": {
      "title": "💳 Service de validation",
      "standard": "• Standard : 10 validations incluses par mois, puis 150 € par validation",
      "premium": "• Premium : 50 validations incluses par mois, puis 150 € par validation",
      "responseTime": "Délai de réponse : 48 à 72 heures ouvrées"
    }
  },
  "estimationSuccessionFiscal": {
    "title": "Rapport fiscal de succession",
    "subtitle": "Analyse fiscale prévisionnelle pour la planification patrimoniale",
    "common": {
      "unknownHeir": "Héritier inconnu",
      "untitled": "Sans titre"
    },
    "alerts": {
      "loadError": "Impossible de charger les données : {{message}}",
      "selectPlan": "Sélectionnez un plan de succession.",
      "uploadError": "Impossible d’envoyer le rapport PDF.",
      "generated": "Rapport fiscal généré."
    },
    "reportTitle": "Rapport fiscal – {{name}}",
    "plan": {
      "title": "Plan de succession",
      "loading": "Chargement des plans…",
      "empty": "Aucun plan de succession trouvé. Créez d’abord un plan dans votre tableau de bord avec les héritiers et la répartition des œuvres.",
      "choose": "— Choisir un plan —",
      "heirs": "Héritiers",
      "artworks": "Œuvres",
      "status": "Statut"
    },
    "status": {
      "draft": "Brouillon",
      "pending": "En attente",
      "active": "Actif",
      "completed": "Terminé",
      "archived": "Archivé"
    },
    "heirTypes": {
      "child": "Enfant",
      "daughter": "Fille",
      "son": "Fils",
      "spouse": "Conjoint",
      "sibling": "Frère / sœur",
      "family": "Famille",
      "institution": "Institution",
      "other": "Autre"
    },
    "summary": {
      "title": "Synthèse fiscale",
      "totalValue": "Valeur totale",
      "inheritanceTax": "Droits de succession",
      "dation": "Dation",
      "recommended": "✓ Recommandée",
      "notNecessary": "Non nécessaire"
    },
    "distribution": {
      "title": "Répartition par héritier",
      "typeAndCount": "{{type}} · {{count}} œuvre(s)",
      "taxes": "Droits : {{value}}",
      "assignedWorks": "Œuvres attribuées selon le score d’affinité",
      "moreWorks": "… et {{count}} autre(s) œuvre(s)",
      "moreWorks_one": "… et 1 autre œuvre",
      "moreWorks_other": "… et {{count}} autres œuvres"
    },
    "actions": {
      "back": "← Retour",
      "generatePdf": "Générer le rapport PDF"
    },
    "difference": {
      "title": "⚠️ Différence importante",
      "validationTitle": "Validation Artkiv",
      "validationIntro": "Service de vérification interne par nos experts. Convient pour :",
      "personalCollection": "Gestion d’une collection personnelle",
      "insuranceUnder": "Assurance d’œuvres inférieures à 80 000 €",
      "firstEvaluation": "Première évaluation avant vente",
      "validationPrice": "Tarif : 10 à 50 validations par mois selon l’abonnement, puis 150 € par validation",
      "cnesTitle": "Expertise CNES",
      "cnesIntro": "Expertise physique par un expert agréé. Obligatoire pour :",
      "insuranceOver": "Assurance d’œuvres supérieures à 80 000 €",
      "majorEstate": "Succession importante",
      "auction": "Vente aux enchères",
      "bankGuarantee": "Garantie bancaire ou contentieux",
      "cnesPrice": "Tarif : à partir de 300 € (déplacement et rapport certifié)",
      "contact": "💡 Artkiv peut vous mettre en relation avec des experts CNES agréés pour les œuvres de haute valeur ou les besoins légaux."
    },
    "pdf": {
      "title": "RAPPORT FISCAL DE SUCCESSION",
      "plan": "Plan : {{name}}",
      "date": "Date : {{date}}",
      "valuation": "VALORISATION",
      "totalValue": "Valeur totale : {{value}}",
      "estimatedTaxes": "Droits estimés : {{value}}",
      "distribution": "RÉPARTITION PAR HÉRITIER",
      "receivedValue": "Valeur reçue : {{value}}",
      "taxes": "Droits : {{value}}",
      "artworks": "Œuvres : {{count}}",
      "artworks_one": "Œuvre : 1",
      "artworks_other": "Œuvres : {{count}}"
    }
  },
  "autoCUPAssistant": {
    "header": {
      "eyebrow": "Assistant CUP",
      "title": "Pré-analyse des comparables importés",
      "description": "Analyse les lots Artprice, lit la cotation personnelle de l’expert et intègre les analogies du Groupe B.",
      "premiumOnly": "Réservé Art Advisor Premium",
      "active": "Actif"
    },
    "loading": "Chargement des comparables importés…",
    "errors": {
      "load": "Impossible de charger les comparables importés."
    },
    "methodGroups": {
      "directCup": "Groupe A — CUP directe",
      "analogyCup": "Groupe B — CUP par analogie",
      "pointMethod": "Groupe C — Méthode par points",
      "directCupPrudent": "CUP directe prudente",
      "analogyCupRatio": "CUP analogique par ratio",
      "hybridPointsCup": "Hybride points + comparables",
      "unknown": "Méthode non renseignée"
    },
    "mediums": {
      "painting": "Peinture",
      "sculpture": "Sculpture",
      "photography": "Photographie",
      "drawing": "Dessin",
      "print": "Estampe",
      "mixed_media": "Technique mixte",
      "installation": "Installation",
      "video": "Vidéo",
      "textile": "Textile",
      "ceramic": "Céramique",
      "nft": "NFT / Art numérique",
      "other": "Autre",
      "oil_on_canvas": "Huile sur toile",
      "acrylic_on_canvas": "Acrylique sur toile",
      "ink_on_paper": "Encre sur papier",
      "watercolor_on_paper": "Aquarelle sur papier",
      "pencil_on_paper": "Crayon sur papier",
      "charcoal_on_paper": "Fusain sur papier",
      "mixed_media_on_paper": "Technique mixte sur papier"
    },
    "supports": {
      "oil_canvas": "huile sur toile",
      "acrylic_canvas": "acrylique sur toile",
      "paper_mounted_canvas": "papier marouflé sur toile",
      "paper_work": "œuvre sur papier",
      "canvas": "toile"
    },
    "exclusions": {
      "condition": "État irréparable : exclu du calcul, conservé comme contexte.",
      "freshness": "Résultat de plus de cinq ans ou date incohérente : exclu du calcul, conservé comme contexte."
    },
    "marketSegments": {
      "primary": "Segment principal",
      "secondary": "Segment voisin",
      "own_context": "Même artiste · technique distante",
      "analog_same_segment": "Analogue du même segment",
      "analog_context": "Analogue contextuel",
      "unclassified": "Segment non classé"
    },
    "minimum": {
      "groupA": "3 comparables minimum en Groupe A",
      "groupB": "5 références minimum en Groupe B",
      "pointMethod": "Méthode à points"
    },
    "quote": {
      "loaded": "Cotation personnelle chargée",
      "date": "date : {{date}}",
      "analogies": "analogies : {{names}}"
    },
    "empty": {
      "title": "Aucun comparable importé pour cet artiste ou ses analogies.",
      "description": "Importez des fiches Artprice. En Groupe B, l’assistant cherchera aussi les artistes comparables définis dans la cotation personnelle.",
      "import": "Importer des fiches Artprice"
    },
    "metrics": {
      "comparables": "Comparables",
      "minimum": "{{current}}/{{minimum}} minimum",
      "breakdown": "{{primary}} principal · {{secondary}} voisin · {{analog}} analogique · {{sameSegment}} même segment",
      "calculationStatus": "Statut du calcul",
      "weightedMedian": "Médiane pondérée",
      "proposedRange": "Fourchette proposée",
      "confidence": "Confiance"
    },
    "status": {
      "finalizable": "Finalisable",
      "provisional": "Provisoire",
      "insufficient": "Insuffisant"
    },
    "notices": {
      "provisional": "Pré-estimation calculée avec {{count}} référence(s). La validation CUP complète reste verrouillée tant que le seuil métier n’est pas atteint : {{minimum}}.",
      "insufficient": "Ajoutez au moins trois ventes exploitables pour afficher une pré-estimation. {{minimum}} pour finaliser.",
      "marketStructure": "La technique structure le sous-marché : segment principal = même artiste et même technique, segment voisin = même artiste et famille technique proche, analogues = contexte de marché. Les analogues sont affichés mais pèsent faiblement dans la médiane."
    },
    "badges": {
      "analogyB": "Analogie B",
      "ownGroupB": "Résultat propre · Groupe B",
      "directGroupA": "Groupe A direct"
    },
    "row": {
      "technique": "Technique",
      "supportDriver": "support moteur : {{support}}",
      "decision": "Décision : état {{condition}} · dim. {{dimensions}} · tech. {{technique}} · proximité {{proximity}} · fraîcheur {{freshness}} · poids {{weight}}",
      "afterDiscount": "Après décote : {{value}}",
      "estimateRange": "Est. {{low}} – {{high}}",
      "match": "Match {{score}}/100"
    },
    "analog": {
      "reasonFallback": "Comparable d’artiste du Groupe B"
    },
    "summary": {
      "analogDiscount": "Analogie Groupe B, décote {{discount}} %",
      "analog": "Analogie Groupe B",
      "ownGroupB": "Résultat propre · ajustement qualitatif expert (Groupe B)",
      "directGroupA": "Groupe A — CUP directe"
    },
    "stock": {
      "eyebrow": "Stock complet de l’artiste",
      "found": "{{count}} vente(s) aux enchères trouvée(s) pour {{artist}}",
      "found_one": "1 vente aux enchères trouvée pour {{artist}}",
      "found_other": "{{count}} ventes aux enchères trouvées pour {{artist}}",
      "auditHelp": "Le CUP reste calculé sur les meilleurs comparables ; ce stock sert à l’audit et à la sélection experte.",
      "tabs": {
        "all": "Toutes les ventes",
        "sameTechnique": "Même technique",
        "sameFamily": "Famille technique proche",
        "priced": "Ventes avec prix",
        "estimates": "Estimations seules"
      },
      "empty": "Aucune vente dans cet onglet.",
      "autoSelected": "sélection automatique CUP",
      "addedToForm": "ajouté au formulaire",
      "family": "Famille",
      "technique": "Technique",
      "supportDriver": "Support moteur : {{support}}",
      "priceUnpublished": "Prix non publié",
      "alreadyAdded": "Déjà ajouté",
      "addToForm": "Ajouter au formulaire"
    },
    "sources": {
      "artprice": "Ouvrir Artprice",
      "invaluable": "Ouvrir Invaluable",
      "artnet": "Ouvrir Artnet",
      "sothebys": "Ouvrir Sotheby’s",
      "christies": "Ouvrir Christie’s",
      "named": "Ouvrir la source {{name}}",
      "generic": "Ouvrir la source"
    },
    "suggestion": {
      "finalizable": "Proposition finalisable : appliquez les meilleurs comparables pondérés.",
      "provisional": "Proposition provisoire : le calcul est visible, mais la validation finale doit être complétée avec les références manquantes.",
      "expertControl": "L’expert garde la main sur la décote du Groupe B et l’ajustement final.",
      "apply": "Appliquer la suggestion"
    },
    "locked": {
      "title": "Pré-analyse automatique réservée au Premium",
      "description": "Avec Art Advisor Standard, l’expert saisit ses comparables manuellement. Avec Art Advisor Premium, ARTKIV lit les imports Artprice et propose une fourchette CUP exploitable."
    },
    "common": {
      "untitled": "Sans titre",
      "thisArtist": "cet artiste"
    }
  },
  "auctionProposalPage": {
    "title": "Proposer une œuvre à une maison de ventes",
    "loading": "Chargement de l’œuvre…",
    "artworkSection": {
      "title": "Informations sur l’œuvre"
    },
    "summary": {
      "title": "Titre",
      "artist": "Artiste",
      "year": "Année",
      "medium": "Technique",
      "dimensions": "Dimensions",
      "value": "Valeur"
    },
    "fallbacks": {
      "untitled": "Sans titre",
      "untitledArtwork": "Œuvre sans titre",
      "unknownArtist": "Artiste inconnu",
      "notSpecifiedFeminine": "Non spécifiée",
      "notSpecifiedMasculine": "Non spécifié",
      "notSpecifiedPlural": "Non spécifiées",
      "artwork": "Œuvre",
      "artworkFile": "oeuvre",
      "auctionHouseFile": "maison-de-ventes"
    },
    "form": {
      "title": "Détails de la proposition",
      "auctionHouse": "Maison de ventes",
      "auctionHousePlaceholder": "Ex. : Christie’s, Sotheby’s, Drouot…",
      "message": "Message de présentation",
      "messagePlaceholder": "Informations complémentaires sur l’œuvre, sa provenance et son état…",
      "email": "Votre adresse e-mail pour recevoir le rapport",
      "emailPlaceholder": "votre@email.com",
      "emailHelp": "Nous vous enverrons le rapport mis en forme à cette adresse."
    },
    "actions": {
      "preview": "Aperçu",
      "downloadPdf": "Télécharger le PDF",
      "generating": "Génération…",
      "submit": "Soumettre la proposition",
      "closePreview": "Fermer l’aperçu",
      "generatingPdf": "Génération du PDF…",
      "downloadFullPdf": "Télécharger le PDF complet"
    },
    "preview": {
      "title": "Aperçu de la proposition",
      "heading": "Proposition de mise en vente aux enchères"
    },
    "notFound": {
      "title": "Œuvre introuvable",
      "description": "L’œuvre n’a pas été trouvée dans la base de données.",
      "back": "Retour au tableau de bord"
    },
    "errors": {
      "loadArtwork": "Erreur lors du chargement des informations de l’œuvre.",
      "pdf": "Erreur lors de la génération du rapport PDF.",
      "required": "Veuillez remplir tous les champs obligatoires.",
      "submit": "Erreur lors de l’envoi de la proposition : {{message}}",
      "unknown": "Erreur inconnue"
    },
    "pdf": {
      "filePrefix": "proposition-vente-encheres"
    }
  },
  "readiness": {
    "dimensions": {
      "identification": "Identification",
      "documentation": "Documentation",
      "provenance": "Authenticité / provenance",
      "valuation": "Valorisation à jour",
      "insurance": "Assurance",
      "conservation": "Conservation suivie",
      "property": "Propriété clarifiée",
      "transmission": "Transmission préparée"
    },
    "actions": {
      "identification_one": "Compléter l’identification de {{count}} œuvre",
      "identification_other": "Compléter l’identification de {{count}} œuvres",
      "documentation_one": "Ajouter facture / certificat pour {{count}} œuvre",
      "documentation_other": "Ajouter facture / certificat pour {{count}} œuvres",
      "provenance_one": "Documenter la provenance de {{count}} œuvre",
      "provenance_other": "Documenter la provenance de {{count}} œuvres",
      "valuation_one": "Actualiser la valorisation de {{count}} œuvre",
      "valuation_other": "Actualiser la valorisation de {{count}} œuvres",
      "insurance_one": "Vérifier l’assurance de {{count}} œuvre",
      "insurance_other": "Vérifier l’assurance de {{count}} œuvres",
      "conservation_one": "Renseigner l’état de conservation de {{count}} œuvre",
      "conservation_other": "Renseigner l’état de conservation de {{count}} œuvres",
      "property_one": "Clarifier le statut de propriété de {{count}} œuvre",
      "property_other": "Clarifier le statut de propriété de {{count}} œuvres",
      "transmission_one": "Préparer la transmission de {{count}} œuvre",
      "transmission_other": "Préparer la transmission de {{count}} œuvres",
      "generic_one": "{{count}} œuvre",
      "generic_other": "{{count}} œuvres"
    },
    "priority": {
      "high": "Élevée",
      "medium": "Moyenne",
      "low": "Faible"
    },
    "cards": {
      "artwork": {
        "eyebrow": "Art Asset Readiness",
        "subtitle": "Préparation patrimoniale de l’œuvre",
        "missingPrefix": "À compléter :",
        "dossierTitle": "Générer un dossier patrimonial structuré (identification, propriété, valorisation, marché, risque)",
        "dossierButton": "Préparer le dossier patrimonial (PDF)"
      },
      "advisor": {
        "eyebrow": "Collections sous mandat",
        "title": "À traiter : préparation patrimoniale",
        "subtitle_one": "{{count}} œuvre dans votre périmètre. Interventions prioritaires ci-dessous.",
        "subtitle_other": "{{count}} œuvres dans votre périmètre. Interventions prioritaires ci-dessous.",
        "average": "Readiness moyen",
        "exceptional_one": "⚠️ {{count}} œuvre exceptionnelle sans traitement successoral.",
        "exceptional_other": "⚠️ {{count}} œuvres exceptionnelles sans traitement successoral.",
        "allCovered": "Toutes les dimensions sont couvertes sur votre périmètre."
      },
      "collection": {
        "eyebrow": "État patrimonial",
        "title": "Préparation de votre collection",
        "subtitle_one": "Ce qui est prêt et ce qui nécessite votre attention sur {{count}} œuvre.",
        "subtitle_other": "Ce qui est prêt et ce qui nécessite votre attention sur {{count}} œuvres.",
        "readinessLabel": "Collection Readiness",
        "exceptional_one": "⚠️ {{count}} œuvre exceptionnelle sans traitement successoral.",
        "exceptional_other": "⚠️ {{count}} œuvres exceptionnelles sans traitement successoral.",
        "actionsTitle": "Pour améliorer votre préparation",
        "viewCollection": "Voir ma collection →"
      },
      "portfolio": {
        "eyebrow": "Patrimoine artistique supervisé",
        "title": "Portfolio Readiness",
        "subtitle": "Préparation patrimoniale par famille, avec isolation stricte des données.",
        "consolidated": "Consolidé",
        "columns": {
          "family": "Famille",
          "artValue": "Valeur art",
          "readiness": "Collection Readiness",
          "priority": "Priorité"
        }
      }
    }
  },
  "artAssetDossierPdf": {
    "common": {
      "yes": "Oui",
      "no": "Non",
      "present": "Présents",
      "missing": "Manquants"
    },
    "header": {
      "eyebrow": "DOSSIER PATRIMONIAL — ART ASSET DOSSIER",
      "untitled": "Œuvre sans titre",
      "completeness": "Complétude du dossier"
    },
    "ownership": {
      "full": "Pleine propriété",
      "usufruct": "Usufruit",
      "bare_ownership": "Nue-propriété"
    },
    "condition": {
      "excellent": "Excellent",
      "very_good": "Très bon",
      "good": "Bon",
      "fair": "Moyen",
      "very_poor": "Très moyen",
      "poor": "Mauvais",
      "heavily_damaged": "Très abîmé (restaurable)",
      "partially_restorable": "Partiellement restaurable",
      "irreparable": "Irréparable"
    },
    "sections": {
      "identification": {
        "title": "Identification",
        "artist": "Artiste",
        "artworkTitle": "Titre",
        "year": "Année",
        "medium": "Médium",
        "dimensions": "Dimensions",
        "inventory": "N° d’inventaire"
      },
      "acquisition": {
        "title": "Propriété & acquisition",
        "owner": "Propriétaire",
        "ownershipStatus": "Statut de détention",
        "date": "Date d’acquisition",
        "source": "Source",
        "price": "Prix d’acquisition",
        "documents": "Justificatifs"
      },
      "authenticity": {
        "title": "Authenticité & documentation",
        "invoice": "Facture",
        "certificate": "Certificat d’authenticité",
        "provenance": "Provenance",
        "signature": "Signature"
      },
      "valuation": {
        "title": "Valorisation",
        "currentValue": "Valeur actuelle",
        "range": "Estimation basse / haute",
        "method": "Méthode",
        "comparables": "Comparables",
        "date": "Date de valorisation"
      },
      "market": {
        "title": "Marché (indicatif)",
        "liquidity": "Liquidité indicative",
        "trend": "Tendance",
        "demand": "Demande"
      },
      "risk": {
        "title": "Risque physique",
        "condition": "État de conservation",
        "lastInspection": "Dernier constat",
        "storage": "Stockage",
        "insurance": "Assurance",
        "insured": "Assurée",
        "uninsured": "Non assurée"
      }
    },
    "missing": {
      "title": "Éléments à compléter pour un dossier complet"
    },
    "footer": {
      "disclaimer": "Dossier généré via ARTKIV le {{date}}. ARTKIV fournit une donnée structurée, traçable et partageable ; la décision (financement, cession, expertise) reste humaine et professionnelle. Les indicateurs de marché sont fournis à titre indicatif, avec avertissements méthodologiques."
    },
    "file": {
      "prefix": "dossier-patrimonial",
      "untitledSlug": "oeuvre"
    }
  },
  "familyOfficeReportPdf": {
    "header": {
      "eyebrow": "FAMILY OFFICE REPORT — PATRIMOINE ARTISTIQUE",
      "defaultName": "Family Office",
      "portfolioReadiness": "Portfolio Readiness"
    },
    "summary": {
      "supervisedFamilies": "Familles supervisées",
      "consolidatedArtValue": "Valeur art consolidée"
    },
    "families": {
      "title": "Préparation par famille",
      "columns": {
        "family": "Famille",
        "artValue": "Valeur art",
        "readiness": "Collection Readiness",
        "priority": "Priorité"
      }
    },
    "attention": {
      "title": "Points d’attention (consolidé)",
      "valuation": "Valorisations à actualiser",
      "insurance": "Œuvres sous-assurées",
      "documentation": "Documentation à compléter",
      "provenance": "Provenance à compléter",
      "conservation": "Conservation à renseigner",
      "exceptional": "Œuvres exceptionnelles sans transmission"
    },
    "footer": {
      "disclaimer": "Reporting consolidé établi via ARTKIV le {{date}}. Isolation stricte entre familles ; chaque famille reste maîtresse de ses données. ARTKIV structure la donnée patrimoniale ; les décisions et validations relèvent des professionnels habilités."
    },
    "file": {
      "prefix": "family-office-report"
    }
  },
  "aiConsentInfoPage": {
    "backToProfile": "Retour à mon profil",
    "eyebrow": "Intelligence artificielle & données",
    "title": "Comment ARTKIV utilise l’IA et les données de vos œuvres",
    "intro": "Cette page explique les fonctionnalités d’intelligence artificielle proposées par ARTKIV, les données qu’elles peuvent utiliser, leurs limites et les choix que vous gardez à chaque étape.",
    "principle": {
      "title": "Principe ARTKIV",
      "body": "L’IA assiste la documentation, l’analyse et la préparation des décisions. Elle n’a pas vocation à décider à votre place. Vous gardez la validation finale."
    },
    "access": {
      "title": "Accès aux fonctionnalités IA",
      "body": "L’accès aux modules IA dépend de votre rôle et de votre offre ARTKIV. Lorsqu’une fonction IA est incluse dans votre offre, elle reste désactivée tant que vous n’avez pas choisi de l’activer au niveau de votre compte.",
      "standardTitle": "Compte sans accès IA",
      "standardBody": "Vous continuez à gérer manuellement votre collection. Les fonctions nécessitant l’IA restent indisponibles tant que votre offre ne les inclut pas.",
      "eligibleTitle": "Compte éligible à l’IA",
      "eligibleBody": "Votre accord autorise l’utilisation des fonctions IA lorsque vous les lancez. Il ne déclenche pas l’analyse automatique de toute votre collection."
    },
    "purposes": {
      "title": "À quoi servent les modules IA ?",
      "visual": {
        "title": "Analyse visuelle",
        "body": "Proposer une classification, un style, des mots-clés ou des éléments descriptifs à partir des images d’une œuvre."
      },
      "documents": {
        "title": "Documents & OCR",
        "body": "Lire une facture, un certificat ou un autre document et proposer des informations à reporter dans la fiche. Les données proposées doivent être vérifiées avant validation."
      },
      "conservation": {
        "title": "Conservation",
        "body": "Aider à structurer les observations d’état, repérer des éléments à surveiller et préparer un suivi documentaire. Cette assistance ne remplace pas un constat professionnel."
      },
      "valuation": {
        "title": "Valorisation assistée",
        "body": "Croiser les informations de l’œuvre avec des comparables et des données disponibles pour produire des indications de valeur et des éléments d’analyse."
      }
    },
    "data": {
      "title": "Quelles données peuvent être traitées ?",
      "intro": "Selon la fonction que vous utilisez, ARTKIV peut transmettre au module concerné uniquement les éléments nécessaires à la tâche demandée, notamment :",
      "items": {
        "images": "les images de l’œuvre que vous choisissez d’analyser ;",
        "documents": "les documents que vous soumettez à l’OCR ou à une analyse documentaire ;",
        "metadata": "les métadonnées utiles de la fiche, par exemple artiste, titre, date, technique ou dimensions ;",
        "condition": "les observations et informations de conservation nécessaires au module concerné ;",
        "valuation": "les données de valorisation, comparables et informations de marché utiles au calcul ou à l’analyse ;",
        "outputs": "les résultats produits par les modules afin de les afficher, les vérifier ou les rattacher à votre dossier."
      }
    },
    "control": {
      "title": "Vous gardez le contrôle",
      "items": {
        "onDemand": "L’activation du compte n’analyse pas automatiquement chaque œuvre. Une fonction IA est utilisée lorsque vous lancez l’action correspondante.",
        "review": "Les résultats IA sont des propositions que vous pouvez consulter, corriger, accepter ou ignorer selon le workflow.",
        "noSilentWrite": "Les données sensibles extraites par OCR ou proposées par l’IA ne doivent pas être écrites silencieusement dans les champs métier sans validation prévue par l’interface.",
        "permissions": "L’activation de l’IA ne modifie pas les règles de partage, les droits d’accès ni les permissions existantes de vos collections."
      }
    },
    "limits": {
      "title": "Ce que l’IA ARTKIV ne fait pas",
      "items": {
        "indicative": "Les analyses et valorisations produites par l’IA sont indicatives et peuvent comporter des erreurs ou des incertitudes.",
        "noAuthentication": "Une analyse IA ne constitue pas, à elle seule, une authentification, une certification d’authenticité ou une expertise formelle.",
        "noProfessionalReplacement": "Elle ne remplace pas le jugement d’un expert, restaurateur, assureur, commissaire-priseur, conseiller juridique ou notaire lorsqu’une validation professionnelle est nécessaire.",
        "uncertainty": "Lorsque les informations disponibles sont insuffisantes, contradictoires ou incertaines, le résultat doit être relu et complété humainement."
      }
    },
    "statistics": {
      "title": "Statistiques agrégées : un choix séparé",
      "body": "Le consentement aux fonctionnalités IA du compte est distinct de l’opt-in d’une œuvre pour les statistiques et analyses agrégées anonymisées ARTKIV. Activer l’IA n’active jamais automatiquement cet opt-in. Il se gère séparément sur la fiche de l’œuvre."
    },
    "consent": {
      "title": "Activation et retrait",
      "body": "Lorsque votre offre donne accès à l’IA, vous pouvez choisir de l’activer depuis votre profil. ARTKIV enregistre alors votre choix et sa date afin d’appliquer correctement les règles d’accès aux modules.",
      "withdrawal": "Vous pouvez retirer cet accord depuis le même réglage. Le retrait bloque les nouveaux traitements IA nécessitant ce consentement.",
      "afterWithdrawal": "Le retrait n’efface pas automatiquement les données, documents ou résultats déjà enregistrés dans votre dossier ARTKIV. Leur gestion reste soumise aux règles habituelles de votre compte et aux fonctionnalités de suppression disponibles."
    },
    "privacy": {
      "title": "Confidentialité et permissions",
      "permissions": "Activer l’IA ne donne aucun droit supplémentaire à un tiers et ne contourne jamais les permissions ARTKIV existantes.",
      "noPublicity": "L’activation des fonctions IA ne rend pas votre collection publique et ne transforme pas une fiche privée en fiche publique.",
      "technicalDetails": "Les informations techniques susceptibles d’évoluer, notamment les prestataires, l’hébergement, les durées de conservation ou les éventuels transferts, doivent rester décrites dans la documentation de confidentialité ARTKIV tenue à jour. Cette page décrit le fonctionnement produit et ne remplace pas cette documentation."
    },
    "footer": {
      "title": "Modifier mon choix",
      "body": "Le réglage d’activation reste disponible dans votre profil. Si votre offre ne comprend pas de fonctionnalités IA, vos données de collection restent accessibles et gérables manuellement.",
      "cta": "Retour au réglage IA"
    }
  }
};

export default fr;
